import * as tn from "react";
import $e, { useState as G, useEffect as le, forwardRef as Ot, useCallback as nt, useRef as xe, useMemo as rt, useLayoutEffect as po, useContext as mo, createContext as ki, Fragment as Ve, memo as Bi, createElement as da, Component as go } from "react";
import { Listbox as qe, Dialog as yt, Transition as lt } from "@headlessui/react";
import { documentToReactComponents as Gr } from "@contentful/rich-text-react-renderer";
import { BLOCKS as q, INLINES as _t } from "@contentful/rich-text-types";
import { useFloating as $o, flip as xo, shift as vo, arrow as bo, autoUpdate as yo, useHover as Co, safePolygon as Eo, useFocus as No, useDismiss as To, useRole as So, useInteractions as jo, FloatingArrow as Po } from "@floating-ui/react";
import Ao from "youtube-player";
import Io from "@vimeo/player";
import { createPortal as Hi } from "react-dom";
var Wt;
(function(e) {
  e.BOOK = "book", e.MEDIUM = "medium";
})(Wt || (Wt = {}));
var _e;
(function(e) {
  e.NORMAL = "normal", e.SMALL = "small", e.BIG = "big";
})(_e || (_e = {}));
var Qe;
(function(e) {
  e.SELF = "_self", e.BLANK = "_blank";
})(Qe || (Qe = {}));
var Bt;
(function(e) {
  e.OPEN_URL = "Open URL", e.GO_BACK = "Go back", e.SCROLL_TO = "Scroll to";
})(Bt || (Bt = {}));
const Oo = {
  bluedark: "#29305E",
  dark: "#2C3136",
  gray: "#6C757D",
  subdued: "#F8F9FA",
  white: "#FFFFFF",
  // Surface colors
  primary: "#2C5881",
  secondary: "#495057",
  "light-hover": "#E9EEF1",
  "primary-hover": "#224564",
  "secondary-hover": "#343A40",
  "light-active": "#DEE2E6",
  "primary-active": "#1F3E5B",
  "secondary-active": "#1F3E5B",
  "light-disabled": "#C8CBCF",
  // Outlined colors
  "outlined-gray": "#DFE2E6",
  "outlined-medium": "#ADB5BD",
  // Status colors
  success: "#10B981",
  warning: "#FBBF24",
  error: "#DC2626",
  link: "#007BFF",
  // Util to set svg color from parent element
  currentColor: "currentColor"
};
var Ze;
(function(e) {
  e.CENTER = "center", e.LEFT = "left";
})(Ze || (Ze = {}));
const zt = {
  [Ze.CENTER]: "tw-text-center",
  [Ze.LEFT]: "tw-text-left"
}, Gi = {
  [Wt.BOOK]: "tw-font-book",
  [Wt.MEDIUM]: "tw-font-medium"
};
var Yt;
(function(e) {
  e.D_DIN_CONDENSED = "D-DIN Condensed", e.GOTHAM = "Gotham";
})(Yt || (Yt = {}));
const _o = {
  [Yt.D_DIN_CONDENSED]: "tw-font-condensed",
  [Yt.GOTHAM]: "tw-font-sans"
}, Lo = 5;
var Le;
(function(e) {
  e.VIDEO = "video", e.SQUARE = "square", e.RECTANGULAR = "rectangular";
})(Le || (Le = {}));
const Sn = {
  [Le.VIDEO]: "md:tw-aspect-video",
  [Le.SQUARE]: "md:tw-aspect-square",
  [Le.RECTANGULAR]: "md:tw-aspect-rectangular"
}, Ro = {
  [Le.VIDEO]: "lg:tw-aspect-video",
  [Le.SQUARE]: "lg:tw-aspect-square",
  [Le.RECTANGULAR]: "lg:tw-aspect-rectangular"
}, ln = {
  [Le.VIDEO]: "tw-aspect-video",
  [Le.SQUARE]: "tw-aspect-square",
  [Le.RECTANGULAR]: "tw-aspect-rectangular"
};
function Vi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var mr = { exports: {} }, nn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ca;
function Mo() {
  if (ca)
    return nn;
  ca = 1;
  var e = $e, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(l, d, c) {
    var f, w = {}, u = null, p = null;
    c !== void 0 && (u = "" + c), d.key !== void 0 && (u = "" + d.key), d.ref !== void 0 && (p = d.ref);
    for (f in d)
      r.call(d, f) && !s.hasOwnProperty(f) && (w[f] = d[f]);
    if (l && l.defaultProps)
      for (f in d = l.defaultProps, d)
        w[f] === void 0 && (w[f] = d[f]);
    return { $$typeof: t, type: l, key: u, ref: p, props: w, _owner: a.current };
  }
  return nn.Fragment = n, nn.jsx = o, nn.jsxs = o, nn;
}
var rn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ua;
function Fo() {
  return ua || (ua = 1, process.env.NODE_ENV !== "production" && function() {
    var e = $e, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), u = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), h = Symbol.iterator, m = "@@iterator";
    function $(b) {
      if (b === null || typeof b != "object")
        return null;
      var _ = h && b[h] || b[m];
      return typeof _ == "function" ? _ : null;
    }
    var g = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(b) {
      {
        for (var _ = arguments.length, F = new Array(_ > 1 ? _ - 1 : 0), K = 1; K < _; K++)
          F[K - 1] = arguments[K];
        C("error", b, F);
      }
    }
    function C(b, _, F) {
      {
        var K = g.ReactDebugCurrentFrame, ce = K.getStackAddendum();
        ce !== "" && (_ += "%s", F = F.concat([ce]));
        var pe = F.map(function(se) {
          return String(se);
        });
        pe.unshift("Warning: " + _), Function.prototype.apply.call(console[b], console, pe);
      }
    }
    var y = !1, x = !1, E = !1, O = !1, I = !1, B;
    B = Symbol.for("react.module.reference");
    function P(b) {
      return !!(typeof b == "string" || typeof b == "function" || b === r || b === s || I || b === a || b === c || b === f || O || b === p || y || x || E || typeof b == "object" && b !== null && (b.$$typeof === u || b.$$typeof === w || b.$$typeof === o || b.$$typeof === l || b.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      b.$$typeof === B || b.getModuleId !== void 0));
    }
    function A(b, _, F) {
      var K = b.displayName;
      if (K)
        return K;
      var ce = _.displayName || _.name || "";
      return ce !== "" ? F + "(" + ce + ")" : F;
    }
    function L(b) {
      return b.displayName || "Context";
    }
    function U(b) {
      if (b == null)
        return null;
      if (typeof b.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof b == "function")
        return b.displayName || b.name || null;
      if (typeof b == "string")
        return b;
      switch (b) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case l:
            var _ = b;
            return L(_) + ".Consumer";
          case o:
            var F = b;
            return L(F._context) + ".Provider";
          case d:
            return A(b, b.render, "ForwardRef");
          case w:
            var K = b.displayName || null;
            return K !== null ? K : U(b.type) || "Memo";
          case u: {
            var ce = b, pe = ce._payload, se = ce._init;
            try {
              return U(se(pe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var X = Object.assign, W = 0, Z, j, M, R, N, T, k;
    function V() {
    }
    V.__reactDisabledLog = !0;
    function H() {
      {
        if (W === 0) {
          Z = console.log, j = console.info, M = console.warn, R = console.error, N = console.group, T = console.groupCollapsed, k = console.groupEnd;
          var b = {
            configurable: !0,
            enumerable: !0,
            value: V,
            writable: !0
          };
          Object.defineProperties(console, {
            info: b,
            log: b,
            warn: b,
            error: b,
            group: b,
            groupCollapsed: b,
            groupEnd: b
          });
        }
        W++;
      }
    }
    function Q() {
      {
        if (W--, W === 0) {
          var b = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: X({}, b, {
              value: Z
            }),
            info: X({}, b, {
              value: j
            }),
            warn: X({}, b, {
              value: M
            }),
            error: X({}, b, {
              value: R
            }),
            group: X({}, b, {
              value: N
            }),
            groupCollapsed: X({}, b, {
              value: T
            }),
            groupEnd: X({}, b, {
              value: k
            })
          });
        }
        W < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var z = g.ReactCurrentDispatcher, Y;
    function ee(b, _, F) {
      {
        if (Y === void 0)
          try {
            throw Error();
          } catch (ce) {
            var K = ce.stack.trim().match(/\n( *(at )?)/);
            Y = K && K[1] || "";
          }
        return `
` + Y + b;
      }
    }
    var re = !1, te;
    {
      var ve = typeof WeakMap == "function" ? WeakMap : Map;
      te = new ve();
    }
    function S(b, _) {
      if (!b || re)
        return "";
      {
        var F = te.get(b);
        if (F !== void 0)
          return F;
      }
      var K;
      re = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var pe;
      pe = z.current, z.current = null, H();
      try {
        if (_) {
          var se = function() {
            throw Error();
          };
          if (Object.defineProperty(se.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(se, []);
            } catch (at) {
              K = at;
            }
            Reflect.construct(b, [], se);
          } else {
            try {
              se.call();
            } catch (at) {
              K = at;
            }
            b.call(se.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (at) {
            K = at;
          }
          b();
        }
      } catch (at) {
        if (at && K && typeof at.stack == "string") {
          for (var ae = at.stack.split(`
`), Ie = K.stack.split(`
`), ye = ae.length - 1, Ce = Ie.length - 1; ye >= 1 && Ce >= 0 && ae[ye] !== Ie[Ce]; )
            Ce--;
          for (; ye >= 1 && Ce >= 0; ye--, Ce--)
            if (ae[ye] !== Ie[Ce]) {
              if (ye !== 1 || Ce !== 1)
                do
                  if (ye--, Ce--, Ce < 0 || ae[ye] !== Ie[Ce]) {
                    var We = `
` + ae[ye].replace(" at new ", " at ");
                    return b.displayName && We.includes("<anonymous>") && (We = We.replace("<anonymous>", b.displayName)), typeof b == "function" && te.set(b, We), We;
                  }
                while (ye >= 1 && Ce >= 0);
              break;
            }
        }
      } finally {
        re = !1, z.current = pe, Q(), Error.prepareStackTrace = ce;
      }
      var Ft = b ? b.displayName || b.name : "", la = Ft ? ee(Ft) : "";
      return typeof b == "function" && te.set(b, la), la;
    }
    function be(b, _, F) {
      return S(b, !1);
    }
    function Ae(b) {
      var _ = b.prototype;
      return !!(_ && _.isReactComponent);
    }
    function Fe(b, _, F) {
      if (b == null)
        return "";
      if (typeof b == "function")
        return S(b, Ae(b));
      if (typeof b == "string")
        return ee(b);
      switch (b) {
        case c:
          return ee("Suspense");
        case f:
          return ee("SuspenseList");
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case d:
            return be(b.render);
          case w:
            return Fe(b.type, _, F);
          case u: {
            var K = b, ce = K._payload, pe = K._init;
            try {
              return Fe(pe(ce), _, F);
            } catch {
            }
          }
        }
      return "";
    }
    var ut = Object.prototype.hasOwnProperty, Rt = {}, qr = g.ReactDebugCurrentFrame;
    function xn(b) {
      if (b) {
        var _ = b._owner, F = Fe(b.type, b._source, _ ? _.type : null);
        qr.setExtraStackFrame(F);
      } else
        qr.setExtraStackFrame(null);
    }
    function Zs(b, _, F, K, ce) {
      {
        var pe = Function.call.bind(ut);
        for (var se in b)
          if (pe(b, se)) {
            var ae = void 0;
            try {
              if (typeof b[se] != "function") {
                var Ie = Error((K || "React class") + ": " + F + " type `" + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[se] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ie.name = "Invariant Violation", Ie;
              }
              ae = b[se](_, se, K, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ye) {
              ae = ye;
            }
            ae && !(ae instanceof Error) && (xn(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", K || "React class", F, se, typeof ae), xn(null)), ae instanceof Error && !(ae.message in Rt) && (Rt[ae.message] = !0, xn(ce), v("Failed %s type: %s", F, ae.message), xn(null));
          }
      }
    }
    var Xs = Array.isArray;
    function Yn(b) {
      return Xs(b);
    }
    function Ks(b) {
      {
        var _ = typeof Symbol == "function" && Symbol.toStringTag, F = _ && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return F;
      }
    }
    function qs(b) {
      try {
        return Jr(b), !1;
      } catch {
        return !0;
      }
    }
    function Jr(b) {
      return "" + b;
    }
    function Qr(b) {
      if (qs(b))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ks(b)), Jr(b);
    }
    var en = g.ReactCurrentOwner, Js = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ea, ta, Zn;
    Zn = {};
    function Qs(b) {
      if (ut.call(b, "ref")) {
        var _ = Object.getOwnPropertyDescriptor(b, "ref").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return b.ref !== void 0;
    }
    function eo(b) {
      if (ut.call(b, "key")) {
        var _ = Object.getOwnPropertyDescriptor(b, "key").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return b.key !== void 0;
    }
    function to(b, _) {
      if (typeof b.ref == "string" && en.current && _ && en.current.stateNode !== _) {
        var F = U(en.current.type);
        Zn[F] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(en.current.type), b.ref), Zn[F] = !0);
      }
    }
    function no(b, _) {
      {
        var F = function() {
          ea || (ea = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        F.isReactWarning = !0, Object.defineProperty(b, "key", {
          get: F,
          configurable: !0
        });
      }
    }
    function ro(b, _) {
      {
        var F = function() {
          ta || (ta = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        F.isReactWarning = !0, Object.defineProperty(b, "ref", {
          get: F,
          configurable: !0
        });
      }
    }
    var ao = function(b, _, F, K, ce, pe, se) {
      var ae = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: b,
        key: _,
        ref: F,
        props: se,
        // Record the component responsible for creating this element.
        _owner: pe
      };
      return ae._store = {}, Object.defineProperty(ae._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ae, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: K
      }), Object.defineProperty(ae, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(ae.props), Object.freeze(ae)), ae;
    };
    function io(b, _, F, K, ce) {
      {
        var pe, se = {}, ae = null, Ie = null;
        F !== void 0 && (Qr(F), ae = "" + F), eo(_) && (Qr(_.key), ae = "" + _.key), Qs(_) && (Ie = _.ref, to(_, ce));
        for (pe in _)
          ut.call(_, pe) && !Js.hasOwnProperty(pe) && (se[pe] = _[pe]);
        if (b && b.defaultProps) {
          var ye = b.defaultProps;
          for (pe in ye)
            se[pe] === void 0 && (se[pe] = ye[pe]);
        }
        if (ae || Ie) {
          var Ce = typeof b == "function" ? b.displayName || b.name || "Unknown" : b;
          ae && no(se, Ce), Ie && ro(se, Ce);
        }
        return ao(b, ae, Ie, ce, K, en.current, se);
      }
    }
    var Xn = g.ReactCurrentOwner, na = g.ReactDebugCurrentFrame;
    function Mt(b) {
      if (b) {
        var _ = b._owner, F = Fe(b.type, b._source, _ ? _.type : null);
        na.setExtraStackFrame(F);
      } else
        na.setExtraStackFrame(null);
    }
    var Kn;
    Kn = !1;
    function qn(b) {
      return typeof b == "object" && b !== null && b.$$typeof === t;
    }
    function ra() {
      {
        if (Xn.current) {
          var b = U(Xn.current.type);
          if (b)
            return `

Check the render method of \`` + b + "`.";
        }
        return "";
      }
    }
    function so(b) {
      {
        if (b !== void 0) {
          var _ = b.fileName.replace(/^.*[\\\/]/, ""), F = b.lineNumber;
          return `

Check your code at ` + _ + ":" + F + ".";
        }
        return "";
      }
    }
    var aa = {};
    function oo(b) {
      {
        var _ = ra();
        if (!_) {
          var F = typeof b == "string" ? b : b.displayName || b.name;
          F && (_ = `

Check the top-level render call using <` + F + ">.");
        }
        return _;
      }
    }
    function ia(b, _) {
      {
        if (!b._store || b._store.validated || b.key != null)
          return;
        b._store.validated = !0;
        var F = oo(_);
        if (aa[F])
          return;
        aa[F] = !0;
        var K = "";
        b && b._owner && b._owner !== Xn.current && (K = " It was passed a child from " + U(b._owner.type) + "."), Mt(b), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', F, K), Mt(null);
      }
    }
    function sa(b, _) {
      {
        if (typeof b != "object")
          return;
        if (Yn(b))
          for (var F = 0; F < b.length; F++) {
            var K = b[F];
            qn(K) && ia(K, _);
          }
        else if (qn(b))
          b._store && (b._store.validated = !0);
        else if (b) {
          var ce = $(b);
          if (typeof ce == "function" && ce !== b.entries)
            for (var pe = ce.call(b), se; !(se = pe.next()).done; )
              qn(se.value) && ia(se.value, _);
        }
      }
    }
    function lo(b) {
      {
        var _ = b.type;
        if (_ == null || typeof _ == "string")
          return;
        var F;
        if (typeof _ == "function")
          F = _.propTypes;
        else if (typeof _ == "object" && (_.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _.$$typeof === w))
          F = _.propTypes;
        else
          return;
        if (F) {
          var K = U(_);
          Zs(F, b.props, "prop", K, b);
        } else if (_.PropTypes !== void 0 && !Kn) {
          Kn = !0;
          var ce = U(_);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function co(b) {
      {
        for (var _ = Object.keys(b.props), F = 0; F < _.length; F++) {
          var K = _[F];
          if (K !== "children" && K !== "key") {
            Mt(b), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", K), Mt(null);
            break;
          }
        }
        b.ref !== null && (Mt(b), v("Invalid attribute `ref` supplied to `React.Fragment`."), Mt(null));
      }
    }
    function oa(b, _, F, K, ce, pe) {
      {
        var se = P(b);
        if (!se) {
          var ae = "";
          (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (ae += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ie = so(ce);
          Ie ? ae += Ie : ae += ra();
          var ye;
          b === null ? ye = "null" : Yn(b) ? ye = "array" : b !== void 0 && b.$$typeof === t ? (ye = "<" + (U(b.type) || "Unknown") + " />", ae = " Did you accidentally export a JSX literal instead of a component?") : ye = typeof b, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ye, ae);
        }
        var Ce = io(b, _, F, ce, pe);
        if (Ce == null)
          return Ce;
        if (se) {
          var We = _.children;
          if (We !== void 0)
            if (K)
              if (Yn(We)) {
                for (var Ft = 0; Ft < We.length; Ft++)
                  sa(We[Ft], b);
                Object.freeze && Object.freeze(We);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              sa(We, b);
        }
        return b === r ? co(Ce) : lo(Ce), Ce;
      }
    }
    function uo(b, _, F) {
      return oa(b, _, F, !0);
    }
    function fo(b, _, F) {
      return oa(b, _, F, !1);
    }
    var wo = fo, ho = uo;
    rn.Fragment = r, rn.jsx = wo, rn.jsxs = ho;
  }()), rn;
}
process.env.NODE_ENV === "production" ? mr.exports = Mo() : mr.exports = Fo();
var i = mr.exports;
const Lt = (e) => {
  const [t, n] = G(!e);
  return le(() => {
    if (e) {
      const [r, a] = e.replaceAll('"', "").split("="), s = document.querySelector(`input[name="${r}"]`);
      s == null || s.addEventListener("input", (o) => {
        n(o.target.value === a);
      });
    }
  }, [e]), { showElement: t };
}, An = (e, t) => {
  if (!Array.isArray(e))
    return {
      nodeType: "document",
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: e,
              nodeType: "text"
            }
          ],
          nodeType: t
        }
      ]
    };
  const n = e.map((r) => ({
    data: {},
    content: [
      {
        data: {},
        marks: [],
        value: r,
        nodeType: "text"
      }
    ],
    nodeType: t
  }));
  return {
    nodeType: "document",
    data: {},
    content: [...n]
  };
}, kw = (e, t = "select") => ({
  control: t,
  options: Object.values(e)
}), Ui = {
  [Qe.SELF]: (e) => {
    window.location.href = e;
  },
  [Qe.BLANK]: (e) => {
    window.open(e);
  }
}, Do = (e) => ({ transitionDuration: `${700 + e * 100}ms` });
var ie;
(function(e) {
  e.FOCUS_WITHIN = "focus-within", e.FOCUS_VISIBLE = "focus-visible", e.FOCUS_VISIBLE_SHADOW = "focus-visible-shadow", e.NO_FOCUS = "no-focus";
})(ie || (ie = {}));
const ge = {
  [ie.FOCUS_WITHIN]: "focus-within:tw-outline focus-within:tw-outline-1 focus-within:tw-outline-offset focus-within:tw-outline-link focus-within:tw-drop-shadow-link",
  [ie.FOCUS_VISIBLE]: "focus-visible:tw-outline focus-visible:tw-outline-1 focus-visible:tw-outline-offset-0 focus-visible:tw-outline-link focus-visible:tw-drop-shadow-link",
  [ie.FOCUS_VISIBLE_SHADOW]: "focus-visible:tw-outline focus-visible:tw-outline-1 focus-visible:tw-outline-offset focus-visible:tw-outline-link focus-visible:tw-drop-shadow-link",
  [ie.NO_FOCUS]: "focus:tw-outline-none focus-visible:tw-outline-none focus:tw-drop-shadow-none focus-visible:tw-drop-shadow-none"
}, ko = (e, t) => {
  const { name: n } = t;
  let r = !1, a = "";
  return Object.keys(e).forEach((s) => {
    s === n && (r = !0, a = e[s]);
  }), r ? { error: r, errorMessage: a } : void 0;
}, fa = (e) => (t) => {
  const n = {};
  return Object.keys(t).forEach((r) => {
    const a = e.find((s) => s.name === r);
    a && !a.hiddenField && (a.required && !t[r] ? n[r] = a.errorMessage || "This field is required" : a.type === "email" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(t[r]) ? n[r] = a.errorMessage || "Invalid email address format" : a.type === "text" && a.allowLetterOnly && !/^[^0-9´]*$/i.test(t[r]) ? n[r] = a.errorMessage || "This field only allows letters" : a.type === "tel" && !/^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm.test(t[r]) ? n[r] = a.errorMessage || "Must be a valid phone number format, for example: 1234567890, (123) 456-7890, +31636363634, +3(123) 123-12-12" : a.minLength && String(t[r]).length < a.minLength ? n[r] = `Must be greater than ${a.minLength} characters` : a.maxLength && String(t[r]).length > a.maxLength ? n[r] = `Must be lower than ${a.maxLength} characters` : a.min && !isNaN(Number(t[r])) && Number(t[r]) < Number(a.min) ? n[r] = `Must be greater than or equal to ${a.min}` : a.max && !isNaN(Number(t[r])) && Number(t[r]) > Number(a.max) && (n[r] = `Must be lower than or equal to ${a.max}`));
  }), n;
}, Bo = (e) => (t) => {
  const n = {};
  return Object.keys(t).length && e.forEach((r) => {
    if (r && r.name) {
      if (r.showCondition) {
        const [a, s] = r.showCondition.replaceAll('"', "").split("="), o = document.querySelector(`input[name="${a}"]`);
        if (o && o.value !== s)
          return;
      }
      if (r.hiddenField)
        return;
      r.required && !t[r.name] ? n[r.name] = r.errorMessage || "This field is required" : r.type === "email" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(t[r.name]) ? n[r.name] = r.errorMessage || "Invalid email address format" : r.type === "text" && r.allowLetterOnly && !/^[^0-9´]*$/i.test(t[r.name]) ? n[r.name] = r.errorMessage || "This field only allows letters" : r.type === "tel" && !/^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm.test(t[r.name]) ? n[r.name] = r.errorMessage || "Must be a valid phone number format, for example: 1234567890, (123) 456-7890, +31636363634, +3(123) 123-12-12" : r.minLength && String(t[r.name]).length < r.minLength ? n[r.name] = `Must be greater than ${r.minLength} characters` : r.maxLength && String(t[r.name]).length > r.maxLength ? n[r.name] = `Must be lower than ${r.maxLength} characters` : r.min && !isNaN(Number(t[r.name])) && Number(t[r.name]) < Number(r.min) ? n[r.name] = `Must be greater than or equal to ${r.min}` : r.max && !isNaN(Number(t[r.name])) && Number(t[r.name]) > Number(r.max) && (n[r.name] = `Must be lower than or equal to ${r.max}`);
    }
  }), n;
}, wa = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), Wi = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0(4(?:[14]4|56)|[579])?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([3-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-4]))\\d{4}"], ["69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10, 13], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "200\\d{6}|(?:33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function Ho(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(Wi), e.apply(this, n);
}
function gr(e) {
  "@babel/helpers - typeof";
  return gr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gr(e);
}
function ha(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Go(e, t, n) {
  return t && ha(e.prototype, t), n && ha(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Vo(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Uo(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && hn(e, t);
}
function Wo(e) {
  var t = Yi();
  return function() {
    var r = pn(e), a;
    if (t) {
      var s = pn(this).constructor;
      a = Reflect.construct(r, arguments, s);
    } else
      a = r.apply(this, arguments);
    return zo(this, a);
  };
}
function zo(e, t) {
  if (t && (gr(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return zi(e);
}
function zi(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $r(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return $r = function(r) {
    if (r === null || !Yo(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r))
        return t.get(r);
      t.set(r, a);
    }
    function a() {
      return jn(r, arguments, pn(this).constructor);
    }
    return a.prototype = Object.create(r.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), hn(a, r);
  }, $r(e);
}
function jn(e, t, n) {
  return Yi() ? jn = Reflect.construct : jn = function(a, s, o) {
    var l = [null];
    l.push.apply(l, s);
    var d = Function.bind.apply(a, l), c = new d();
    return o && hn(c, o.prototype), c;
  }, jn.apply(null, arguments);
}
function Yi() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Yo(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function hn(e, t) {
  return hn = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, hn(e, t);
}
function pn(e) {
  return pn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, pn(e);
}
var ft = /* @__PURE__ */ function(e) {
  Uo(n, e);
  var t = Wo(n);
  function n(r) {
    var a;
    return Vo(this, n), a = t.call(this, r), Object.setPrototypeOf(zi(a), n.prototype), a.name = a.constructor.name, a;
  }
  return Go(n);
}(/* @__PURE__ */ $r(Error)), Vr = 2, Zo = 17, Xo = 3, Re = "0-9０-９٠-٩۰-۹", Ko = "-‐-―−ー－", qo = "／/", Jo = "．.", Qo = "  ­​⁠　", el = "()（）［］\\[\\]", tl = "~⁓∼～", Je = "".concat(Ko).concat(qo).concat(Jo).concat(Qo).concat(el).concat(tl), Bn = "+＋";
function pa(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), a = 0; a < 3; a++) {
    var s = Number(n[a]), o = Number(r[a]);
    if (s > o)
      return 1;
    if (o > s)
      return -1;
    if (!isNaN(s) && isNaN(o))
      return 1;
    if (isNaN(s) && !isNaN(o))
      return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
function In(e) {
  "@babel/helpers - typeof";
  return In = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, In(e);
}
function Hn(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ma(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Gn(e, t, n) {
  return t && ma(e.prototype, t), n && ma(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var nl = "1.2.0", rl = "1.7.35", ga = " ext. ", al = /^\d+$/, Se = /* @__PURE__ */ function() {
  function e(t) {
    Hn(this, e), ll(t), this.metadata = t, Zi.call(this, t);
  }
  return Gn(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && al.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new $a(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new $a(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[n];
        if (a)
          return a;
      } else {
        var s = this.countryCallingCodes()[n];
        if (s && s.length === 1 && s[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), $a = /* @__PURE__ */ function() {
  function e(t, n) {
    Hn(this, e), this.globalMetadataObject = n, this.metadata = t, Zi.call(this, n.metadata);
  }
  return Gn(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(a) {
        return new il(a, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && xa(this.types(), n))
        return new ol(xa(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? ga : this.metadata[13] || ga;
    }
  }]), e;
}(), il = /* @__PURE__ */ function() {
  function e(t, n) {
    Hn(this, e), this._format = t, this.metadata = n;
  }
  return Gn(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !sl.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), sl = /^\(?\$1\)?$/, ol = /* @__PURE__ */ function() {
  function e(t, n) {
    Hn(this, e), this.type = t, this.metadata = n;
  }
  return Gn(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function xa(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function ll(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Jn(e) || !Jn(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Jn(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + dl(e) + ": " + e, "."));
}
var Jn = function(t) {
  return In(t) === "object";
}, dl = function(t) {
  return In(t);
};
function Ur(e, t) {
  if (t = new Se(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Zi(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? pa(t, nl) === -1 ? this.v2 = !0 : pa(t, rl) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var cl = ";ext=", Dt = function(t) {
  return "([".concat(Re, "]{1,").concat(t, "})");
};
function Xi(e) {
  var t = "20", n = "15", r = "9", a = "6", s = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", l = "#?", d = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", c = "(?:[xｘ#＃~～]|int|ｉｎｔ)", f = "[- ]+", w = "[  \\t]*", u = "(?:,{2}|;)", p = cl + Dt(t), h = s + d + o + Dt(t) + l, m = s + c + o + Dt(r) + l, $ = f + Dt(a) + "#", g = w + u + o + Dt(n) + l, v = w + "(?:,)+" + o + Dt(r) + l;
  return p + "|" + h + "|" + m + "|" + $ + "|" + g + "|" + v;
}
var ul = "[" + Re + "]{" + Vr + "}", fl = "[" + Bn + "]{0,1}(?:[" + Je + "]*[" + Re + "]){3,}[" + Je + Re + "]*", wl = new RegExp("^[" + Bn + "]{0,1}(?:[" + Je + "]*[" + Re + "]){1,2}$", "i"), hl = fl + // Phone number extensions
"(?:" + Xi() + ")?", pl = new RegExp(
  // Either a short two-digit-only phone number
  "^" + ul + "$|^" + hl + "$",
  "i"
);
function ml(e) {
  return e.length >= Vr && pl.test(e);
}
function gl(e) {
  return wl.test(e);
}
var va = new RegExp("(?:" + Xi() + ")$", "i");
function $l(e) {
  var t = e.search(va);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(va), a = 1; a < r.length; ) {
    if (r[a])
      return {
        number: n,
        ext: r[a]
      };
    a++;
  }
}
function xl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = vl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vl(e, t) {
  if (e) {
    if (typeof e == "string")
      return ba(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ba(e, t);
  }
}
function ba(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var bl = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Ki(e) {
  return bl[e];
}
function On(e) {
  for (var t = "", n = xl(e.split("")), r; !(r = n()).done; ) {
    var a = r.value, s = Ki(a);
    s && (t += s);
  }
  return t;
}
function yl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Cl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Cl(e, t) {
  if (e) {
    if (typeof e == "string")
      return ya(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ya(e, t);
  }
}
function ya(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Ca(e) {
  for (var t = "", n = yl(e.split("")), r; !(r = n()).done; ) {
    var a = r.value;
    t += El(a, t) || "";
  }
  return t;
}
function El(e, t) {
  return e === "+" ? t ? void 0 : "+" : Ki(e);
}
function Nl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Tl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tl(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ea(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ea(e, t);
  }
}
function Ea(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Sl(e, t) {
  for (var n = e.slice(), r = Nl(t), a; !(a = r()).done; ) {
    var s = a.value;
    e.indexOf(s) < 0 && n.push(s);
  }
  return n.sort(function(o, l) {
    return o - l;
  });
}
function Vn(e, t) {
  return qi(e, void 0, t);
}
function qi(e, t, n) {
  var r = n.type(t), a = r && r.possibleLengths() || n.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  if (t === "FIXED_LINE_OR_MOBILE") {
    if (!n.type("FIXED_LINE"))
      return qi(e, "MOBILE", n);
    var s = n.type("MOBILE");
    s && (a = Sl(a, s.possibleLengths()));
  } else if (t && !r)
    return "INVALID_LENGTH";
  var o = e.length, l = a[0];
  return l === o ? "IS_POSSIBLE" : l > o ? "TOO_SHORT" : a[a.length - 1] < o ? "TOO_LONG" : a.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function jl(e, t, n) {
  if (t === void 0 && (t = {}), n = new Se(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return Ji(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Ji(e, t) {
  switch (Vn(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function ct(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function Pl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Al(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Al(e, t) {
  if (e) {
    if (typeof e == "string")
      return Na(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Na(e, t);
  }
}
function Na(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Il = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Wr(e, t, n) {
  if (t = t || {}, !!e.country) {
    n = new Se(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (ct(r, n.nationalNumberPattern())) {
      if (Qn(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Qn(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = Pl(Il), s; !(s = a()).done; ) {
        var o = s.value;
        if (Qn(r, o, n))
          return o;
      }
    }
  }
}
function Qn(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : ct(e, t.pattern());
}
function Ol(e, t, n) {
  if (t = t || {}, n = new Se(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return Wr(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return ct(r, n.nationalNumberPattern());
}
function _l(e, t, n) {
  var r = new Se(n), a = r.getCountryCodesForCallingCode(e);
  return a ? a.filter(function(s) {
    return Ll(t, s, n);
  }) : [];
}
function Ll(e, t, n) {
  var r = new Se(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function Qi(e) {
  return e.replace(new RegExp("[".concat(Je, "]+"), "g"), " ").trim();
}
var es = /(\$\d)/;
function ts(e, t, n) {
  var r = n.useInternationalFormat, a = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var s = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && t.nationalPrefixFormattingRule() ? t.format().replace(es, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? Qi(s) : s;
}
var Rl = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Ml(e, t, n) {
  var r = new Se(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (Rl.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
function Fl(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function Dl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = kl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kl(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ta(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ta(e, t);
  }
}
function Ta(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Sa(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ja(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sa(Object(n), !0).forEach(function(r) {
      Bl(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sa(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Bl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Pa = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function Hl(e, t, n, r) {
  if (n ? n = ja(ja({}, Pa), n) : n = Pa, r = new Se(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else
    return e.phone || "";
  var a = r.countryCallingCode(), s = n.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return s ? (o = _n(s, e.carrierCode, "NATIONAL", r, n), er(o, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return s ? (o = _n(s, null, "INTERNATIONAL", r, n), o = "+".concat(a, " ").concat(o), er(o, e.ext, r, n.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(s);
    case "RFC3966":
      return Fl({
        number: "+".concat(a).concat(s),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var l = Vl(s, e.carrierCode, a, n.fromCountry, r);
      return er(l, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function _n(e, t, n, r, a) {
  var s = Gl(r.formats(), e);
  return s ? ts(e, s, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(s.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1),
    carrierCode: t,
    metadata: r
  }) : e;
}
function Gl(e, t) {
  for (var n = Dl(e), r; !(r = n()).done; ) {
    var a = r.value;
    if (a.leadingDigitsPatterns().length > 0) {
      var s = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
      if (t.search(s) !== 0)
        continue;
    }
    if (ct(t, a.pattern()))
      return a;
  }
}
function er(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function Vl(e, t, n, r, a) {
  var s = Ur(r, a.metadata);
  if (s === n) {
    var o = _n(e, t, "NATIONAL", a);
    return n === "1" ? n + " " + o : o;
  }
  var l = Ml(r, void 0, a.metadata);
  if (l)
    return "".concat(l, " ").concat(n, " ").concat(_n(e, null, "INTERNATIONAL", a));
}
function Aa(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ia(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Aa(Object(n), !0).forEach(function(r) {
      Ul(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Aa(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ul(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Wl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Oa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function zl(e, t, n) {
  return t && Oa(e.prototype, t), n && Oa(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var ns = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (Wl(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!r)
      throw new TypeError("`metadata` not passed");
    var a = Zl(t, r), s = a.country, o = a.countryCallingCode;
    this.country = s, this.countryCallingCode = o, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return zl(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : _l(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return jl(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return Ol(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new Se(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Wr(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return Hl(this, n, r ? Ia(Ia({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), Yl = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function Zl(e, t) {
  var n, r, a = new Se(t);
  return Yl(e) ? (n = e, a.selectNumberingPlan(n), r = a.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var Xl = new RegExp("([" + Re + "])");
function rs(e, t, n, r) {
  if (t) {
    var a = new Se(r);
    a.selectNumberingPlan(t, n);
    var s = new RegExp(a.IDDPrefix());
    if (e.search(s) === 0) {
      e = e.slice(e.match(s)[0].length);
      var o = e.match(Xl);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function xr(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var a, s, o = r.length - 1, l = o > 0 && r[o];
      if (t.nationalPrefixTransformRule() && l)
        a = e.replace(n, t.nationalPrefixTransformRule()), o > 1 && (s = r[1]);
      else {
        var d = r[0];
        a = e.slice(d.length), l && (s = r[1]);
      }
      var c;
      if (l) {
        var f = e.indexOf(r[1]), w = e.slice(0, f);
        w === t.numberingPlan.nationalPrefix() && (c = t.numberingPlan.nationalPrefix());
      } else
        c = r[0];
      return {
        nationalNumber: a,
        nationalPrefix: c,
        carrierCode: s
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function vr(e, t) {
  var n = xr(e, t), r = n.carrierCode, a = n.nationalNumber;
  if (a !== e) {
    if (!Kl(e, a, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !ql(a, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: r
  };
}
function Kl(e, t, n) {
  return !(ct(e, n.nationalNumberPattern()) && !ct(t, n.nationalNumberPattern()));
}
function ql(e, t) {
  switch (Vn(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function as(e, t, n, r) {
  var a = t ? Ur(t, r) : n;
  if (e.indexOf(a) === 0) {
    r = new Se(r), r.selectNumberingPlan(t, n);
    var s = e.slice(a.length), o = vr(s, r), l = o.nationalNumber, d = vr(e, r), c = d.nationalNumber;
    if (!ct(c, r.nationalNumberPattern()) && ct(l, r.nationalNumberPattern()) || Vn(c, r) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: s
      };
  }
  return {
    number: e
  };
}
function is(e, t, n, r) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var s = rs(e, t, n, r);
    if (s && s !== e)
      a = !0, e = "+" + s;
    else {
      if (t || n) {
        var o = as(e, t, n, r), l = o.countryCallingCode, d = o.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: d
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new Se(r);
  for (var c = 2; c - 1 <= Xo && c <= e.length; ) {
    var f = e.slice(1, c);
    if (r.hasCallingCode(f))
      return r.selectNumberingPlan(f), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: f,
        number: e.slice(c)
      };
    c++;
  }
  return {};
}
function Jl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Ql(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ql(e, t) {
  if (e) {
    if (typeof e == "string")
      return _a(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _a(e, t);
  }
}
function _a(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ss(e, t) {
  var n = t.countries, r = t.defaultCountry, a = t.metadata;
  a = new Se(a);
  for (var s = [], o = Jl(n), l; !(l = o()).done; ) {
    var d = l.value;
    if (a.country(d), a.leadingDigits()) {
      if (e && e.search(a.leadingDigits()) === 0)
        return d;
    } else if (Wr({
      phone: e,
      country: d
    }, void 0, a.metadata))
      if (r) {
        if (d === r)
          return d;
        s.push(d);
      } else
        return d;
  }
  if (s.length > 0)
    return s[0];
}
var ed = !1;
function os(e, t) {
  var n = t.nationalNumber, r = t.defaultCountry, a = t.metadata;
  if (ed && a.isNonGeographicCallingCode(e))
    return "001";
  var s = a.getCountryCodesForCallingCode(e);
  if (s)
    return s.length === 1 ? s[0] : ss(n, {
      countries: s,
      defaultCountry: r,
      metadata: a.metadata
    });
}
var ls = "+", td = "[\\-\\.\\(\\)]?", La = "([" + Re + "]|" + td + ")", nd = "^\\" + ls + La + "*[" + Re + "]" + La + "*$", rd = new RegExp(nd, "g"), br = Re, ad = "[" + br + "]+((\\-)*[" + br + "])*", id = "a-zA-Z", sd = "[" + id + "]+((\\-)*[" + br + "])*", od = "^(" + ad + "\\.)*" + sd + "\\.?$", ld = new RegExp(od, "g"), Ra = "tel:", yr = ";phone-context=", dd = ";isub=";
function cd(e) {
  var t = e.indexOf(yr);
  if (t < 0)
    return null;
  var n = t + yr.length;
  if (n >= e.length)
    return "";
  var r = e.indexOf(";", n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function ud(e) {
  return e === null ? !0 : e.length === 0 ? !1 : rd.test(e) || ld.test(e);
}
function fd(e, t) {
  var n = t.extractFormattedPhoneNumber, r = cd(e);
  if (!ud(r))
    throw new ft("NOT_A_NUMBER");
  var a;
  if (r === null)
    a = n(e) || "";
  else {
    a = "", r.charAt(0) === ls && (a += r);
    var s = e.indexOf(Ra), o;
    s >= 0 ? o = s + Ra.length : o = 0;
    var l = e.indexOf(yr);
    a += e.substring(o, l);
  }
  var d = a.indexOf(dd);
  if (d > 0 && (a = a.substring(0, d)), a !== "")
    return a;
}
var wd = 250, hd = new RegExp("[" + Bn + Re + "]"), pd = new RegExp("[^" + Re + "#]+$");
function md(e, t, n) {
  if (t = t || {}, n = new Se(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new ft("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = $d(e, t.v2, t.extract), a = r.number, s = r.ext, o = r.error;
  if (!a) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new ft("TOO_SHORT") : new ft("NOT_A_NUMBER");
    return {};
  }
  var l = vd(a, t.defaultCountry, t.defaultCallingCode, n), d = l.country, c = l.nationalNumber, f = l.countryCallingCode, w = l.countryCallingCodeSource, u = l.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new ft("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < Vr) {
    if (t.v2)
      throw new ft("TOO_SHORT");
    return {};
  }
  if (c.length > Zo) {
    if (t.v2)
      throw new ft("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var p = new ns(f, c, n.metadata);
    return d && (p.country = d), u && (p.carrierCode = u), s && (p.ext = s), p.__countryCallingCodeSource = w, p;
  }
  var h = (t.extended ? n.hasSelectedNumberingPlan() : d) ? ct(c, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: d,
    countryCallingCode: f,
    carrierCode: u,
    valid: h,
    possible: h ? !0 : !!(t.extended === !0 && n.possibleLengths() && Ji(c, n)),
    phone: c,
    ext: s
  } : h ? xd(d, c, s) : {};
}
function gd(e, t, n) {
  if (e) {
    if (e.length > wd) {
      if (n)
        throw new ft("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(hd);
    if (!(r < 0))
      return e.slice(r).replace(pd, "");
  }
}
function $d(e, t, n) {
  var r = fd(e, {
    extractFormattedPhoneNumber: function(o) {
      return gd(o, n, t);
    }
  });
  if (!r)
    return {};
  if (!ml(r))
    return gl(r) ? {
      error: "TOO_SHORT"
    } : {};
  var a = $l(r);
  return a.ext ? a : {
    number: r
  };
}
function xd(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function vd(e, t, n, r) {
  var a = is(Ca(e), t, n, r.metadata), s = a.countryCallingCodeSource, o = a.countryCallingCode, l = a.number, d;
  if (o)
    r.selectNumberingPlan(o);
  else if (l && (t || n))
    r.selectNumberingPlan(t, n), t && (d = t), o = n || Ur(t, r.metadata);
  else
    return {};
  if (!l)
    return {
      countryCallingCodeSource: s,
      countryCallingCode: o
    };
  var c = vr(Ca(l), r), f = c.nationalNumber, w = c.carrierCode, u = os(o, {
    nationalNumber: f,
    defaultCountry: t,
    metadata: r
  });
  return u && (d = u, u === "001" || r.country(d)), {
    country: d,
    countryCallingCode: o,
    countryCallingCodeSource: s,
    nationalNumber: f,
    carrierCode: w
  };
}
function Ma(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Fa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ma(Object(n), !0).forEach(function(r) {
      bd(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ma(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bd(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function yd(e, t, n) {
  return md(e, Fa(Fa({}, t), {}, {
    v2: !0
  }), n);
}
function Cr(e) {
  "@babel/helpers - typeof";
  return Cr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cr(e);
}
function Da(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Cd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Da(Object(n), !0).forEach(function(r) {
      Ed(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Da(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ed(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Nd(e, t) {
  return Pd(e) || jd(e, t) || Sd(e, t) || Td();
}
function Td() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sd(e, t) {
  if (e) {
    if (typeof e == "string")
      return ka(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ka(e, t);
  }
}
function ka(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function jd(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, s = !1, o, l;
    try {
      for (n = n.call(e); !(a = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); a = !0)
        ;
    } catch (d) {
      s = !0, l = d;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (s)
          throw l;
      }
    }
    return r;
  }
}
function Pd(e) {
  if (Array.isArray(e))
    return e;
}
function Ad(e) {
  var t = Array.prototype.slice.call(e), n = Nd(t, 4), r = n[0], a = n[1], s = n[2], o = n[3], l, d, c;
  if (typeof r == "string")
    l = r;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    o ? (d = s, c = o) : (d = void 0, c = s), a && (d = Cd({
      defaultCountry: a
    }, d));
  else if (Id(a))
    s ? (d = a, c = s) : c = a;
  else
    throw new Error("Invalid second argument: ".concat(a));
  return {
    text: l,
    options: d,
    metadata: c
  };
}
var Id = function(t) {
  return Cr(t) === "object";
};
function Od() {
  var e = Ad(arguments), t = e.text, n = e.options, r = e.metadata;
  return yd(t, n, r);
}
function _d(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ba(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ld(e, t, n) {
  return t && Ba(e.prototype, t), n && Ba(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Rd = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.onCountryChange, r = t.onCallingCodeChange;
    _d(this, e), this.onCountryChange = n, this.onCallingCodeChange = r;
  }
  return Ld(e, [{
    key: "reset",
    value: function(n) {
      var r = n.country, a = n.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, a);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(n) {
      for (var r = 0, a = Object.keys(n); r < a.length; r++) {
        var s = a[r];
        this[s] = n[s];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(n, r) {
      this.setCountry(n), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(n) {
      this.country = n, this.onCountryChange(n);
    }
  }, {
    key: "setCallingCode",
    value: function(n) {
      this.callingCode = n, this.onCallingCodeChange(n, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      this.international = !0, this.initCountryAndCallingCode(n, r);
    }
  }, {
    key: "appendDigits",
    value: function(n) {
      this.digits += n;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(n) {
      this.nationalSignificantNumber += n;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function Md(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Fd(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fd(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ha(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ha(e, t);
  }
}
function Ha(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Ke = "x", tr = new RegExp(Ke);
function Pn(e, t) {
  if (t < 1)
    return "";
  for (var n = ""; t > 1; )
    t & 1 && (n += e), t >>= 1, e += e;
  return n + e;
}
function Ga(e, t) {
  return e[t] === ")" && t++, Dd(e.slice(0, t));
}
function Dd(e) {
  for (var t = [], n = 0; n < e.length; )
    e[n] === "(" ? t.push(n) : e[n] === ")" && t.pop(), n++;
  var r = 0, a = "";
  t.push(e.length);
  for (var s = 0, o = t; s < o.length; s++) {
    var l = o[s];
    a += e.slice(r, l), r = l + 1;
  }
  return a;
}
function kd(e, t, n) {
  for (var r = Md(n.split("")), a; !(a = r()).done; ) {
    var s = a.value;
    if (e.slice(t + 1).search(tr) < 0)
      return;
    t = e.search(tr), e = e.replace(tr, s);
  }
  return [e, t];
}
function Bd(e, t, n) {
  var r = n.metadata, a = n.shouldTryNationalPrefixFormattingRule, s = n.getSeparatorAfterNationalPrefix, o = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (o.test(e.nationalSignificantNumber))
    return Gd(e, t, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: a,
      getSeparatorAfterNationalPrefix: s
    });
}
function Hd(e, t) {
  return Vn(e, t) === "IS_POSSIBLE";
}
function Gd(e, t, n) {
  var r = n.metadata, a = n.shouldTryNationalPrefixFormattingRule, s = n.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, a(t)) {
    var o = Va(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: s,
      metadata: r
    });
    if (o)
      return o;
  }
  return Va(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: s,
    metadata: r
  });
}
function Va(e, t, n) {
  var r = n.metadata, a = n.useNationalPrefixFormattingRule, s = n.getSeparatorAfterNationalPrefix, o = ts(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: a,
    metadata: r
  });
  if (a || (e.nationalPrefix ? o = e.nationalPrefix + s(t) + o : e.complexPrefixBeforeNationalSignificantNumber && (o = e.complexPrefixBeforeNationalSignificantNumber + " " + o)), Vd(o, e))
    return o;
}
function Vd(e, t) {
  return On(e) === t.getNationalDigits();
}
function Ud(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ua(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Wd(e, t, n) {
  return t && Ua(e.prototype, t), n && Ua(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var zd = /* @__PURE__ */ function() {
  function e() {
    Ud(this, e);
  }
  return Wd(e, [{
    key: "parse",
    value: function(n) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(n), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], a = r.branches, s = r.instructions;
      if (a)
        return {
          op: "|",
          args: a.concat([nr(s)])
        };
      if (s.length === 0)
        throw new Error("Pattern is required");
      return s.length === 1 ? s[0] : s;
    }
  }, {
    key: "startContext",
    value: function(n) {
      this.context.push(n);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(n) {
      if (!n)
        throw new Error("Pattern is required");
      var r = n.match(Xd);
      if (!r) {
        if (Zd.test(n))
          throw new Error("Illegal characters found in a pattern: ".concat(n));
        this.getContext().instructions = this.getContext().instructions.concat(n.split(""));
        return;
      }
      var a = r[1], s = n.slice(0, r.index), o = n.slice(r.index + a.length);
      switch (a) {
        case "(?:":
          s && this.parsePattern(s), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (s && this.parsePattern(s), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var l = this.getContext(), d = l.branches;
          d.push(nr(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: d
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (s && this.parsePattern(s), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(nr(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          s && this.parsePattern(s), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: Yd(s)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(a));
      }
      o && this.parsePattern(o);
    }
  }]), e;
}();
function Yd(e) {
  for (var t = [], n = 0; n < e.length; ) {
    if (e[n] === "-") {
      if (n === 0 || n === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var r = e[n - 1].charCodeAt(0) + 1, a = e[n + 1].charCodeAt(0) - 1, s = r; s <= a; )
        t.push(String.fromCharCode(s)), s++;
    } else
      t.push(e[n]);
    n++;
  }
  return t;
}
var Zd = /[\(\)\[\]\?\:\|]/, Xd = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function nr(e) {
  return e.length === 1 ? e[0] : e;
}
function Wa(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Kd(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kd(e, t) {
  if (e) {
    if (typeof e == "string")
      return za(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return za(e, t);
  }
}
function za(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function qd(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ya(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Jd(e, t, n) {
  return t && Ya(e.prototype, t), n && Ya(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Qd = /* @__PURE__ */ function() {
  function e(t) {
    qd(this, e), this.matchTree = new zd().parse(t);
  }
  return Jd(e, [{
    key: "match",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.allowOverflow;
      if (!n)
        throw new Error("String is required");
      var s = Er(n.split(""), this.matchTree, !0);
      if (s && s.match && delete s.matchedChars, !(s && s.overflow && !a))
        return s;
    }
  }]), e;
}();
function Er(e, t, n) {
  if (typeof t == "string") {
    var r = e.join("");
    return t.indexOf(r) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(t) === 0 ? n && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var a = e.slice(), s = 0; s < t.length; ) {
      var o = t[s], l = Er(a, o, n && s === t.length - 1);
      if (l) {
        if (l.overflow)
          return l;
        if (l.match) {
          if (a = a.slice(l.matchedChars.length), a.length === 0)
            return s === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (l.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(l, null, 2)));
        }
      } else
        return;
      s++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - a.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var d, c = Wa(t.args), f; !(f = c()).done; ) {
        var w = f.value, u = Er(e, w, n);
        if (u) {
          if (u.overflow)
            return u;
          if (u.match)
            return {
              match: !0,
              matchedChars: u.matchedChars
            };
          if (u.partialMatch)
            d = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(u, null, 2)));
        }
      }
      return d ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var p = Wa(t.args), h; !(h = p()).done; ) {
        var m = h.value;
        if (e[0] === m)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : n ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [m]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function Za(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = ec(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ec(e, t) {
  if (e) {
    if (typeof e == "string")
      return Xa(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Xa(e, t);
  }
}
function Xa(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function tc(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ka(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function nc(e, t, n) {
  return t && Ka(e.prototype, t), n && Ka(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Nr = "9", rc = 15, ac = Pn(Nr, rc), ic = /[- ]/, sc = function() {
  return /\[([^\[\]])*\]/g;
}, oc = function() {
  return /\d(?=[^,}][^,}])/g;
}, lc = new RegExp("[" + Je + "]*\\$1[" + Je + "]*(\\$\\d[" + Je + "]*)*$"), qa = 3, dc = /* @__PURE__ */ function() {
  function e(t) {
    t.state;
    var n = t.metadata;
    tc(this, e), this.metadata = n, this.resetFormat();
  }
  return nc(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(n, r) {
      this.resetFormat(), n ? (this.isNANP = n.callingCode() === "1", this.matchingFormats = n.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(n, r) {
      var a = this;
      if (Hd(r.nationalSignificantNumber, this.metadata))
        for (var s = Za(this.matchingFormats), o; !(o = s()).done; ) {
          var l = o.value, d = Bd(r, l, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(f) {
              return a.shouldTryNationalPrefixFormattingRule(f, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(f) {
              return a.getSeparatorAfterNationalPrefix(f);
            }
          });
          if (d)
            return this.resetFormat(), this.chosenFormat = l, this.setNationalNumberTemplate(d.replace(/\d/g, Ke), r), this.populatedNationalNumberTemplate = d, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(Ke), d;
        }
      return this.formatNationalNumberWithNextDigits(n, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(n, r) {
      var a = this.chosenFormat, s = this.chooseFormat(r);
      if (s)
        return s === a ? this.formatNextNationalNumberDigits(n) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(n) {
      var r = this, a = n.nationalSignificantNumber, s = n.nationalPrefix, o = n.international, l = a, d = l.length - qa;
      d < 0 && (d = 0), this.matchingFormats = this.matchingFormats.filter(function(c) {
        return r.formatSuits(c, o, s) && r.formatMatches(c, l, d);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(n, r, a) {
      return !(a && !n.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !n.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !a && n.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(n, r, a) {
      var s = n.leadingDigitsPatterns().length;
      if (s === 0)
        return !0;
      a = Math.min(a, s - 1);
      var o = n.leadingDigitsPatterns()[a];
      if (r.length < qa)
        try {
          return new Qd(o).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (l) {
          return console.error(l), !0;
        }
      return new RegExp("^(".concat(o, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(n, r) {
      return r ? n.internationalFormat() : n.format();
    }
  }, {
    key: "chooseFormat",
    value: function(n) {
      for (var r = this, a = function() {
        var c = o.value;
        return r.chosenFormat === c ? "break" : lc.test(r.getFormatFormat(c, n.international)) ? r.createTemplateForFormat(c, n) ? (r.chosenFormat = c, "break") : (r.matchingFormats = r.matchingFormats.filter(function(f) {
          return f !== c;
        }), "continue") : "continue";
      }, s = Za(this.matchingFormats.slice()), o; !(o = s()).done; ) {
        var l = a();
        if (l === "break")
          break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(n, r) {
      if (!(n.pattern().indexOf("|") >= 0)) {
        var a = this.getTemplateForFormat(n, r);
        if (a)
          return this.setNationalNumberTemplate(a, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(n) {
      return this.isNANP || n && n.nationalPrefixFormattingRule() && ic.test(n.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(n, r) {
      var a = n.IDDPrefix, s = n.missingPlus;
      return a ? r && r.spacing === !1 ? a : a + " " : s ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(n) {
      if (this.template) {
        for (var r = -1, a = 0, s = n.international ? this.getInternationalPrefixBeforeCountryCallingCode(n, {
          spacing: !1
        }) : ""; a < s.length + n.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(Ke, r + 1), a++;
        return Ga(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(n, r) {
      this.nationalNumberTemplate = n, this.populatedNationalNumberTemplate = n, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, Ke) + Pn(Ke, r.callingCode.length) + " " + n : this.template = n;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(n, r) {
      var a = r.nationalSignificantNumber, s = r.international, o = r.nationalPrefix, l = r.complexPrefixBeforeNationalSignificantNumber, d = n.pattern();
      d = d.replace(sc(), "\\d").replace(oc(), "\\d");
      var c = ac.match(d)[0];
      if (!(a.length > c.length)) {
        var f = new RegExp("^" + d + "$"), w = a.replace(/\d/g, Nr);
        f.test(w) && (c = w);
        var u = this.getFormatFormat(n, s), p;
        if (this.shouldTryNationalPrefixFormattingRule(n, {
          international: s,
          nationalPrefix: o
        })) {
          var h = u.replace(es, n.nationalPrefixFormattingRule());
          if (On(n.nationalPrefixFormattingRule()) === (o || "") + On("$1") && (u = h, p = !0, o))
            for (var m = o.length; m > 0; )
              u = u.replace(/\d/, Ke), m--;
        }
        var $ = c.replace(new RegExp(d), u).replace(new RegExp(Nr, "g"), Ke);
        return p || (l ? $ = Pn(Ke, l.length) + " " + $ : o && ($ = Pn(Ke, o.length) + this.getSeparatorAfterNationalPrefix(n) + $)), s && ($ = Qi($)), $;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(n) {
      var r = kd(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, n);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], Ga(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(n, r) {
      var a = r.international, s = r.nationalPrefix;
      if (n.nationalPrefixFormattingRule()) {
        var o = n.usesNationalPrefix();
        if (o && s || !o && !a)
          return !0;
      }
    }
  }]), e;
}();
function ds(e, t) {
  return wc(e) || fc(e, t) || uc(e, t) || cc();
}
function cc() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uc(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ja(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ja(e, t);
  }
}
function Ja(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function fc(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, s = !1, o, l;
    try {
      for (n = n.call(e); !(a = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); a = !0)
        ;
    } catch (d) {
      s = !0, l = d;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (s)
          throw l;
      }
    }
    return r;
  }
}
function wc(e) {
  if (Array.isArray(e))
    return e;
}
function hc(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Qa(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function pc(e, t, n) {
  return t && Qa(e.prototype, t), n && Qa(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var mc = "[" + Je + Re + "]+", gc = new RegExp("^" + mc + "$", "i"), $c = "(?:[" + Bn + "][" + Je + Re + "]*|[" + Je + Re + "]+)", xc = new RegExp("[^" + Je + Re + "]+.*$"), vc = /[^\d\[\]]/, bc = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.defaultCountry, r = t.defaultCallingCode, a = t.metadata, s = t.onNationalSignificantNumberChange;
    hc(this, e), this.defaultCountry = n, this.defaultCallingCode = r, this.metadata = a, this.onNationalSignificantNumberChange = s;
  }
  return pc(e, [{
    key: "input",
    value: function(n, r) {
      var a = Ec(n), s = ds(a, 2), o = s[0], l = s[1], d = On(o), c;
      return l && (r.digits || (r.startInternationalNumber(), d || (c = !0))), d && this.inputDigits(d, r), {
        digits: d,
        justLeadingPlus: c
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(n, r) {
      var a = r.digits, s = a.length < 3 && a.length + n.length >= 3;
      if (r.appendDigits(n), s && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(n);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(o) {
        return r.update(o);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(n) {
      var r = n.international, a = n.callingCode;
      return r && !a;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(n) {
      var r = is("+" + n.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = r.countryCallingCode, s = r.number;
      if (a)
        return n.setCallingCode(a), n.update({
          nationalSignificantNumber: s
        }), !0;
    }
  }, {
    key: "reset",
    value: function(n) {
      if (n) {
        this.hasSelectedNumberingPlan = !0;
        var r = n._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && vc.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(n, r) {
      if (this.hasSelectedNumberingPlan) {
        var a = xr(n, this.metadata), s = a.nationalPrefix, o = a.nationalNumber, l = a.carrierCode;
        if (o !== n)
          return this.onExtractedNationalNumber(s, l, o, n, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(n, r, a) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(n, a);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var s = xr(n, this.metadata), o = s.nationalPrefix, l = s.nationalNumber, d = s.carrierCode;
        if (l !== r)
          return this.onExtractedNationalNumber(o, d, l, n, a), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(n, r, a, s, o) {
      var l, d, c = s.lastIndexOf(a);
      if (c >= 0 && c === s.length - a.length) {
        d = !0;
        var f = s.slice(0, c);
        f !== n && (l = f);
      }
      o({
        nationalPrefix: n,
        carrierCode: r,
        nationalSignificantNumber: a,
        nationalSignificantNumberMatchesInput: d,
        complexPrefixBeforeNationalSignificantNumber: l
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(n) {
      if (this.extractAnotherNationalSignificantNumber(n.getNationalDigits(), n.nationalSignificantNumber, function(r) {
        return n.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
      if (this.fixMissingPlus(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(n) {
      var r = n.international, a = n.IDDPrefix, s = n.digits;
      if (n.nationalSignificantNumber, !(r || a)) {
        var o = rs(s, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (o !== void 0 && o !== s)
          return n.update({
            IDDPrefix: s.slice(0, s.length - o.length)
          }), this.startInternationalNumber(n, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(n) {
      if (!n.international) {
        var r = as(n.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = r.countryCallingCode;
        if (r.number, a)
          return n.update({
            missingPlus: !0
          }), this.startInternationalNumber(n, {
            country: n.country,
            callingCode: a
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      var a = r.country, s = r.callingCode;
      n.startInternationalNumber(a, s), n.nationalSignificantNumber && (n.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(n) {
      this.extractCountryCallingCode(n) && this.extractNationalSignificantNumber(n.getNationalDigits(), function(r) {
        return n.update(r);
      });
    }
  }]), e;
}();
function yc(e) {
  var t = e.search($c);
  if (!(t < 0)) {
    e = e.slice(t);
    var n;
    return e[0] === "+" && (n = !0, e = e.slice(1)), e = e.replace(xc, ""), n && (e = "+" + e), e;
  }
}
function Cc(e) {
  var t = yc(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function Ec(e) {
  var t = Cc(e), n = ds(t, 2), r = n[0], a = n[1];
  return gc.test(r) || (r = ""), [r, a];
}
function Tr(e) {
  "@babel/helpers - typeof";
  return Tr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tr(e);
}
function Nc(e, t) {
  return Pc(e) || jc(e, t) || Sc(e, t) || Tc();
}
function Tc() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sc(e, t) {
  if (e) {
    if (typeof e == "string")
      return ei(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ei(e, t);
  }
}
function ei(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function jc(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, s = !1, o, l;
    try {
      for (n = n.call(e); !(a = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); a = !0)
        ;
    } catch (d) {
      s = !0, l = d;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (s)
          throw l;
      }
    }
    return r;
  }
}
function Pc(e) {
  if (Array.isArray(e))
    return e;
}
function Ac(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ti(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ic(e, t, n) {
  return t && ti(e.prototype, t), n && ti(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var cs = /* @__PURE__ */ function() {
  function e(t, n) {
    Ac(this, e), this.metadata = new Se(n);
    var r = this.getCountryAndCallingCode(t), a = Nc(r, 2), s = a[0], o = a[1];
    this.defaultCountry = s, this.defaultCallingCode = o, this.reset();
  }
  return Ic(e, [{
    key: "getCountryAndCallingCode",
    value: function(n) {
      var r, a;
      return n && (Tr(n) === "object" ? (r = n.defaultCountry, a = n.defaultCallingCode) : r = n), r && !this.metadata.hasCountry(r) && (r = void 0), [r, a];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(n) {
      var r = this.parser.input(n, this.state), a = r.digits, s = r.justLeadingPlus;
      if (s)
        this.formattedOutput = "+";
      else if (a) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var o;
        if (this.metadata.hasSelectedNumberingPlan() && (o = this.formatter.format(a, this.state)), o === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var l = this.state.getNationalDigits();
          l && (o = this.formatter.format(l, this.state));
        }
        this.formattedOutput = o ? this.getFullNumber(o) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var n = this;
      return this.state = new Rd({
        onCountryChange: function(a) {
          n.country = a;
        },
        onCallingCodeChange: function(a, s) {
          n.metadata.selectNumberingPlan(s, a), n.formatter.reset(n.metadata.numberingPlan, n.state), n.parser.reset(n.metadata.numberingPlan);
        }
      }), this.formatter = new dc({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new bc({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          n.determineTheCountryIfNeeded(), n.formatter.reset(n.metadata.numberingPlan, n.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var n = this.state.digits;
      if (n)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var n = this.state.country;
      return n;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(n) {
      var r = this;
      if (this.isInternational()) {
        var a = function(l) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!l
          }) + l;
        }, s = this.state.callingCode;
        return a(s ? n ? "".concat(s, " ").concat(n) : s : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return n;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, a = n.complexPrefixBeforeNationalSignificantNumber, s = n.nationalPrefix, o = r, l = a || s;
      return l && (o = l + o), o;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var n = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(n ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var n = this.getNonFormattedNumber();
      if (n)
        return n.replace(/[\+\d]/g, Ke);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var n = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(n);
      return r && r.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(os(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var n = this.state, r = n.digits, a = n.callingCode, s = n.country, o = n.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return a ? "+" + a + o : "+" + r;
        if (s || a) {
          var l = s ? this.metadata.countryCallingCode() : a;
          return "+" + l + o;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, a = n.carrierCode, s = n.callingCode, o = this._getCountry();
      if (r && !(!o && !s)) {
        if (o && o === this.defaultCountry) {
          var l = new Se(this.metadata.metadata);
          l.selectNumberingPlan(o);
          var d = l.numberingPlan.callingCode(), c = this.metadata.getCountryCodesForCallingCode(d);
          if (c.length > 1) {
            var f = ss(r, {
              countries: c,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            f && (o = f);
          }
        }
        var w = new ns(o || s, r, this.metadata.metadata);
        return a && (w.carrierCode = a), w;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var n = this.getNumber();
      return n ? n.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var n = this.getNumber();
      return n ? n.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function us() {
  return Ho(Od, arguments);
}
function Ln(e) {
  return cs.call(this, e, Wi);
}
Ln.prototype = Object.create(cs.prototype, {});
Ln.prototype.constructor = Ln;
const Sr = (e, t) => {
  let n = "", r = "";
  return e.length > 6 ? (n = new Ln(t).input(e), r = us(n, t).format("E.164")) : (n = e, r = e), {
    mask: n,
    phoneNumber: r
  };
}, Oc = (e) => {
  let t = Ht;
  if (e.length > 6)
    try {
      const n = us(e);
      return t = _c(n.country || "US") || Ht, {
        country: t,
        ...Sr(n.nationalNumber, n.country || "US")
      };
    } catch {
      return {
        mask: e,
        country: t,
        phoneNumber: e
      };
    }
  else
    return {
      mask: e,
      country: t,
      phoneNumber: e
    };
  return {
    mask: e,
    country: t,
    defaultCountry: Ht,
    phoneNumber: e
  };
}, _c = (e) => sn.find((t) => t.code == e), Ht = {
  name: "United States",
  code: "US",
  dialCode: "+1"
}, ni = [
  Ht,
  {
    name: "Canada",
    code: "CA",
    dialCode: "+1"
  },
  {
    name: "United Kingdom",
    code: "GB",
    dialCode: "+44"
  }
], sn = [
  {
    name: "Afghanistan",
    dialCode: "+93",
    code: "AF"
  },
  {
    name: "Aland Islands",
    dialCode: "+358",
    code: "AX"
  },
  {
    name: "Albania",
    dialCode: "+355",
    code: "AL"
  },
  {
    name: "Algeria",
    dialCode: "+213",
    code: "DZ"
  },
  {
    name: "AmericanSamoa",
    dialCode: "+1684",
    code: "AS"
  },
  {
    name: "Andorra",
    dialCode: "+376",
    code: "AD"
  },
  {
    name: "Angola",
    dialCode: "+244",
    code: "AO"
  },
  {
    name: "Anguilla",
    dialCode: "+1264",
    code: "AI"
  },
  {
    name: "Antigua and Barbuda",
    dialCode: "+1268",
    code: "AG"
  },
  {
    name: "Argentina",
    dialCode: "+54",
    code: "AR"
  },
  {
    name: "Armenia",
    dialCode: "+374",
    code: "AM"
  },
  {
    name: "Aruba",
    dialCode: "+297",
    code: "AW"
  },
  {
    name: "Australia",
    dialCode: "+61",
    code: "AU"
  },
  {
    name: "Austria",
    dialCode: "+43",
    code: "AT"
  },
  {
    name: "Azerbaijan",
    dialCode: "+994",
    code: "AZ"
  },
  {
    name: "Bahamas",
    dialCode: "+1242",
    code: "BS"
  },
  {
    name: "Bahrain",
    dialCode: "+973",
    code: "BH"
  },
  {
    name: "Bangladesh",
    dialCode: "+880",
    code: "BD"
  },
  {
    name: "Barbados",
    dialCode: "+1246",
    code: "BB"
  },
  {
    name: "Belarus",
    dialCode: "+375",
    code: "BY"
  },
  {
    name: "Belgium",
    dialCode: "+32",
    code: "BE"
  },
  {
    name: "Belize",
    dialCode: "+501",
    code: "BZ"
  },
  {
    name: "Benin",
    dialCode: "+229",
    code: "BJ"
  },
  {
    name: "Bermuda",
    dialCode: "+1441",
    code: "BM"
  },
  {
    name: "Bhutan",
    dialCode: "+975",
    code: "BT"
  },
  {
    name: "Bolivia, Plurinational State of",
    dialCode: "+591",
    code: "BO"
  },
  {
    name: "Bosnia and Herzegovina",
    dialCode: "+387",
    code: "BA"
  },
  {
    name: "Botswana",
    dialCode: "+267",
    code: "BW"
  },
  {
    name: "Brazil",
    dialCode: "+55",
    code: "BR"
  },
  {
    name: "Brunei Darussalam",
    dialCode: "+673",
    code: "BN"
  },
  {
    name: "Bulgaria",
    dialCode: "+359",
    code: "BG"
  },
  {
    name: "Burkina Faso",
    dialCode: "+226",
    code: "BF"
  },
  {
    name: "Burundi",
    dialCode: "+257",
    code: "BI"
  },
  {
    name: "Cambodia",
    dialCode: "+855",
    code: "KH"
  },
  {
    name: "Cameroon",
    dialCode: "+237",
    code: "CM"
  },
  {
    name: "Canada",
    dialCode: "+1",
    code: "CA"
  },
  {
    name: "Cape Verde",
    dialCode: "+238",
    code: "CV"
  },
  {
    name: "Cayman Islands",
    dialCode: "+ 345",
    code: "KY"
  },
  {
    name: "Central African Republic",
    dialCode: "+236",
    code: "CF"
  },
  {
    name: "Chad",
    dialCode: "+235",
    code: "TD"
  },
  {
    name: "Chile",
    dialCode: "+56",
    code: "CL"
  },
  {
    name: "China",
    dialCode: "+86",
    code: "CN"
  },
  {
    name: "Christmas Island",
    dialCode: "+61",
    code: "CX"
  },
  {
    name: "Cocos (Keeling) Islands",
    dialCode: "+61",
    code: "CC"
  },
  {
    name: "Colombia",
    dialCode: "+57",
    code: "CO"
  },
  {
    name: "Comoros",
    dialCode: "+269",
    code: "KM"
  },
  {
    name: "Congo",
    dialCode: "+242",
    code: "CG"
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    dialCode: "+243",
    code: "CD"
  },
  {
    name: "Cook Islands",
    dialCode: "+682",
    code: "CK"
  },
  {
    name: "Costa Rica",
    dialCode: "+506",
    code: "CR"
  },
  {
    name: "Cote d'Ivoire",
    dialCode: "+225",
    code: "CI"
  },
  {
    name: "Croatia",
    dialCode: "+385",
    code: "HR"
  },
  {
    name: "Cuba",
    dialCode: "+53",
    code: "CU"
  },
  {
    name: "Cyprus",
    dialCode: "+357",
    code: "CY"
  },
  {
    name: "Czech Republic",
    dialCode: "+420",
    code: "CZ"
  },
  {
    name: "Denmark",
    dialCode: "+45",
    code: "DK"
  },
  {
    name: "Djibouti",
    dialCode: "+253",
    code: "DJ"
  },
  {
    name: "Dominica",
    dialCode: "+1767",
    code: "DM"
  },
  {
    name: "Dominican Republic",
    dialCode: "+1849",
    code: "DO"
  },
  {
    name: "Ecuador",
    dialCode: "+593",
    code: "EC"
  },
  {
    name: "Egypt",
    dialCode: "+20",
    code: "EG"
  },
  {
    name: "El Salvador",
    dialCode: "+503",
    code: "SV"
  },
  {
    name: "Equatorial Guinea",
    dialCode: "+240",
    code: "GQ"
  },
  {
    name: "Eritrea",
    dialCode: "+291",
    code: "ER"
  },
  {
    name: "Estonia",
    dialCode: "+372",
    code: "EE"
  },
  {
    name: "Ethiopia",
    dialCode: "+251",
    code: "ET"
  },
  {
    name: "Falkland Islands (Malvinas)",
    dialCode: "+500",
    code: "FK"
  },
  {
    name: "Faroe Islands",
    dialCode: "+298",
    code: "FO"
  },
  {
    name: "Fiji",
    dialCode: "+679",
    code: "FJ"
  },
  {
    name: "Finland",
    dialCode: "+358",
    code: "FI"
  },
  {
    name: "France",
    dialCode: "+33",
    code: "FR"
  },
  {
    name: "French Polynesia",
    dialCode: "+689",
    code: "PF"
  },
  {
    name: "Gabon",
    dialCode: "+241",
    code: "GA"
  },
  {
    name: "Gambia",
    dialCode: "+220",
    code: "GM"
  },
  {
    name: "Georgia",
    dialCode: "+995",
    code: "GE"
  },
  {
    name: "Germany",
    dialCode: "+49",
    code: "DE"
  },
  {
    name: "Ghana",
    dialCode: "+233",
    code: "GH"
  },
  {
    name: "Gibraltar",
    dialCode: "+350",
    code: "GI"
  },
  {
    name: "Greece",
    dialCode: "+30",
    code: "GR"
  },
  {
    name: "Greenland",
    dialCode: "+299",
    code: "GL"
  },
  {
    name: "Grenada",
    dialCode: "+1473",
    code: "GD"
  },
  {
    name: "Guam",
    dialCode: "+1671",
    code: "GU"
  },
  {
    name: "Guatemala",
    dialCode: "+502",
    code: "GT"
  },
  {
    name: "Guernsey",
    dialCode: "+44",
    code: "GG"
  },
  {
    name: "Guinea",
    dialCode: "+224",
    code: "GN"
  },
  {
    name: "Guinea-Bissau",
    dialCode: "+245",
    code: "GW"
  },
  {
    name: "Guyana",
    dialCode: "+595",
    code: "GY"
  },
  {
    name: "Haiti",
    dialCode: "+509",
    code: "HT"
  },
  {
    name: "Holy See (Vatican City State)",
    dialCode: "+379",
    code: "VA"
  },
  {
    name: "Honduras",
    dialCode: "+504",
    code: "HN"
  },
  {
    name: "Hong Kong",
    dialCode: "+852",
    code: "HK"
  },
  {
    name: "Hungary",
    dialCode: "+36",
    code: "HU"
  },
  {
    name: "Iceland",
    dialCode: "+354",
    code: "IS"
  },
  {
    name: "India",
    dialCode: "+91",
    code: "IN"
  },
  {
    name: "Indonesia",
    dialCode: "+62",
    code: "ID"
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    dialCode: "+98",
    code: "IR"
  },
  {
    name: "Iraq",
    dialCode: "+964",
    code: "IQ"
  },
  {
    name: "Ireland",
    dialCode: "+353",
    code: "IE"
  },
  {
    name: "Isle of Man",
    dialCode: "+44",
    code: "IM"
  },
  {
    name: "Israel",
    dialCode: "+972",
    code: "IL"
  },
  {
    name: "Italy",
    dialCode: "+39",
    code: "IT"
  },
  {
    name: "Jamaica",
    dialCode: "+1876",
    code: "JM"
  },
  {
    name: "Japan",
    dialCode: "+81",
    code: "JP"
  },
  {
    name: "Jersey",
    dialCode: "+44",
    code: "JE"
  },
  {
    name: "Jordan",
    dialCode: "+962",
    code: "JO"
  },
  {
    name: "Kazakhstan",
    dialCode: "+77",
    code: "KZ"
  },
  {
    name: "Kenya",
    dialCode: "+254",
    code: "KE"
  },
  {
    name: "Kiribati",
    dialCode: "+686",
    code: "KI"
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dialCode: "+850",
    code: "KP"
  },
  {
    name: "Korea, Republic of South Korea",
    dialCode: "+82",
    code: "KR"
  },
  {
    name: "Kuwait",
    dialCode: "+965",
    code: "KW"
  },
  {
    name: "Kyrgyzstan",
    dialCode: "+996",
    code: "KG"
  },
  {
    name: "Laos",
    dialCode: "+856",
    code: "LA"
  },
  {
    name: "Latvia",
    dialCode: "+371",
    code: "LV"
  },
  {
    name: "Lebanon",
    dialCode: "+961",
    code: "LB"
  },
  {
    name: "Lesotho",
    dialCode: "+266",
    code: "LS"
  },
  {
    name: "Liberia",
    dialCode: "+231",
    code: "LR"
  },
  {
    name: "Libyan Arab Jamahiriya",
    dialCode: "+218",
    code: "LY"
  },
  {
    name: "Liechtenstein",
    dialCode: "+423",
    code: "LI"
  },
  {
    name: "Lithuania",
    dialCode: "+370",
    code: "LT"
  },
  {
    name: "Luxembourg",
    dialCode: "+352",
    code: "LU"
  },
  {
    name: "Macao",
    dialCode: "+853",
    code: "MO"
  },
  {
    name: "Macedonia",
    dialCode: "+389",
    code: "MK"
  },
  {
    name: "Madagascar",
    dialCode: "+261",
    code: "MG"
  },
  {
    name: "Malawi",
    dialCode: "+265",
    code: "MW"
  },
  {
    name: "Malaysia",
    dialCode: "+60",
    code: "MY"
  },
  {
    name: "Maldives",
    dialCode: "+960",
    code: "MV"
  },
  {
    name: "Mali",
    dialCode: "+223",
    code: "ML"
  },
  {
    name: "Malta",
    dialCode: "+356",
    code: "MT"
  },
  {
    name: "Marshall Islands",
    dialCode: "+692",
    code: "MH"
  },
  {
    name: "Martinique",
    dialCode: "+596",
    code: "MQ"
  },
  {
    name: "Mauritania",
    dialCode: "+222",
    code: "MR"
  },
  {
    name: "Mauritius",
    dialCode: "+230",
    code: "MU"
  },
  {
    name: "Mayotte",
    dialCode: "+262",
    code: "YT"
  },
  {
    name: "Mexico",
    dialCode: "+52",
    code: "MX"
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    dialCode: "+691",
    code: "FM"
  },
  {
    name: "Moldova",
    dialCode: "+373",
    code: "MD"
  },
  {
    name: "Monaco",
    dialCode: "+377",
    code: "MC"
  },
  {
    name: "Mongolia",
    dialCode: "+976",
    code: "MN"
  },
  {
    name: "Montenegro",
    dialCode: "+382",
    code: "ME"
  },
  {
    name: "Montserrat",
    dialCode: "+1664",
    code: "MS"
  },
  {
    name: "Morocco",
    dialCode: "+212",
    code: "MA"
  },
  {
    name: "Mozambique",
    dialCode: "+258",
    code: "MZ"
  },
  {
    name: "Myanmar",
    dialCode: "+95",
    code: "MM"
  },
  {
    name: "Namibia",
    dialCode: "+264",
    code: "NA"
  },
  {
    name: "Nauru",
    dialCode: "+674",
    code: "NR"
  },
  {
    name: "Nepal",
    dialCode: "+977",
    code: "NP"
  },
  {
    name: "Netherlands",
    dialCode: "+31",
    code: "NL"
  },
  {
    name: "New Caledonia",
    dialCode: "+687",
    code: "NC"
  },
  {
    name: "New Zealand",
    dialCode: "+64",
    code: "NZ"
  },
  {
    name: "Nicaragua",
    dialCode: "+505",
    code: "NI"
  },
  {
    name: "Niger",
    dialCode: "+227",
    code: "NE"
  },
  {
    name: "Nigeria",
    dialCode: "+234",
    code: "NG"
  },
  {
    name: "Niue",
    dialCode: "+683",
    code: "NU"
  },
  {
    name: "Norfolk Island",
    dialCode: "+672",
    code: "NF"
  },
  {
    name: "Northern Mariana Islands",
    dialCode: "+1670",
    code: "MP"
  },
  {
    name: "Norway",
    dialCode: "+47",
    code: "NO"
  },
  {
    name: "Oman",
    dialCode: "+968",
    code: "OM"
  },
  {
    name: "Pakistan",
    dialCode: "+92",
    code: "PK"
  },
  {
    name: "Palau",
    dialCode: "+680",
    code: "PW"
  },
  {
    name: "Palestinian Territory, Occupied",
    dialCode: "+970",
    code: "PS"
  },
  {
    name: "Panama",
    dialCode: "+507",
    code: "PA"
  },
  {
    name: "Papua New Guinea",
    dialCode: "+675",
    code: "PG"
  },
  {
    name: "Paraguay",
    dialCode: "+595",
    code: "PY"
  },
  {
    name: "Peru",
    dialCode: "+51",
    code: "PE"
  },
  {
    name: "Philippines",
    dialCode: "+63",
    code: "PH"
  },
  {
    name: "Poland",
    dialCode: "+48",
    code: "PL"
  },
  {
    name: "Portugal",
    dialCode: "+351",
    code: "PT"
  },
  {
    name: "Puerto Rico",
    dialCode: "+1939",
    code: "PR"
  },
  {
    name: "Qatar",
    dialCode: "+974",
    code: "QA"
  },
  {
    name: "Romania",
    dialCode: "+40",
    code: "RO"
  },
  {
    name: "Russia",
    dialCode: "+7",
    code: "RU"
  },
  {
    name: "Rwanda",
    dialCode: "+250",
    code: "RW"
  },
  {
    name: "Reunion",
    dialCode: "+262",
    code: "RE"
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dialCode: "+290",
    code: "SH"
  },
  {
    name: "Saint Kitts and Nevis",
    dialCode: "+1869",
    code: "KN"
  },
  {
    name: "Saint Lucia",
    dialCode: "+1758",
    code: "LC"
  },
  {
    name: "Saint Martin",
    dialCode: "+590",
    code: "MF"
  },
  {
    name: "Saint Vincent and the Grenadines",
    dialCode: "+1784",
    code: "VC"
  },
  {
    name: "Samoa",
    dialCode: "+685",
    code: "WS"
  },
  {
    name: "San Marino",
    dialCode: "+378",
    code: "SM"
  },
  {
    name: "Sao Tome and Principe",
    dialCode: "+239",
    code: "ST"
  },
  {
    name: "Saudi Arabia",
    dialCode: "+966",
    code: "SA"
  },
  {
    name: "Senegal",
    dialCode: "+221",
    code: "SN"
  },
  {
    name: "Serbia",
    dialCode: "+381",
    code: "RS"
  },
  {
    name: "Seychelles",
    dialCode: "+248",
    code: "SC"
  },
  {
    name: "Sierra Leone",
    dialCode: "+232",
    code: "SL"
  },
  {
    name: "Singapore",
    dialCode: "+65",
    code: "SG"
  },
  {
    name: "Slovakia",
    dialCode: "+421",
    code: "SK"
  },
  {
    name: "Slovenia",
    dialCode: "+386",
    code: "SI"
  },
  {
    name: "Solomon Islands",
    dialCode: "+677",
    code: "SB"
  },
  {
    name: "Somalia",
    dialCode: "+252",
    code: "SO"
  },
  {
    name: "South Africa",
    dialCode: "+27",
    code: "ZA"
  },
  {
    name: "South Sudan",
    dialCode: "+211",
    code: "SS"
  },
  {
    name: "Spain",
    dialCode: "+34",
    code: "ES"
  },
  {
    name: "Sri Lanka",
    dialCode: "+94",
    code: "LK"
  },
  {
    name: "Sudan",
    dialCode: "+249",
    code: "SD"
  },
  {
    name: "Suriname",
    dialCode: "+597",
    code: "SR"
  },
  {
    name: "Swaziland",
    dialCode: "+268",
    code: "SZ"
  },
  {
    name: "Sweden",
    dialCode: "+46",
    code: "SE"
  },
  {
    name: "Switzerland",
    dialCode: "+41",
    code: "CH"
  },
  {
    name: "Syrian Arab Republic",
    dialCode: "+963",
    code: "SY"
  },
  {
    name: "Taiwan",
    dialCode: "+886",
    code: "TW"
  },
  {
    name: "Tajikistan",
    dialCode: "+992",
    code: "TJ"
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    dialCode: "+255",
    code: "TZ"
  },
  {
    name: "Thailand",
    dialCode: "+66",
    code: "TH"
  },
  {
    name: "Timor-Leste",
    dialCode: "+670",
    code: "TL"
  },
  {
    name: "Togo",
    dialCode: "+228",
    code: "TG"
  },
  {
    name: "Tokelau",
    dialCode: "+690",
    code: "TK"
  },
  {
    name: "Tonga",
    dialCode: "+676",
    code: "TO"
  },
  {
    name: "Trinidad and Tobago",
    dialCode: "+1868",
    code: "TT"
  },
  {
    name: "Tunisia",
    dialCode: "+216",
    code: "TN"
  },
  {
    name: "Turkey",
    dialCode: "+90",
    code: "TR"
  },
  {
    name: "Turkmenistan",
    dialCode: "+993",
    code: "TM"
  },
  {
    name: "Turks and Caicos Islands",
    dialCode: "+1649",
    code: "TC"
  },
  {
    name: "Tuvalu",
    dialCode: "+688",
    code: "TV"
  },
  {
    name: "Uganda",
    dialCode: "+256",
    code: "UG"
  },
  {
    name: "Ukraine",
    dialCode: "+380",
    code: "UA"
  },
  {
    name: "United Arab Emirates",
    dialCode: "+971",
    code: "AE"
  },
  {
    name: "United Kingdom",
    dialCode: "+44",
    code: "GB"
  },
  {
    name: "United States",
    dialCode: "+1",
    code: "US"
  },
  {
    name: "Uruguay",
    dialCode: "+598",
    code: "UY"
  },
  {
    name: "Uzbekistan",
    dialCode: "+998",
    code: "UZ"
  },
  {
    name: "Vanuatu",
    dialCode: "+678",
    code: "VU"
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    dialCode: "+58",
    code: "VE"
  },
  {
    name: "Vietnam",
    dialCode: "+84",
    code: "VN"
  },
  {
    name: "Virgin Islands, British",
    dialCode: "+1284",
    code: "VG"
  },
  {
    name: "Virgin Islands, U.S.",
    dialCode: "+1340",
    code: "VI"
  },
  {
    name: "Wallis and Futuna",
    dialCode: "+681",
    code: "WF"
  },
  {
    name: "Yemen",
    dialCode: "+967",
    code: "YE"
  },
  {
    name: "Zambia",
    dialCode: "+260",
    code: "ZM"
  },
  {
    name: "Zimbabwe",
    dialCode: "+263",
    code: "ZW"
  }
], fs = "tw-text-secondary tw-caret-primary tw-rounded-none tw-border tw-border-outlined-gray tw-border-1 focus:tw-outline-none tw-py-3 tw-px-4 tw-h-12 disabled:tw-bg-outlined-gray disabled:tw-cursor-not-allowed disabled:placeholder:tw-text-secondary", jr = ({
  // eslint-disable-next-line unused-imports/no-unused-vars
  allowLetterOnly: e,
  hiddenField: t,
  dataTestId: n,
  disabled: r,
  error: a,
  errorMessage: s,
  fieldId: o = "",
  helperMessage: l = "",
  inputClassName: d = "",
  label: c = "",
  labelClassName: f = "",
  leftIcon: w,
  name: u = "",
  placeholder: p,
  rightIcon: h,
  type: m,
  value: $,
  required: g,
  showButtonPassword: v,
  onChange: C,
  onClick: y,
  showCondition: x,
  hasInfoButton: E,
  InfoButtonIcon: O,
  popover: I,
  textDecoration: B,
  isInputFocus: P,
  ...A
}) => {
  const [L, U] = G(!1), X = "tw-w-full tw-leading-6 focus:tw-border-primary focus:tw-text-dark", W = a ? "!tw-border-error !focus:tw-border-error" : "", Z = !!w, j = !!h, M = Z ? "tw-pl-14" : "", R = j ? "tw-pr-14" : "", N = "tw-absolute tw-inset-y-0 tw-flex tw-items-center", T = P ? "tw-border-primary tw-text-dark" : "", { showElement: k } = Lt(x);
  return k ? i.jsxs("div", { className: `tw-flex tw-flex-col tw-gap-1${t ? " tw-hidden" : ""}`, children: [c && i.jsxs("label", { htmlFor: o || u, className: `tw-text-secondary tw-text-sm tw-leading-4 tw-flex tw-gap-1 ${E ? "tw-items-center" : ""} ${f}`, children: [c, g && i.jsx(ne, { type: "asterisk", size: 8, color: "error", className: "tw-ml-1" }), E && i.jsx(Ys, { hasPopover: E, popover: I, name: u, children: i.jsx("button", { className: `${ge[ie.FOCUS_VISIBLE]} focus-visible:tw-rounded-full`, type: "button", children: i.jsx(ne, { type: O || "info", color: "link" }) }) })] }), i.jsxs("div", { className: "tw-relative", children: [i.jsx("input", { className: `${fs} ${X} ${W} ${M} ${R} ${d}`, "data-testid": n, disabled: r, id: o || u, name: u, placeholder: p, type: m === "password" && L ? "text" : m, value: $, required: g && k, onChange: C, onClick: y, ...A }), i.jsxs("div", { className: `${N} ${Z ? "tw-left-4" : B ? "tw-right-16" : "tw-right-4"}`, children: [v && i.jsx("button", { type: "button", className: "tw-underline", onClick: () => U(!L), children: L ? "hide" : "show" }), Z && !v && i.jsx(i.Fragment, { children: typeof w == "string" ? i.jsx(ne, { type: w, color: "gray", size: 18 }) : w }), j && !v && i.jsx(i.Fragment, { children: typeof h == "string" ? i.jsx(ne, { type: h, color: a ? "error" : "gray" }) : h })] }), !!B && i.jsx("div", { className: `tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-bg-subdued tw-px-5 tw-border tw-border-outlined-gray tw-border-1 ${T} ${W} !tw-border-l-0 `, children: i.jsx("span", { className: "tw-text-base tw-text-center tw-text-secondary", children: B }) })] }), !a && l && i.jsx("span", { className: "tw-text-secondary tw-text-sm tw-leading-4", children: l }), a && s && i.jsx("span", { className: "tw-text-error tw-text-sm tw-leading-4", children: s })] }) : null;
}, Lc = {
  [Bt.OPEN_URL]: (e, { actionValue: t, target: n }) => {
    typeof window !== void 0 && t && n && Ui[n](t);
  },
  [Bt.GO_BACK]: (e) => {
    typeof window !== void 0 && window.history.back();
  },
  [Bt.SCROLL_TO]: (e, { actionValue: t }) => {
    typeof window !== void 0 && t && (window.location.href = `${window.location.href}#${t}`);
  }
}, vn = {
  primary: {
    base: "tw-bg-primary tw-shadow-md",
    hover: "hover:tw-bg-primary-hover",
    active: "tw-text-white active:tw-bg-primary-active",
    disable: "tw-bg-light-disabled tw-text-secondary tw-cursor-not-allowed tw-shadow-none"
  },
  secondary: {
    base: "tw-bg-secondary tw-shadow-md",
    hover: "hover:tw-bg-secondary-hover",
    active: "tw-text-white active:tw-bg-secondary-active",
    disable: "tw-bg-light-disabled tw-text-secondary tw-cursor-not-allowed tw-shadow-none"
  },
  tertiary: {
    base: "tw-bg-white tw-ring-1 tw-ring-secondary tw-shadow-md",
    hover: "hover:tw-bg-light-hover",
    active: "tw-text-secondary active:tw-bg-light-active",
    disable: "tw-bg-light-disabled tw-text-secondary tw-cursor-not-allowed tw-shadow-none tw-ring-0"
  }
}, Rc = {
  default: "tw-px-8 tw-py-3 tw-text-base",
  compact: "tw-py-2 tw-px-4 tw-text-sm"
}, Mc = ({ size: e = 24, color: t, className: n = "", direction: r = "right", ...a }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: `${B0(r)} ${n}`, ...a, children: i.jsx("path", { d: "M21.776 16.703a.911.911 0 0 1-1.286.068l-8.485-7.64-8.487 7.64a.914.914 0 0 1-1.286-.067.912.912 0 0 1 .069-1.286l9.043-8.185a.913.913 0 0 1 1.22 0l9.043 8.186c.476.335.504.909.169 1.284Z", fill: t }) }), Fc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "m21.81 12.056-7.407 7.857a.82.82 0 0 1-.55.233.754.754 0 0 1-.498-.186.697.697 0 0 1-.05-1.009l6.281-6.663H2.741c-.41 0-.741-.32-.741-.674 0-.355.331-.755.74-.755h16.846l-6.282-6.665a.696.696 0 0 1 .05-1.009.761.761 0 0 1 1.047.049l7.407 7.858a.702.702 0 0 1 .001.964Z", fill: t }) }), Dc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M21.286 2a.715.715 0 0 0-.715.714v5.773C19.151 5.023 15.777 2.714 12 2.714a9.25 9.25 0 0 0-9.156 7.737.715.715 0 0 0 .585.826c.04.004.08.009.119.009a.715.715 0 0 0 .704-.596A7.83 7.83 0 0 1 12 4.143c3.236 0 6.13 2.003 7.304 5h-5.161a.716.716 0 0 0-.714.714c0 .393.321.714.714.714h7.143A.716.716 0 0 0 22 9.857V2.714A.715.715 0 0 0 21.286 2Zm-.755 10.723a.709.709 0 0 0-.822.586c-.597 3.794-3.856 6.548-7.75 6.548-3.235 0-6.129-2.003-7.303-5h5.201a.716.716 0 0 0 .714-.714.716.716 0 0 0-.714-.714H2.714a.715.715 0 0 0-.714.714v7.143a.715.715 0 0 0 1.429 0v-5.773C4.85 18.978 8.223 21.286 12 21.286c4.513 0 8.406-3.255 9.156-7.737.067-.393-.196-.759-.625-.826Z", fill: t }) }), kc = ({ size: e = 24, color: t, className: n = "", ...r }) => i.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: "none", viewBox: "0 0 8 8", className: n, ...r, children: i.jsx("path", { fill: t, d: "M2.88 7.66h1.248l-.24-3L6.36 6.412l.648-1.128-2.784-1.272 2.784-1.296-.648-1.104L3.888 3.34l.24-3H2.88l.24 3L.648 1.612 0 2.716l2.784 1.296L0 5.284l.648 1.128L3.12 4.66l-.24 3Z" }) }), Bc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M9.778 16.889c0 .305-.25.555-.556.555a.557.557 0 0 1-.555-.555v-3.333c0-.306.25-.556.555-.556.306 0 .556.25.556.556v3.333ZM12 12.999c.306 0 .556.25.556.556v3.334c0 .305-.25.555-.556.555a.557.557 0 0 1-.556-.555v-3.333c0-.306.25-.556.556-.556Zm3.333 3.89c0 .305-.25.555-.555.555a.557.557 0 0 1-.556-.555v-3.333c0-.306.25-.556.556-.556.305 0 .555.25.555.556v3.333ZM14.146 3.276l3.729 6.39h3.57c.305 0 .555.25.555.556 0 .306-.25.556-.556.556h-.833l-2.08 8.316c-.277.99-1.135 1.684-2.156 1.684H7.594c-.99 0-1.879-.695-2.126-1.684l-2.08-8.316h-.832a.556.556 0 0 1 0-1.111h3.569l3.73-6.391a.555.555 0 1 1 .957.56l-3.399 5.83h9.174l-3.4-5.83a.555.555 0 1 1 .959-.56Zm-7.6 15.55c.124.493.569.84 1.048.84h8.781c.51 0 .955-.347 1.08-.84l2.01-8.048H4.534l2.011 8.048Z", fill: t }) }), Hc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M4.472 4c.261 0 .464.162.515.39l.138.61h13.806c.635 0 1.14.633.963 1.27L18.8 10.154a5.512 5.512 0 0 0-.997-.144L18.931 6H5.353l1.338 6h6.565a5.459 5.459 0 0 0-.656 1H6.944l.456 2h4.622a5.314 5.314 0 0 0-.022.5c0 .169.006.334.022.5H7a.501.501 0 0 1-.487-.39L4.1 5H2.5a.5.5 0 1 1 0-1h1.972Zm1.5 14.25c0-.966.812-1.75 1.75-1.75.994 0 1.75.784 1.75 1.75S8.716 20 7.722 20a1.77 1.77 0 0 1-1.75-1.75Zm1.75.75c.444 0 .75-.334.75-.75a.731.731 0 0 0-.75-.75.767.767 0 0 0-.75.75c0 .416.362.75.75.75Zm11.881-4.853a.496.496 0 0 1 0 .706l-2.25 2.25a.496.496 0 0 1-.706 0l-1.25-1.25a.496.496 0 0 1 0-.706.496.496 0 0 1 .706 0l.897.897 1.897-1.897a.496.496 0 0 1 .706 0ZM13 15.5a4.501 4.501 0 0 1 9 0 4.501 4.501 0 0 1-9 0Zm4.5 3.5c1.934 0 3.5-1.566 3.5-3.5S19.434 12 17.5 12a3.498 3.498 0 0 0-3.5 3.5c0 1.934 1.566 3.5 3.5 3.5Z", fill: t }) }), Gc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M4.472 4c.261 0 .464.162.515.39l.138.61h13.806c.635 0 1.14.633.963 1.27L18.8 10.154a5.512 5.512 0 0 0-.997-.144L18.931 6H5.353l1.338 6h6.565a5.467 5.467 0 0 0-.656 1H6.944l.456 2h4.622a5.312 5.312 0 0 0-.022.5c0 .169.006.334.022.5H7a.501.501 0 0 1-.487-.39L4.1 5H2.5a.5.5 0 1 1 0-1h1.972Zm1.5 14.25c0-.966.812-1.75 1.75-1.75.994 0 1.75.784 1.75 1.75S8.716 20 7.722 20a1.77 1.77 0 0 1-1.75-1.75Zm1.75.75c.444 0 .75-.334.75-.75a.731.731 0 0 0-.75-.75.767.767 0 0 0-.75.75c0 .416.362.75.75.75Zm10.484-3.5 1.147 1.147a.496.496 0 0 1 0 .706.496.496 0 0 1-.706 0L17.5 16.206l-1.147 1.147a.496.496 0 0 1-.706 0 .496.496 0 0 1 0-.706l1.147-1.147-1.147-1.147a.496.496 0 0 1 0-.706.496.496 0 0 1 .706 0l1.147 1.147 1.147-1.147a.496.496 0 0 1 .706 0 .496.496 0 0 1 0 .706L18.206 15.5Zm3.794 0a4.501 4.501 0 0 1-9 0 4.501 4.501 0 0 1 9 0ZM17.5 12a3.498 3.498 0 0 0-3.5 3.5c0 1.934 1.566 3.5 3.5 3.5s3.5-1.566 3.5-3.5-1.566-3.5-3.5-3.5Z", fill: t }) }), Vc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M4.789 3c.26 0 .486.18.543.434l.154.681h15.4c.708 0 1.272.706 1.074 1.418l-1.883 6.694a1.116 1.116 0 0 1-1.073.812H7.514l.51 2.231H19.29a.56.56 0 0 1 .557.558.56.56 0 0 1-.557.558H7.577a.559.559 0 0 1-.543-.436L4.344 4.115H2.558a.558.558 0 1 1 0-1.115h2.23Zm.951 2.23 1.492 6.694h11.772l1.882-6.693H5.74Zm.722 13.665c0-1.077.875-1.952 1.952-1.952s1.952.875 1.952 1.952a1.953 1.953 0 0 1-3.904 0Zm1.952.837a.835.835 0 0 0 .836-.837.835.835 0 0 0-.836-.836.835.835 0 0 0-.837.836c0 .464.373.837.837.837Zm11.433-.837a1.953 1.953 0 0 1-3.904 0c0-1.077.875-1.952 1.952-1.952s1.952.875 1.952 1.952Zm-1.952-.836a.835.835 0 0 0-.836.836c0 .464.373.837.836.837a.835.835 0 0 0 .837-.837.835.835 0 0 0-.837-.836Z", fill: t }) }), Uc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M15 9.5C15 6.462 12.09 4 8.5 4S2 6.462 2 9.5c0 1.296.534 2.486 1.42 3.425a8.212 8.212 0 0 1-1.217 1.824A.74.74 0 0 0 2.74 16c1.693 0 3.055-.647 3.934-1.223.58.143 1.192.224 1.826.224 3.59 0 6.5-2.463 6.5-5.5ZM8.5 14c-.53 0-1.064-.066-1.586-.195l-.423-.105-.366.24c-.638.419-1.612.906-2.808 1.03a8.924 8.924 0 0 0 1.008-1.619l.289-.616-.466-.494C3.398 11.444 3 10.497 3 9.5 3 7.019 5.44 5 8.5 5S14 7.019 14 9.5 11.531 14 8.5 14Zm12.45 3.606A5.155 5.155 0 0 0 22 14.5c0-3.038-2.688-5.5-6-5.5L15.97 9c.014.165.03.33.03.499 0 .17-.014.336-.03.503.011 0 .02-.003.03-.003 2.757 0 5 2.019 5 4.5 0 .896-.294 1.764-.852 2.508l-.408.546.359.58c.205.331.412.616.581.835a6.013 6.013 0 0 1-1.697-.44l-.396-.166-.393.174A5.41 5.41 0 0 1 16 19c-2.345 0-4.303-1.466-4.84-3.428-.316.104-.641.191-.976.258C10.835 18.222 13.16 20 16 20c.932 0 1.81-.2 2.598-.548a6.842 6.842 0 0 0 2.661.548.74.74 0 0 0 .537-1.25c-.005-.006-.433-.475-.846-1.144Z", fill: t }) }), Wc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M21.79 5.21a.709.709 0 0 1 0 1.008L9.646 18.361a.709.709 0 0 1-1.009 0l-6.429-6.429a.713.713 0 0 1 0-1.008.71.71 0 0 1 1.01 0l5.923 5.923L20.78 5.21a.712.712 0 0 1 1.01 0Z", fill: t }) }), zc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", ...n, children: i.jsx("path", { d: "M1 0h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1Zm7.003 13 7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829L3.76 8.757 8.003 13Z", fill: t }) }), Yc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", ...n, children: i.jsx("path", { d: "M1 0h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1Zm1 2v14h14V2H2Zm6.003 11L3.76 8.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L8.003 13Z", fill: t }) }), Zc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "m15.309 12.184-2.684 2.683V7.625A.627.627 0 0 0 12 7a.627.627 0 0 0-.625.625v7.242l-2.684-2.683a.625.625 0 1 0-.883.883l3.75 3.75a.622.622 0 0 0 .884 0l3.75-3.75a.625.625 0 1 0-.883-.883ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.75c-4.824 0-8.75-3.926-8.75-8.75S7.176 3.25 12 3.25s8.75 3.926 8.75 8.75-3.926 8.75-8.75 8.75Z", fill: t }) }), Xc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M9.191 13.441a.62.62 0 0 1-.882 0l-2.5-2.5a.62.62 0 0 1 0-.882.62.62 0 0 1 .882 0l2.059 2.058 4.559-4.558a.62.62 0 0 1 .882 0 .62.62 0 0 1 0 .882l-5 5ZM20 10.5c0 5.523-4.477 10-10 10s-10-4.477-10-10S4.477.5 10 .5s10 4.477 10 10ZM10 1.75a8.75 8.75 0 1 0 .001 17.501A8.75 8.75 0 0 0 10 1.75Z", fill: t }) }), Kc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M5 6h2V4.5a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4c.275 0 .5.225.5.5s-.225.5-.5.5H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2V4.5a.5.5 0 1 1 1 0V6Zm7 8.75c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75h-1.5a.748.748 0 0 1-.75-.75v-1.5ZM14 16v-1h-1v1h1Zm.25-10a.75.75 0 0 1 .75.75v1.5c0 .416-.334.75-.75.75h-1.5a.748.748 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75h1.5ZM14 8V7h-1v1h1Zm-2 2.75c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75h-1.5a.748.748 0 0 1-.75-.75v-1.5ZM14 12v-1h-1v1h1Zm3.75 6a.748.748 0 0 1-.75-.75v-1.5c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75h-1.5Zm.25-2v1h1v-1h-1Zm-1-4.25c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75h-1.5a.748.748 0 0 1-.75-.75v-1.5ZM19 13v-1h-1v1h1Zm-1-7v3h2c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2h-9c-1.103 0-2-.897-2-2V6a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2Zm-1 4V6a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v12c0 .553.447 1 1 1h9c.553 0 1-.447 1-1v-7c0-.553-.447-1-1-1h-3ZM4.75 15a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75h1.5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75h-1.5ZM5 13v1h1v-1H5ZM4 8.75A.75.75 0 0 1 4.75 8h1.5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75h-1.5a.75.75 0 0 1-.75-.75v-1.5ZM6 10V9H5v1h1Z", fill: t }) }), qc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.75c-4.824 0-8.75-3.926-8.75-8.75S7.176 3.25 12 3.25s8.75 3.926 8.75 8.75-3.926 8.75-8.75 8.75Zm4.156-13.602a.625.625 0 0 0-.88.069L12 11.039 8.724 7.217a.631.631 0 0 0-.88-.069.624.624 0 0 0-.068.882l3.4 3.97-3.402 3.969a.624.624 0 1 0 .95.813L12 12.96l3.276 3.822a.624.624 0 0 0 .948-.814L12.824 12l3.402-3.969a.629.629 0 0 0-.07-.883Z", fill: t }) }), Jc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M19.764 19.764a.8.8 0 0 1-1.132 0L12 13.13l-6.634 6.634a.8.8 0 1 1-1.132-1.132L10.87 12 4.235 5.366a.8.8 0 1 1 1.132-1.132L12 10.87l6.634-6.634a.8.8 0 1 1 1.131 1.131L13.13 12l6.634 6.634c.315.31.315.82 0 1.13Z", fill: t }) }), Qc = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M22 12c0-5.524-4.476-10-10-10S2 6.476 2 12c0 4.991 3.657 9.128 8.438 9.879v-6.988h-2.54V12h2.54V9.797c0-2.506 1.491-3.89 3.776-3.89 1.095 0 2.24.195 2.24.195v2.46h-1.262c-1.242 0-1.63.77-1.63 1.561V12h2.774l-.444 2.89h-2.33v6.989C18.343 21.129 22 16.991 22 12Z", fill: t }) }), e0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "m18.27 6.895-4.16-4.16A2.502 2.502 0 0 0 12.34 2H6.5A2.5 2.5 0 0 0 4 4.5v15A2.5 2.5 0 0 0 6.5 22h10a2.5 2.5 0 0 0 2.5-2.5V8.66c0-.664-.262-1.297-.73-1.765Zm-.887.882c.137.133.226.297.285.473h-4.293a.627.627 0 0 1-.625-.625V3.331c.175.061.338.15.473.285l4.16 4.161ZM17.75 19.5c0 .69-.56 1.25-1.25 1.25h-10c-.69 0-1.25-.56-1.25-1.25v-15c0-.689.56-1.25 1.25-1.25h5v4.375c0 1.035.84 1.875 1.875 1.875h4.375v10Z", fill: t }) }), t0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...n, children: i.jsx("path", { d: "M2 18.625c0-.344.28-.625.625-.625h2.563a3.127 3.127 0 0 1 3.062-2.5c1.512 0 2.738 1.074 3.063 2.5h10.062c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625H11.312c-.324 1.426-1.55 2.5-3.062 2.5a3.127 3.127 0 0 1-3.063-2.5H2.626A.626.626 0 0 1 2 18.625Zm8.125 0a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0ZM15.75 9.25c1.512 0 2.738 1.074 3.063 2.5h2.562c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625h-2.563c-.324 1.426-1.55 2.5-3.062 2.5a3.126 3.126 0 0 1-3.063-2.5H2.626a.626.626 0 0 1 0-1.25h10.063a3.126 3.126 0 0 1 3.062-2.5Zm1.875 3.125a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0Zm3.75-6.875a.626.626 0 0 1 0 1.25h-8.813c-.324 1.426-1.55 2.5-3.062 2.5a3.126 3.126 0 0 1-3.063-2.5H2.626a.626.626 0 0 1 0-1.25h3.813A3.126 3.126 0 0 1 9.5 3c1.512 0 2.738 1.073 3.063 2.5h8.812Zm-13.75.625a1.875 1.875 0 1 0 3.751-.001 1.875 1.875 0 0 0-3.751.001Z", fill: t }) }), n0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 18.75c.652 0 1.578-.563 2.418-2.238.387-.774.71-1.742.906-2.762H8.641c.23 1.02.554 1.988.941 2.762.84 1.675 1.766 2.238 2.418 2.238ZM8.418 14.5h7.164c.11-.79.168-1.629.168-2.5s-.059-1.71-.168-2.5H8.418c-.11.79-.168 1.629-.168 2.5s.059 1.71.168 2.5Zm6.906-6.25a10.476 10.476 0 0 0-.906-2.762C13.578 3.81 12.652 3.25 12 3.25c-.652 0-1.578.561-2.418 2.238-.387.774-.71 1.707-.941 2.762h6.683ZM16.81 9.5c.136.8.191 1.637.191 2.5s-.055 1.7-.191 2.5h3.578a8.675 8.675 0 0 0 .363-2.5c0-.867-.125-1.707-.363-2.5h-3.578Zm-2.016-5.795c.82 1.107 1.469 2.686 1.844 4.545h3.27a8.764 8.764 0 0 0-5.114-4.545Zm-5.586 0A8.776 8.776 0 0 0 4.092 8.25h3.271c.375-1.86 1.024-3.438 1.844-4.545ZM3.25 12c0 .867.127 1.707.362 2.5h3.544C7.055 13.7 7 12.863 7 12s.055-1.7.156-2.5H3.613A8.757 8.757 0 0 0 3.25 12Zm16.656 3.75h-3.27c-.374 1.86-1.023 3.438-1.843 4.543a8.754 8.754 0 0 0 5.113-4.543Zm-12.543 0h-3.27a8.766 8.766 0 0 0 5.114 4.543c-.82-1.105-1.469-2.684-1.844-4.543Z", fill: t }) }), r0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M2 4.714C2 4.32 2.32 4 2.714 4h18.572a.715.715 0 0 1 0 1.429H2.714A.714.714 0 0 1 2 4.714Zm0 7.143c0-.393.32-.714.714-.714h18.572c.393 0 .714.321.714.714a.716.716 0 0 1-.714.714H2.714A.715.715 0 0 1 2 11.857Zm19.286 7.857H2.714a.715.715 0 0 1 0-1.428h18.572c.393 0 .714.321.714.714a.716.716 0 0 1-.714.714Z", fill: t }) }), a0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M21.428 14.61c-.33-.3-.766-.464-1.222-.464-.435 0-.866.147-1.205.421l-2.139 1.713a.378.378 0 0 1-.236.083h-1.45c.162-.335.227-.722.166-1.122-.137-.975-1.032-1.66-2.01-1.66H8.307c-.723 0-1.396.235-2.002.67l-1.34 1H2.557a.558.558 0 0 0-.557.556c0 .306.25.527.526.527H5.31l1.631-1.228a2.248 2.248 0 0 1 1.336-.444h5.106a.835.835 0 1 1 0 1.67h-3.061a.56.56 0 0 0-.557.557.56.56 0 0 0 .557.556h6.272c.335 0 .66-.113.926-.322l2.145-1.713a.83.83 0 0 1 .509-.183.739.739 0 0 1 .448 1.318l-3.505 2.805a1.489 1.489 0 0 1-.93.326H2.557a.558.558 0 0 0-.557.556c0 .306.25.588.526.588h13.66c.592 0 1.162-.204 1.623-.57l3.512-2.808c.426-.34.678-.848.665-1.392.079-.545-.179-1.07-.558-1.44Zm-9.853-4.97c-.24-.038-.435-.093-1.323-.393a.556.556 0 1 0-.355 1.055c1.021.347 1.273.399 1.57.441v.61a.557.557 0 0 0 1.113 0v-.585c1.035-.122 1.761-.671 1.916-1.521.295-1.618-1.285-2.046-2.33-2.331l-.25-.07c-1.187-.362-1.347-.561-1.267-.984.104-.58.976-.714 1.791-.593.229.033.506.106.873.226a.556.556 0 1 0 .348-1.058 6.684 6.684 0 0 0-1.08-.272v-.608A.556.556 0 0 0 12.026 3c-.307 0-.59.25-.59.557v.585c-1.005.122-1.73.671-1.914 1.521-.26 1.597 1.33 2.043 2.092 2.255l.261.073c1.33.362 1.615.56 1.525 1.057-.105.579-.971.718-1.824.593Z", fill: t }) }), i0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M16.797 9.5H14a.5.5 0 1 0 0 1h2.797c.112 0 .203.09.203.203v1.406c0 .113-.09.203-.203.203H16.5a.5.5 0 0 0-.5.5v1.406c0 .517-.363.906-.844.906H15a.5.5 0 0 0-.5.5c0 .76-.617 1.376-1.375 1.376H9.5a.503.503 0 0 0-.248.065l-3.5 2a.5.5 0 0 0 .496.869l3.386-1.935h3.49a2.379 2.379 0 0 0 2.328-1.899C16.34 15.96 17 15.184 17 14.218v-.925c.567-.096 1-.59 1-1.185V10.7c0-.66-.541-1.201-1.203-1.201Zm-10.86 2.837c0-1.365.68-2.59 1.82-3.275a.5.5 0 0 0 .17-.686c-.143-.236-.449-.342-.683-.17-1.36.816-2.204 2.234-2.297 3.834l-2.693 1.525a.5.5 0 1 0 .492.87l3.192-1.807v-.29ZM10.75 13c.965 0 1.75-.785 1.75-1.75V8.812a.5.5 0 1 0-1 0v2.438c0 .412-.338.75-.75.75a.752.752 0 0 1-.75-.75V7.687a.43.43 0 0 1 .204-.367 5.43 5.43 0 0 1 2.87-.82H15a.493.493 0 0 0 .23-.064c.009-.005.018-.003.026-.007l2.5-1.5a.5.5 0 1 0-.514-.858L14.862 5.5h-1.786c-1.203 0-2.379.336-3.4.972A1.424 1.424 0 0 0 9 7.687v3.563c0 .965.784 1.75 1.75 1.75ZM21.92 9.734c-.143-.234-.48-.303-.687-.156l-1.994 1.256a.5.5 0 1 0 .533.845l1.994-1.256c.233-.148.304-.483.154-.689Z", fill: t }) }), s0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "data-testid": "house-icon", ...n, children: i.jsx("path", { d: "M21.818 11.475c.229.2.25.524.017.784-.17.23-.524.25-.754.018l-1.299-1.146v6.873a2.778 2.778 0 0 1-2.778 2.778H7.001a2.778 2.778 0 0 1-2.778-2.778v-6.873l-1.3 1.146a.53.53 0 0 1-.784-.018c-.203-.26-.181-.583.049-.784l9.446-8.336a.557.557 0 0 1 .737 0l9.447 8.336ZM7 19.67h2.223v-5.557a1.11 1.11 0 0 1 1.112-1.111h3.334a1.11 1.11 0 0 1 1.111 1.111v5.557h2.223c.92 0 1.667-.747 1.667-1.667v-7.825l-6.668-5.882-6.669 5.882v7.825c0 .92.747 1.667 1.667 1.667Zm3.335 0h3.334v-5.557h-3.334v5.557Z", fill: t }) }), o0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.75c-4.824 0-8.75-3.926-8.75-8.75S7.176 3.25 12 3.25s8.75 3.926 8.75 8.75-3.926 8.75-8.75 8.75Zm0-11.563a.937.937 0 1 0 0-1.874.937.937 0 0 0 0 1.875Zm1.875 6.563h-1.25v-4.375A.627.627 0 0 0 12 10.75h-1.25a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h.625v3.75h-1.25a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h3.75a.625.625 0 1 0 0-1.25Z", fill: t }) }), l0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M18.111 18.444H5.333a2.222 2.222 0 0 1-2.222-2.222V6.778a.556.556 0 0 0-1.111 0v9.444a3.333 3.333 0 0 0 3.333 3.334h12.778a.556.556 0 0 0 0-1.112ZM19.778 4H7.556a2.223 2.223 0 0 0-2.223 2.222V14c0 1.227.995 2.222 2.223 2.222h12.222A2.222 2.222 0 0 0 22 14V6.222A2.223 2.223 0 0 0 19.778 4Zm-3.334 11.111H10.89v-.555c0-.92.746-1.667 1.667-1.667h2.222c.92 0 1.666.746 1.666 1.667v.555ZM20.89 14c0 .613-.499 1.111-1.111 1.111h-2.222v-.555a2.777 2.777 0 0 0-2.778-2.778h-2.222a2.777 2.777 0 0 0-2.778 2.778v.555H7.556A1.113 1.113 0 0 1 6.444 14V6.222c0-.612.5-1.11 1.112-1.11h12.222c.612 0 1.11.498 1.11 1.11V14Zm-7.222-7.778a2.222 2.222 0 1 0 0 4.444 2.222 2.222 0 0 0 0-4.444Zm0 3.334a1.113 1.113 0 0 1-1.111-1.112c0-.612.498-1.11 1.11-1.11.613 0 1.112.498 1.112 1.11 0 .613-.5 1.112-1.111 1.112Z", fill: t }) }), d0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M12.002 6.871a5.118 5.118 0 0 0-5.126 5.127 5.118 5.118 0 0 0 5.126 5.126 5.118 5.118 0 0 0 5.127-5.126 5.118 5.118 0 0 0-5.127-5.127Zm0 8.46a3.339 3.339 0 0 1-3.333-3.333 3.336 3.336 0 0 1 3.333-3.333 3.336 3.336 0 0 1 3.333 3.333c0 1.838-1.499 3.333-3.333 3.333Zm6.532-8.67c0 .665-.535 1.196-1.195 1.196a1.196 1.196 0 1 1 1.196-1.196Zm3.396 1.214c-.076-1.602-.442-3.02-1.615-4.19-1.17-1.169-2.588-1.534-4.19-1.615-1.65-.093-6.6-.093-8.25 0-1.597.076-3.016.442-4.19 1.611C2.512 4.85 2.151 6.269 2.07 7.871c-.093 1.65-.093 6.599 0 8.25.076 1.601.442 3.02 1.615 4.19 1.174 1.168 2.588 1.534 4.19 1.614 1.65.094 6.6.094 8.25 0 1.602-.076 3.02-.442 4.19-1.615 1.168-1.169 1.534-2.588 1.615-4.19.093-1.65.093-6.594 0-8.245Zm-2.133 10.017a3.375 3.375 0 0 1-1.9 1.9c-1.317.523-4.44.402-5.895.402-1.454 0-4.582.116-5.894-.401a3.374 3.374 0 0 1-1.9-1.901c-.523-1.316-.402-4.44-.402-5.894 0-1.455-.116-4.582.401-5.894a3.374 3.374 0 0 1 1.901-1.901c1.316-.522 4.44-.402 5.894-.402 1.455 0 4.582-.116 5.894.402a3.374 3.374 0 0 1 1.901 1.9c.522 1.317.401 4.44.401 5.895 0 1.454.121 4.582-.401 5.894Z", fill: t }) }), c0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M20.571 2H3.424C2.638 2 2 2.647 2 3.442v17.116C2 21.353 2.638 22 3.424 22h17.147c.786 0 1.429-.647 1.429-1.442V3.442C22 2.647 21.357 2 20.571 2ZM8.045 19.143H5.08V9.598h2.97v9.545h-.005ZM6.563 8.295a1.72 1.72 0 0 1 0-3.438c.946 0 1.718.772 1.718 1.719 0 .95-.768 1.719-1.719 1.719Zm12.593 10.848h-2.964V14.5c0-1.107-.022-2.531-1.54-2.531-1.545 0-1.781 1.205-1.781 2.45v4.724H9.905V9.598h2.844v1.304h.04c.398-.75 1.366-1.54 2.808-1.54 3 0 3.558 1.977 3.558 4.549v5.232Z", fill: t }) }), u0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M19.5 4h-15A2.5 2.5 0 0 0 2 6.5v10A2.5 2.5 0 0 0 4.5 19h15a2.5 2.5 0 0 0 2.5-2.5v-10C22 5.12 20.879 4 19.5 4Zm-15 1.25h15c.69 0 1.25.56 1.25 1.25v1.407l-7.625 5.718a1.886 1.886 0 0 1-2.251 0L3.25 7.906V6.5c0-.688.56-1.25 1.25-1.25ZM20.75 16.5c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25V9.434l6.875 5.191a3.123 3.123 0 0 0 3.75 0l6.875-5.191V16.5Z", fill: t }) }), f0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M22 11.77c0 .422-.346.769-.77.769H2.77a.769.769 0 1 1 0-1.539h18.46c.424 0 .77.346.77.77Z", fill: t }) }), w0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M18.597 22.213a.787.787 0 0 1-.788.787H6.787a.788.788 0 0 1 0-1.575h4.724V3.255L8.813 5.143a.787.787 0 1 1-.902-1.288l3.936-2.712c.24-.169.555-.19.815-.053.261.09.424.36.424.654v19.681h4.723a.79.79 0 0 1 .788.788Z", fill: t }) }), h0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm-1.25 7.465v5c0 .726-.559 1.285-1.25 1.285s-1.25-.559-1.25-1.25V9.465c0-.656.559-1.215 1.215-1.215s1.285.559 1.285 1.215Zm5 0v5c0 .726-.559 1.285-1.25 1.285s-1.25-.559-1.25-1.25V9.465c0-.656.559-1.215 1.215-1.215s1.285.559 1.285 1.215Z", fill: t }) }), p0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 4.944A1.947 1.947 0 0 1 5.056 6.89 1.947 1.947 0 0 1 3.11 4.944C3.111 3.872 3.983 3 5.056 3 6.128 3 7 3.872 7 4.944Zm-1.111 0a.834.834 0 1 0-.833.833.835.835 0 0 0 .833-.833ZM2 15.778a.556.556 0 0 1 1.111 0v4.444a.556.556 0 0 1-1.111 0v-4.444ZM8.667 8c0-.92.746-1.667 1.666-1.667h3.334A1.668 1.668 0 0 1 15.334 8v3.333c0 .195-.034.382-.096.556h.521a.552.552 0 0 0 .497-.307l1.47-2.88a2.185 2.185 0 0 1 2.002-1.258A2.276 2.276 0 0 1 22 9.715v3.194c0 .596-.322 1.151-.84 1.448l-3.123 1.784-1.054 4.215a.546.546 0 0 1-.507.422.555.555 0 0 1-.54-.69l1.111-4.445a.555.555 0 0 1 .264-.348l3.297-1.903a.552.552 0 0 0 .28-.482V9.715a1.162 1.162 0 0 0-2.2-.518l-1.44 2.882a1.66 1.66 0 0 1-1.491.921H8.243a1.66 1.66 0 0 1-1.492-.921l-1.44-2.882a1.162 1.162 0 0 0-2.2.518v3.195c0 .201.107.385.28.482l3.298 1.903c.132.075.227.201.263.348l1.112 4.445a.555.555 0 0 1-.54.69.546.546 0 0 1-.507-.422l-1.054-4.215-3.123-1.784A1.672 1.672 0 0 1 2 12.909V9.715c0-1.25 1.02-2.27 2.272-2.27.867 0 1.645.482 2.002 1.256l1.47 2.88c.094.19.285.308.497.308h.52a1.663 1.663 0 0 1-.094-.556V8Zm5 3.889c.305 0 .555-.25.555-.556V8a.557.557 0 0 0-.555-.556h-3.334A.557.557 0 0 0 9.778 8v3.333c0 .306.25.556.555.556h3.334ZM17 4.944c0 1.073.872 1.945 1.944 1.945a1.947 1.947 0 0 0 1.945-1.945A1.946 1.946 0 0 0 18.944 3 1.946 1.946 0 0 0 17 4.944Zm1.111 0c0-.459.375-.833.833-.833a.834.834 0 0 1 0 1.667.835.835 0 0 1-.833-.834ZM22 15.778a.556.556 0 0 0-1.111 0v4.444a.556.556 0 0 0 1.111 0v-4.444Z", fill: t }) }), m0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "m20.93 14.914-3.977-1.705a1.784 1.784 0 0 0-2.06.51L13.598 15.3a12.29 12.29 0 0 1-4.895-4.894l1.583-1.296a1.76 1.76 0 0 0 .502-2.064L9.085 3.069a1.776 1.776 0 0 0-2.024-1.024l-3.688.856A1.757 1.757 0 0 0 2 4.62C2 14.204 9.797 22 19.379 22c.83 0 1.54-.564 1.725-1.372l.852-3.69a1.777 1.777 0 0 0-1.026-2.024Zm-1.043 5.434a.525.525 0 0 1-.507.402c-8.895 0-16.13-7.234-16.13-16.129 0-.241.166-.448.405-.503l3.688-.856a.522.522 0 0 1 .595.3L9.64 7.536c.09.215.032.461-.148.61L7.52 9.762a.624.624 0 0 0-.165.758 13.53 13.53 0 0 0 6.13 6.128c.259.13.575.06.759-.164l1.617-1.973a.527.527 0 0 1 .605-.15l3.969 1.701c.23.1.357.35.301.595l-.85 3.69Z", fill: t }) }), g0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M22 12a9.998 9.998 0 0 1-12.96 9.552c.408-.665 1.017-1.754 1.242-2.62.121-.468.621-2.38.621-2.38.327.621 1.278 1.15 2.29 1.15 3.017 0 5.19-2.775 5.19-6.222 0-3.303-2.697-5.774-6.165-5.774-4.315 0-6.61 2.895-6.61 6.052 0 1.468.783 3.294 2.03 3.875.189.089.29.049.334-.133.032-.137.201-.819.278-1.133a.3.3 0 0 0-.069-.286c-.407-.504-.737-1.424-.737-2.283 0-2.205 1.669-4.338 4.516-4.338 2.455 0 4.177 1.673 4.177 4.068 0 2.706-1.367 4.58-3.145 4.58-.98 0-1.718-.81-1.48-1.806.282-1.19.827-2.471.827-3.33 0-.766-.412-1.407-1.266-1.407-1.005 0-1.81 1.036-1.81 2.427 0 .887.297 1.484.297 1.484s-.987 4.185-1.169 4.967c-.201.863-.12 2.081-.036 2.871A10.004 10.004 0 0 1 2 12C2 6.476 6.476 2 12 2s10 4.476 10 10Z", fill: t }) }), ws = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM8.875 8.562v6.876c0 .34.184.652.48.816.293.168.657.16.946-.016l5.625-3.437a.943.943 0 0 0 .449-.801.943.943 0 0 0-.45-.8l-5.624-3.438c-.29-.211-.653-.184-.946-.016a.932.932 0 0 0-.48.816Z", fill: t }) }), $0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M22 12c0 .423-.346.769-.77.769h-8.46v8.461a.77.77 0 1 1-1.54 0V12.77H2.77a.768.768 0 1 1 0-1.539h8.46V2.77a.768.768 0 1 1 1.54 0v8.461h8.46c.424 0 .77.346.77.77Z", fill: t }) }), x0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "m21.815 20.933-5.527-5.527c1.219-1.422 1.926-3.262 1.926-5.281A8.124 8.124 0 0 0 10.089 2C5.603 2 2 5.638 2 10.125c0 4.486 3.637 8.124 8.09 8.124 2.018 0 3.86-.74 5.28-1.959l5.528 5.527c.156.12.316.182.476.182.16 0 .32-.061.442-.183a.621.621 0 0 0 0-.883Zm-11.69-3.934a6.862 6.862 0 0 1-6.875-6.874 6.862 6.862 0 0 1 6.875-6.875 6.84 6.84 0 0 1 6.874 6.875 6.862 6.862 0 0 1-6.874 6.874Z", fill: t }) }), v0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M13.25 9.5h-2.5V7A.625.625 0 1 0 9.5 7v2.5H7a.627.627 0 0 0-.625.625c0 .343.281.625.625.625h2.5v2.5a.625.625 0 1 0 1.25 0v-2.5h2.5a.625.625 0 1 0 0-1.25Zm8.565 11.433-5.527-5.527a8.083 8.083 0 0 0 1.961-5.281A8.124 8.124 0 0 0 10.125 2a8.125 8.125 0 0 0 0 16.25c2.018 0 3.86-.741 5.28-1.96l5.528 5.527a.622.622 0 0 0 .883-.001.621.621 0 0 0 0-.883Zm-11.69-3.934a6.862 6.862 0 0 1-6.875-6.874 6.862 6.862 0 0 1 6.875-6.875 6.84 6.84 0 0 1 6.874 6.875 6.862 6.862 0 0 1-6.874 6.874Z", fill: t }) }), b0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M22 5.571a3.57 3.57 0 0 1-3.571 3.572 3.442 3.442 0 0 1-2.594-1.156l-6.741 3.41c.031.197.049.398.049.603 0 .205-.018.406-.05.603l6.742 3.37A3.57 3.57 0 0 1 22 18.428 3.57 3.57 0 0 1 18.429 22a3.57 3.57 0 0 1-3.572-3.571c0-.433.076-.889.219-1.237l-6.505-3.25a3.568 3.568 0 0 1-3 1.63 3.571 3.571 0 1 1 0-7.143c1.26 0 2.362.647 3 1.629l6.505-3.25A3.571 3.571 0 1 1 22 5.571ZM5.531 14.143c1.223 0 2.143-.96 2.143-2.143 0-1.183-.92-2.143-2.143-2.143-1.143 0-2.143.96-2.143 2.143 0 1.183 1 2.143 2.143 2.143ZM18.43 3.429a2.143 2.143 0 1 0 0 4.286 2.143 2.143 0 0 0 0-4.286Zm0 17.142a2.143 2.143 0 1 0-.002-4.286 2.143 2.143 0 0 0 .002 4.286Z", fill: t }) }), y0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, className: `tw-animate-spin ${n.className}`, children: i.jsx("path", { d: "M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7V3Z", fill: t }) }), C0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M19.875 4.5a.626.626 0 0 1 0 1.25h-.715l-.996 13.93c-.09 1.308-1.215 2.32-2.492 2.32H7.828a2.499 2.499 0 0 1-2.494-2.32L4.339 5.75h-.714a.625.625 0 1 1 0-1.25H7.34l1.012-1.619A1.879 1.879 0 0 1 9.942 2h3.617c.644 0 1.246.333 1.554.881L16.16 4.5h3.715ZM9.941 3.25a.62.62 0 0 0-.527.294l-.598.956h5.868l-.598-.956a.62.62 0 0 0-.527-.294H9.94Zm7.965 2.5H5.593l.988 13.84a1.25 1.25 0 0 0 1.247 1.16h7.844c.656 0 1.2-.508 1.246-1.16l.988-13.84Z", fill: t }) }), E0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M8.809 10.309a.62.62 0 0 1 .882 0l2.059 2.058 2.059-2.058a.62.62 0 0 1 .882 0 .62.62 0 0 1 0 .882l-2.058 2.059 2.058 2.059a.62.62 0 0 1 0 .882.62.62 0 0 1-.882 0l-2.059-2.058-2.059 2.058a.62.62 0 0 1-.882 0 .62.62 0 0 1 0-.882l2.058-2.059-2.058-2.059a.62.62 0 0 1 0-.882Zm6.304-7.428L16.16 4.5h3.715a.626.626 0 0 1 0 1.25h-.715l-.996 13.93c-.09 1.308-1.215 2.32-2.492 2.32H7.828a2.499 2.499 0 0 1-2.494-2.32L4.339 5.75h-.714a.625.625 0 1 1 0-1.25H7.34l1.012-1.619A1.879 1.879 0 0 1 9.942 2h3.617c.644 0 1.246.333 1.554.881ZM8.816 4.5h5.868l-.598-.956a.62.62 0 0 0-.527-.294H9.94a.62.62 0 0 0-.527.294l-.598.956ZM6.581 19.59a1.25 1.25 0 0 0 1.247 1.16h7.844c.656 0 1.2-.508 1.246-1.16l.988-13.84H5.593l.988 13.84Z", fill: t }) }), N0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M9 9h.5c.275 0 .5.225.5.5s-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5V8c0-.275.225-.5.5-.5s.5.225.5.5v1Zm-4 .5C5 7.566 6.566 6 8.5 6S12 7.566 12 9.5 10.434 13 8.5 13A3.498 3.498 0 0 1 5 9.5ZM8.5 12a2.5 2.5 0 1 0 .001-4.999A2.5 2.5 0 0 0 8.5 12ZM4 17a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1h2.04c.438 0 .854.19 1.138.525l2.46 2.869c.234.272.362.618.362.975V16h.5c.275 0 .5.225.5.5s-.225.5-.5.5H20a3 3 0 0 1-3 3c-1.684 0-3-1.344-3-3H9.972c0 1.656-1.316 3-3 3a3 3 0 0 1-3-3H4ZM3 6v9a1 1 0 0 0 1 1h.17a3 3 0 0 1 5.658 0H14V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Zm12 5h4.84L17.42 8.175A.534.534 0 0 0 17.04 8H15v3Zm0 1v2.762c.503-.475 1.231-.762 2-.762 1.306 0 2.419.834 2.828 2H20v-4h-5Zm-8 3c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2Zm10 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2Z", fill: t }) }), T0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M5 6v1h4.5c.275 0 .5.225.5.5s-.225.5-.5.5h-7a.5.5 0 0 1 0-1H4V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v1h2.04c.438 0 .854.19 1.138.525l2.46 2.869c.234.272.362.618.362.975V16h.5c.275 0 .5.225.5.5s-.225.5-.5.5H20a3 3 0 0 1-3 3c-1.684 0-3-1.344-3-3H9.972c0 1.656-1.316 3-3 3a3 3 0 0 1-3-3v-4h1v1.762a3.043 3.043 0 0 1 2-.762c1.334 0 2.447.834 2.856 2H14V6a1 1 0 0 0-1-1H5.972c-.525 0-1 .448-1 1H5Zm12.419 2.175A.534.534 0 0 0 17.04 8H15v3h4.84L17.42 8.175ZM15 12v2.762c.503-.475 1.231-.762 2-.762 1.306 0 2.419.834 2.828 2H20v-4h-5Zm-8 3c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2Zm10 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2ZM10.5 9c.275 0 .5.225.5.5s-.225.5-.5.5h-7a.5.5 0 0 1 0-1h7Zm-1 2c.275 0 .5.225.5.5s-.225.5-.5.5h-7a.5.5 0 0 1 0-1h7Z", fill: t }) }), S0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M4 17.203c-1.105 0-2-.91-2-2.031v-9.14C2 4.908 2.895 4 4 4h9c1.103 0 2 .91 2 2.031v1.016h2.04c.438 0 .854.193 1.138.533l2.46 2.914c.234.276.362.628.362.99v4.704h.5c.275 0 .5.228.5.507 0 .28-.225.508-.5.508H20c0 1.682-1.344 3.047-3 3.047-1.684 0-3-1.365-3-3.047H9.972c0 1.682-1.316 3.047-3 3.047-1.656 0-3-1.365-3-3.047H4ZM3 6.031v9.14c0 .563.448 1.017 1 1.017h.17c.412-1.184 1.524-2.032 2.83-2.032a3 3 0 0 1 2.828 2.031H14V6.031c0-.56-.447-1.015-1-1.015H4c-.552 0-1 .454-1 1.015Zm16.84 5.078L17.42 8.24a.53.53 0 0 0-.378-.178H15v3.047h4.84ZM15 12.125v2.806c.503-.483 1.231-.775 2-.775a3 3 0 0 1 2.828 2.031H20v-4.062h-5Zm-8 3.047c-1.103 0-2 .91-2 2.031 0 1.12.897 2.031 2 2.031s2-.91 2-2.03c0-1.121-.897-2.032-2-2.032Zm10 4.062c1.103 0 2-.91 2-2.03 0-1.121-.897-2.032-2-2.032s-2 .91-2 2.031c0 1.12.897 2.031 2 2.031Z", fill: t }) }), j0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M11.738 5.75h.025c1.475 0 2.812.863 3.415 2.212.601 1.353.351 2.943-.64 4.035 0 .005 0-.005 0 0l.337.003c.645 0 1.246-.336 1.583-.883A4.944 4.944 0 0 0 16.75 9.5c0-2.764-2.236-5-5-5s-5 2.236-5 5c0 1.577.747 2.968 1.89 3.886-.007-.05-.015-.085-.015-.136A2.47 2.47 0 0 1 8.973 12a3.744 3.744 0 0 1-.655-4.035 3.743 3.743 0 0 1 3.42-2.215Zm-6.863 5a.622.622 0 0 0 .625-.625V9.5a6.256 6.256 0 0 1 6.25-6.25A6.256 6.256 0 0 1 18 9.5v.625a3.13 3.13 0 0 1-3.125 3.125h-1.25c0-.688-.562-1.25-1.25-1.25h-1.25c-.688 0-1.25.562-1.25 1.25s.562 1.25 1.25 1.25h3.75a4.38 4.38 0 0 0 4.375-4.375V9.5c0-4.137-3.364-7.5-7.5-7.5s-7.5 3.364-7.5 7.5v.625c0 .348.279.625.625.625Zm10.418 5H8.207A5.208 5.208 0 0 0 3 20.957 1.04 1.04 0 0 0 4.041 22h15.416a1.04 1.04 0 0 0 1.043-1.043 5.208 5.208 0 0 0-5.207-5.207Zm-11.038 5A3.963 3.963 0 0 1 8.21 17h7.082a3.963 3.963 0 0 1 3.953 3.75H4.255Z", fill: t }) }), P0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M11.75 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-8.75A3.754 3.754 0 0 1 15.5 7a3.754 3.754 0 0 1-3.75 3.75A3.755 3.755 0 0 1 8 7a3.755 3.755 0 0 1 3.75-3.75Zm1.981 10.626H9.77A6.77 6.77 0 0 0 3 20.646C3 21.393 3.606 22 4.354 22h14.794a1.351 1.351 0 0 0 1.353-1.354 6.77 6.77 0 0 0-6.77-6.77Zm5.414 6.875H4.354a.105.105 0 0 1-.104-.105 5.527 5.527 0 0 1 5.52-5.52h3.957a5.528 5.528 0 0 1 5.524 5.52.105.105 0 0 1-.106.105Z", fill: t }) }), A0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M14.44 11.378a7.732 7.732 0 0 1 3.2 1.97.5.5 0 1 0 .718-.697 8.768 8.768 0 0 0-5.616-2.615l1.699 1.342ZM12 6c3.497 0 6.828 1.401 9.138 3.844a.5.5 0 1 0 .725-.688C19.366 6.515 15.772 5 11.972 5c-1.569 0-3.131.287-4.594.802l.935.737A12.98 12.98 0 0 1 12 6ZM2.137 9.156a.5.5 0 0 0 .726.688c.46-.487.97-.92 1.505-1.32l-.809-.64c-.5.394-.984.81-1.422 1.272Zm3.507 3.494a.499.499 0 1 0 .713.698 7.74 7.74 0 0 1 2.161-1.55l-.864-.682a8.844 8.844 0 0 0-2.01 1.534Zm7.122 2.503A2 2 0 1 0 13.999 17c0-.446-.151-.854-.399-1.187l-.834-.659ZM12 18c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.45 1-1 1ZM2.81 4.107a.5.5 0 0 0-.62.785l19 15c.091.074.2.108.282.108a.5.5 0 0 0 .31-.892L2.81 4.107Z", fill: t }) }), I0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M12 1C8.14 1 5 4.532 5 8.873v6.254C5 19.468 8.14 23 12 23s7-3.532 7-7.873V8.872C19 4.532 15.859 1 12 1Zm5.6 14.17c0 3.474-2.512 6.3-5.6 6.3-3.088 0-5.6-2.826-5.6-6.3V8.873C6.4 5.4 8.912 2.574 12 2.574c3.088 0 5.6 2.825 5.6 6.298v6.299Z", fill: t }) }), O0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...n, children: i.jsx("path", { d: "M10.75 7.833a.418.418 0 0 0-.417.417V12c0 .46-.373.834-.833.834H2A.833.833 0 0 1 1.167 12V4.5c0-.46.373-.833.833-.833h2.917c.229 0 .416-.188.416-.417a.418.418 0 0 0-.416-.417H2C1.08 2.833.333 3.58.333 4.5V12c0 .92.746 1.667 1.667 1.667h7.5c.92 0 1.667-.746 1.667-1.667V8.25a.418.418 0 0 0-.417-.417Zm2.5-7.5H9.083a.417.417 0 0 0 0 .834h3.162L5.039 8.373a.416.416 0 1 0 .589.588l7.205-7.205v3.16c0 .23.188.417.417.417.23 0 .417-.187.417-.416V.75a.417.417 0 0 0-.417-.417Z", fill: t }) }), _0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M21.596 19.66 4.34 2.403A1.342 1.342 0 0 0 3.38 2C2.677 2 2 2.547 2 3.374v17.255A1.37 1.37 0 0 0 3.371 22h17.255c1.222 0 1.833-1.477.97-2.34Zm-.858 1.015c-.031.075-.08.075-.112.075H3.371a.121.121 0 0 1-.121-.121V3.374c0-.122.125-.124.131-.124.019 0 .04.003.076.038l2.882 2.883-.663.663a.313.313 0 0 0 0 .441l.442.442a.312.312 0 0 0 .443 0l.662-.663 1.768 1.768-.662.663a.313.313 0 0 0 0 .442l.441.442a.313.313 0 0 0 .443 0l.662-.663 1.768 1.768-.663.663a.313.313 0 0 0 0 .441l.442.442a.311.311 0 0 0 .442 0l.663-.663 1.768 1.768-.663.663a.313.313 0 0 0 0 .442l.442.441a.312.312 0 0 0 .442 0l.663-.662 1.768 1.767-.663.663a.313.313 0 0 0 0 .442l.441.442a.312.312 0 0 0 .443 0l.663-.663 2.882 2.882c.021.024.056.059.025.133ZM6.817 10.933a.626.626 0 0 0-1.067.442v6.25c0 .345.28.625.625.625h6.25a.624.624 0 0 0 .442-1.068l-6.25-6.25ZM7 17v-4.116L11.116 17H7Z", fill: t }) }), L0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M18.125 10C18.125 7.84512 17.269 5.77849 15.7452 4.25476C14.2215 2.73102 12.1549 1.875 10 1.875C7.84512 1.875 5.77849 2.73102 4.25476 4.25476C2.73102 5.77849 1.875 7.84512 1.875 10C1.875 12.1549 2.73102 14.2215 4.25476 15.7452C5.77849 17.269 7.84512 18.125 10 18.125C12.1549 18.125 14.2215 17.269 15.7452 15.7452C17.269 14.2215 18.125 12.1549 18.125 10ZM0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10Z", fill: t }) }), R0 = ({ size: e = 20, color: t, ...n }) => i.jsxs("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 16", ...n, children: [i.jsx("rect", { x: "0.5", width: e, height: e - 4, rx: "1", stroke: t, strokeWidth: "3" }), i.jsx("rect", { x: "0.5", width: e, height: e - 4, rx: "1", stroke: t, strokeWidth: "1" })] }), M0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { width: e, height: e, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: i.jsx("path", { d: "M23.4 4.40039C23.73 4.40039 24 4.66889 24 5.00039C24 5.33189 23.73 5.60039 23.4 5.60039H22.8V8.00039H23.4C23.73 8.00039 24 8.27039 24 8.60039C24 8.93039 23.73 9.20039 23.4 9.20039H22.8V11.0004H23.4C23.73 11.0004 24 11.2704 24 11.6004C24 11.9304 23.73 12.2004 23.4 12.2004H22.8V14.0004H23.4C23.73 14.0004 24 14.2704 24 14.6004C24 14.9304 23.73 15.2004 23.4 15.2004H22.8V17.6004H23.4C23.73 17.6004 24 17.8704 24 18.2004C24 18.5304 23.73 18.8004 23.4 18.8004H0.6C0.26865 18.8004 0 18.5304 0 18.2004C0 17.8704 0.26865 17.6004 0.6 17.6004H1.2V15.2004H0.6C0.26865 15.2004 0 14.9304 0 14.6004C0 14.2704 0.26865 14.0004 0.6 14.0004H1.2V12.2004H0.6C0.26865 12.2004 0 11.9304 0 11.6004C0 11.2704 0.26865 11.0004 0.6 11.0004H1.2V9.20039H0.6C0.26865 9.20039 0 8.93039 0 8.60039C0 8.27039 0.26865 8.00039 0.6 8.00039H1.2V5.60039H0.6C0.26865 5.60039 0 5.33189 0 5.00039C0 4.66889 0.26865 4.40039 0.6 4.40039H23.4ZM2.4 5.60039V17.6004H4.8V5.60039H2.4ZM19.2 17.6004H21.6V5.60039H19.2V17.6004ZM18 5.60039H6V17.6004H18V5.60039Z", fill: t }) }), F0 = ({ size: e = 26, color: t, ...n }) => i.jsxs("svg", { width: e, height: e - 1, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: [i.jsx("path", { d: "M0.5 1H24.5V25", stroke: t, strokeWidth: "1.5" }), i.jsx("path", { d: "M0.5 5.92383H19.5769V24.3854", stroke: t, strokeWidth: "1.5" }), i.jsx("path", { d: "M19.5769 5.92308L24.5 1", stroke: t, strokeWidth: "1.5" })] }), D0 = ({ size: e = 25, color: t, ...n }) => i.jsxs("svg", { width: e, height: e + 1, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...n, children: [i.jsx("path", { d: "M0.5 1H24.5V25", stroke: t, strokeWidth: "1.5" }), i.jsx("path", { d: "M0.5 5.92383H19.5769V24.3854", stroke: t, strokeWidth: "1.5" }), i.jsx("path", { d: "M19.5769 1V7.76923", stroke: t, strokeWidth: "1.5" })] }), k0 = ({ size: e = 24, color: t, ...n }) => i.jsx("svg", { version: "1.0", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, viewBox: "0 0 24 24", preserveAspectRatio: "xMidYMid meet", ...n, children: i.jsx("g", { transform: "translate(0.000000,24.000000) scale(0.000577,-0.000577)", fill: t, stroke: "none", children: i.jsx("path", { d: `M17895 32750 c-1248 -99 -2351 -510 -3330 -1241 -299 -224 -367 -286
                        -1205 -1098 -1875 -1820 -3551 -3449 -5255 -5106 -3720 -3617 -4257 -4147
                        -4450 -4384 -336 -413 -563 -766 -790 -1226 -382 -775 -593 -1564 -681 -2540
                        -21 -241 -30 -945 -15 -1171 74 -1075 363 -2131 841 -3069 708 -1388 1821
                        -2495 3206 -3188 902 -451 1874 -711 2989 -798 194 -16 -674 -15 9458 -5
                        l8268 9 6291 6246 c5720 5679 6289 6246 6262 6248 -16 1 -3863 59 -8549 129
                        -4686 70 -8522 128 -8524 130 -2 2 124 135 280 296 422 436 606 658 854 1033
                        598 901 936 1874 1037 2990 17 185 17 796 0 985 -75 834 -280 1572 -638 2290
                        -284 570 -595 1023 -1021 1485 -938 1019 -2250 1715 -3628 1925 -327 50 -492
                        62 -900 65 -214 2 -439 -1 -500 -5z m690 -910 c759 -41 1444 -221 2115 -556
                        555 -277 999 -602 1451 -1061 425 -431 728 -858 990 -1397 651 -1339 710
                        -2909 162 -4301 -67 -171 -228 -503 -324 -672 -164 -286 -400 -616 -626 -873
                        -111 -127 -6803 -6973 -6810 -6967 -2 2 4 61 12 132 91 781 -3 1626 -277 2474
                        -283 878 -675 1602 -1224 2262 -157 190 -558 593 -756 761 -720 612 -1632
                        1121 -2455 1369 -1091 329 -2268 379 -3396 146 -86 -18 -156 -30 -155 -26 5
                        13 7338 7217 7448 7317 1057 961 2453 1466 3845 1392z m-9240 -9480 c405 -36
                        760 -102 1142 -211 732 -210 1530 -646 2173 -1189 274 -231 600 -569 810 -840
                        502 -647 866 -1430 1064 -2290 92 -401 120 -652 121 -1075 0 -349 -8 -460 -51
                        -715 -123 -727 -456 -1430 -942 -1991 -113 -131 -377 -391 -502 -494 -972
                        -805 -2282 -1242 -3595 -1201 -1211 39 -2170 410 -2908 1126 -272 264 -477
                        538 -693 926 -277 499 -448 1009 -521 1554 -22 167 -25 609 -5 770 59 484 202
                        921 436 1335 408 721 1041 1305 1740 1605 421 181 821 262 1286 263 590 0
                        1127 -127 1632 -385 842 -429 1344 -1156 1453 -2103 19 -166 19 -474 0 -636
                        -50 -429 -195 -805 -429 -1117 -317 -420 -881 -748 -1399 -812 -208 -26 -478
                        -2 -691 61 -336 100 -688 341 -942 643 -291 347 -484 772 -564 1244 -11 68
                        -28 142 -37 165 -118 302 -512 389 -748 166 -106 -100 -152 -219 -142 -369 11
                        -177 101 -545 194 -794 53 -142 190 -430 264 -554 153 -254 298 -441 504 -648
                        184 -185 271 -257 479 -395 349 -233 732 -378 1147 -436 151 -20 497 -23 644
                        -4 407 52 801 190 1175 414 667 398 1119 977 1343 1717 196 649 195 1396 -4
                        2100 -62 221 -130 395 -239 615 -169 343 -350 594 -625 871 -313 315 -629 537
                        -1057 743 -823 396 -1821 535 -2698 375 -1365 -249 -2571 -1185 -3210 -2489
                        -239 -488 -385 -1004 -435 -1529 -17 -186 -20 -586 -4 -773 49 -602 214 -1183
                        504 -1779 413 -850 914 -1445 1620 -1923 720 -488 1521 -760 2510 -853 190
                        -18 939 -18 1135 0 833 76 1579 285 2315 647 559 275 1033 604 1450 1007 138
                        133 321 332 425 462 30 38 1627 1676 3548 3640 l3493 3571 97 -3 c151 -4
                        15400 -232 15550 -232 74 0 132 -4 130 -8 -1 -4 -2421 -2408 -5377 -5342
                        l-5373 -5335 -8322 -9 c-9208 -10 -8701 -10 -8916 5 -2168 144 -3993 1177
                        -5123 2899 -631 963 -1015 2142 -1088 3345 -14 227 -6 688 16 953 92 1102 397
                        2022 941 2839 l114 171 635 624 c606 595 641 627 764 709 214 143 373 234 636
                        364 727 360 1482 561 2311 615 162 11 680 5 839 -10z` }) }) }), de = ({ renderWrapper: e, disableFadding: t = !1, captionClassName: n, playButtonOverlay: r = !1, playButtonOverlaySize: a = 96, ...s }) => {
  const o = e || (() => i.jsx("img", { ...s, loading: "lazy", className: `tw-ease-in-out tw-duration-700 ${!t && "group-hover:tw-opacity-75"} tw-w-full tw-h-full ${s.className ?? ""}` }));
  return i.jsxs(i.Fragment, { children: [i.jsxs("div", { className: `tw-w-full tw-h-full tw-grid tw-relative ${s.className ?? ""}${r ? " tw-items-center" : ""}`, children: [o(s.className), r && i.jsx(ws, { color: "white", size: a, className: "tw-absolute tw-mx-auto tw-w-full" })] }), s.caption && i.jsx("span", { className: `tw-my-2 tw-mx-1 tw-text-secondary tw-text-sm tw-text-left tw-block tw-w-full ${n ?? ""}`, children: s.caption })] });
}, B0 = (e) => {
  switch (e) {
    case "right":
      return "tw-rotate-90";
    case "down":
      return "tw-rotate-180";
    case "left":
      return "-tw-rotate-90";
    default:
      return "";
  }
}, H0 = {
  "angle-icon": (e) => i.jsx(Mc, { ...e }),
  "arrows-rotate": (e) => i.jsx(Dc, { ...e }),
  "basket-shopping": (e) => i.jsx(Bc, { ...e }),
  "cart-check": (e) => i.jsx(Hc, { ...e }),
  "cart-error": (e) => i.jsx(Gc, { ...e }),
  "cart-shopping": (e) => i.jsx(Vc, { ...e }),
  "checkbox-outline": (e) => i.jsx(Yc, { ...e }),
  "circle-arrow-down": (e) => i.jsx(Zc, { ...e }),
  "circle-check": (e) => i.jsx(Xc, { ...e }),
  "close-circle": (e) => i.jsx(qc, { ...e }),
  "external-link": (e) => i.jsx(O0, { ...e }),
  "hand-holding-dollar": (e) => i.jsx(a0, { ...e }),
  "handshake-angle": (e) => i.jsx(i0, { ...e }),
  "pause-video": (e) => i.jsx(h0, { ...e }),
  "person-delivery": (e) => i.jsx(p0, { ...e }),
  "play-video": (e) => i.jsx(ws, { ...e }),
  "search-plus": (e) => i.jsx(v0, { ...e }),
  "share-nodes": (e) => i.jsx(b0, { ...e }),
  "trash-x": (e) => i.jsx(E0, { ...e }),
  "truck-clock": (e) => i.jsx(N0, { ...e }),
  "truck-fast": (e) => i.jsx(T0, { ...e }),
  "user-headset": (e) => i.jsx(j0, { ...e }),
  "wifi-no": (e) => i.jsx(A0, { ...e }),
  "mitered-corner": (e) => i.jsx(F0, { ...e }),
  "lapped-corner": (e) => i.jsx(D0, { ...e }),
  "wall-to-wall": (e) => i.jsx(k0, { ...e }),
  arrows: (e) => i.jsx(Fc, { ...e }),
  asterisk: (e) => i.jsx(kc, { ...e }),
  chat: (e) => i.jsx(Uc, { ...e }),
  check: (e) => i.jsx(Wc, { ...e }),
  checkbox: (e) => i.jsx(zc, { ...e }),
  city: (e) => i.jsx(Kc, { ...e }),
  close: (e) => i.jsx(Jc, { ...e }),
  facebook: (e) => i.jsx(Qc, { ...e }),
  file: (e) => i.jsx(e0, { ...e }),
  filters: (e) => i.jsx(t0, { ...e }),
  globe: (e) => i.jsx(n0, { ...e }),
  hamburger: (e) => i.jsx(r0, { ...e }),
  house: (e) => i.jsx(s0, { ...e }),
  image: (e) => i.jsx(l0, { ...e }),
  info: (e) => i.jsx(o0, { ...e }),
  instagram: (e) => i.jsx(d0, { ...e }),
  linkedin: (e) => i.jsx(c0, { ...e }),
  mail: (e) => i.jsx(u0, { ...e }),
  minus: (e) => i.jsx(f0, { ...e }),
  one: (e) => i.jsx(w0, { ...e }),
  phone: (e) => i.jsx(m0, { ...e }),
  pinterest: (e) => i.jsx(g0, { ...e }),
  plus: (e) => i.jsx($0, { ...e }),
  ruler: (e) => i.jsx(_0, { ...e }),
  search: (e) => i.jsx(x0, { ...e }),
  spinner: (e) => i.jsx(y0, { ...e }),
  trash: (e) => i.jsx(C0, { ...e }),
  truck: (e) => i.jsx(S0, { ...e }),
  user: (e) => i.jsx(P0, { ...e }),
  zero: (e) => i.jsx(I0, { ...e }),
  circle: (e) => i.jsx(L0, { ...e }),
  rectangle: (e) => i.jsx(R0, { ...e }),
  rug: (e) => i.jsx(M0, { ...e })
}, ne = ({ alt: e, type: t, src: n, ...r }) => {
  if (n)
    return i.jsx(de, { ...r, className: r.className, src: n, alt: e });
  if (t) {
    const a = H0[t];
    if (a)
      return a({ ...r, color: Oo[r.color ?? "currentColor"] });
  }
  return null;
};
var Me;
(function(e) {
  e.PRIMARY = "primary", e.SECONDARY = "secondary", e.TERTIARY = "tertiary";
})(Me || (Me = {}));
var De;
(function(e) {
  e.ENABLED = "enabled", e.DISABLED = "disabled", e.LOADING = "loading";
})(De || (De = {}));
var St;
(function(e) {
  e.DEFAULT = "default", e.COMPACT = "compact";
})(St || (St = {}));
const G0 = "tw-tracking-wider tw-font-bold tw-inline-flex tw-items-center tw-justify-center tw-font-normal tw-leading-4 tw-transition-colors", Te = Ot(({ ariaLabel: e, actionType: t, actionValue: n, className: r = "", icon: a, label: s, price: o, size: l = St.DEFAULT, state: d, target: c = Qe.SELF, type: f = "button", variant: w = Me.PRIMARY, focus: u = ie.FOCUS_VISIBLE, onClick: p, ...h }, m) => {
  const $ = nt((g) => {
    t && n && typeof n == "string" && Lc[t ?? Bt.OPEN_URL](g, { actionValue: n, target: c }), p && p(g);
  }, [t, n, p, c]);
  return i.jsxs("button", { "aria-label": e, className: `
            ${G0}
            ${Rc[l]}
            ${ge[u]}
            ${d === De.DISABLED || d === De.LOADING ? `${vn[w].disable}` : `${vn[w].base} ${vn[w].hover} ${vn[w].active}`}
            ${r}
          `, disabled: d === De.DISABLED || d === De.LOADING, onClick: $, ref: m, type: f, ...h, children: [a && i.jsx(ne, { className: "tw-w-4 tw-h-4", ...a }), i.jsx("span", { className: `tw-leading-5 ${a ? "tw-ml-2" : ""}`, children: s }), typeof o < "u" && w === Me.TERTIARY && i.jsx("span", { className: "tw-ml-3 tw-bg-secondary tw-rounded-full tw-text-white tw-py-0.5 tw-px-2 tw-text-price-tag tw-tracking-price-tag", children: `$ ${Math.max(o ?? 0, 0).toFixed(2)}` })] });
}), V0 = "tw-bg-subdued tw-cursor-pointer tw-text-secondary tw-caret-primary tw-ring-outlined-gray tw-ring-1 focus:tw-outline-none tw-py-3 tw-px-4", U0 = "tw-w-full tw-leading-6 focus:tw-ring-primary focus:tw-text-dark", W0 = "tw-pr-14", hs = ({ hiddenField: e, className: t = "", options: n, placeholder: r = "", currentOption: a, required: s, filterHandler: o, error: l, errorMessage: d, helperMessage: c = "", showCondition: f, childSelect: w, ...u }) => {
  const { label: p, labelClassName: h, onSelectChange: m } = u, [$, g] = G(!1), [v, C] = G(a && a.value ? a : null), [y, x] = G(void 0), { showElement: E } = Lt(f);
  le(() => {
    a || C(null);
  }, [a]);
  const O = xe(null), I = xe(null), B = (A) => {
    I.current && !I.current.contains(A.target) && g(!1);
  };
  le(() => (document.addEventListener("mousedown", B), () => {
    document.removeEventListener("mousedown", B);
  }), [I]);
  const P = (A) => {
    C(A), m && m(A, u.name ?? "no-name"), O.current && (O.current.value = A.value), typeof o == "function" && o(A), g(!1);
  };
  return le(() => {
    O.current && (v == null ? void 0 : v.value) !== "" && O.current.dispatchEvent(new Event("input", {
      bubbles: !0,
      cancelable: !1
    }));
  }, [v]), le(() => {
    if (!w || !w.options)
      return;
    const A = w.options.filter((L) => L.value === (v == null ? void 0 : v.value));
    x((A == null ? void 0 : A.length) === 0 ? void 0 : A[0].children);
  }, [v, w]), E ? i.jsxs(i.Fragment, { children: [i.jsxs("div", { className: `tw-relative tw-flex tw-flex-col tw-gap-1${e ? " tw-hidden" : ""}`, ref: I, children: [i.jsxs(qe, { value: v, onChange: P, children: [p && i.jsxs(qe.Label, { className: `tw-text-secondary tw-text-sm tw-leading-4 tw-flex tw-gap-1 ${h || ""}`, children: [p, s && i.jsx(ne, { type: "asterisk", size: 8, color: "error", className: "tw-ml-1" })] }), i.jsxs("div", { className: "tw-relative", children: [i.jsxs(qe.Button, { placeholder: r, className: `tw-flex tw-justify-between ${V0} ${U0} ${t}`, onClick: () => {
    g(!$);
  }, children: [i.jsx("span", { className: `tw-w-full tw-text-left ${W0}`, children: (v == null ? void 0 : v.label) ?? r }), i.jsx("span", { children: i.jsx(ne, { className: "h-5 w-5 text-gray-400", "aria-hidden": "true", type: "angle-icon", direction: $ ? "up" : "down", color: "gray" }) })] }), i.jsx(qe.Options, { className: "tw-absolute tw-top-full  tw-bg-white tw-w-full tw-mt-1 tw-z-50 tw-ring-1 tw-ring-outlined-gray cursor-default focus:tw-outline-none tw-max-h-60 tw-overflow-auto", children: n == null ? void 0 : n.map((A, L) => {
    const U = (A == null ? void 0 : A.value) === (v == null ? void 0 : v.value);
    return i.jsxs(qe.Option, { className: ({ active: X, selected: W }) => `tw-relative tw-cursor-default tw-select-none tw-flex tw-flex-row tw-gap-4
                  ${X ? "tw-text-dark tw-bg-light-hover" : ""} 
                  ${W ? "tw-text-dark" : "tw-text-secondary"}
                  tw-py-3 tw-px-4 tw-w-full tw-text-left`, value: A, children: [i.jsx("span", { children: A == null ? void 0 : A.label }), U && i.jsx("span", { children: i.jsx(ne, { type: "check", color: "secondary" }) })] }, L);
  }) })] })] }), i.jsx("input", { ref: O, type: "hidden", id: u.id, name: u.name, value: (v == null ? void 0 : v.value) ?? "" }), !l && c && i.jsx("span", { className: "tw-text-secondary tw-text-sm tw-leading-4", children: c }), l && d && i.jsx("span", { className: "tw-text-error tw-text-sm tw-leading-4", children: d })] }), w && (v == null ? void 0 : v.value) !== "" && y && w.name !== u.name ? i.jsx(Un, { ...u, ...w, options: y, onSelectChange: m, filterHandler: o, error: l, errorMessage: d }, `${v == null ? void 0 : v.value}-options`) : null] }) : null;
}, z0 = " tw-text-secondary tw-caret-primary  tw-ring-1 focus:tw-outline-none", Y0 = "tw-w-full tw-leading-6 focus:tw-ring-primary focus:tw-text-dark", Z0 = ({ hiddenField: e, className: t = "", placeholder: n = "", required: r, error: a, errorMessage: s, helperMessage: o = "", onBlur: l, dataTestId: d, disabled: c, fieldId: f = "phone", onClick: w, onCountryChange: u, onChange: p, value: h = "", showCondition: m, ...$ }) => {
  const g = a ? "tw-ring-error tw-ring-1" : "tw-ring-outlined-gray", { label: v, labelClassName: C, onSelectChange: y, name: x = "phone" } = $, [E, O] = G(!1), [I, B] = G(""), [P, A] = G(""), [L, U] = G(null), { showElement: X } = Lt(m), W = xe(null), Z = rt(() => sn.find((T) => L ? T.code == L.value : T.code == Ht.code) || Ht, [L]), j = (T) => {
    W.current && !W.current.contains(T.target) && O(!1);
  }, M = (T) => {
    const k = T.value, { phoneNumber: V } = Sr(I, k);
    O(!1), U(T), y && y(T, $.name ?? "no-name"), u && u(k), R(V);
  }, R = nt((T) => {
    p && p({
      currentTarget: { name: x, id: $.id || f, value: T },
      target: { name: x, id: $.id || f, value: T }
    });
  }, [x, $, f, p]), N = nt(({ target: { value: T } }) => {
    if (Z) {
      const k = Z.code, { phoneNumber: V } = Sr(T, k);
      A(V), R(V);
    }
  }, [Z, R]);
  return le(() => (document.addEventListener("mousedown", j), () => {
    document.removeEventListener("mousedown", j);
  }), [W]), le(() => {
    let T = h === void 0 ? "" : String(h);
    const { country: k, mask: V } = Oc(T);
    L || U({
      value: k.code,
      label: k.name,
      isRefined: !1,
      isDefault: !0
    }), B(V), A(T);
  }, [h, L]), X ? i.jsxs("div", { className: `tw-relative tw-flex tw-flex-col tw-gap-1${e ? " tw-hidden" : ""}`, ref: W, children: [i.jsxs(qe, { value: L, onChange: M, children: [v && i.jsxs(qe.Label, { className: `tw-text-secondary tw-text-sm tw-leading-4 tw-flex tw-gap-1 ${C || ""}`, htmlFor: `${f}-input`, children: [v, r && i.jsx(ne, { type: "asterisk", size: 8, color: "error", className: "tw-ml-1" })] }), i.jsxs("div", { className: `tw-flex ${z0} ${Y0} ${t} ${g}`, children: [i.jsx(qe.Button, { className: "tw-flex tw-justify-center tw-items-center tw-flex-shrink-0 tw-gap-2 tw-cursor-pointer tw-py-3 tw-pl-4", onClick: () => {
    O(!E);
  }, children: Z && i.jsxs(i.Fragment, { children: [i.jsx("img", { src: `https://flagsapi.com/${Z.code}/flat/24.png`, alt: "" }), i.jsx(ne, { size: 20, type: "angle-icon", direction: E ? "up" : "down", className: "tw-transition-all tw-ease-in-out tw-duration-200 tw-flex-shrink-0" }), i.jsxs("span", { className: "tw-text-gray", children: [" ", Z.dialCode] })] }) }), i.jsx("input", { type: "tel", id: `${f}-input`, value: I, required: r && X, disabled: c, placeholder: n, "data-testid": d, onChange: N, onClick: w, onBlur: (T) => {
    l && l({
      ...T,
      target: { ...T.target, name: x || "", id: f || "", value: P }
    });
  }, className: "tw-w-full tw-cursor-text tw-py-3 tw-px-4 tw-outline-none" })] }), i.jsxs(qe.Options, { className: "tw-absolute tw-top-full  tw-bg-white tw-w-full tw-mt-1 tw-z-50 tw-ring-1 tw-ring-outlined-gray cursor-default focus:tw-outline-none tw-max-h-60 tw-overflow-auto", children: [ni.map((T, k) => {
    const V = k == ni.length - 1;
    return i.jsxs(qe.Option, { className: ({ active: H, selected: Q }) => `tw-relative tw-cursor-default tw-select-none tw-flex tw-flex-row tw-gap-2
                  ${H ? "tw-text-dark tw-bg-light-hover" : ""} 
                  ${Q ? "tw-text-dark" : "tw-text-secondary"}
                  ${V ? "tw-border-b tw-border-outlined-gray" : ""}
                   tw-py-3 tw-px-4 tw-w-full tw-text-left`, value: { value: T.code, label: T.name }, children: [i.jsx("img", { src: `https://flagsapi.com/${T.code}/flat/24.png`, alt: "" }), i.jsxs("span", { className: "tw-text-dark", children: [" ", T.name] }), i.jsxs("span", { className: "tw-text-gray", children: [" ", T.dialCode] })] }, k);
  }), sn == null ? void 0 : sn.map((T, k) => i.jsxs(qe.Option, { className: ({ active: V, selected: H }) => `tw-relative tw-cursor-default tw-select-none tw-flex tw-flex-row tw-gap-2
                  ${V ? "tw-text-dark tw-bg-light-hover" : ""} 
                  ${H ? "tw-text-dark" : "tw-text-secondary"}
                  tw-py-3 tw-px-4 tw-w-full tw-text-left`, value: { value: T.code, label: T.name }, children: [i.jsx("img", { src: `https://flagsapi.com/${T.code}/flat/24.png`, alt: "" }), i.jsxs("span", { className: "tw-text-dark", children: [" ", T.name] }), i.jsxs("span", { className: "tw-text-gray", children: [" ", T.dialCode] })] }, `option-${k}`))] })] }), i.jsx("input", { type: "hidden", id: f, name: x, value: P }), !a && o && i.jsx("span", { className: "tw-text-secondary tw-text-sm tw-leading-4", children: o }), a && s && i.jsx("span", { className: "tw-text-error tw-text-sm tw-leading-4", children: s })] }) : null;
};
var jt;
(function(e) {
  e.FILLED = "filled", e.OUTLINED = "outlined";
})(jt || (jt = {}));
const ps = {
  [jt.FILLED]: "checkbox",
  [jt.OUTLINED]: "checkbox-outline"
}, Un = ({
  // eslint-disable-next-line unused-imports/no-unused-vars
  defaultFieldValue: e,
  fieldId: t = "",
  checkboxVariant: n = jt.FILLED,
  dataTestId: r,
  disabled: a,
  error: s,
  errorMessage: o,
  helperMessage: l = "",
  helperMessageRichText: d,
  label: c = "",
  leftIcon: f,
  name: w = "",
  currentOption: u,
  options: p = [],
  placeholder: h,
  rightIcon: m,
  type: $ = "text",
  value: g,
  min: v,
  max: C,
  maxLength: y,
  minLength: x,
  multiple: E,
  allowLetterOnly: O,
  image: I,
  hasInfoButton: B = !1,
  showButtonPassword: P = !1,
  onChange: A,
  onClick: L,
  onBlur: U,
  onCountryChange: X,
  filterHandler: W,
  onClickInfoHandler: Z,
  showCondition: j,
  childSelect: M,
  hasPopover: R,
  popover: N,
  textDecoration: T,
  isInputFocus: k,
  containerClassName: V,
  ...H
}) => {
  switch ($) {
    case "tel":
      return i.jsx(Z0, { dataTestId: r, disabled: a, error: s, errorMessage: o, helperMessage: l, fieldId: t, label: c, name: w, placeholder: h, type: $, value: g, min: v, max: C, onCountryChange: X, maxLength: y, minLength: x, onChange: A, onBlur: U, onClick: L, showCondition: j, ...H });
    case "text":
    case "email":
    case "password":
    case "number":
    case "search":
      return i.jsx(jr, { dataTestId: r, disabled: a, error: s, errorMessage: o, helperMessage: l, fieldId: t, label: c, leftIcon: f, name: w, placeholder: h, rightIcon: m, type: $, value: g, min: v, max: C, maxLength: y, minLength: x, allowLetterOnly: O, onChange: A, onBlur: U, onClick: L, showButtonPassword: P, showCondition: j, hasInfoButton: B, popover: N, textDecoration: T, isInputFocus: k, ...H });
    case "select":
      return i.jsx(hs, { name: w, id: t, label: c, placeholder: h, currentOption: u, options: p, filterHandler: W, error: s, errorMessage: o, helperMessage: l, showCondition: j, childSelect: M, ...H });
    case "textarea":
      return i.jsx(Sw, { label: c, name: w, placeholder: h, value: g, min: v, max: C, maxLength: y, minLength: x, error: s, errorMessage: o, helperMessage: l, onChange: A, onBlur: U, showCondition: j, containerClassName: V, ...H });
    case "control":
      return i.jsx(vw, { dataTestId: r, disabled: a, fieldId: t, label: c, type: $, name: w, value: g, error: s, errorMessage: o, helperMessage: l, showCondition: j, ...H });
    case "checkbox":
      return i.jsx($w, { checkboxVariant: n, dataTestId: r, disabled: a, fieldId: t, label: c, name: w, type: $, value: g, checked: H.checked, error: s, errorMessage: o, helperMessage: l, image: I, hasInfoButton: B, onChange: A, onClickInfoHandler: Z, showCondition: j, hasPopover: R, popover: N, ...H });
    case "radio":
      return i.jsx(bw, { dataTestId: r, disabled: a, fieldId: t, label: c, name: w, type: $, value: g, error: s, errorMessage: o, helperMessage: l, helperMessageRichText: d, image: I, hasInfoButton: B, onChange: A, onClickInfoHandler: Z, showCondition: j, hasPopover: R, popover: N, ...H });
    case "file":
      return i.jsx(jr, { multiple: E, dataTestId: r, error: s, errorMessage: o, helperMessage: l, fieldId: t, label: c, leftIcon: f, name: w, rightIcon: m, type: $, value: g, onChange: A, onBlur: U, showCondition: j, ...H });
    default:
      return null;
  }
}, X0 = (e, t, n) => e ? "Submitted!" : t ? "Loading..." : n, K0 = ({ button: e, description: t, input: n, title: r, form: a }) => {
  const [s, o] = G(!1), [l, d] = G(!1), c = (f) => {
    d(!0), f.preventDefault(), a != null && a.onSubmit && a.onSubmit(f).then((w) => {
      if (!w.success && w.code === 500)
        throw new Error(w.message);
      if (!w.success) {
        console.error(w.message), d(!1), o(!1);
        return;
      }
      d(!1), o(!0);
    }).catch((w) => {
      console.error(w.message), o(!1), d(!1);
    });
  };
  return i.jsxs("div", { className: "tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-between", children: [i.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-4", children: [r && i.jsx("h4", { className: "tw-text-secondary tw-text-xl tw-font-medium tw-leading-7", children: r }), t && i.jsx("p", { className: "tw-text-secondary tw-text-base", children: t })] }), i.jsxs("form", { className: "tw-w-news-letter-form tw-mt-4 lg:tw-mt-0 tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-4", action: a == null ? void 0 : a.action, method: a == null ? void 0 : a.method, id: a == null ? void 0 : a.id, name: a == null ? void 0 : a.name, target: a == null ? void 0 : a.target, onSubmit: (a == null ? void 0 : a.onSubmit) && c, children: [!!n && i.jsxs("div", { className: "tw-flex-1", children: [i.jsx(Un, { ...n, autoComplete: "email", pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$" }), a.hiddenInputName && i.jsx("input", { type: "hidden", name: a.hiddenInputName, tabIndex: -1, value: "" })] }), !!e && i.jsx(Te, { ...e, label: X0(s, l, e.label), type: "submit", className: "tw-w-full sm:tw-w-auto", state: s || l ? De.DISABLED : De.ENABLED, disabled: s || l })] })] });
};
function ri(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function zr(e = {}, t = {}) {
  Object.keys(t).forEach((n) => {
    typeof e[n] > "u" ? e[n] = t[n] : ri(t[n]) && ri(e[n]) && Object.keys(t[n]).length > 0 && zr(e[n], t[n]);
  });
}
const ms = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Be() {
  const e = typeof document < "u" ? document : {};
  return zr(e, ms), e;
}
const q0 = {
  document: ms,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function Ne() {
  const e = typeof window < "u" ? window : {};
  return zr(e, q0), e;
}
function J0(e) {
  const t = e.__proto__;
  Object.defineProperty(e, "__proto__", {
    get() {
      return t;
    },
    set(n) {
      t.__proto__ = n;
    }
  });
}
class wt extends Array {
  constructor(t) {
    typeof t == "number" ? super(t) : (super(...t || []), J0(this));
  }
}
function $n(e = []) {
  const t = [];
  return e.forEach((n) => {
    Array.isArray(n) ? t.push(...$n(n)) : t.push(n);
  }), t;
}
function gs(e, t) {
  return Array.prototype.filter.call(e, t);
}
function Q0(e) {
  const t = [];
  for (let n = 0; n < e.length; n += 1)
    t.indexOf(e[n]) === -1 && t.push(e[n]);
  return t;
}
function e1(e, t) {
  if (typeof e != "string")
    return [e];
  const n = [], r = t.querySelectorAll(e);
  for (let a = 0; a < r.length; a += 1)
    n.push(r[a]);
  return n;
}
function D(e, t) {
  const n = Ne(), r = Be();
  let a = [];
  if (!t && e instanceof wt)
    return e;
  if (!e)
    return new wt(a);
  if (typeof e == "string") {
    const s = e.trim();
    if (s.indexOf("<") >= 0 && s.indexOf(">") >= 0) {
      let o = "div";
      s.indexOf("<li") === 0 && (o = "ul"), s.indexOf("<tr") === 0 && (o = "tbody"), (s.indexOf("<td") === 0 || s.indexOf("<th") === 0) && (o = "tr"), s.indexOf("<tbody") === 0 && (o = "table"), s.indexOf("<option") === 0 && (o = "select");
      const l = r.createElement(o);
      l.innerHTML = s;
      for (let d = 0; d < l.childNodes.length; d += 1)
        a.push(l.childNodes[d]);
    } else
      a = e1(e.trim(), t || r);
  } else if (e.nodeType || e === n || e === r)
    a.push(e);
  else if (Array.isArray(e)) {
    if (e instanceof wt)
      return e;
    a = e;
  }
  return new wt(Q0(a));
}
D.fn = wt.prototype;
function t1(...e) {
  const t = $n(e.map((n) => n.split(" ")));
  return this.forEach((n) => {
    n.classList.add(...t);
  }), this;
}
function n1(...e) {
  const t = $n(e.map((n) => n.split(" ")));
  return this.forEach((n) => {
    n.classList.remove(...t);
  }), this;
}
function r1(...e) {
  const t = $n(e.map((n) => n.split(" ")));
  this.forEach((n) => {
    t.forEach((r) => {
      n.classList.toggle(r);
    });
  });
}
function a1(...e) {
  const t = $n(e.map((n) => n.split(" ")));
  return gs(this, (n) => t.filter((r) => n.classList.contains(r)).length > 0).length > 0;
}
function i1(e, t) {
  if (arguments.length === 1 && typeof e == "string")
    return this[0] ? this[0].getAttribute(e) : void 0;
  for (let n = 0; n < this.length; n += 1)
    if (arguments.length === 2)
      this[n].setAttribute(e, t);
    else
      for (const r in e)
        this[n][r] = e[r], this[n].setAttribute(r, e[r]);
  return this;
}
function s1(e) {
  for (let t = 0; t < this.length; t += 1)
    this[t].removeAttribute(e);
  return this;
}
function o1(e) {
  for (let t = 0; t < this.length; t += 1)
    this[t].style.transform = e;
  return this;
}
function l1(e) {
  for (let t = 0; t < this.length; t += 1)
    this[t].style.transitionDuration = typeof e != "string" ? `${e}ms` : e;
  return this;
}
function d1(...e) {
  let [t, n, r, a] = e;
  typeof e[1] == "function" && ([t, r, a] = e, n = void 0), a || (a = !1);
  function s(c) {
    const f = c.target;
    if (!f)
      return;
    const w = c.target.dom7EventData || [];
    if (w.indexOf(c) < 0 && w.unshift(c), D(f).is(n))
      r.apply(f, w);
    else {
      const u = D(f).parents();
      for (let p = 0; p < u.length; p += 1)
        D(u[p]).is(n) && r.apply(u[p], w);
    }
  }
  function o(c) {
    const f = c && c.target ? c.target.dom7EventData || [] : [];
    f.indexOf(c) < 0 && f.unshift(c), r.apply(this, f);
  }
  const l = t.split(" ");
  let d;
  for (let c = 0; c < this.length; c += 1) {
    const f = this[c];
    if (n)
      for (d = 0; d < l.length; d += 1) {
        const w = l[d];
        f.dom7LiveListeners || (f.dom7LiveListeners = {}), f.dom7LiveListeners[w] || (f.dom7LiveListeners[w] = []), f.dom7LiveListeners[w].push({
          listener: r,
          proxyListener: s
        }), f.addEventListener(w, s, a);
      }
    else
      for (d = 0; d < l.length; d += 1) {
        const w = l[d];
        f.dom7Listeners || (f.dom7Listeners = {}), f.dom7Listeners[w] || (f.dom7Listeners[w] = []), f.dom7Listeners[w].push({
          listener: r,
          proxyListener: o
        }), f.addEventListener(w, o, a);
      }
  }
  return this;
}
function c1(...e) {
  let [t, n, r, a] = e;
  typeof e[1] == "function" && ([t, r, a] = e, n = void 0), a || (a = !1);
  const s = t.split(" ");
  for (let o = 0; o < s.length; o += 1) {
    const l = s[o];
    for (let d = 0; d < this.length; d += 1) {
      const c = this[d];
      let f;
      if (!n && c.dom7Listeners ? f = c.dom7Listeners[l] : n && c.dom7LiveListeners && (f = c.dom7LiveListeners[l]), f && f.length)
        for (let w = f.length - 1; w >= 0; w -= 1) {
          const u = f[w];
          r && u.listener === r || r && u.listener && u.listener.dom7proxy && u.listener.dom7proxy === r ? (c.removeEventListener(l, u.proxyListener, a), f.splice(w, 1)) : r || (c.removeEventListener(l, u.proxyListener, a), f.splice(w, 1));
        }
    }
  }
  return this;
}
function u1(...e) {
  const t = Ne(), n = e[0].split(" "), r = e[1];
  for (let a = 0; a < n.length; a += 1) {
    const s = n[a];
    for (let o = 0; o < this.length; o += 1) {
      const l = this[o];
      if (t.CustomEvent) {
        const d = new t.CustomEvent(s, {
          detail: r,
          bubbles: !0,
          cancelable: !0
        });
        l.dom7EventData = e.filter((c, f) => f > 0), l.dispatchEvent(d), l.dom7EventData = [], delete l.dom7EventData;
      }
    }
  }
  return this;
}
function f1(e) {
  const t = this;
  function n(r) {
    r.target === this && (e.call(this, r), t.off("transitionend", n));
  }
  return e && t.on("transitionend", n), this;
}
function w1(e) {
  if (this.length > 0) {
    if (e) {
      const t = this.styles();
      return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function h1(e) {
  if (this.length > 0) {
    if (e) {
      const t = this.styles();
      return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function p1() {
  if (this.length > 0) {
    const e = Ne(), t = Be(), n = this[0], r = n.getBoundingClientRect(), a = t.body, s = n.clientTop || a.clientTop || 0, o = n.clientLeft || a.clientLeft || 0, l = n === e ? e.scrollY : n.scrollTop, d = n === e ? e.scrollX : n.scrollLeft;
    return {
      top: r.top + l - s,
      left: r.left + d - o
    };
  }
  return null;
}
function m1() {
  const e = Ne();
  return this[0] ? e.getComputedStyle(this[0], null) : {};
}
function g1(e, t) {
  const n = Ne();
  let r;
  if (arguments.length === 1)
    if (typeof e == "string") {
      if (this[0])
        return n.getComputedStyle(this[0], null).getPropertyValue(e);
    } else {
      for (r = 0; r < this.length; r += 1)
        for (const a in e)
          this[r].style[a] = e[a];
      return this;
    }
  if (arguments.length === 2 && typeof e == "string") {
    for (r = 0; r < this.length; r += 1)
      this[r].style[e] = t;
    return this;
  }
  return this;
}
function $1(e) {
  return e ? (this.forEach((t, n) => {
    e.apply(t, [t, n]);
  }), this) : this;
}
function x1(e) {
  const t = gs(this, e);
  return D(t);
}
function v1(e) {
  if (typeof e > "u")
    return this[0] ? this[0].innerHTML : null;
  for (let t = 0; t < this.length; t += 1)
    this[t].innerHTML = e;
  return this;
}
function b1(e) {
  if (typeof e > "u")
    return this[0] ? this[0].textContent.trim() : null;
  for (let t = 0; t < this.length; t += 1)
    this[t].textContent = e;
  return this;
}
function y1(e) {
  const t = Ne(), n = Be(), r = this[0];
  let a, s;
  if (!r || typeof e > "u")
    return !1;
  if (typeof e == "string") {
    if (r.matches)
      return r.matches(e);
    if (r.webkitMatchesSelector)
      return r.webkitMatchesSelector(e);
    if (r.msMatchesSelector)
      return r.msMatchesSelector(e);
    for (a = D(e), s = 0; s < a.length; s += 1)
      if (a[s] === r)
        return !0;
    return !1;
  }
  if (e === n)
    return r === n;
  if (e === t)
    return r === t;
  if (e.nodeType || e instanceof wt) {
    for (a = e.nodeType ? [e] : e, s = 0; s < a.length; s += 1)
      if (a[s] === r)
        return !0;
    return !1;
  }
  return !1;
}
function C1() {
  let e = this[0], t;
  if (e) {
    for (t = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (t += 1);
    return t;
  }
}
function E1(e) {
  if (typeof e > "u")
    return this;
  const t = this.length;
  if (e > t - 1)
    return D([]);
  if (e < 0) {
    const n = t + e;
    return n < 0 ? D([]) : D([this[n]]);
  }
  return D([this[e]]);
}
function N1(...e) {
  let t;
  const n = Be();
  for (let r = 0; r < e.length; r += 1) {
    t = e[r];
    for (let a = 0; a < this.length; a += 1)
      if (typeof t == "string") {
        const s = n.createElement("div");
        for (s.innerHTML = t; s.firstChild; )
          this[a].appendChild(s.firstChild);
      } else if (t instanceof wt)
        for (let s = 0; s < t.length; s += 1)
          this[a].appendChild(t[s]);
      else
        this[a].appendChild(t);
  }
  return this;
}
function T1(e) {
  const t = Be();
  let n, r;
  for (n = 0; n < this.length; n += 1)
    if (typeof e == "string") {
      const a = t.createElement("div");
      for (a.innerHTML = e, r = a.childNodes.length - 1; r >= 0; r -= 1)
        this[n].insertBefore(a.childNodes[r], this[n].childNodes[0]);
    } else if (e instanceof wt)
      for (r = 0; r < e.length; r += 1)
        this[n].insertBefore(e[r], this[n].childNodes[0]);
    else
      this[n].insertBefore(e, this[n].childNodes[0]);
  return this;
}
function S1(e) {
  return this.length > 0 ? e ? this[0].nextElementSibling && D(this[0].nextElementSibling).is(e) ? D([this[0].nextElementSibling]) : D([]) : this[0].nextElementSibling ? D([this[0].nextElementSibling]) : D([]) : D([]);
}
function j1(e) {
  const t = [];
  let n = this[0];
  if (!n)
    return D([]);
  for (; n.nextElementSibling; ) {
    const r = n.nextElementSibling;
    e ? D(r).is(e) && t.push(r) : t.push(r), n = r;
  }
  return D(t);
}
function P1(e) {
  if (this.length > 0) {
    const t = this[0];
    return e ? t.previousElementSibling && D(t.previousElementSibling).is(e) ? D([t.previousElementSibling]) : D([]) : t.previousElementSibling ? D([t.previousElementSibling]) : D([]);
  }
  return D([]);
}
function A1(e) {
  const t = [];
  let n = this[0];
  if (!n)
    return D([]);
  for (; n.previousElementSibling; ) {
    const r = n.previousElementSibling;
    e ? D(r).is(e) && t.push(r) : t.push(r), n = r;
  }
  return D(t);
}
function I1(e) {
  const t = [];
  for (let n = 0; n < this.length; n += 1)
    this[n].parentNode !== null && (e ? D(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
  return D(t);
}
function O1(e) {
  const t = [];
  for (let n = 0; n < this.length; n += 1) {
    let r = this[n].parentNode;
    for (; r; )
      e ? D(r).is(e) && t.push(r) : t.push(r), r = r.parentNode;
  }
  return D(t);
}
function _1(e) {
  let t = this;
  return typeof e > "u" ? D([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
}
function L1(e) {
  const t = [];
  for (let n = 0; n < this.length; n += 1) {
    const r = this[n].querySelectorAll(e);
    for (let a = 0; a < r.length; a += 1)
      t.push(r[a]);
  }
  return D(t);
}
function R1(e) {
  const t = [];
  for (let n = 0; n < this.length; n += 1) {
    const r = this[n].children;
    for (let a = 0; a < r.length; a += 1)
      (!e || D(r[a]).is(e)) && t.push(r[a]);
  }
  return D(t);
}
function M1() {
  for (let e = 0; e < this.length; e += 1)
    this[e].parentNode && this[e].parentNode.removeChild(this[e]);
  return this;
}
const ai = {
  addClass: t1,
  removeClass: n1,
  hasClass: a1,
  toggleClass: r1,
  attr: i1,
  removeAttr: s1,
  transform: o1,
  transition: l1,
  on: d1,
  off: c1,
  trigger: u1,
  transitionEnd: f1,
  outerWidth: w1,
  outerHeight: h1,
  styles: m1,
  offset: p1,
  css: g1,
  each: $1,
  html: v1,
  text: b1,
  is: y1,
  index: C1,
  eq: E1,
  append: N1,
  prepend: T1,
  next: S1,
  nextAll: j1,
  prev: P1,
  prevAll: A1,
  parent: I1,
  parents: O1,
  closest: _1,
  find: L1,
  children: R1,
  filter: x1,
  remove: M1
};
Object.keys(ai).forEach((e) => {
  Object.defineProperty(D.fn, e, {
    value: ai[e],
    writable: !0
  });
});
function F1(e) {
  const t = e;
  Object.keys(t).forEach((n) => {
    try {
      t[n] = null;
    } catch {
    }
    try {
      delete t[n];
    } catch {
    }
  });
}
function Pr(e, t) {
  return t === void 0 && (t = 0), setTimeout(e, t);
}
function mn() {
  return Date.now();
}
function D1(e) {
  const t = Ne();
  let n;
  return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n;
}
function Ar(e, t) {
  t === void 0 && (t = "x");
  const n = Ne();
  let r, a, s;
  const o = D1(e);
  return n.WebKitCSSMatrix ? (a = o.transform || o.webkitTransform, a.split(",").length > 6 && (a = a.split(", ").map((l) => l.replace(",", ".")).join(", ")), s = new n.WebKitCSSMatrix(a === "none" ? "" : a)) : (s = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = s.toString().split(",")), t === "x" && (n.WebKitCSSMatrix ? a = s.m41 : r.length === 16 ? a = parseFloat(r[12]) : a = parseFloat(r[4])), t === "y" && (n.WebKitCSSMatrix ? a = s.m42 : r.length === 16 ? a = parseFloat(r[13]) : a = parseFloat(r[5])), a || 0;
}
function on(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function k1(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function Ge() {
  const e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < arguments.length; n += 1) {
    const r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (r != null && !k1(r)) {
      const a = Object.keys(Object(r)).filter((s) => t.indexOf(s) < 0);
      for (let s = 0, o = a.length; s < o; s += 1) {
        const l = a[s], d = Object.getOwnPropertyDescriptor(r, l);
        d !== void 0 && d.enumerable && (on(e[l]) && on(r[l]) ? r[l].__swiper__ ? e[l] = r[l] : Ge(e[l], r[l]) : !on(e[l]) && on(r[l]) ? (e[l] = {}, r[l].__swiper__ ? e[l] = r[l] : Ge(e[l], r[l])) : e[l] = r[l]);
      }
    }
  }
  return e;
}
function bn(e, t, n) {
  e.style.setProperty(t, n);
}
function $s(e) {
  let {
    swiper: t,
    targetPosition: n,
    side: r
  } = e;
  const a = Ne(), s = -t.translate;
  let o = null, l;
  const d = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", a.cancelAnimationFrame(t.cssModeFrameID);
  const c = n > s ? "next" : "prev", f = (u, p) => c === "next" && u >= p || c === "prev" && u <= p, w = () => {
    l = (/* @__PURE__ */ new Date()).getTime(), o === null && (o = l);
    const u = Math.max(Math.min((l - o) / d, 1), 0), p = 0.5 - Math.cos(u * Math.PI) / 2;
    let h = s + p * (n - s);
    if (f(h, n) && (h = n), t.wrapperEl.scrollTo({
      [r]: h
    }), f(h, n)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [r]: h
        });
      }), a.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = a.requestAnimationFrame(w);
  };
  w();
}
let rr;
function B1() {
  const e = Ne(), t = Be();
  return {
    smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch),
    passiveListener: function() {
      let r = !1;
      try {
        const a = Object.defineProperty({}, "passive", {
          // eslint-disable-next-line
          get() {
            r = !0;
          }
        });
        e.addEventListener("testPassiveListener", null, a);
      } catch {
      }
      return r;
    }(),
    gestures: function() {
      return "ongesturestart" in e;
    }()
  };
}
function xs() {
  return rr || (rr = B1()), rr;
}
let ar;
function H1(e) {
  let {
    userAgent: t
  } = e === void 0 ? {} : e;
  const n = xs(), r = Ne(), a = r.navigator.platform, s = t || r.navigator.userAgent, o = {
    ios: !1,
    android: !1
  }, l = r.screen.width, d = r.screen.height, c = s.match(/(Android);?[\s\/]+([\d.]+)?/);
  let f = s.match(/(iPad).*OS\s([\d_]+)/);
  const w = s.match(/(iPod)(.*OS\s([\d_]+))?/), u = !f && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/), p = a === "Win32";
  let h = a === "MacIntel";
  const m = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !f && h && n.touch && m.indexOf(`${l}x${d}`) >= 0 && (f = s.match(/(Version)\/([\d.]+)/), f || (f = [0, 1, "13_0_0"]), h = !1), c && !p && (o.os = "android", o.android = !0), (f || u || w) && (o.os = "ios", o.ios = !0), o;
}
function G1(e) {
  return e === void 0 && (e = {}), ar || (ar = H1(e)), ar;
}
let ir;
function V1() {
  const e = Ne();
  function t() {
    const n = e.navigator.userAgent.toLowerCase();
    return n.indexOf("safari") >= 0 && n.indexOf("chrome") < 0 && n.indexOf("android") < 0;
  }
  return {
    isSafari: t(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
  };
}
function U1() {
  return ir || (ir = V1()), ir;
}
function W1(e) {
  let {
    swiper: t,
    on: n,
    emit: r
  } = e;
  const a = Ne();
  let s = null, o = null;
  const l = () => {
    !t || t.destroyed || !t.initialized || (r("beforeResize"), r("resize"));
  }, d = () => {
    !t || t.destroyed || !t.initialized || (s = new ResizeObserver((w) => {
      o = a.requestAnimationFrame(() => {
        const {
          width: u,
          height: p
        } = t;
        let h = u, m = p;
        w.forEach(($) => {
          let {
            contentBoxSize: g,
            contentRect: v,
            target: C
          } = $;
          C && C !== t.el || (h = v ? v.width : (g[0] || g).inlineSize, m = v ? v.height : (g[0] || g).blockSize);
        }), (h !== u || m !== p) && l();
      });
    }), s.observe(t.el));
  }, c = () => {
    o && a.cancelAnimationFrame(o), s && s.unobserve && t.el && (s.unobserve(t.el), s = null);
  }, f = () => {
    !t || t.destroyed || !t.initialized || r("orientationchange");
  };
  n("init", () => {
    if (t.params.resizeObserver && typeof a.ResizeObserver < "u") {
      d();
      return;
    }
    a.addEventListener("resize", l), a.addEventListener("orientationchange", f);
  }), n("destroy", () => {
    c(), a.removeEventListener("resize", l), a.removeEventListener("orientationchange", f);
  });
}
function z1(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: a
  } = e;
  const s = [], o = Ne(), l = function(f, w) {
    w === void 0 && (w = {});
    const u = o.MutationObserver || o.WebkitMutationObserver, p = new u((h) => {
      if (h.length === 1) {
        a("observerUpdate", h[0]);
        return;
      }
      const m = function() {
        a("observerUpdate", h[0]);
      };
      o.requestAnimationFrame ? o.requestAnimationFrame(m) : o.setTimeout(m, 0);
    });
    p.observe(f, {
      attributes: typeof w.attributes > "u" ? !0 : w.attributes,
      childList: typeof w.childList > "u" ? !0 : w.childList,
      characterData: typeof w.characterData > "u" ? !0 : w.characterData
    }), s.push(p);
  }, d = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const f = t.$el.parents();
        for (let w = 0; w < f.length; w += 1)
          l(f[w]);
      }
      l(t.$el[0], {
        childList: t.params.observeSlideChildren
      }), l(t.$wrapperEl[0], {
        attributes: !1
      });
    }
  }, c = () => {
    s.forEach((f) => {
      f.disconnect();
    }), s.splice(0, s.length);
  };
  n({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), r("init", d), r("destroy", c);
}
const Y1 = {
  on(e, t, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function")
      return r;
    const a = n ? "unshift" : "push";
    return e.split(" ").forEach((s) => {
      r.eventsListeners[s] || (r.eventsListeners[s] = []), r.eventsListeners[s][a](t);
    }), r;
  },
  once(e, t, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function")
      return r;
    function a() {
      r.off(e, a), a.__emitterProxy && delete a.__emitterProxy;
      for (var s = arguments.length, o = new Array(s), l = 0; l < s; l++)
        o[l] = arguments[l];
      t.apply(r, o);
    }
    return a.__emitterProxy = t, r.on(e, a, n);
  },
  onAny(e, t) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function")
      return n;
    const r = t ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners)
      return t;
    const n = t.eventsAnyListeners.indexOf(e);
    return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
  },
  off(e, t) {
    const n = this;
    return !n.eventsListeners || n.destroyed || !n.eventsListeners || e.split(" ").forEach((r) => {
      typeof t > "u" ? n.eventsListeners[r] = [] : n.eventsListeners[r] && n.eventsListeners[r].forEach((a, s) => {
        (a === t || a.__emitterProxy && a.__emitterProxy === t) && n.eventsListeners[r].splice(s, 1);
      });
    }), n;
  },
  emit() {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners)
      return e;
    let t, n, r;
    for (var a = arguments.length, s = new Array(a), o = 0; o < a; o++)
      s[o] = arguments[o];
    return typeof s[0] == "string" || Array.isArray(s[0]) ? (t = s[0], n = s.slice(1, s.length), r = e) : (t = s[0].events, n = s[0].data, r = s[0].context || e), n.unshift(r), (Array.isArray(t) ? t : t.split(" ")).forEach((d) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((c) => {
        c.apply(r, [d, ...n]);
      }), e.eventsListeners && e.eventsListeners[d] && e.eventsListeners[d].forEach((c) => {
        c.apply(r, n);
      });
    }), e;
  }
};
function Z1() {
  const e = this;
  let t, n;
  const r = e.$el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = r[0].clientWidth, typeof e.params.height < "u" && e.params.height !== null ? n = e.params.height : n = r[0].clientHeight, !(t === 0 && e.isHorizontal() || n === 0 && e.isVertical()) && (t = t - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10), n = n - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
    width: t,
    height: n,
    size: e.isHorizontal() ? t : n
  }));
}
function X1() {
  const e = this;
  function t(P) {
    return e.isHorizontal() ? P : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[P];
  }
  function n(P, A) {
    return parseFloat(P.getPropertyValue(t(A)) || 0);
  }
  const r = e.params, {
    $wrapperEl: a,
    size: s,
    rtlTranslate: o,
    wrongRTL: l
  } = e, d = e.virtual && r.virtual.enabled, c = d ? e.virtual.slides.length : e.slides.length, f = a.children(`.${e.params.slideClass}`), w = d ? e.virtual.slides.length : f.length;
  let u = [];
  const p = [], h = [];
  let m = r.slidesOffsetBefore;
  typeof m == "function" && (m = r.slidesOffsetBefore.call(e));
  let $ = r.slidesOffsetAfter;
  typeof $ == "function" && ($ = r.slidesOffsetAfter.call(e));
  const g = e.snapGrid.length, v = e.slidesGrid.length;
  let C = r.spaceBetween, y = -m, x = 0, E = 0;
  if (typeof s > "u")
    return;
  typeof C == "string" && C.indexOf("%") >= 0 && (C = parseFloat(C.replace("%", "")) / 100 * s), e.virtualSize = -C, o ? f.css({
    marginLeft: "",
    marginBottom: "",
    marginTop: ""
  }) : f.css({
    marginRight: "",
    marginBottom: "",
    marginTop: ""
  }), r.centeredSlides && r.cssMode && (bn(e.wrapperEl, "--swiper-centered-offset-before", ""), bn(e.wrapperEl, "--swiper-centered-offset-after", ""));
  const O = r.grid && r.grid.rows > 1 && e.grid;
  O && e.grid.initSlides(w);
  let I;
  const B = r.slidesPerView === "auto" && r.breakpoints && Object.keys(r.breakpoints).filter((P) => typeof r.breakpoints[P].slidesPerView < "u").length > 0;
  for (let P = 0; P < w; P += 1) {
    I = 0;
    const A = f.eq(P);
    if (O && e.grid.updateSlide(P, A, w, t), A.css("display") !== "none") {
      if (r.slidesPerView === "auto") {
        B && (f[P].style[t("width")] = "");
        const L = getComputedStyle(A[0]), U = A[0].style.transform, X = A[0].style.webkitTransform;
        if (U && (A[0].style.transform = "none"), X && (A[0].style.webkitTransform = "none"), r.roundLengths)
          I = e.isHorizontal() ? A.outerWidth(!0) : A.outerHeight(!0);
        else {
          const W = n(L, "width"), Z = n(L, "padding-left"), j = n(L, "padding-right"), M = n(L, "margin-left"), R = n(L, "margin-right"), N = L.getPropertyValue("box-sizing");
          if (N && N === "border-box")
            I = W + M + R;
          else {
            const {
              clientWidth: T,
              offsetWidth: k
            } = A[0];
            I = W + Z + j + M + R + (k - T);
          }
        }
        U && (A[0].style.transform = U), X && (A[0].style.webkitTransform = X), r.roundLengths && (I = Math.floor(I));
      } else
        I = (s - (r.slidesPerView - 1) * C) / r.slidesPerView, r.roundLengths && (I = Math.floor(I)), f[P] && (f[P].style[t("width")] = `${I}px`);
      f[P] && (f[P].swiperSlideSize = I), h.push(I), r.centeredSlides ? (y = y + I / 2 + x / 2 + C, x === 0 && P !== 0 && (y = y - s / 2 - C), P === 0 && (y = y - s / 2 - C), Math.abs(y) < 1 / 1e3 && (y = 0), r.roundLengths && (y = Math.floor(y)), E % r.slidesPerGroup === 0 && u.push(y), p.push(y)) : (r.roundLengths && (y = Math.floor(y)), (E - Math.min(e.params.slidesPerGroupSkip, E)) % e.params.slidesPerGroup === 0 && u.push(y), p.push(y), y = y + I + C), e.virtualSize += I + C, x = I, E += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, s) + $, o && l && (r.effect === "slide" || r.effect === "coverflow") && a.css({
    width: `${e.virtualSize + r.spaceBetween}px`
  }), r.setWrapperSize && a.css({
    [t("width")]: `${e.virtualSize + r.spaceBetween}px`
  }), O && e.grid.updateWrapperSize(I, u, t), !r.centeredSlides) {
    const P = [];
    for (let A = 0; A < u.length; A += 1) {
      let L = u[A];
      r.roundLengths && (L = Math.floor(L)), u[A] <= e.virtualSize - s && P.push(L);
    }
    u = P, Math.floor(e.virtualSize - s) - Math.floor(u[u.length - 1]) > 1 && u.push(e.virtualSize - s);
  }
  if (u.length === 0 && (u = [0]), r.spaceBetween !== 0) {
    const P = e.isHorizontal() && o ? "marginLeft" : t("marginRight");
    f.filter((A, L) => r.cssMode ? L !== f.length - 1 : !0).css({
      [P]: `${C}px`
    });
  }
  if (r.centeredSlides && r.centeredSlidesBounds) {
    let P = 0;
    h.forEach((L) => {
      P += L + (r.spaceBetween ? r.spaceBetween : 0);
    }), P -= r.spaceBetween;
    const A = P - s;
    u = u.map((L) => L < 0 ? -m : L > A ? A + $ : L);
  }
  if (r.centerInsufficientSlides) {
    let P = 0;
    if (h.forEach((A) => {
      P += A + (r.spaceBetween ? r.spaceBetween : 0);
    }), P -= r.spaceBetween, P < s) {
      const A = (s - P) / 2;
      u.forEach((L, U) => {
        u[U] = L - A;
      }), p.forEach((L, U) => {
        p[U] = L + A;
      });
    }
  }
  if (Object.assign(e, {
    slides: f,
    snapGrid: u,
    slidesGrid: p,
    slidesSizesGrid: h
  }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
    bn(e.wrapperEl, "--swiper-centered-offset-before", `${-u[0]}px`), bn(e.wrapperEl, "--swiper-centered-offset-after", `${e.size / 2 - h[h.length - 1] / 2}px`);
    const P = -e.snapGrid[0], A = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((L) => L + P), e.slidesGrid = e.slidesGrid.map((L) => L + A);
  }
  if (w !== c && e.emit("slidesLengthChange"), u.length !== g && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), p.length !== v && e.emit("slidesGridLengthChange"), r.watchSlidesProgress && e.updateSlidesOffset(), !d && !r.cssMode && (r.effect === "slide" || r.effect === "fade")) {
    const P = `${r.containerModifierClass}backface-hidden`, A = e.$el.hasClass(P);
    w <= r.maxBackfaceHiddenSlides ? A || e.$el.addClass(P) : A && e.$el.removeClass(P);
  }
}
function K1(e) {
  const t = this, n = [], r = t.virtual && t.params.virtual.enabled;
  let a = 0, s;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const o = (l) => r ? t.slides.filter((d) => parseInt(d.getAttribute("data-swiper-slide-index"), 10) === l)[0] : t.slides.eq(l)[0];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      t.visibleSlides.each((l) => {
        n.push(l);
      });
    else
      for (s = 0; s < Math.ceil(t.params.slidesPerView); s += 1) {
        const l = t.activeIndex + s;
        if (l > t.slides.length && !r)
          break;
        n.push(o(l));
      }
  else
    n.push(o(t.activeIndex));
  for (s = 0; s < n.length; s += 1)
    if (typeof n[s] < "u") {
      const l = n[s].offsetHeight;
      a = l > a ? l : a;
    }
  (a || a === 0) && t.$wrapperEl.css("height", `${a}px`);
}
function q1() {
  const e = this, t = e.slides;
  for (let n = 0; n < t.length; n += 1)
    t[n].swiperSlideOffset = e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop;
}
function J1(e) {
  e === void 0 && (e = this && this.translate || 0);
  const t = this, n = t.params, {
    slides: r,
    rtlTranslate: a,
    snapGrid: s
  } = t;
  if (r.length === 0)
    return;
  typeof r[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let o = -e;
  a && (o = e), r.removeClass(n.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  for (let l = 0; l < r.length; l += 1) {
    const d = r[l];
    let c = d.swiperSlideOffset;
    n.cssMode && n.centeredSlides && (c -= r[0].swiperSlideOffset);
    const f = (o + (n.centeredSlides ? t.minTranslate() : 0) - c) / (d.swiperSlideSize + n.spaceBetween), w = (o - s[0] + (n.centeredSlides ? t.minTranslate() : 0) - c) / (d.swiperSlideSize + n.spaceBetween), u = -(o - c), p = u + t.slidesSizesGrid[l];
    (u >= 0 && u < t.size - 1 || p > 1 && p <= t.size || u <= 0 && p >= t.size) && (t.visibleSlides.push(d), t.visibleSlidesIndexes.push(l), r.eq(l).addClass(n.slideVisibleClass)), d.progress = a ? -f : f, d.originalProgress = a ? -w : w;
  }
  t.visibleSlides = D(t.visibleSlides);
}
function Q1(e) {
  const t = this;
  if (typeof e > "u") {
    const c = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * c || 0;
  }
  const n = t.params, r = t.maxTranslate() - t.minTranslate();
  let {
    progress: a,
    isBeginning: s,
    isEnd: o
  } = t;
  const l = s, d = o;
  r === 0 ? (a = 0, s = !0, o = !0) : (a = (e - t.minTranslate()) / r, s = a <= 0, o = a >= 1), Object.assign(t, {
    progress: a,
    isBeginning: s,
    isEnd: o
  }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), s && !l && t.emit("reachBeginning toEdge"), o && !d && t.emit("reachEnd toEdge"), (l && !s || d && !o) && t.emit("fromEdge"), t.emit("progress", a);
}
function eu() {
  const e = this, {
    slides: t,
    params: n,
    $wrapperEl: r,
    activeIndex: a,
    realIndex: s
  } = e, o = e.virtual && n.virtual.enabled;
  t.removeClass(`${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`);
  let l;
  o ? l = e.$wrapperEl.find(`.${n.slideClass}[data-swiper-slide-index="${a}"]`) : l = t.eq(a), l.addClass(n.slideActiveClass), n.loop && (l.hasClass(n.slideDuplicateClass) ? r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${s}"]`).addClass(n.slideDuplicateActiveClass) : r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${s}"]`).addClass(n.slideDuplicateActiveClass));
  let d = l.nextAll(`.${n.slideClass}`).eq(0).addClass(n.slideNextClass);
  n.loop && d.length === 0 && (d = t.eq(0), d.addClass(n.slideNextClass));
  let c = l.prevAll(`.${n.slideClass}`).eq(0).addClass(n.slidePrevClass);
  n.loop && c.length === 0 && (c = t.eq(-1), c.addClass(n.slidePrevClass)), n.loop && (d.hasClass(n.slideDuplicateClass) ? r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass) : r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass), c.hasClass(n.slideDuplicateClass) ? r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass) : r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass)), e.emitSlidesClasses();
}
function tu(e) {
  const t = this, n = t.rtlTranslate ? t.translate : -t.translate, {
    slidesGrid: r,
    snapGrid: a,
    params: s,
    activeIndex: o,
    realIndex: l,
    snapIndex: d
  } = t;
  let c = e, f;
  if (typeof c > "u") {
    for (let u = 0; u < r.length; u += 1)
      typeof r[u + 1] < "u" ? n >= r[u] && n < r[u + 1] - (r[u + 1] - r[u]) / 2 ? c = u : n >= r[u] && n < r[u + 1] && (c = u + 1) : n >= r[u] && (c = u);
    s.normalizeSlideIndex && (c < 0 || typeof c > "u") && (c = 0);
  }
  if (a.indexOf(n) >= 0)
    f = a.indexOf(n);
  else {
    const u = Math.min(s.slidesPerGroupSkip, c);
    f = u + Math.floor((c - u) / s.slidesPerGroup);
  }
  if (f >= a.length && (f = a.length - 1), c === o) {
    f !== d && (t.snapIndex = f, t.emit("snapIndexChange"));
    return;
  }
  const w = parseInt(t.slides.eq(c).attr("data-swiper-slide-index") || c, 10);
  Object.assign(t, {
    snapIndex: f,
    realIndex: w,
    previousIndex: o,
    activeIndex: c
  }), t.emit("activeIndexChange"), t.emit("snapIndexChange"), l !== w && t.emit("realIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
}
function nu(e) {
  const t = this, n = t.params, r = D(e).closest(`.${n.slideClass}`)[0];
  let a = !1, s;
  if (r) {
    for (let o = 0; o < t.slides.length; o += 1)
      if (t.slides[o] === r) {
        a = !0, s = o;
        break;
      }
  }
  if (r && a)
    t.clickedSlide = r, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(D(r).attr("data-swiper-slide-index"), 10) : t.clickedIndex = s;
  else {
    t.clickedSlide = void 0, t.clickedIndex = void 0;
    return;
  }
  n.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
const ru = {
  updateSize: Z1,
  updateSlides: X1,
  updateAutoHeight: K1,
  updateSlidesOffset: q1,
  updateSlidesProgress: J1,
  updateProgress: Q1,
  updateSlidesClasses: eu,
  updateActiveIndex: tu,
  updateClickedSlide: nu
};
function au(e) {
  e === void 0 && (e = this.isHorizontal() ? "x" : "y");
  const t = this, {
    params: n,
    rtlTranslate: r,
    translate: a,
    $wrapperEl: s
  } = t;
  if (n.virtualTranslate)
    return r ? -a : a;
  if (n.cssMode)
    return a;
  let o = Ar(s[0], e);
  return r && (o = -o), o || 0;
}
function iu(e, t) {
  const n = this, {
    rtlTranslate: r,
    params: a,
    $wrapperEl: s,
    wrapperEl: o,
    progress: l
  } = n;
  let d = 0, c = 0;
  const f = 0;
  n.isHorizontal() ? d = r ? -e : e : c = e, a.roundLengths && (d = Math.floor(d), c = Math.floor(c)), a.cssMode ? o[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -d : -c : a.virtualTranslate || s.transform(`translate3d(${d}px, ${c}px, ${f}px)`), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? d : c;
  let w;
  const u = n.maxTranslate() - n.minTranslate();
  u === 0 ? w = 0 : w = (e - n.minTranslate()) / u, w !== l && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
}
function su() {
  return -this.snapGrid[0];
}
function ou() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function lu(e, t, n, r, a) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), r === void 0 && (r = !0);
  const s = this, {
    params: o,
    wrapperEl: l
  } = s;
  if (s.animating && o.preventInteractionOnTransition)
    return !1;
  const d = s.minTranslate(), c = s.maxTranslate();
  let f;
  if (r && e > d ? f = d : r && e < c ? f = c : f = e, s.updateProgress(f), o.cssMode) {
    const w = s.isHorizontal();
    if (t === 0)
      l[w ? "scrollLeft" : "scrollTop"] = -f;
    else {
      if (!s.support.smoothScroll)
        return $s({
          swiper: s,
          targetPosition: -f,
          side: w ? "left" : "top"
        }), !0;
      l.scrollTo({
        [w ? "left" : "top"]: -f,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (s.setTransition(0), s.setTranslate(f), n && (s.emit("beforeTransitionStart", t, a), s.emit("transitionEnd"))) : (s.setTransition(t), s.setTranslate(f), n && (s.emit("beforeTransitionStart", t, a), s.emit("transitionStart")), s.animating || (s.animating = !0, s.onTranslateToWrapperTransitionEnd || (s.onTranslateToWrapperTransitionEnd = function(u) {
    !s || s.destroyed || u.target === this && (s.$wrapperEl[0].removeEventListener("transitionend", s.onTranslateToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onTranslateToWrapperTransitionEnd), s.onTranslateToWrapperTransitionEnd = null, delete s.onTranslateToWrapperTransitionEnd, n && s.emit("transitionEnd"));
  }), s.$wrapperEl[0].addEventListener("transitionend", s.onTranslateToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onTranslateToWrapperTransitionEnd))), !0;
}
const du = {
  getTranslate: au,
  setTranslate: iu,
  minTranslate: su,
  maxTranslate: ou,
  translateTo: lu
};
function cu(e, t) {
  const n = this;
  n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t);
}
function vs(e) {
  let {
    swiper: t,
    runCallbacks: n,
    direction: r,
    step: a
  } = e;
  const {
    activeIndex: s,
    previousIndex: o
  } = t;
  let l = r;
  if (l || (s > o ? l = "next" : s < o ? l = "prev" : l = "reset"), t.emit(`transition${a}`), n && s !== o) {
    if (l === "reset") {
      t.emit(`slideResetTransition${a}`);
      return;
    }
    t.emit(`slideChangeTransition${a}`), l === "next" ? t.emit(`slideNextTransition${a}`) : t.emit(`slidePrevTransition${a}`);
  }
}
function uu(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: r
  } = n;
  r.cssMode || (r.autoHeight && n.updateAutoHeight(), vs({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function fu(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: r
  } = n;
  n.animating = !1, !r.cssMode && (n.setTransition(0), vs({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
const wu = {
  setTransition: cu,
  transitionStart: uu,
  transitionEnd: fu
};
function hu(e, t, n, r, a) {
  if (e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), typeof e != "number" && typeof e != "string")
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);
  if (typeof e == "string") {
    const C = parseInt(e, 10);
    if (!isFinite(C))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
    e = C;
  }
  const s = this;
  let o = e;
  o < 0 && (o = 0);
  const {
    params: l,
    snapGrid: d,
    slidesGrid: c,
    previousIndex: f,
    activeIndex: w,
    rtlTranslate: u,
    wrapperEl: p,
    enabled: h
  } = s;
  if (s.animating && l.preventInteractionOnTransition || !h && !r && !a)
    return !1;
  const m = Math.min(s.params.slidesPerGroupSkip, o);
  let $ = m + Math.floor((o - m) / s.params.slidesPerGroup);
  $ >= d.length && ($ = d.length - 1), (w || l.initialSlide || 0) === (f || 0) && n && s.emit("beforeSlideChangeStart");
  const g = -d[$];
  if (s.updateProgress(g), l.normalizeSlideIndex)
    for (let C = 0; C < c.length; C += 1) {
      const y = -Math.floor(g * 100), x = Math.floor(c[C] * 100), E = Math.floor(c[C + 1] * 100);
      typeof c[C + 1] < "u" ? y >= x && y < E - (E - x) / 2 ? o = C : y >= x && y < E && (o = C + 1) : y >= x && (o = C);
    }
  if (s.initialized && o !== w && (!s.allowSlideNext && g < s.translate && g < s.minTranslate() || !s.allowSlidePrev && g > s.translate && g > s.maxTranslate() && (w || 0) !== o))
    return !1;
  let v;
  if (o > w ? v = "next" : o < w ? v = "prev" : v = "reset", u && -g === s.translate || !u && g === s.translate)
    return s.updateActiveIndex(o), l.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), l.effect !== "slide" && s.setTranslate(g), v !== "reset" && (s.transitionStart(n, v), s.transitionEnd(n, v)), !1;
  if (l.cssMode) {
    const C = s.isHorizontal(), y = u ? g : -g;
    if (t === 0) {
      const x = s.virtual && s.params.virtual.enabled;
      x && (s.wrapperEl.style.scrollSnapType = "none", s._immediateVirtual = !0), p[C ? "scrollLeft" : "scrollTop"] = y, x && requestAnimationFrame(() => {
        s.wrapperEl.style.scrollSnapType = "", s._swiperImmediateVirtual = !1;
      });
    } else {
      if (!s.support.smoothScroll)
        return $s({
          swiper: s,
          targetPosition: y,
          side: C ? "left" : "top"
        }), !0;
      p.scrollTo({
        [C ? "left" : "top"]: y,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return s.setTransition(t), s.setTranslate(g), s.updateActiveIndex(o), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, r), s.transitionStart(n, v), t === 0 ? s.transitionEnd(n, v) : s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function(y) {
    !s || s.destroyed || y.target === this && (s.$wrapperEl[0].removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(n, v));
  }), s.$wrapperEl[0].addEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd)), !0;
}
function pu(e, t, n, r) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0);
  const a = this;
  let s = e;
  return a.params.loop && (s += a.loopedSlides), a.slideTo(s, t, n, r);
}
function mu(e, t, n) {
  e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
  const r = this, {
    animating: a,
    enabled: s,
    params: o
  } = r;
  if (!s)
    return r;
  let l = o.slidesPerGroup;
  o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (l = Math.max(r.slidesPerViewDynamic("current", !0), 1));
  const d = r.activeIndex < o.slidesPerGroupSkip ? 1 : l;
  if (o.loop) {
    if (a && o.loopPreventsSlide)
      return !1;
    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft;
  }
  return o.rewind && r.isEnd ? r.slideTo(0, e, t, n) : r.slideTo(r.activeIndex + d, e, t, n);
}
function gu(e, t, n) {
  e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
  const r = this, {
    params: a,
    animating: s,
    snapGrid: o,
    slidesGrid: l,
    rtlTranslate: d,
    enabled: c
  } = r;
  if (!c)
    return r;
  if (a.loop) {
    if (s && a.loopPreventsSlide)
      return !1;
    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft;
  }
  const f = d ? r.translate : -r.translate;
  function w($) {
    return $ < 0 ? -Math.floor(Math.abs($)) : Math.floor($);
  }
  const u = w(f), p = o.map(($) => w($));
  let h = o[p.indexOf(u) - 1];
  if (typeof h > "u" && a.cssMode) {
    let $;
    o.forEach((g, v) => {
      u >= g && ($ = v);
    }), typeof $ < "u" && (h = o[$ > 0 ? $ - 1 : $]);
  }
  let m = 0;
  if (typeof h < "u" && (m = l.indexOf(h), m < 0 && (m = r.activeIndex - 1), a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (m = m - r.slidesPerViewDynamic("previous", !0) + 1, m = Math.max(m, 0))), a.rewind && r.isBeginning) {
    const $ = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
    return r.slideTo($, e, t, n);
  }
  return r.slideTo(m, e, t, n);
}
function $u(e, t, n) {
  e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
  const r = this;
  return r.slideTo(r.activeIndex, e, t, n);
}
function xu(e, t, n, r) {
  e === void 0 && (e = this.params.speed), t === void 0 && (t = !0), r === void 0 && (r = 0.5);
  const a = this;
  let s = a.activeIndex;
  const o = Math.min(a.params.slidesPerGroupSkip, s), l = o + Math.floor((s - o) / a.params.slidesPerGroup), d = a.rtlTranslate ? a.translate : -a.translate;
  if (d >= a.snapGrid[l]) {
    const c = a.snapGrid[l], f = a.snapGrid[l + 1];
    d - c > (f - c) * r && (s += a.params.slidesPerGroup);
  } else {
    const c = a.snapGrid[l - 1], f = a.snapGrid[l];
    d - c <= (f - c) * r && (s -= a.params.slidesPerGroup);
  }
  return s = Math.max(s, 0), s = Math.min(s, a.slidesGrid.length - 1), a.slideTo(s, e, t, n);
}
function vu() {
  const e = this, {
    params: t,
    $wrapperEl: n
  } = e, r = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let a = e.clickedIndex, s;
  if (t.loop) {
    if (e.animating)
      return;
    s = parseInt(D(e.clickedSlide).attr("data-swiper-slide-index"), 10), t.centeredSlides ? a < e.loopedSlides - r / 2 || a > e.slides.length - e.loopedSlides + r / 2 ? (e.loopFix(), a = n.children(`.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`).eq(0).index(), Pr(() => {
      e.slideTo(a);
    })) : e.slideTo(a) : a > e.slides.length - r ? (e.loopFix(), a = n.children(`.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`).eq(0).index(), Pr(() => {
      e.slideTo(a);
    })) : e.slideTo(a);
  } else
    e.slideTo(a);
}
const bu = {
  slideTo: hu,
  slideToLoop: pu,
  slideNext: mu,
  slidePrev: gu,
  slideReset: $u,
  slideToClosest: xu,
  slideToClickedSlide: vu
};
function yu() {
  const e = this, t = Be(), {
    params: n,
    $wrapperEl: r
  } = e, a = r.children().length > 0 ? D(r.children()[0].parentNode) : r;
  a.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();
  let s = a.children(`.${n.slideClass}`);
  if (n.loopFillGroupWithBlank) {
    const d = n.slidesPerGroup - s.length % n.slidesPerGroup;
    if (d !== n.slidesPerGroup) {
      for (let c = 0; c < d; c += 1) {
        const f = D(t.createElement("div")).addClass(`${n.slideClass} ${n.slideBlankClass}`);
        a.append(f);
      }
      s = a.children(`.${n.slideClass}`);
    }
  }
  n.slidesPerView === "auto" && !n.loopedSlides && (n.loopedSlides = s.length), e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10)), e.loopedSlides += n.loopAdditionalSlides, e.loopedSlides > s.length && (e.loopedSlides = s.length);
  const o = [], l = [];
  s.each((d, c) => {
    const f = D(d);
    c < e.loopedSlides && l.push(d), c < s.length && c >= s.length - e.loopedSlides && o.push(d), f.attr("data-swiper-slide-index", c);
  });
  for (let d = 0; d < l.length; d += 1)
    a.append(D(l[d].cloneNode(!0)).addClass(n.slideDuplicateClass));
  for (let d = o.length - 1; d >= 0; d -= 1)
    a.prepend(D(o[d].cloneNode(!0)).addClass(n.slideDuplicateClass));
}
function Cu() {
  const e = this;
  e.emit("beforeLoopFix");
  const {
    activeIndex: t,
    slides: n,
    loopedSlides: r,
    allowSlidePrev: a,
    allowSlideNext: s,
    snapGrid: o,
    rtlTranslate: l
  } = e;
  let d;
  e.allowSlidePrev = !0, e.allowSlideNext = !0;
  const f = -o[t] - e.getTranslate();
  t < r ? (d = n.length - r * 3 + t, d += r, e.slideTo(d, 0, !1, !0) && f !== 0 && e.setTranslate((l ? -e.translate : e.translate) - f)) : t >= n.length - r && (d = -n.length + t + r, d += r, e.slideTo(d, 0, !1, !0) && f !== 0 && e.setTranslate((l ? -e.translate : e.translate) - f)), e.allowSlidePrev = a, e.allowSlideNext = s, e.emit("loopFix");
}
function Eu() {
  const e = this, {
    $wrapperEl: t,
    params: n,
    slides: r
  } = e;
  t.children(`.${n.slideClass}.${n.slideDuplicateClass},.${n.slideClass}.${n.slideBlankClass}`).remove(), r.removeAttr("data-swiper-slide-index");
}
const Nu = {
  loopCreate: yu,
  loopFix: Cu,
  loopDestroy: Eu
};
function Tu(e) {
  const t = this;
  if (t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)
    return;
  const n = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab";
}
function Su() {
  const e = this;
  e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "");
}
const ju = {
  setGrabCursor: Tu,
  unsetGrabCursor: Su
};
function Pu(e, t) {
  t === void 0 && (t = this);
  function n(r) {
    return !r || r === Be() || r === Ne() ? null : (r.assignedSlot && (r = r.assignedSlot), r.closest(e) || n(r.getRootNode().host));
  }
  return n(t);
}
function Au(e) {
  const t = this, n = Be(), r = Ne(), a = t.touchEventsData, {
    params: s,
    touches: o,
    enabled: l
  } = t;
  if (!l || t.animating && s.preventInteractionOnTransition)
    return;
  !t.animating && s.cssMode && s.loop && t.loopFix();
  let d = e;
  d.originalEvent && (d = d.originalEvent);
  let c = D(d.target);
  if (s.touchEventsTarget === "wrapper" && !c.closest(t.wrapperEl).length || (a.isTouchEvent = d.type === "touchstart", !a.isTouchEvent && "which" in d && d.which === 3) || !a.isTouchEvent && "button" in d && d.button > 0 || a.isTouched && a.isMoved)
    return;
  !!s.noSwipingClass && s.noSwipingClass !== "" && d.target && d.target.shadowRoot && e.path && e.path[0] && (c = D(e.path[0]));
  const w = s.noSwipingSelector ? s.noSwipingSelector : `.${s.noSwipingClass}`, u = !!(d.target && d.target.shadowRoot);
  if (s.noSwiping && (u ? Pu(w, d.target) : c.closest(w)[0])) {
    t.allowClick = !0;
    return;
  }
  if (s.swipeHandler && !c.closest(s.swipeHandler)[0])
    return;
  o.currentX = d.type === "touchstart" ? d.targetTouches[0].pageX : d.pageX, o.currentY = d.type === "touchstart" ? d.targetTouches[0].pageY : d.pageY;
  const p = o.currentX, h = o.currentY, m = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection, $ = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold;
  if (m && (p <= $ || p >= r.innerWidth - $))
    if (m === "prevent")
      e.preventDefault();
    else
      return;
  if (Object.assign(a, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), o.startX = p, o.startY = h, a.touchStartTime = mn(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, s.threshold > 0 && (a.allowThresholdMove = !1), d.type !== "touchstart") {
    let g = !0;
    c.is(a.focusableElements) && (g = !1, c[0].nodeName === "SELECT" && (a.isTouched = !1)), n.activeElement && D(n.activeElement).is(a.focusableElements) && n.activeElement !== c[0] && n.activeElement.blur();
    const v = g && t.allowTouchMove && s.touchStartPreventDefault;
    (s.touchStartForcePreventDefault || v) && !c[0].isContentEditable && d.preventDefault();
  }
  t.params.freeMode && t.params.freeMode.enabled && t.freeMode && t.animating && !s.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", d);
}
function Iu(e) {
  const t = Be(), n = this, r = n.touchEventsData, {
    params: a,
    touches: s,
    rtlTranslate: o,
    enabled: l
  } = n;
  if (!l)
    return;
  let d = e;
  if (d.originalEvent && (d = d.originalEvent), !r.isTouched) {
    r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", d);
    return;
  }
  if (r.isTouchEvent && d.type !== "touchmove")
    return;
  const c = d.type === "touchmove" && d.targetTouches && (d.targetTouches[0] || d.changedTouches[0]), f = d.type === "touchmove" ? c.pageX : d.pageX, w = d.type === "touchmove" ? c.pageY : d.pageY;
  if (d.preventedByNestedSwiper) {
    s.startX = f, s.startY = w;
    return;
  }
  if (!n.allowTouchMove) {
    D(d.target).is(r.focusableElements) || (n.allowClick = !1), r.isTouched && (Object.assign(s, {
      startX: f,
      startY: w,
      currentX: f,
      currentY: w
    }), r.touchStartTime = mn());
    return;
  }
  if (r.isTouchEvent && a.touchReleaseOnEdges && !a.loop) {
    if (n.isVertical()) {
      if (w < s.startY && n.translate <= n.maxTranslate() || w > s.startY && n.translate >= n.minTranslate()) {
        r.isTouched = !1, r.isMoved = !1;
        return;
      }
    } else if (f < s.startX && n.translate <= n.maxTranslate() || f > s.startX && n.translate >= n.minTranslate())
      return;
  }
  if (r.isTouchEvent && t.activeElement && d.target === t.activeElement && D(d.target).is(r.focusableElements)) {
    r.isMoved = !0, n.allowClick = !1;
    return;
  }
  if (r.allowTouchCallbacks && n.emit("touchMove", d), d.targetTouches && d.targetTouches.length > 1)
    return;
  s.currentX = f, s.currentY = w;
  const u = s.currentX - s.startX, p = s.currentY - s.startY;
  if (n.params.threshold && Math.sqrt(u ** 2 + p ** 2) < n.params.threshold)
    return;
  if (typeof r.isScrolling > "u") {
    let g;
    n.isHorizontal() && s.currentY === s.startY || n.isVertical() && s.currentX === s.startX ? r.isScrolling = !1 : u * u + p * p >= 25 && (g = Math.atan2(Math.abs(p), Math.abs(u)) * 180 / Math.PI, r.isScrolling = n.isHorizontal() ? g > a.touchAngle : 90 - g > a.touchAngle);
  }
  if (r.isScrolling && n.emit("touchMoveOpposite", d), typeof r.startMoving > "u" && (s.currentX !== s.startX || s.currentY !== s.startY) && (r.startMoving = !0), r.isScrolling) {
    r.isTouched = !1;
    return;
  }
  if (!r.startMoving)
    return;
  n.allowClick = !1, !a.cssMode && d.cancelable && d.preventDefault(), a.touchMoveStopPropagation && !a.nested && d.stopPropagation(), r.isMoved || (a.loop && !a.cssMode && n.loopFix(), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"), r.allowMomentumBounce = !1, a.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", d)), n.emit("sliderMove", d), r.isMoved = !0;
  let h = n.isHorizontal() ? u : p;
  s.diff = h, h *= a.touchRatio, o && (h = -h), n.swipeDirection = h > 0 ? "prev" : "next", r.currentTranslate = h + r.startTranslate;
  let m = !0, $ = a.resistanceRatio;
  if (a.touchReleaseOnEdges && ($ = 0), h > 0 && r.currentTranslate > n.minTranslate() ? (m = !1, a.resistance && (r.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + r.startTranslate + h) ** $)) : h < 0 && r.currentTranslate < n.maxTranslate() && (m = !1, a.resistance && (r.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - r.startTranslate - h) ** $)), m && (d.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (r.currentTranslate = r.startTranslate), a.threshold > 0)
    if (Math.abs(h) > a.threshold || r.allowThresholdMove) {
      if (!r.allowThresholdMove) {
        r.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, r.currentTranslate = r.startTranslate, s.diff = n.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY;
        return;
      }
    } else {
      r.currentTranslate = r.startTranslate;
      return;
    }
  !a.followFinger || a.cssMode || ((a.freeMode && a.freeMode.enabled && n.freeMode || a.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), n.params.freeMode && a.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate));
}
function Ou(e) {
  const t = this, n = t.touchEventsData, {
    params: r,
    touches: a,
    rtlTranslate: s,
    slidesGrid: o,
    enabled: l
  } = t;
  if (!l)
    return;
  let d = e;
  if (d.originalEvent && (d = d.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", d), n.allowTouchCallbacks = !1, !n.isTouched) {
    n.isMoved && r.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
    return;
  }
  r.grabCursor && n.isMoved && n.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const c = mn(), f = c - n.touchStartTime;
  if (t.allowClick) {
    const v = d.path || d.composedPath && d.composedPath();
    t.updateClickedSlide(v && v[0] || d.target), t.emit("tap click", d), f < 300 && c - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", d);
  }
  if (n.lastClickTime = mn(), Pr(() => {
    t.destroyed || (t.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !t.swipeDirection || a.diff === 0 || n.currentTranslate === n.startTranslate) {
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    return;
  }
  n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
  let w;
  if (r.followFinger ? w = s ? t.translate : -t.translate : w = -n.currentTranslate, r.cssMode)
    return;
  if (t.params.freeMode && r.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: w
    });
    return;
  }
  let u = 0, p = t.slidesSizesGrid[0];
  for (let v = 0; v < o.length; v += v < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
    const C = v < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
    typeof o[v + C] < "u" ? w >= o[v] && w < o[v + C] && (u = v, p = o[v + C] - o[v]) : w >= o[v] && (u = v, p = o[o.length - 1] - o[o.length - 2]);
  }
  let h = null, m = null;
  r.rewind && (t.isBeginning ? m = t.params.virtual && t.params.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (h = 0));
  const $ = (w - o[u]) / p, g = u < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
  if (f > r.longSwipesMs) {
    if (!r.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && ($ >= r.longSwipesRatio ? t.slideTo(r.rewind && t.isEnd ? h : u + g) : t.slideTo(u)), t.swipeDirection === "prev" && ($ > 1 - r.longSwipesRatio ? t.slideTo(u + g) : m !== null && $ < 0 && Math.abs($) > r.longSwipesRatio ? t.slideTo(m) : t.slideTo(u));
  } else {
    if (!r.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (d.target === t.navigation.nextEl || d.target === t.navigation.prevEl) ? d.target === t.navigation.nextEl ? t.slideTo(u + g) : t.slideTo(u) : (t.swipeDirection === "next" && t.slideTo(h !== null ? h : u + g), t.swipeDirection === "prev" && t.slideTo(m !== null ? m : u));
  }
}
function ii() {
  const e = this, {
    params: t,
    el: n
  } = e;
  if (n && n.offsetWidth === 0)
    return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: r,
    allowSlidePrev: a,
    snapGrid: s
  } = e;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = a, e.allowSlideNext = r, e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow();
}
function _u(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function Lu() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: n,
    enabled: r
  } = e;
  if (!r)
    return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let a;
  const s = e.maxTranslate() - e.minTranslate();
  s === 0 ? a = 0 : a = (e.translate - e.minTranslate()) / s, a !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
let si = !1;
function Ru() {
}
const bs = (e, t) => {
  const n = Be(), {
    params: r,
    touchEvents: a,
    el: s,
    wrapperEl: o,
    device: l,
    support: d
  } = e, c = !!r.nested, f = t === "on" ? "addEventListener" : "removeEventListener", w = t;
  if (!d.touch)
    s[f](a.start, e.onTouchStart, !1), n[f](a.move, e.onTouchMove, c), n[f](a.end, e.onTouchEnd, !1);
  else {
    const u = a.start === "touchstart" && d.passiveListener && r.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    s[f](a.start, e.onTouchStart, u), s[f](a.move, e.onTouchMove, d.passiveListener ? {
      passive: !1,
      capture: c
    } : c), s[f](a.end, e.onTouchEnd, u), a.cancel && s[f](a.cancel, e.onTouchEnd, u);
  }
  (r.preventClicks || r.preventClicksPropagation) && s[f]("click", e.onClick, !0), r.cssMode && o[f]("scroll", e.onScroll), r.updateOnWindowResize ? e[w](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", ii, !0) : e[w]("observerUpdate", ii, !0);
};
function Mu() {
  const e = this, t = Be(), {
    params: n,
    support: r
  } = e;
  e.onTouchStart = Au.bind(e), e.onTouchMove = Iu.bind(e), e.onTouchEnd = Ou.bind(e), n.cssMode && (e.onScroll = Lu.bind(e)), e.onClick = _u.bind(e), r.touch && !si && (t.addEventListener("touchstart", Ru), si = !0), bs(e, "on");
}
function Fu() {
  bs(this, "off");
}
const Du = {
  attachEvents: Mu,
  detachEvents: Fu
}, oi = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function ku() {
  const e = this, {
    activeIndex: t,
    initialized: n,
    loopedSlides: r = 0,
    params: a,
    $el: s
  } = e, o = a.breakpoints;
  if (!o || o && Object.keys(o).length === 0)
    return;
  const l = e.getBreakpoint(o, e.params.breakpointsBase, e.el);
  if (!l || e.currentBreakpoint === l)
    return;
  const c = (l in o ? o[l] : void 0) || e.originalParams, f = oi(e, a), w = oi(e, c), u = a.enabled;
  f && !w ? (s.removeClass(`${a.containerModifierClass}grid ${a.containerModifierClass}grid-column`), e.emitContainerClasses()) : !f && w && (s.addClass(`${a.containerModifierClass}grid`), (c.grid.fill && c.grid.fill === "column" || !c.grid.fill && a.grid.fill === "column") && s.addClass(`${a.containerModifierClass}grid-column`), e.emitContainerClasses());
  const p = c.direction && c.direction !== a.direction, h = a.loop && (c.slidesPerView !== a.slidesPerView || p);
  p && n && e.changeDirection(), Ge(e.params, c);
  const m = e.params.enabled;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), u && !m ? e.disable() : !u && m && e.enable(), e.currentBreakpoint = l, e.emit("_beforeBreakpoint", c), h && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - r + e.loopedSlides, 0, !1)), e.emit("breakpoint", c);
}
function Bu(e, t, n) {
  if (t === void 0 && (t = "window"), !e || t === "container" && !n)
    return;
  let r = !1;
  const a = Ne(), s = t === "window" ? a.innerHeight : n.clientHeight, o = Object.keys(e).map((l) => {
    if (typeof l == "string" && l.indexOf("@") === 0) {
      const d = parseFloat(l.substr(1));
      return {
        value: s * d,
        point: l
      };
    }
    return {
      value: l,
      point: l
    };
  });
  o.sort((l, d) => parseInt(l.value, 10) - parseInt(d.value, 10));
  for (let l = 0; l < o.length; l += 1) {
    const {
      point: d,
      value: c
    } = o[l];
    t === "window" ? a.matchMedia(`(min-width: ${c}px)`).matches && (r = d) : c <= n.clientWidth && (r = d);
  }
  return r || "max";
}
const Hu = {
  setBreakpoint: ku,
  getBreakpoint: Bu
};
function Gu(e, t) {
  const n = [];
  return e.forEach((r) => {
    typeof r == "object" ? Object.keys(r).forEach((a) => {
      r[a] && n.push(t + a);
    }) : typeof r == "string" && n.push(t + r);
  }), n;
}
function Vu() {
  const e = this, {
    classNames: t,
    params: n,
    rtl: r,
    $el: a,
    device: s,
    support: o
  } = e, l = Gu(["initialized", n.direction, {
    "pointer-events": !o.touch
  }, {
    "free-mode": e.params.freeMode && n.freeMode.enabled
  }, {
    autoheight: n.autoHeight
  }, {
    rtl: r
  }, {
    grid: n.grid && n.grid.rows > 1
  }, {
    "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
  }, {
    android: s.android
  }, {
    ios: s.ios
  }, {
    "css-mode": n.cssMode
  }, {
    centered: n.cssMode && n.centeredSlides
  }, {
    "watch-progress": n.watchSlidesProgress
  }], n.containerModifierClass);
  t.push(...l), a.addClass([...t].join(" ")), e.emitContainerClasses();
}
function Uu() {
  const e = this, {
    $el: t,
    classNames: n
  } = e;
  t.removeClass(n.join(" ")), e.emitContainerClasses();
}
const Wu = {
  addClasses: Vu,
  removeClasses: Uu
};
function zu(e, t, n, r, a, s) {
  const o = Ne();
  let l;
  function d() {
    s && s();
  }
  !D(e).parent("picture")[0] && (!e.complete || !a) && t ? (l = new o.Image(), l.onload = d, l.onerror = d, r && (l.sizes = r), n && (l.srcset = n), t && (l.src = t)) : d();
}
function Yu() {
  const e = this;
  e.imagesToLoad = e.$el.find("img");
  function t() {
    typeof e > "u" || e === null || !e || e.destroyed || (e.imagesLoaded !== void 0 && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
  }
  for (let n = 0; n < e.imagesToLoad.length; n += 1) {
    const r = e.imagesToLoad[n];
    e.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, t);
  }
}
const Zu = {
  loadImage: zu,
  preloadImages: Yu
};
function Xu() {
  const e = this, {
    isLocked: t,
    params: n
  } = e, {
    slidesOffsetBefore: r
  } = n;
  if (r) {
    const a = e.slides.length - 1, s = e.slidesGrid[a] + e.slidesSizesGrid[a] + r * 2;
    e.isLocked = e.size > s;
  } else
    e.isLocked = e.snapGrid.length === 1;
  n.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), n.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
const Ku = {
  checkOverflow: Xu
}, li = {
  init: !0,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 0,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // Images
  preloadImages: !0,
  updateOnImagesReady: !0,
  // loop
  loop: !1,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: !1,
  loopPreventsSlide: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function qu(e, t) {
  return function(r) {
    r === void 0 && (r = {});
    const a = Object.keys(r)[0], s = r[a];
    if (typeof s != "object" || s === null) {
      Ge(t, r);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(a) >= 0 && e[a] === !0 && (e[a] = {
      auto: !0
    }), !(a in e && "enabled" in s)) {
      Ge(t, r);
      return;
    }
    e[a] === !0 && (e[a] = {
      enabled: !0
    }), typeof e[a] == "object" && !("enabled" in e[a]) && (e[a].enabled = !0), e[a] || (e[a] = {
      enabled: !1
    }), Ge(t, r);
  };
}
const sr = {
  eventsEmitter: Y1,
  update: ru,
  translate: du,
  transition: wu,
  slide: bu,
  loop: Nu,
  grabCursor: ju,
  events: Du,
  breakpoints: Hu,
  checkOverflow: Ku,
  classes: Wu,
  images: Zu
}, or = {};
let Zt = class it {
  constructor() {
    let t, n;
    for (var r = arguments.length, a = new Array(r), s = 0; s < r; s++)
      a[s] = arguments[s];
    if (a.length === 1 && a[0].constructor && Object.prototype.toString.call(a[0]).slice(8, -1) === "Object" ? n = a[0] : [t, n] = a, n || (n = {}), n = Ge({}, n), t && !n.el && (n.el = t), n.el && D(n.el).length > 1) {
      const c = [];
      return D(n.el).each((f) => {
        const w = Ge({}, n, {
          el: f
        });
        c.push(new it(w));
      }), c;
    }
    const o = this;
    o.__swiper__ = !0, o.support = xs(), o.device = G1({
      userAgent: n.userAgent
    }), o.browser = U1(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], n.modules && Array.isArray(n.modules) && o.modules.push(...n.modules);
    const l = {};
    o.modules.forEach((c) => {
      c({
        swiper: o,
        extendParams: qu(n, l),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    const d = Ge({}, li, l);
    return o.params = Ge({}, d, or, n), o.originalParams = Ge({}, o.params), o.passedParams = Ge({}, n), o.params && o.params.on && Object.keys(o.params.on).forEach((c) => {
      o.on(c, o.params.on[c]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), o.$ = D, Object.assign(o, {
      enabled: o.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: D(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return o.params.direction === "horizontal";
      },
      isVertical() {
        return o.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      // Locks
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      // Touch Events
      touchEvents: function() {
        const f = ["touchstart", "touchmove", "touchend", "touchcancel"], w = ["pointerdown", "pointermove", "pointerup"];
        return o.touchEventsTouch = {
          start: f[0],
          move: f[1],
          end: f[2],
          cancel: f[3]
        }, o.touchEventsDesktop = {
          start: w[0],
          move: w[1],
          end: w[2]
        }, o.support.touch || !o.params.simulateTouch ? o.touchEventsTouch : o.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: o.params.focusableElements,
        // Last click time
        lastClickTime: mn(),
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, n) {
    const r = this;
    t = Math.min(Math.max(t, 0), 1);
    const a = r.minTranslate(), o = (r.maxTranslate() - a) * t + a;
    r.translateTo(o, typeof n > "u" ? 0 : n), r.updateActiveIndex(), r.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el)
      return;
    const n = t.el.className.split(" ").filter((r) => r.indexOf("swiper") === 0 || r.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", n.join(" "));
  }
  getSlideClasses(t) {
    const n = this;
    return n.destroyed ? "" : t.className.split(" ").filter((r) => r.indexOf("swiper-slide") === 0 || r.indexOf(n.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el)
      return;
    const n = [];
    t.slides.each((r) => {
      const a = t.getSlideClasses(r);
      n.push({
        slideEl: r,
        classNames: a
      }), t.emit("_slideClass", r, a);
    }), t.emit("_slideClasses", n);
  }
  slidesPerViewDynamic(t, n) {
    t === void 0 && (t = "current"), n === void 0 && (n = !1);
    const r = this, {
      params: a,
      slides: s,
      slidesGrid: o,
      slidesSizesGrid: l,
      size: d,
      activeIndex: c
    } = r;
    let f = 1;
    if (a.centeredSlides) {
      let w = s[c].swiperSlideSize, u;
      for (let p = c + 1; p < s.length; p += 1)
        s[p] && !u && (w += s[p].swiperSlideSize, f += 1, w > d && (u = !0));
      for (let p = c - 1; p >= 0; p -= 1)
        s[p] && !u && (w += s[p].swiperSlideSize, f += 1, w > d && (u = !0));
    } else if (t === "current")
      for (let w = c + 1; w < s.length; w += 1)
        (n ? o[w] + l[w] - o[c] < d : o[w] - o[c] < d) && (f += 1);
    else
      for (let w = c - 1; w >= 0; w -= 1)
        o[c] - o[w] < d && (f += 1);
    return f;
  }
  update() {
    const t = this;
    if (!t || t.destroyed)
      return;
    const {
      snapGrid: n,
      params: r
    } = t;
    r.breakpoints && t.setBreakpoint(), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function a() {
      const o = t.rtlTranslate ? t.translate * -1 : t.translate, l = Math.min(Math.max(o, t.maxTranslate()), t.minTranslate());
      t.setTranslate(l), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let s;
    t.params.freeMode && t.params.freeMode.enabled ? (a(), t.params.autoHeight && t.updateAutoHeight()) : ((t.params.slidesPerView === "auto" || t.params.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides ? s = t.slideTo(t.slides.length - 1, 0, !1, !0) : s = t.slideTo(t.activeIndex, 0, !1, !0), s || a()), r.watchOverflow && n !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, n) {
    n === void 0 && (n = !0);
    const r = this, a = r.params.direction;
    return t || (t = a === "horizontal" ? "vertical" : "horizontal"), t === a || t !== "horizontal" && t !== "vertical" || (r.$el.removeClass(`${r.params.containerModifierClass}${a}`).addClass(`${r.params.containerModifierClass}${t}`), r.emitContainerClasses(), r.params.direction = t, r.slides.each((s) => {
      t === "vertical" ? s.style.width = "" : s.style.height = "";
    }), r.emit("changeDirection"), n && r.update()), r;
  }
  mount(t) {
    const n = this;
    if (n.mounted)
      return !0;
    const r = D(t || n.params.el);
    if (t = r[0], !t)
      return !1;
    t.swiper = n;
    const a = () => `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let o = (() => {
      if (t && t.shadowRoot && t.shadowRoot.querySelector) {
        const l = D(t.shadowRoot.querySelector(a()));
        return l.children = (d) => r.children(d), l;
      }
      return r.children(a());
    })();
    if (o.length === 0 && n.params.createElements) {
      const d = Be().createElement("div");
      o = D(d), d.className = n.params.wrapperClass, r.append(d), r.children(`.${n.params.slideClass}`).each((c) => {
        o.append(c);
      });
    }
    return Object.assign(n, {
      $el: r,
      el: t,
      $wrapperEl: o,
      wrapperEl: o[0],
      mounted: !0,
      // RTL
      rtl: t.dir.toLowerCase() === "rtl" || r.css("direction") === "rtl",
      rtlTranslate: n.params.direction === "horizontal" && (t.dir.toLowerCase() === "rtl" || r.css("direction") === "rtl"),
      wrongRTL: o.css("display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const n = this;
    return n.initialized || n.mount(t) === !1 || (n.emit("beforeInit"), n.params.breakpoints && n.setBreakpoint(), n.addClasses(), n.params.loop && n.loopCreate(), n.updateSize(), n.updateSlides(), n.params.watchOverflow && n.checkOverflow(), n.params.grabCursor && n.enabled && n.setGrabCursor(), n.params.preloadImages && n.preloadImages(), n.params.loop ? n.slideTo(n.params.initialSlide + n.loopedSlides, 0, n.params.runCallbacksOnInit, !1, !0) : n.slideTo(n.params.initialSlide, 0, n.params.runCallbacksOnInit, !1, !0), n.attachEvents(), n.initialized = !0, n.emit("init"), n.emit("afterInit")), n;
  }
  destroy(t, n) {
    t === void 0 && (t = !0), n === void 0 && (n = !0);
    const r = this, {
      params: a,
      $el: s,
      $wrapperEl: o,
      slides: l
    } = r;
    return typeof r.params > "u" || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), a.loop && r.loopDestroy(), n && (r.removeClasses(), s.removeAttr("style"), o.removeAttr("style"), l && l.length && l.removeClass([a.slideVisibleClass, a.slideActiveClass, a.slideNextClass, a.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), r.emit("destroy"), Object.keys(r.eventsListeners).forEach((d) => {
      r.off(d);
    }), t !== !1 && (r.$el[0].swiper = null, F1(r)), r.destroyed = !0), null;
  }
  static extendDefaults(t) {
    Ge(or, t);
  }
  static get extendedDefaults() {
    return or;
  }
  static get defaults() {
    return li;
  }
  static installModule(t) {
    it.prototype.__modules__ || (it.prototype.__modules__ = []);
    const n = it.prototype.__modules__;
    typeof t == "function" && n.indexOf(t) < 0 && n.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((n) => it.installModule(n)), it) : (it.installModule(t), it);
  }
};
Object.keys(sr).forEach((e) => {
  Object.keys(sr[e]).forEach((t) => {
    Zt.prototype[t] = sr[e][t];
  });
});
Zt.use([W1, z1]);
function ys(e, t, n, r) {
  const a = Be();
  return e.params.createElements && Object.keys(r).forEach((s) => {
    if (!n[s] && n.auto === !0) {
      let o = e.$el.children(`.${r[s]}`)[0];
      o || (o = a.createElement("div"), o.className = r[s], e.$el.append(o)), n[s] = o, t[s] = o;
    }
  }), n;
}
function Ju(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: a
  } = e;
  n({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock"
    }
  }), t.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };
  function s(u) {
    let p;
    return u && (p = D(u), t.params.uniqueNavElements && typeof u == "string" && p.length > 1 && t.$el.find(u).length === 1 && (p = t.$el.find(u))), p;
  }
  function o(u, p) {
    const h = t.params.navigation;
    u && u.length > 0 && (u[p ? "addClass" : "removeClass"](h.disabledClass), u[0] && u[0].tagName === "BUTTON" && (u[0].disabled = p), t.params.watchOverflow && t.enabled && u[t.isLocked ? "addClass" : "removeClass"](h.lockClass));
  }
  function l() {
    if (t.params.loop)
      return;
    const {
      $nextEl: u,
      $prevEl: p
    } = t.navigation;
    o(p, t.isBeginning && !t.params.rewind), o(u, t.isEnd && !t.params.rewind);
  }
  function d(u) {
    u.preventDefault(), !(t.isBeginning && !t.params.loop && !t.params.rewind) && t.slidePrev();
  }
  function c(u) {
    u.preventDefault(), !(t.isEnd && !t.params.loop && !t.params.rewind) && t.slideNext();
  }
  function f() {
    const u = t.params.navigation;
    if (t.params.navigation = ys(t, t.originalParams.navigation, t.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(u.nextEl || u.prevEl))
      return;
    const p = s(u.nextEl), h = s(u.prevEl);
    p && p.length > 0 && p.on("click", c), h && h.length > 0 && h.on("click", d), Object.assign(t.navigation, {
      $nextEl: p,
      nextEl: p && p[0],
      $prevEl: h,
      prevEl: h && h[0]
    }), t.enabled || (p && p.addClass(u.lockClass), h && h.addClass(u.lockClass));
  }
  function w() {
    const {
      $nextEl: u,
      $prevEl: p
    } = t.navigation;
    u && u.length && (u.off("click", c), u.removeClass(t.params.navigation.disabledClass)), p && p.length && (p.off("click", d), p.removeClass(t.params.navigation.disabledClass));
  }
  r("init", () => {
    f(), l();
  }), r("toEdge fromEdge lock unlock", () => {
    l();
  }), r("destroy", () => {
    w();
  }), r("enable disable", () => {
    const {
      $nextEl: u,
      $prevEl: p
    } = t.navigation;
    u && u[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass), p && p[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass);
  }), r("click", (u, p) => {
    const {
      $nextEl: h,
      $prevEl: m
    } = t.navigation, $ = p.target;
    if (t.params.navigation.hideOnClick && !D($).is(m) && !D($).is(h)) {
      if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === $ || t.pagination.el.contains($)))
        return;
      let g;
      h ? g = h.hasClass(t.params.navigation.hiddenClass) : m && (g = m.hasClass(t.params.navigation.hiddenClass)), a(g === !0 ? "navigationShow" : "navigationHide"), h && h.toggleClass(t.params.navigation.hiddenClass), m && m.toggleClass(t.params.navigation.hiddenClass);
    }
  }), Object.assign(t.navigation, {
    update: l,
    init: f,
    destroy: w
  });
}
function kt(e) {
  return e === void 0 && (e = ""), `.${e.trim().replace(/([\.:!\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Cs(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: a
  } = e;
  const s = "swiper-pagination";
  n({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (h) => h,
      formatFractionTotal: (h) => h,
      bulletClass: `${s}-bullet`,
      bulletActiveClass: `${s}-bullet-active`,
      modifierClass: `${s}-`,
      currentClass: `${s}-current`,
      totalClass: `${s}-total`,
      hiddenClass: `${s}-hidden`,
      progressbarFillClass: `${s}-progressbar-fill`,
      progressbarOppositeClass: `${s}-progressbar-opposite`,
      clickableClass: `${s}-clickable`,
      lockClass: `${s}-lock`,
      horizontalClass: `${s}-horizontal`,
      verticalClass: `${s}-vertical`
    }
  }), t.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let o, l = 0;
  function d() {
    return !t.params.pagination.el || !t.pagination.el || !t.pagination.$el || t.pagination.$el.length === 0;
  }
  function c(h, m) {
    const {
      bulletActiveClass: $
    } = t.params.pagination;
    h[m]().addClass(`${$}-${m}`)[m]().addClass(`${$}-${m}-${m}`);
  }
  function f() {
    const h = t.rtl, m = t.params.pagination;
    if (d())
      return;
    const $ = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length, g = t.pagination.$el;
    let v;
    const C = t.params.loop ? Math.ceil(($ - t.loopedSlides * 2) / t.params.slidesPerGroup) : t.snapGrid.length;
    if (t.params.loop ? (v = Math.ceil((t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup), v > $ - 1 - t.loopedSlides * 2 && (v -= $ - t.loopedSlides * 2), v > C - 1 && (v -= C), v < 0 && t.params.paginationType !== "bullets" && (v = C + v)) : typeof t.snapIndex < "u" ? v = t.snapIndex : v = t.activeIndex || 0, m.type === "bullets" && t.pagination.bullets && t.pagination.bullets.length > 0) {
      const y = t.pagination.bullets;
      let x, E, O;
      if (m.dynamicBullets && (o = y.eq(0)[t.isHorizontal() ? "outerWidth" : "outerHeight"](!0), g.css(t.isHorizontal() ? "width" : "height", `${o * (m.dynamicMainBullets + 4)}px`), m.dynamicMainBullets > 1 && t.previousIndex !== void 0 && (l += v - (t.previousIndex - t.loopedSlides || 0), l > m.dynamicMainBullets - 1 ? l = m.dynamicMainBullets - 1 : l < 0 && (l = 0)), x = Math.max(v - l, 0), E = x + (Math.min(y.length, m.dynamicMainBullets) - 1), O = (E + x) / 2), y.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((I) => `${m.bulletActiveClass}${I}`).join(" ")), g.length > 1)
        y.each((I) => {
          const B = D(I), P = B.index();
          P === v && B.addClass(m.bulletActiveClass), m.dynamicBullets && (P >= x && P <= E && B.addClass(`${m.bulletActiveClass}-main`), P === x && c(B, "prev"), P === E && c(B, "next"));
        });
      else {
        const I = y.eq(v), B = I.index();
        if (I.addClass(m.bulletActiveClass), m.dynamicBullets) {
          const P = y.eq(x), A = y.eq(E);
          for (let L = x; L <= E; L += 1)
            y.eq(L).addClass(`${m.bulletActiveClass}-main`);
          if (t.params.loop)
            if (B >= y.length) {
              for (let L = m.dynamicMainBullets; L >= 0; L -= 1)
                y.eq(y.length - L).addClass(`${m.bulletActiveClass}-main`);
              y.eq(y.length - m.dynamicMainBullets - 1).addClass(`${m.bulletActiveClass}-prev`);
            } else
              c(P, "prev"), c(A, "next");
          else
            c(P, "prev"), c(A, "next");
        }
      }
      if (m.dynamicBullets) {
        const I = Math.min(y.length, m.dynamicMainBullets + 4), B = (o * I - o) / 2 - O * o, P = h ? "right" : "left";
        y.css(t.isHorizontal() ? P : "top", `${B}px`);
      }
    }
    if (m.type === "fraction" && (g.find(kt(m.currentClass)).text(m.formatFractionCurrent(v + 1)), g.find(kt(m.totalClass)).text(m.formatFractionTotal(C))), m.type === "progressbar") {
      let y;
      m.progressbarOpposite ? y = t.isHorizontal() ? "vertical" : "horizontal" : y = t.isHorizontal() ? "horizontal" : "vertical";
      const x = (v + 1) / C;
      let E = 1, O = 1;
      y === "horizontal" ? E = x : O = x, g.find(kt(m.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${E}) scaleY(${O})`).transition(t.params.speed);
    }
    m.type === "custom" && m.renderCustom ? (g.html(m.renderCustom(t, v + 1, C)), a("paginationRender", g[0])) : a("paginationUpdate", g[0]), t.params.watchOverflow && t.enabled && g[t.isLocked ? "addClass" : "removeClass"](m.lockClass);
  }
  function w() {
    const h = t.params.pagination;
    if (d())
      return;
    const m = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length, $ = t.pagination.$el;
    let g = "";
    if (h.type === "bullets") {
      let v = t.params.loop ? Math.ceil((m - t.loopedSlides * 2) / t.params.slidesPerGroup) : t.snapGrid.length;
      t.params.freeMode && t.params.freeMode.enabled && !t.params.loop && v > m && (v = m);
      for (let C = 0; C < v; C += 1)
        h.renderBullet ? g += h.renderBullet.call(t, C, h.bulletClass) : g += `<${h.bulletElement} class="${h.bulletClass}"></${h.bulletElement}>`;
      $.html(g), t.pagination.bullets = $.find(kt(h.bulletClass));
    }
    h.type === "fraction" && (h.renderFraction ? g = h.renderFraction.call(t, h.currentClass, h.totalClass) : g = `<span class="${h.currentClass}"></span> / <span class="${h.totalClass}"></span>`, $.html(g)), h.type === "progressbar" && (h.renderProgressbar ? g = h.renderProgressbar.call(t, h.progressbarFillClass) : g = `<span class="${h.progressbarFillClass}"></span>`, $.html(g)), h.type !== "custom" && a("paginationRender", t.pagination.$el[0]);
  }
  function u() {
    t.params.pagination = ys(t, t.originalParams.pagination, t.params.pagination, {
      el: "swiper-pagination"
    });
    const h = t.params.pagination;
    if (!h.el)
      return;
    let m = D(h.el);
    m.length !== 0 && (t.params.uniqueNavElements && typeof h.el == "string" && m.length > 1 && (m = t.$el.find(h.el), m.length > 1 && (m = m.filter(($) => D($).parents(".swiper")[0] === t.el))), h.type === "bullets" && h.clickable && m.addClass(h.clickableClass), m.addClass(h.modifierClass + h.type), m.addClass(t.isHorizontal() ? h.horizontalClass : h.verticalClass), h.type === "bullets" && h.dynamicBullets && (m.addClass(`${h.modifierClass}${h.type}-dynamic`), l = 0, h.dynamicMainBullets < 1 && (h.dynamicMainBullets = 1)), h.type === "progressbar" && h.progressbarOpposite && m.addClass(h.progressbarOppositeClass), h.clickable && m.on("click", kt(h.bulletClass), function(g) {
      g.preventDefault();
      let v = D(this).index() * t.params.slidesPerGroup;
      t.params.loop && (v += t.loopedSlides), t.slideTo(v);
    }), Object.assign(t.pagination, {
      $el: m,
      el: m[0]
    }), t.enabled || m.addClass(h.lockClass));
  }
  function p() {
    const h = t.params.pagination;
    if (d())
      return;
    const m = t.pagination.$el;
    m.removeClass(h.hiddenClass), m.removeClass(h.modifierClass + h.type), m.removeClass(t.isHorizontal() ? h.horizontalClass : h.verticalClass), t.pagination.bullets && t.pagination.bullets.removeClass && t.pagination.bullets.removeClass(h.bulletActiveClass), h.clickable && m.off("click", kt(h.bulletClass));
  }
  r("init", () => {
    u(), w(), f();
  }), r("activeIndexChange", () => {
    (t.params.loop || typeof t.snapIndex > "u") && f();
  }), r("snapIndexChange", () => {
    t.params.loop || f();
  }), r("slidesLengthChange", () => {
    t.params.loop && (w(), f());
  }), r("snapGridLengthChange", () => {
    t.params.loop || (w(), f());
  }), r("destroy", () => {
    p();
  }), r("enable disable", () => {
    const {
      $el: h
    } = t.pagination;
    h && h[t.enabled ? "removeClass" : "addClass"](t.params.pagination.lockClass);
  }), r("lock unlock", () => {
    f();
  }), r("click", (h, m) => {
    const $ = m.target, {
      $el: g
    } = t.pagination;
    if (t.params.pagination.el && t.params.pagination.hideOnClick && g.length > 0 && !D($).hasClass(t.params.pagination.bulletClass)) {
      if (t.navigation && (t.navigation.nextEl && $ === t.navigation.nextEl || t.navigation.prevEl && $ === t.navigation.prevEl))
        return;
      const v = g.hasClass(t.params.pagination.hiddenClass);
      a(v === !0 ? "paginationShow" : "paginationHide"), g.toggleClass(t.params.pagination.hiddenClass);
    }
  }), Object.assign(t.pagination, {
    render: w,
    update: f,
    init: u,
    destroy: p
  });
}
function Qu(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: a
  } = e;
  const s = Ne();
  n({
    zoom: {
      enabled: !1,
      maxRatio: 3,
      minRatio: 1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), t.zoom = {
    enabled: !1
  };
  let o = 1, l = !1, d, c, f;
  const w = {
    $slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    $imageEl: void 0,
    $imageWrapEl: void 0,
    maxRatio: 3
  }, u = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, p = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let h = 1;
  Object.defineProperty(t.zoom, "scale", {
    get() {
      return h;
    },
    set(j) {
      if (h !== j) {
        const M = w.$imageEl ? w.$imageEl[0] : void 0, R = w.$slideEl ? w.$slideEl[0] : void 0;
        a("zoomChange", j, M, R);
      }
      h = j;
    }
  });
  function m(j) {
    if (j.targetTouches.length < 2)
      return 1;
    const M = j.targetTouches[0].pageX, R = j.targetTouches[0].pageY, N = j.targetTouches[1].pageX, T = j.targetTouches[1].pageY;
    return Math.sqrt((N - M) ** 2 + (T - R) ** 2);
  }
  function $(j) {
    const M = t.support, R = t.params.zoom;
    if (c = !1, f = !1, !M.gestures) {
      if (j.type !== "touchstart" || j.type === "touchstart" && j.targetTouches.length < 2)
        return;
      c = !0, w.scaleStart = m(j);
    }
    if ((!w.$slideEl || !w.$slideEl.length) && (w.$slideEl = D(j.target).closest(`.${t.params.slideClass}`), w.$slideEl.length === 0 && (w.$slideEl = t.slides.eq(t.activeIndex)), w.$imageEl = w.$slideEl.find(`.${R.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), w.$imageWrapEl = w.$imageEl.parent(`.${R.containerClass}`), w.maxRatio = w.$imageWrapEl.attr("data-swiper-zoom") || R.maxRatio, w.$imageWrapEl.length === 0)) {
      w.$imageEl = void 0;
      return;
    }
    w.$imageEl && w.$imageEl.transition(0), l = !0;
  }
  function g(j) {
    const M = t.support, R = t.params.zoom, N = t.zoom;
    if (!M.gestures) {
      if (j.type !== "touchmove" || j.type === "touchmove" && j.targetTouches.length < 2)
        return;
      f = !0, w.scaleMove = m(j);
    }
    if (!w.$imageEl || w.$imageEl.length === 0) {
      j.type === "gesturechange" && $(j);
      return;
    }
    M.gestures ? N.scale = j.scale * o : N.scale = w.scaleMove / w.scaleStart * o, N.scale > w.maxRatio && (N.scale = w.maxRatio - 1 + (N.scale - w.maxRatio + 1) ** 0.5), N.scale < R.minRatio && (N.scale = R.minRatio + 1 - (R.minRatio - N.scale + 1) ** 0.5), w.$imageEl.transform(`translate3d(0,0,0) scale(${N.scale})`);
  }
  function v(j) {
    const M = t.device, R = t.support, N = t.params.zoom, T = t.zoom;
    if (!R.gestures) {
      if (!c || !f || j.type !== "touchend" || j.type === "touchend" && j.changedTouches.length < 2 && !M.android)
        return;
      c = !1, f = !1;
    }
    !w.$imageEl || w.$imageEl.length === 0 || (T.scale = Math.max(Math.min(T.scale, w.maxRatio), N.minRatio), w.$imageEl.transition(t.params.speed).transform(`translate3d(0,0,0) scale(${T.scale})`), o = T.scale, l = !1, T.scale === 1 && (w.$slideEl = void 0));
  }
  function C(j) {
    const M = t.device;
    !w.$imageEl || w.$imageEl.length === 0 || u.isTouched || (M.android && j.cancelable && j.preventDefault(), u.isTouched = !0, u.touchesStart.x = j.type === "touchstart" ? j.targetTouches[0].pageX : j.pageX, u.touchesStart.y = j.type === "touchstart" ? j.targetTouches[0].pageY : j.pageY);
  }
  function y(j) {
    const M = t.zoom;
    if (!w.$imageEl || w.$imageEl.length === 0 || (t.allowClick = !1, !u.isTouched || !w.$slideEl))
      return;
    u.isMoved || (u.width = w.$imageEl[0].offsetWidth, u.height = w.$imageEl[0].offsetHeight, u.startX = Ar(w.$imageWrapEl[0], "x") || 0, u.startY = Ar(w.$imageWrapEl[0], "y") || 0, w.slideWidth = w.$slideEl[0].offsetWidth, w.slideHeight = w.$slideEl[0].offsetHeight, w.$imageWrapEl.transition(0));
    const R = u.width * M.scale, N = u.height * M.scale;
    if (!(R < w.slideWidth && N < w.slideHeight)) {
      if (u.minX = Math.min(w.slideWidth / 2 - R / 2, 0), u.maxX = -u.minX, u.minY = Math.min(w.slideHeight / 2 - N / 2, 0), u.maxY = -u.minY, u.touchesCurrent.x = j.type === "touchmove" ? j.targetTouches[0].pageX : j.pageX, u.touchesCurrent.y = j.type === "touchmove" ? j.targetTouches[0].pageY : j.pageY, !u.isMoved && !l) {
        if (t.isHorizontal() && (Math.floor(u.minX) === Math.floor(u.startX) && u.touchesCurrent.x < u.touchesStart.x || Math.floor(u.maxX) === Math.floor(u.startX) && u.touchesCurrent.x > u.touchesStart.x)) {
          u.isTouched = !1;
          return;
        }
        if (!t.isHorizontal() && (Math.floor(u.minY) === Math.floor(u.startY) && u.touchesCurrent.y < u.touchesStart.y || Math.floor(u.maxY) === Math.floor(u.startY) && u.touchesCurrent.y > u.touchesStart.y)) {
          u.isTouched = !1;
          return;
        }
      }
      j.cancelable && j.preventDefault(), j.stopPropagation(), u.isMoved = !0, u.currentX = u.touchesCurrent.x - u.touchesStart.x + u.startX, u.currentY = u.touchesCurrent.y - u.touchesStart.y + u.startY, u.currentX < u.minX && (u.currentX = u.minX + 1 - (u.minX - u.currentX + 1) ** 0.8), u.currentX > u.maxX && (u.currentX = u.maxX - 1 + (u.currentX - u.maxX + 1) ** 0.8), u.currentY < u.minY && (u.currentY = u.minY + 1 - (u.minY - u.currentY + 1) ** 0.8), u.currentY > u.maxY && (u.currentY = u.maxY - 1 + (u.currentY - u.maxY + 1) ** 0.8), p.prevPositionX || (p.prevPositionX = u.touchesCurrent.x), p.prevPositionY || (p.prevPositionY = u.touchesCurrent.y), p.prevTime || (p.prevTime = Date.now()), p.x = (u.touchesCurrent.x - p.prevPositionX) / (Date.now() - p.prevTime) / 2, p.y = (u.touchesCurrent.y - p.prevPositionY) / (Date.now() - p.prevTime) / 2, Math.abs(u.touchesCurrent.x - p.prevPositionX) < 2 && (p.x = 0), Math.abs(u.touchesCurrent.y - p.prevPositionY) < 2 && (p.y = 0), p.prevPositionX = u.touchesCurrent.x, p.prevPositionY = u.touchesCurrent.y, p.prevTime = Date.now(), w.$imageWrapEl.transform(`translate3d(${u.currentX}px, ${u.currentY}px,0)`);
    }
  }
  function x() {
    const j = t.zoom;
    if (!w.$imageEl || w.$imageEl.length === 0)
      return;
    if (!u.isTouched || !u.isMoved) {
      u.isTouched = !1, u.isMoved = !1;
      return;
    }
    u.isTouched = !1, u.isMoved = !1;
    let M = 300, R = 300;
    const N = p.x * M, T = u.currentX + N, k = p.y * R, V = u.currentY + k;
    p.x !== 0 && (M = Math.abs((T - u.currentX) / p.x)), p.y !== 0 && (R = Math.abs((V - u.currentY) / p.y));
    const H = Math.max(M, R);
    u.currentX = T, u.currentY = V;
    const Q = u.width * j.scale, z = u.height * j.scale;
    u.minX = Math.min(w.slideWidth / 2 - Q / 2, 0), u.maxX = -u.minX, u.minY = Math.min(w.slideHeight / 2 - z / 2, 0), u.maxY = -u.minY, u.currentX = Math.max(Math.min(u.currentX, u.maxX), u.minX), u.currentY = Math.max(Math.min(u.currentY, u.maxY), u.minY), w.$imageWrapEl.transition(H).transform(`translate3d(${u.currentX}px, ${u.currentY}px,0)`);
  }
  function E() {
    const j = t.zoom;
    w.$slideEl && t.previousIndex !== t.activeIndex && (w.$imageEl && w.$imageEl.transform("translate3d(0,0,0) scale(1)"), w.$imageWrapEl && w.$imageWrapEl.transform("translate3d(0,0,0)"), j.scale = 1, o = 1, w.$slideEl = void 0, w.$imageEl = void 0, w.$imageWrapEl = void 0);
  }
  function O(j) {
    const M = t.zoom, R = t.params.zoom;
    if (w.$slideEl || (j && j.target && (w.$slideEl = D(j.target).closest(`.${t.params.slideClass}`)), w.$slideEl || (t.params.virtual && t.params.virtual.enabled && t.virtual ? w.$slideEl = t.$wrapperEl.children(`.${t.params.slideActiveClass}`) : w.$slideEl = t.slides.eq(t.activeIndex)), w.$imageEl = w.$slideEl.find(`.${R.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), w.$imageWrapEl = w.$imageEl.parent(`.${R.containerClass}`)), !w.$imageEl || w.$imageEl.length === 0 || !w.$imageWrapEl || w.$imageWrapEl.length === 0)
      return;
    t.params.cssMode && (t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.touchAction = "none"), w.$slideEl.addClass(`${R.zoomedSlideClass}`);
    let N, T, k, V, H, Q, z, Y, ee, re, te, ve, S, be, Ae, Fe, ut, Rt;
    typeof u.touchesStart.x > "u" && j ? (N = j.type === "touchend" ? j.changedTouches[0].pageX : j.pageX, T = j.type === "touchend" ? j.changedTouches[0].pageY : j.pageY) : (N = u.touchesStart.x, T = u.touchesStart.y), M.scale = w.$imageWrapEl.attr("data-swiper-zoom") || R.maxRatio, o = w.$imageWrapEl.attr("data-swiper-zoom") || R.maxRatio, j ? (ut = w.$slideEl[0].offsetWidth, Rt = w.$slideEl[0].offsetHeight, k = w.$slideEl.offset().left + s.scrollX, V = w.$slideEl.offset().top + s.scrollY, H = k + ut / 2 - N, Q = V + Rt / 2 - T, ee = w.$imageEl[0].offsetWidth, re = w.$imageEl[0].offsetHeight, te = ee * M.scale, ve = re * M.scale, S = Math.min(ut / 2 - te / 2, 0), be = Math.min(Rt / 2 - ve / 2, 0), Ae = -S, Fe = -be, z = H * M.scale, Y = Q * M.scale, z < S && (z = S), z > Ae && (z = Ae), Y < be && (Y = be), Y > Fe && (Y = Fe)) : (z = 0, Y = 0), w.$imageWrapEl.transition(300).transform(`translate3d(${z}px, ${Y}px,0)`), w.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${M.scale})`);
  }
  function I() {
    const j = t.zoom, M = t.params.zoom;
    w.$slideEl || (t.params.virtual && t.params.virtual.enabled && t.virtual ? w.$slideEl = t.$wrapperEl.children(`.${t.params.slideActiveClass}`) : w.$slideEl = t.slides.eq(t.activeIndex), w.$imageEl = w.$slideEl.find(`.${M.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), w.$imageWrapEl = w.$imageEl.parent(`.${M.containerClass}`)), !(!w.$imageEl || w.$imageEl.length === 0 || !w.$imageWrapEl || w.$imageWrapEl.length === 0) && (t.params.cssMode && (t.wrapperEl.style.overflow = "", t.wrapperEl.style.touchAction = ""), j.scale = 1, o = 1, w.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), w.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), w.$slideEl.removeClass(`${M.zoomedSlideClass}`), w.$slideEl = void 0);
  }
  function B(j) {
    const M = t.zoom;
    M.scale && M.scale !== 1 ? I() : O(j);
  }
  function P() {
    const j = t.support, M = t.touchEvents.start === "touchstart" && j.passiveListener && t.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, R = j.passiveListener ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: M,
      activeListenerWithCapture: R
    };
  }
  function A() {
    return `.${t.params.slideClass}`;
  }
  function L(j) {
    const {
      passiveListener: M
    } = P(), R = A();
    t.$wrapperEl[j]("gesturestart", R, $, M), t.$wrapperEl[j]("gesturechange", R, g, M), t.$wrapperEl[j]("gestureend", R, v, M);
  }
  function U() {
    d || (d = !0, L("on"));
  }
  function X() {
    d && (d = !1, L("off"));
  }
  function W() {
    const j = t.zoom;
    if (j.enabled)
      return;
    j.enabled = !0;
    const M = t.support, {
      passiveListener: R,
      activeListenerWithCapture: N
    } = P(), T = A();
    M.gestures ? (t.$wrapperEl.on(t.touchEvents.start, U, R), t.$wrapperEl.on(t.touchEvents.end, X, R)) : t.touchEvents.start === "touchstart" && (t.$wrapperEl.on(t.touchEvents.start, T, $, R), t.$wrapperEl.on(t.touchEvents.move, T, g, N), t.$wrapperEl.on(t.touchEvents.end, T, v, R), t.touchEvents.cancel && t.$wrapperEl.on(t.touchEvents.cancel, T, v, R)), t.$wrapperEl.on(t.touchEvents.move, `.${t.params.zoom.containerClass}`, y, N);
  }
  function Z() {
    const j = t.zoom;
    if (!j.enabled)
      return;
    const M = t.support;
    j.enabled = !1;
    const {
      passiveListener: R,
      activeListenerWithCapture: N
    } = P(), T = A();
    M.gestures ? (t.$wrapperEl.off(t.touchEvents.start, U, R), t.$wrapperEl.off(t.touchEvents.end, X, R)) : t.touchEvents.start === "touchstart" && (t.$wrapperEl.off(t.touchEvents.start, T, $, R), t.$wrapperEl.off(t.touchEvents.move, T, g, N), t.$wrapperEl.off(t.touchEvents.end, T, v, R), t.touchEvents.cancel && t.$wrapperEl.off(t.touchEvents.cancel, T, v, R)), t.$wrapperEl.off(t.touchEvents.move, `.${t.params.zoom.containerClass}`, y, N);
  }
  r("init", () => {
    t.params.zoom.enabled && W();
  }), r("destroy", () => {
    Z();
  }), r("touchStart", (j, M) => {
    t.zoom.enabled && C(M);
  }), r("touchEnd", (j, M) => {
    t.zoom.enabled && x();
  }), r("doubleTap", (j, M) => {
    !t.animating && t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && B(M);
  }), r("transitionEnd", () => {
    t.zoom.enabled && t.params.zoom.enabled && E();
  }), r("slideChange", () => {
    t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && E();
  }), Object.assign(t.zoom, {
    enable: W,
    disable: Z,
    in: O,
    out: I,
    toggle: B
  });
}
function Pt(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r
  } = e;
  n({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let a = !1, s = !1;
  t.thumbs = {
    swiper: null
  };
  function o() {
    const c = t.thumbs.swiper;
    if (!c || c.destroyed)
      return;
    const f = c.clickedIndex, w = c.clickedSlide;
    if (w && D(w).hasClass(t.params.thumbs.slideThumbActiveClass) || typeof f > "u" || f === null)
      return;
    let u;
    if (c.params.loop ? u = parseInt(D(c.clickedSlide).attr("data-swiper-slide-index"), 10) : u = f, t.params.loop) {
      let p = t.activeIndex;
      t.slides.eq(p).hasClass(t.params.slideDuplicateClass) && (t.loopFix(), t._clientLeft = t.$wrapperEl[0].clientLeft, p = t.activeIndex);
      const h = t.slides.eq(p).prevAll(`[data-swiper-slide-index="${u}"]`).eq(0).index(), m = t.slides.eq(p).nextAll(`[data-swiper-slide-index="${u}"]`).eq(0).index();
      typeof h > "u" ? u = m : typeof m > "u" ? u = h : m - p < p - h ? u = m : u = h;
    }
    t.slideTo(u);
  }
  function l() {
    const {
      thumbs: c
    } = t.params;
    if (a)
      return !1;
    a = !0;
    const f = t.constructor;
    if (c.swiper instanceof f)
      t.thumbs.swiper = c.swiper, Object.assign(t.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(t.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      });
    else if (on(c.swiper)) {
      const w = Object.assign({}, c.swiper);
      Object.assign(w, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), t.thumbs.swiper = new f(w), s = !0;
    }
    return t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", o), !0;
  }
  function d(c) {
    const f = t.thumbs.swiper;
    if (!f || f.destroyed)
      return;
    const w = f.params.slidesPerView === "auto" ? f.slidesPerViewDynamic() : f.params.slidesPerView, u = t.params.thumbs.autoScrollOffset, p = u && !f.params.loop;
    if (t.realIndex !== f.realIndex || p) {
      let $ = f.activeIndex, g, v;
      if (f.params.loop) {
        f.slides.eq($).hasClass(f.params.slideDuplicateClass) && (f.loopFix(), f._clientLeft = f.$wrapperEl[0].clientLeft, $ = f.activeIndex);
        const C = f.slides.eq($).prevAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index(), y = f.slides.eq($).nextAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index();
        typeof C > "u" ? g = y : typeof y > "u" ? g = C : y - $ === $ - C ? g = f.params.slidesPerGroup > 1 ? y : $ : y - $ < $ - C ? g = y : g = C, v = t.activeIndex > t.previousIndex ? "next" : "prev";
      } else
        g = t.realIndex, v = g > t.previousIndex ? "next" : "prev";
      p && (g += v === "next" ? u : -1 * u), f.visibleSlidesIndexes && f.visibleSlidesIndexes.indexOf(g) < 0 && (f.params.centeredSlides ? g > $ ? g = g - Math.floor(w / 2) + 1 : g = g + Math.floor(w / 2) - 1 : g > $ && f.params.slidesPerGroup, f.slideTo(g, c ? 0 : void 0));
    }
    let h = 1;
    const m = t.params.thumbs.slideThumbActiveClass;
    if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (h = t.params.slidesPerView), t.params.thumbs.multipleActiveThumbs || (h = 1), h = Math.floor(h), f.slides.removeClass(m), f.params.loop || f.params.virtual && f.params.virtual.enabled)
      for (let $ = 0; $ < h; $ += 1)
        f.$wrapperEl.children(`[data-swiper-slide-index="${t.realIndex + $}"]`).addClass(m);
    else
      for (let $ = 0; $ < h; $ += 1)
        f.slides.eq(t.realIndex + $).addClass(m);
  }
  r("beforeInit", () => {
    const {
      thumbs: c
    } = t.params;
    !c || !c.swiper || (l(), d(!0));
  }), r("slideChange update resize observerUpdate", () => {
    d();
  }), r("setTransition", (c, f) => {
    const w = t.thumbs.swiper;
    !w || w.destroyed || w.setTransition(f);
  }), r("beforeDestroy", () => {
    const c = t.thumbs.swiper;
    !c || c.destroyed || s && c.destroy();
  }), Object.assign(t.thumbs, {
    init: l,
    update: d
  });
}
function At(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function ht(e, t) {
  const n = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((r) => n.indexOf(r) < 0).forEach((r) => {
    typeof e[r] > "u" ? e[r] = t[r] : At(t[r]) && At(e[r]) && Object.keys(t[r]).length > 0 ? t[r].__swiper__ ? e[r] = t[r] : ht(e[r], t[r]) : e[r] = t[r];
  });
}
function Es(e) {
  return e === void 0 && (e = {}), e.navigation && typeof e.navigation.nextEl > "u" && typeof e.navigation.prevEl > "u";
}
function Ns(e) {
  return e === void 0 && (e = {}), e.pagination && typeof e.pagination.el > "u";
}
function Ts(e) {
  return e === void 0 && (e = {}), e.scrollbar && typeof e.scrollbar.el > "u";
}
function Ss(e) {
  e === void 0 && (e = "");
  const t = e.split(" ").map((r) => r.trim()).filter((r) => !!r), n = [];
  return t.forEach((r) => {
    n.indexOf(r) < 0 && n.push(r);
  }), n.join(" ");
}
const js = [
  "modules",
  "init",
  "_direction",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_preloadImages",
  "updateOnImagesReady",
  "_loop",
  "_loopAdditionalSlides",
  "_loopedSlides",
  "_loopFillGroupWithBlank",
  "loopPreventsSlide",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideBlankClass",
  "slideActiveClass",
  "slideDuplicateActiveClass",
  "slideVisibleClass",
  "slideDuplicateClass",
  "slideNextClass",
  "slideDuplicateNextClass",
  "slidePrevClass",
  "slideDuplicatePrevClass",
  "wrapperClass",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "lazy",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom"
];
function ef(e) {
  e === void 0 && (e = {});
  const t = {
    on: {}
  }, n = {}, r = {};
  ht(t, Zt.defaults), ht(t, Zt.extendedDefaults), t._emitClasses = !0, t.init = !1;
  const a = {}, s = js.map((o) => o.replace(/_/, ""));
  return Object.keys(e).forEach((o) => {
    s.indexOf(o) >= 0 ? At(e[o]) ? (t[o] = {}, r[o] = {}, ht(t[o], e[o]), ht(r[o], e[o])) : (t[o] = e[o], r[o] = e[o]) : o.search(/on[A-Z]/) === 0 && typeof e[o] == "function" ? n[`${o[2].toLowerCase()}${o.substr(3)}`] = e[o] : a[o] = e[o];
  }), ["navigation", "pagination", "scrollbar"].forEach((o) => {
    t[o] === !0 && (t[o] = {}), t[o] === !1 && delete t[o];
  }), {
    params: t,
    passedParams: r,
    rest: a,
    events: n
  };
}
function tf(e, t) {
  let {
    el: n,
    nextEl: r,
    prevEl: a,
    paginationEl: s,
    scrollbarEl: o,
    swiper: l
  } = e;
  Es(t) && r && a && (l.params.navigation.nextEl = r, l.originalParams.navigation.nextEl = r, l.params.navigation.prevEl = a, l.originalParams.navigation.prevEl = a), Ns(t) && s && (l.params.pagination.el = s, l.originalParams.pagination.el = s), Ts(t) && o && (l.params.scrollbar.el = o, l.originalParams.scrollbar.el = o), l.init(n);
}
function Ps(e, t) {
  let n = t.slidesPerView;
  if (t.breakpoints) {
    const a = Zt.prototype.getBreakpoint(t.breakpoints), s = a in t.breakpoints ? t.breakpoints[a] : void 0;
    s && s.slidesPerView && (n = s.slidesPerView);
  }
  let r = Math.ceil(parseFloat(t.loopedSlides || n, 10));
  return r += t.loopAdditionalSlides, r > e.length && (r = e.length), r;
}
function nf(e, t, n) {
  const r = t.map((d, c) => /* @__PURE__ */ $e.cloneElement(d, {
    swiper: e,
    "data-swiper-slide-index": c
  }));
  function a(d, c, f) {
    return /* @__PURE__ */ $e.cloneElement(d, {
      key: `${d.key}-duplicate-${c}-${f}`,
      className: `${d.props.className || ""} ${n.slideDuplicateClass}`
    });
  }
  if (n.loopFillGroupWithBlank) {
    const d = n.slidesPerGroup - r.length % n.slidesPerGroup;
    if (d !== n.slidesPerGroup)
      for (let c = 0; c < d; c += 1) {
        const f = /* @__PURE__ */ $e.createElement("div", {
          className: `${n.slideClass} ${n.slideBlankClass}`
        });
        r.push(f);
      }
  }
  n.slidesPerView === "auto" && !n.loopedSlides && (n.loopedSlides = r.length);
  const s = Ps(r, n), o = [], l = [];
  return r.forEach((d, c) => {
    c < s && l.push(a(d, c, "prepend")), c < r.length && c >= r.length - s && o.push(a(d, c, "append"));
  }), e && (e.loopedSlides = s), [...o, ...r, ...l];
}
function rf(e, t, n, r) {
  const a = [];
  if (!t)
    return a;
  const s = (c) => {
    a.indexOf(c) < 0 && a.push(c);
  }, o = r.map((c) => c.key), l = n.map((c) => c.key);
  return o.join("") !== l.join("") && s("children"), r.length !== n.length && s("children"), js.filter((c) => c[0] === "_").map((c) => c.replace(/_/, "")).forEach((c) => {
    if (c in e && c in t)
      if (At(e[c]) && At(t[c])) {
        const f = Object.keys(e[c]), w = Object.keys(t[c]);
        f.length !== w.length ? s(c) : (f.forEach((u) => {
          e[c][u] !== t[c][u] && s(c);
        }), w.forEach((u) => {
          e[c][u] !== t[c][u] && s(c);
        }));
      } else
        e[c] !== t[c] && s(c);
  }), a;
}
function As(e) {
  const t = [];
  return $e.Children.toArray(e).forEach((n) => {
    n.type && n.type.displayName === "SwiperSlide" ? t.push(n) : n.props && n.props.children && As(n.props.children).forEach((r) => t.push(r));
  }), t;
}
function af(e) {
  const t = [], n = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return $e.Children.toArray(e).forEach((r) => {
    if (r.type && r.type.displayName === "SwiperSlide")
      t.push(r);
    else if (r.props && r.props.slot && n[r.props.slot])
      n[r.props.slot].push(r);
    else if (r.props && r.props.children) {
      const a = As(r.props.children);
      a.length > 0 ? a.forEach((s) => t.push(s)) : n["container-end"].push(r);
    } else
      n["container-end"].push(r);
  }), {
    slides: t,
    slots: n
  };
}
function sf(e) {
  let {
    swiper: t,
    slides: n,
    passedParams: r,
    changedParams: a,
    nextEl: s,
    prevEl: o,
    scrollbarEl: l,
    paginationEl: d
  } = e;
  const c = a.filter((E) => E !== "children" && E !== "direction"), {
    params: f,
    pagination: w,
    navigation: u,
    scrollbar: p,
    virtual: h,
    thumbs: m
  } = t;
  let $, g, v, C, y;
  a.includes("thumbs") && r.thumbs && r.thumbs.swiper && f.thumbs && !f.thumbs.swiper && ($ = !0), a.includes("controller") && r.controller && r.controller.control && f.controller && !f.controller.control && (g = !0), a.includes("pagination") && r.pagination && (r.pagination.el || d) && (f.pagination || f.pagination === !1) && w && !w.el && (v = !0), a.includes("scrollbar") && r.scrollbar && (r.scrollbar.el || l) && (f.scrollbar || f.scrollbar === !1) && p && !p.el && (C = !0), a.includes("navigation") && r.navigation && (r.navigation.prevEl || o) && (r.navigation.nextEl || s) && (f.navigation || f.navigation === !1) && u && !u.prevEl && !u.nextEl && (y = !0);
  const x = (E) => {
    t[E] && (t[E].destroy(), E === "navigation" ? (f[E].prevEl = void 0, f[E].nextEl = void 0, t[E].prevEl = void 0, t[E].nextEl = void 0) : (f[E].el = void 0, t[E].el = void 0));
  };
  c.forEach((E) => {
    if (At(f[E]) && At(r[E]))
      ht(f[E], r[E]);
    else {
      const O = r[E];
      (O === !0 || O === !1) && (E === "navigation" || E === "pagination" || E === "scrollbar") ? O === !1 && x(E) : f[E] = r[E];
    }
  }), c.includes("controller") && !g && t.controller && t.controller.control && f.controller && f.controller.control && (t.controller.control = f.controller.control), a.includes("children") && h && f.virtual.enabled ? (h.slides = n, h.update(!0)) : a.includes("children") && t.lazy && t.params.lazy.enabled && t.lazy.load(), $ && m.init() && m.update(!0), g && (t.controller.control = f.controller.control), v && (d && (f.pagination.el = d), w.init(), w.render(), w.update()), C && (l && (f.scrollbar.el = l), p.init(), p.updateSize(), p.setTranslate()), y && (s && (f.navigation.nextEl = s), o && (f.navigation.prevEl = o), u.init(), u.update()), a.includes("allowSlideNext") && (t.allowSlideNext = r.allowSlideNext), a.includes("allowSlidePrev") && (t.allowSlidePrev = r.allowSlidePrev), a.includes("direction") && t.changeDirection(r.direction, !1), t.update();
}
function of(e) {
  !e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
}
function lf(e, t, n) {
  if (!n)
    return null;
  const r = e.isHorizontal() ? {
    [e.rtlTranslate ? "right" : "left"]: `${n.offset}px`
  } : {
    top: `${n.offset}px`
  };
  return t.filter((a, s) => s >= n.from && s <= n.to).map((a) => /* @__PURE__ */ $e.cloneElement(a, {
    swiper: e,
    style: r
  }));
}
function dn(e, t) {
  return typeof window > "u" ? le(e, t) : po(e, t);
}
const df = /* @__PURE__ */ ki(null), Is = /* @__PURE__ */ ki(null), Wn = () => mo(Is);
function Ir() {
  return Ir = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ir.apply(this, arguments);
}
const Ye = /* @__PURE__ */ Ot(function(e, t) {
  let {
    className: n,
    tag: r = "div",
    wrapperTag: a = "div",
    children: s,
    onSwiper: o,
    ...l
  } = e === void 0 ? {} : e, d = !1;
  const [c, f] = G("swiper"), [w, u] = G(null), [p, h] = G(!1), m = xe(!1), $ = xe(null), g = xe(null), v = xe(null), C = xe(null), y = xe(null), x = xe(null), E = xe(null), O = xe(null), {
    params: I,
    passedParams: B,
    rest: P,
    events: A
  } = ef(l), {
    slides: L,
    slots: U
  } = af(s), X = () => {
    h(!p);
  };
  Object.assign(I.on, {
    _containerClasses(R, N) {
      f(N);
    }
  });
  const W = () => {
    if (Object.assign(I.on, A), d = !0, g.current = new Zt(I), g.current.loopCreate = () => {
    }, g.current.loopDestroy = () => {
    }, I.loop && (g.current.loopedSlides = Ps(L, I)), g.current.virtual && g.current.params.virtual.enabled) {
      g.current.virtual.slides = L;
      const R = {
        cache: !1,
        slides: L,
        renderExternal: u,
        renderExternalUpdate: !1
      };
      ht(g.current.params.virtual, R), ht(g.current.originalParams.virtual, R);
    }
  };
  $.current || W(), g.current && g.current.on("_beforeBreakpoint", X);
  const Z = () => {
    d || !A || !g.current || Object.keys(A).forEach((R) => {
      g.current.on(R, A[R]);
    });
  }, j = () => {
    !A || !g.current || Object.keys(A).forEach((R) => {
      g.current.off(R, A[R]);
    });
  };
  le(() => () => {
    g.current && g.current.off("_beforeBreakpoint", X);
  }), le(() => {
    !m.current && g.current && (g.current.emitSlidesClasses(), m.current = !0);
  }), dn(() => {
    if (t && (t.current = $.current), !!$.current)
      return g.current.destroyed && W(), tf({
        el: $.current,
        nextEl: y.current,
        prevEl: x.current,
        paginationEl: E.current,
        scrollbarEl: O.current,
        swiper: g.current
      }, I), o && o(g.current), () => {
        g.current && !g.current.destroyed && g.current.destroy(!0, !1);
      };
  }, []), dn(() => {
    Z();
    const R = rf(B, v.current, L, C.current);
    return v.current = B, C.current = L, R.length && g.current && !g.current.destroyed && sf({
      swiper: g.current,
      slides: L,
      passedParams: B,
      changedParams: R,
      nextEl: y.current,
      prevEl: x.current,
      scrollbarEl: O.current,
      paginationEl: E.current
    }), () => {
      j();
    };
  }), dn(() => {
    of(g.current);
  }, [w]);
  function M() {
    return I.virtual ? lf(g.current, L, w) : !I.loop || g.current && g.current.destroyed ? L.map((R) => /* @__PURE__ */ $e.cloneElement(R, {
      swiper: g.current
    })) : nf(g.current, L, I);
  }
  return /* @__PURE__ */ $e.createElement(r, Ir({
    ref: $,
    className: Ss(`${c}${n ? ` ${n}` : ""}`)
  }, P), /* @__PURE__ */ $e.createElement(Is.Provider, {
    value: g.current
  }, U["container-start"], Es(I) && /* @__PURE__ */ $e.createElement($e.Fragment, null, /* @__PURE__ */ $e.createElement("div", {
    ref: x,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ $e.createElement("div", {
    ref: y,
    className: "swiper-button-next"
  })), Ts(I) && /* @__PURE__ */ $e.createElement("div", {
    ref: O,
    className: "swiper-scrollbar"
  }), Ns(I) && /* @__PURE__ */ $e.createElement("div", {
    ref: E,
    className: "swiper-pagination"
  }), /* @__PURE__ */ $e.createElement(a, {
    className: "swiper-wrapper"
  }, U["wrapper-start"], M(), U["wrapper-end"]), U["container-end"]));
});
Ye.displayName = "Swiper";
function Or() {
  return Or = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Or.apply(this, arguments);
}
const Ue = /* @__PURE__ */ Ot(function(e, t) {
  let {
    tag: n = "div",
    children: r,
    className: a = "",
    swiper: s,
    zoom: o,
    virtualIndex: l,
    ...d
  } = e === void 0 ? {} : e;
  const c = xe(null), [f, w] = G("swiper-slide");
  function u(m, $, g) {
    $ === c.current && w(g);
  }
  dn(() => {
    if (t && (t.current = c.current), !(!c.current || !s)) {
      if (s.destroyed) {
        f !== "swiper-slide" && w("swiper-slide");
        return;
      }
      return s.on("_slideClass", u), () => {
        s && s.off("_slideClass", u);
      };
    }
  }), dn(() => {
    s && c.current && !s.destroyed && w(s.getSlideClasses(c.current));
  }, [s]);
  const p = {
    isActive: f.indexOf("swiper-slide-active") >= 0 || f.indexOf("swiper-slide-duplicate-active") >= 0,
    isVisible: f.indexOf("swiper-slide-visible") >= 0,
    isDuplicate: f.indexOf("swiper-slide-duplicate") >= 0,
    isPrev: f.indexOf("swiper-slide-prev") >= 0 || f.indexOf("swiper-slide-duplicate-prev") >= 0,
    isNext: f.indexOf("swiper-slide-next") >= 0 || f.indexOf("swiper-slide-duplicate-next") >= 0
  }, h = () => typeof r == "function" ? r(p) : r;
  return /* @__PURE__ */ $e.createElement(n, Or({
    ref: c,
    className: Ss(`${f}${a ? ` ${a}` : ""}`),
    "data-swiper-slide-index": l
  }, d), /* @__PURE__ */ $e.createElement(df.Provider, {
    value: p
  }, o ? /* @__PURE__ */ $e.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof o == "number" ? o : void 0
  }, h()) : h()));
});
Ue.displayName = "SwiperSlide";
const cf = (e, t) => {
  const [n, r] = $e.useState(e), [a, s] = $e.useState(t);
  return {
    visibility: n || a,
    setVisibility: r,
    setForcedVisibility: s
  };
}, uf = (e, t, n = !0) => {
  const [r, a] = G("disabled"), [s, o] = G(!1), [l, d] = G({
    title: "",
    message: void 0
  }), [c, f] = G({}), [w, u] = G({}), p = xe(null), h = async (E) => {
    E.preventDefault();
    const O = E.target, I = new FormData(O), B = y();
    if (t && Object.values(B).length < 1) {
      if (p.current) {
        if (!I.get("g-recaptcha-response")) {
          f({ ...c, recaptcha: "Please verify that you are not a robot" });
          return;
        }
        p.current.reset();
      }
      a("loading"), t(I).then((P) => {
        if (!P.success && P.code === 500)
          throw new Error(P.message);
        if (!P.success) {
          o(!0), d({ title: P.title, message: An(P.message, "paragraph") }), a("disabled");
          return;
        }
        o(n), d({ title: P.title, message: An(P.message, "paragraph") }), a("send"), u({}), x(), f({}), O.reset();
      }).catch((P) => {
        o(!0), d({ title: "Error!", message: ff(P.message) }), a("disabled");
      });
    }
  }, m = (E) => {
    e.find((I) => I.name === E.target.name) && u({
      ...w,
      [E.target.name]: E.target.value
    }), C();
  }, $ = (E, O) => {
    const { label: I, value: B } = E || {};
    O && I && B && u({
      ...w,
      [O]: B
    });
  }, g = (E) => {
    E || f({ ...c, recaptcha: "Please verify that you are not a robot" }), C();
  }, v = (E) => {
    e.find((I) => I.name === E.target.name) && E.target.value !== "" && u({
      ...w,
      [E.target.name]: E.target.value
    }), C();
  }, C = () => {
    const O = fa(e)(w);
    f(O), a(Object.values(O).length >= 1 ? "disabled" : "enabled");
  }, y = () => {
    const O = Bo(e)(w);
    return f(O), O;
  }, x = nt(() => {
    const E = e.reduce((O, I) => (I.defaultFieldValue && I.name && (O[I.name] = I == null ? void 0 : I.defaultFieldValue), O), {});
    u({ ...E });
  }, [e]);
  return le(() => {
    x();
  }, [x]), le(() => {
    const O = fa(e)(w);
    f(O);
  }, [e, w, r]), {
    values: w,
    errors: c,
    submitFormState: r,
    recaptchaRef: p,
    handleChangeRecaptcha: g,
    handleSubmit: h,
    handleChange: m,
    handleSelectChange: $,
    handleBlur: v,
    isModalOpen: s,
    setIsModalOpen: o,
    modalInfo: l
  };
}, ff = (e) => ({
  nodeType: q.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: q.PARAGRAPH,
      content: [
        {
          nodeType: "text",
          marks: [],
          value: "Something went wrong. Please feel free to ",
          data: {}
        },
        {
          nodeType: _t.HYPERLINK,
          content: [
            {
              nodeType: "text",
              value: "contact us.",
              marks: [],
              data: {}
            }
          ],
          data: {
            uri: "/customer-service"
          }
        }
      ],
      data: {}
    },
    {
      nodeType: q.PARAGRAPH,
      content: [
        {
          nodeType: "text",
          marks: [],
          value: `${e}`,
          data: {}
        }
      ],
      data: {}
    }
  ]
}), Qt = () => {
  const [e, t] = G(!0), [n, r] = G(!1);
  return { isAtTheBeginning: e, isAtTheEnd: n, onTransitionEnd: ({ isBeginning: s, isEnd: o }) => {
    t(s), r(o);
  } };
}, Bw = () => {
  const [e, t] = G({
    x: 0,
    y: 0,
    lastX: 0,
    lastY: 0
  });
  return le(() => {
    const n = () => {
      t((r) => ({
        x: window.scrollX,
        y: window.scrollY,
        lastX: r.x,
        lastY: r.y
      }));
    };
    return window.addEventListener("scroll", n), () => {
      window.removeEventListener("scroll", n);
    };
  }, []), e;
}, Os = (e, t) => {
  const [n, r] = G(() => {
    if (typeof window > "u")
      return t;
    try {
      const o = window.sessionStorage.getItem(e);
      return o ? JSON.parse(o) : (window.sessionStorage.setItem(e, JSON.stringify(t)), t);
    } catch {
      return t;
    }
  });
  return [n, (o) => {
    try {
      window.sessionStorage.setItem(e, JSON.stringify(o));
    } catch (l) {
      console.log(l);
    }
    r(o);
  }, () => {
    try {
      window.sessionStorage.removeItem(e);
    } catch (o) {
      console.log(o);
    }
  }];
}, Rn = (e) => {
  const [t, n] = G(!1);
  return le(() => {
    const r = window.matchMedia(e);
    r.matches !== t && n(r.matches);
    const a = () => n(r.matches);
    return r.addEventListener("change", a), () => r && r.removeEventListener("change", a);
  }, [t, e]), t;
};
function _s() {
  const [e, t] = G(void 0);
  return le(() => {
    t(window.innerWidth);
    const n = () => t(window.innerWidth);
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), e;
}
var Ct;
(function(e) {
  e.CONTAINER = "container", e.CONTAINER_FLUID = "container-fluid";
})(Ct || (Ct = {}));
const wf = {
  [Ct.CONTAINER]: "tw-container tw-mx-auto",
  [Ct.CONTAINER_FLUID]: "tw-max-w-screen-xl tw-mx-auto"
};
var Ee;
(function(e) {
  e.ONE = "one", e.TWO = "two", e.THREE = "three", e.FOUR = "four", e.FIVE = "five";
})(Ee || (Ee = {}));
var _r;
(function(e) {
  e.ONE = "one", e.TWO = "two", e.THREE = "three", e.FOUR = "four", e.FIVE = "five";
})(_r || (_r = {}));
var Lr;
(function(e) {
  e.ONE = "one", e.TWO = "two";
})(Lr || (Lr = {}));
const hf = {
  [Ee.ONE]: "lg:tw-grid-cols-1",
  [Ee.TWO]: "lg:tw-grid-cols-2",
  [Ee.THREE]: "lg:tw-grid-cols-3",
  [Ee.FOUR]: "lg:tw-grid-cols-4",
  [Ee.FIVE]: "lg:tw-grid-cols-5"
}, pf = {
  [Ee.ONE]: "md:tw-grid-cols-1",
  [Ee.TWO]: "md:tw-grid-cols-2",
  [Ee.THREE]: "md:tw-grid-cols-3",
  [Ee.FOUR]: "md:tw-grid-cols-4",
  [Ee.FIVE]: "md:tw-grid-cols-5"
}, mf = {
  [Ee.ONE]: "tw-grid-cols-1",
  [Ee.TWO]: "tw-grid-cols-2"
}, yn = (e) => {
  switch (e) {
    case Ee.ONE:
      return 1;
    case Ee.TWO:
      return 2;
    case Ee.THREE:
      return 3;
    case Ee.FOUR:
      return 4;
    case Ee.FIVE:
      return 5;
    default:
      return "auto";
  }
}, gf = "tw-gap-2 sm:tw-gap-1";
var Et;
(function(e) {
  e.STACK = "stack", e.SLIDER = "slider";
})(Et || (Et = {}));
const $f = {
  [Et.SLIDER]: "",
  [Et.STACK]: "tw-grid"
}, Xt = "xl:tw-px-6 lg:tw-px-4 md:tw-px-2 sm:tw-px-4 tw-px-5", xf = "xl:tw-py-8 lg:tw-py-6 tw-py-4", vf = "xl:tw-pb-8 lg:tw-pb-6 tw-pb-4", bf = "xl:tw-pt-8 lg:tw-pt-6 tw-pt-4", Hw = ({ id: e, name: t, title: n, headingAlignment: r, headingSize: a, isH1: s = !1, description: o, showUnderline: l = !1, showNavigation: d = !0, columnsDesktop: c = Ee.ONE, columnsTablet: f = _r.ONE, columnsMobile: w = Lr.ONE, layout: u = Ct.CONTAINER, variant: p = Et.SLIDER, button: h, elements: m, containerClassName: $, showTopPadding: g = !0, showBotPadding: v = !0 }) => {
  var B;
  const { isAtTheBeginning: C, isAtTheEnd: y, onTransitionEnd: x } = Qt();
  let E = [1.5, 2.8];
  if (m && (m == null ? void 0 : m.length) > 1)
    switch (((B = m[0]) == null ? void 0 : B.type).displayName) {
      case "MlVertical":
        E = [2.5, 3.5];
        break;
      case "MlCard":
        E = [1.2, 2.2];
        break;
      default:
        E = [1.5, 2.8];
    }
  const O = {
    spaceBetween: 16,
    threshold: 2,
    grabCursor: !0,
    modules: [Cs],
    resistanceRatio: 0,
    onTransitionEnd: x,
    breakpoints: {
      375: {
        slidesPerView: E[0]
      },
      640: {
        slidesPerView: E[1]
      },
      768: {
        slidesPerView: yn(f)
      },
      1024: {
        slidesPerView: yn(c)
      }
    }
  }, I = `${m.length <= Number(yn(f)) ? "md:tw-hidden" : "md:tw-flex"} ${m.length <= Number(yn(c)) ? "lg:tw-hidden" : "lg:tw-flex"}`;
  return i.jsx("section", { ...!!e && { id: e }, className: `
      ${u === Ct.CONTAINER ? `${Xt}` : ""} 
      ${g ? bf : ""} ${v ? vf : ""} } ${wf[u]} `, children: i.jsxs("div", { children: [!!n && i.jsx(Hs, { textAlignment: r, headingSize: a, className: `${u === Ct.CONTAINER_FLUID ? `xl:tw-px-0 ${Xt}` : ""} tw-mb-4 `, title: An(n, s ? "heading-1" : "heading-2"), description: o ? An(o, "paragraph") : void 0, hasUnderline: l }), i.jsxs("div", { className: `${$f[p]} ${p === Et.SLIDER ? "" : `${hf[c]} ${pf[f]} ${mf[w]} ${gf}`} ${$ ?? ""}`, children: [m.length <= 1 || p === Et.STACK ? m.map((P, A) => i.jsx(Ve, { children: P }, `${A}-${wa(t)}`)) : i.jsx(i.Fragment, { children: i.jsxs(Ye, { ...O, children: [m == null ? void 0 : m.map((P, A) => i.jsx(Ue, { className: "tw-flex tw-justify-center !tw-h-auto", children: P }, `${A}-${wa(t)}`)), d && i.jsxs("div", { className: `tw-flex ${I} tw-gap-4 tw-pt-4`, children: [i.jsx(ke, { direction: "left", variant: "block", disabled: C }), i.jsx(ke, { direction: "right", variant: "block", disabled: y })] })] }) }), !!h && i.jsx("div", { className: "tw-mt-16 tw-flex tw-justify-center", children: i.jsx(Te, { ...h, className: "tw-w-fit" }) })] })] }) });
}, Gw = ({ copyright: e = "", menuItems: t, newsLetter: n, socialLinks: r }) => {
  const [a, s] = G(-1);
  return i.jsx("footer", { className: "tw-w-full tw-bg-subdued tw-px-4 sm:tw-px-6 tw-py-16", children: i.jsxs("div", { className: `tw-container tw-mx-auto ${Xt} tw-flex tw-gap-8 tw-flex-col tw-justify-between tw-min-h-full tw-m-auto `, children: [i.jsx("div", { className: "tw-block tw-opacity-100 md:tw-hidden md:tw-opacity-0 tw-bg-subdued", children: t == null ? void 0 : t.map(({ title: o, subItems: l }, d) => i.jsx(Kr, { index: d, categories: l, title: o, activeCollapseIndex: a, onActiveCollapseIndex: s }, `footer-menuItem-${o == null ? void 0 : o.label}-${d}`)) }), i.jsx("div", { className: "md:tw-grid md:tw-grid-cols-4 md:tw-gap-8", children: t == null ? void 0 : t.map((o, l) => {
    var d;
    return i.jsx(V2, { ...o }, `footer-menuItem-${(d = o.title) == null ? void 0 : d.label}-${l}`);
  }) }), i.jsx("hr", { className: "tw-border-outlined-gray" }), i.jsx(K0, { ...n }), i.jsx("hr", { className: "tw-border-outlined-gray" }), i.jsxs("div", { className: "tw-flex tw-flex-col sm:tw-flex-row-reverse tw-items-center sm:tw-justify-between tw-gap-8", children: [i.jsx("div", { className: "tw-flex tw-flex-row tw-gap-9 tw-bg-subdued", children: r.map((o, l) => i.jsx(J, { hasUnderline: !1, ...o, icon: { ...o.icon, className: "tw-w-6 tw-h-6" }, className: "hover:tw-drop-shadow-md" }, l)) }), i.jsx("p", { className: "tw-text-secondary tw-leading-6", children: e })] })] }) });
}, yf = ({ customerServiceLink: e, externalSiteLink: t, showExternalSiteLink: n, onClickCustomerServiceMenu: r }) => {
  const a = `${Xt} tw-container tw-mx-auto`;
  return i.jsx("div", { className: "tw-flex tw-h-8 tw-bg-secondary sm:tw-px-4", children: i.jsxs("div", { className: `${a} tw-flex tw-flex-row tw-justify-between tw-items-center`, children: [n ? i.jsx(J, { ...t, className: "tw-gap-2 tw-text-sm tw-p-1", variant: oe.WHITE, active: !1, iconPosition: Br.RIGHT, icon: { type: "external-link" } }) : i.jsx("span", {}), i.jsxs("div", { className: "tw-hidden tw-opacity-0 xs:tw-flex xs:tw-opacity-100 xs:tw-justify-center xs:tw-items-center tw-bg-secondary", children: [i.jsx(J, { ...e, active: !1, className: "tw-gap-2 tw-text-sm lg:tw-hidden tw-p-1", variant: oe.WHITE, onClick: r }), i.jsx(J, { ...e, active: !1, className: "tw-gap-2 tw-text-sm tw-hidden lg:tw-flex tw-p-1", variant: oe.WHITE })] }), i.jsx("div", { className: "tw-flex tw-justify-center tw-items-center tw-opacity-100 xs:tw-hidden xs:tw-opacity-0", children: i.jsx(J, {
    ...e,
    label: "",
    className: "tw-gap-2 tw-text-sm",
    variant: oe.WHITE,
    onClick: r
  }) })] }) });
}, Cf = ({ isModalOpen: e, cartLink: t, logoLink: n, searchComponent: r, showSearchComponent: a, tradeProgramLink: s, userElement: o, toggleHamburgerMenu: l, closeMenuModal: d }) => i.jsxs(i.Fragment, { children: [i.jsxs("div", { className: "tw-flex tw-items-center tw-justify-between tw-flex-row tw-py-4 md:tw-py-0 tw-w-full", children: [i.jsx("button", { "aria-label": e ? "Close button" : "Hamburger button", className: "tw-opacity-100 lg:tw-opacity-0 lg:tw-hidden tw-flex tw-justify-between tw-items-center tw-flex-row tw-gap-2 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-4 focus-visible:tw-outline-link", onClick: e ? d : l, disabled: e, children: i.jsx(ne, { type: e ? "close" : "hamburger", color: "secondary" }) }), i.jsx("div", { className: "tw-w-logo-link tw-flex tw-bg-white tw-p-0.5", children: i.jsx(J, { hasUnderline: !1, ...n, imageClassName: "tw-w-logo-link tw-h-full", ariaLabel: "Curran logo", className: "hover:tw-drop-shadow-sm tw-w-logo-link" }) }), a && i.jsx("div", { className: "tw-hidden tw-opacity-0 md:tw-block md:tw-opacity-100 tw-h-10", children: r }), i.jsxs("div", { className: "tw-flex tw-justify-between tw-items-center tw-flex-row tw-gap-4 tw-bg-white", children: [s && i.jsxs("div", { className: "tw-hidden tw-opacity-0 sm:tw-opacity-100 sm:tw-flex sm:tw-items-center sm:tw-gap-2 tw-bg-white", children: [i.jsx(J, { ...s, className: "tw-font-normal tw-pt-2 sm:tw-w-32", onClick: d, variant: oe.NAV, hasUnderline: !1 }), i.jsx("span", { children: "|" })] }), o ? Ef(o) ? i.jsxs(i.Fragment, { children: [i.jsx(J, { ...o, ariaLabel: `${o.label} link`, className: "tw-hidden tw-opacity-0 lg:tw-inline-flex lg:tw-opacity-100 lg:tw-w-22 lg:tw-pt-2", variant: oe.NAV, hasUnderline: !1 }), i.jsx(J, { ...o, ariaLabel: `${o.label} link`, className: "!tw-font-normal lg:tw-hidden lg:tw-opacity-0 !tw-p-1", variant: oe.NAV, label: "" })] }) : o : null, i.jsx(J, { ...t, ariaLabel: `${t.label} link`, className: "tw-hidden tw-opacity-0 lg:tw-inline-flex lg:tw-opacity-100 lg:tw-pt-2 lg:tw-w-16", variant: oe.NAV, hasUnderline: !1 }), i.jsx(J, { ...t, ariaLabel: `${t.label} link`, className: "!tw-font-normal !tw-p-1 lg:tw-hidden lg:tw-opacity-0", variant: oe.NAV, label: "" })] })] }), a && !e && i.jsx("div", { className: "tw-block tw-opacity-100 md:tw-hidden md:tw-opacity-0 tw-h-10", children: r })] });
function Ef(e) {
  return e.actionUrl !== void 0;
}
const Vw = ({ currenPath: e, logoLink: t, navLinks: n = [], announcement: r, searchComponent: a, showSearchComponent: s, storedAnnouncement: o, customerServiceLink: l, externalSiteLink: d, tradeProgramLink: c, cartLink: f, userElement: w, showExternalSiteLink: u = !0, isSynsisal: p = !1, handleCustomerServiceClick: h, onStoredAnnouncement: m }) => {
  const [$, g] = G(!1), [v, C] = G(-1), y = xe(null), x = xe(null);
  let E = xe(null);
  const O = _s();
  le(() => {
    if (y.current) {
      const U = y.current.clientHeight;
      x.current && (x.current.style.top = `${U}px`);
    }
  }, [O, $]);
  const I = `${Xt} tw-container tw-mx-auto`, B = () => {
    C(-1);
    const U = setTimeout(() => {
      g(!1);
    }, 0);
    return () => clearTimeout(U);
  }, P = () => {
    g(!0);
  }, A = nt(() => {
    $ ? B() : P();
  }, [$]), L = nt((U) => {
    h && h(U), B();
  }, [h]);
  return i.jsxs("header", { ref: y, className: "tw-z-20 tw-w-full tw-border-b-outlined-gray tw-border-b", children: [i.jsx(yf, { externalSiteLink: d, showExternalSiteLink: u, customerServiceLink: l, onClickCustomerServiceMenu: L }), i.jsxs("nav", { role: "navigation", className: "tw-bg-white tw-py-2 lg:tw-pb-0 tw-z-20", children: [i.jsxs("div", { className: `${I} tw-flex tw-flex-col`, children: [i.jsx(Cf, { isModalOpen: $, toggleHamburgerMenu: A, closeMenuModal: B, cartLink: f, logoLink: t, searchComponent: a, tradeProgramLink: c, userElement: w, showSearchComponent: s }), i.jsx("div", { className: "tw-hidden tw-opacity-0 lg:tw-opacity-100 lg:tw-flex lg:tw-justify-center lg:tw-items-center lg:tw-flex-row lg:tw-gap-8 lg:tw-pt-3 lg:tw-pb-1 lg:tw-px-3", children: n.map((U, X) => i.jsx(M2, { ...U, currenPath: e }, `desktop-${X}-${U.title.label}`)) })] }), i.jsx(yt, { initialFocus: E, as: "div", open: $, onClose: B, className: "tw-relative tw-z-20 lg:tw-hidden", children: i.jsx("div", { ref: x, className: "tw-fixed tw-inset-x-0 tw-border-t tw-bottom-0 tw-overflow-y-auto tw-border-t-outlined-gray", children: i.jsx("div", { className: "tw-flex tw-min-h-full", children: i.jsx(yt.Panel, { className: "tw-w-full tw-transform tw-bg-subdued tw-transition-all", children: i.jsxs("div", { ref: E, className: "tw-container tw-mx-auto tw-p-4", children: [c && i.jsxs("div", { className: "tw-flex tw-flex-row sm:tw-hidden tw-relative tw-justify-between tw-text-secondary tw-transition-colors tw-bg-subdued hover:tw-bg-light-hover focus:tw-bg-transparent", children: [i.jsx(J, { ...c, variant: oe.NAV, hasUnderline: !1, className: "!tw-text-xl tw-text-inherit !tw-font-medium !tw-leading-7 tw-flex-1 !tw-p-3 tw-z-10", onClick: B }), i.jsx("span", { className: "tw-absolute tw-right-4 tw-top-4 tw-z-10", children: i.jsx(ne, { type: "arrows", color: "secondary" }) })] }), c && i.jsx("hr", { className: "tw-flex sm:tw-hidden tw-border-outlined-gray tw-my-4" }), n.map(({ title: U, categories: X }, W) => i.jsx(Kr, { activeCollapseIndex: v, hasNestedLinks: !0, index: W, categories: X, title: U, showTitleLink: !!X && !p, onActiveCollapseIndex: C, handleCloseMenu: B }, `header-menuItem-${U.label}-${W}`))] }) }) }) }) })] }), i.jsx("div", { className: "tw-grid tw-grid-cols-1 tw-justify-items-center", children: r && !$ && i.jsx(R2, { ...r, storedAnnouncement: o, onStoredAnnouncement: m }) })] });
}, Uw = Bi(({ id: e = "searchbox", results: t, currentRefinement: n, dataTestId: r, placeholder: a = "", refine: s, onRedirect: o }) => {
  const [l, d] = G(""), [c, f] = G(), w = xe(null), [u, p] = G(!1), h = (g) => {
    w.current && !w.current.contains(g.target) && p(!1);
  };
  le(() => (document.addEventListener("mousedown", h), () => {
    document.removeEventListener("mousedown", h);
  }), [w]), le(() => {
    n || d("");
  }, [n]);
  const m = ({ currentTarget: { value: g } }) => {
    c && clearTimeout(c), d(g), f(setTimeout(() => s && s(g), 400));
  }, $ = (g) => {
    g.preventDefault(), typeof window < "u" && l !== "" && o && o(l);
  };
  return i.jsx("div", { className: "tw-w-searchbox tw-h-10", children: i.jsxs("div", { className: "tw-relative", children: [i.jsx("form", { onSubmit: $, children: i.jsx(Un, { id: e, inputClassName: "tw-bg-subdued !tw-h-10", dataTestId: r, type: "text", leftIcon: l ? i.jsx("button", { "aria-label": "Clear button", role: "button", "data-testid": "clearButton", type: "button", onClick: () => d(""), children: i.jsx(ne, { type: "close", color: "gray", size: 18 }) }) : "search", placeholder: a, value: l, onChange: m, onClick: () => p(!0) }) }), l && u && i.jsx("div", { className: "tw-absolute tw-top-full tw-mt-1 tw-border-outlined-gray tw-border tw-transition-opacity tw-bg-white tw-shadow-sm tw-z-30 tw-w-full", children: i.jsx("div", { ref: w, id: "searchbox-results", className: "tw-p-4", onClick: () => p(!1), children: t }) })] }) });
}), Ww = ({ cards: e = [], isFiltersOpen: t = !0, hasFilters: n = !0 }) => i.jsx("section", { className: `tw-w-full tw-grid tw-gap-8 tw-grid-cols-1 ${n ? "sm:tw-grid-cols-2" : "md:tw-grid-cols-2 lg:tw-grid-cols-3"} ${t ? "md:tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-3" : n ? "xl:tw-grid-cols-4" : ""}`, children: e.map((r, a) => {
  if ("mainImages" in r && "price" in r) {
    const s = r;
    return i.jsx(tw, { ...s }, `product-card-${r.title}-${a}`);
  }
  return i.jsx(P2, { ...r }, `cta-card-${r.title}-${a}`);
}) });
var di;
(function(e) {
  e.WHITE = "tw-bg-white", e.BLACK = "tw-bg-black", e.PRIMARY = "tw-bg-primary", e.SLATE_50 = "tw-bg-slate-50", e.SLATE_100 = "tw-bg-slate-100", e.SLATE_200 = "tw-bg-slate-200";
})(di || (di = {}));
var Rr;
(function(e) {
  e.WHITE = "tw-text-white", e.BLACK = "tw-text-black", e.PRIMARY = "tw-text-primary";
})(Rr || (Rr = {}));
const Nf = ({ idTarget: e, id: t, title: n, content: r, textAlignment: a = Ze.LEFT, isOpen: s, onClick: o, isDisabled: l, onAction: d, className: c = "", showOpenBorder: f = !1, bgColor: w = void 0, textColor: u = void 0, icon: p = void 0, angleIconClassName: h = "" }) => {
  const [m, $] = G(s), g = () => {
    d && d(), !l && (o && o(t, !m), $(!m));
  };
  le(() => $(s), [s]);
  const v = m && f ? "tw-border-t tw-border-secondary tw-pt-4" : "";
  return i.jsxs("section", { ...!!e && { id: e }, className: `tw-flex tw-flex-col tw-border-y tw-border-outlined-gray tw-text-secondary tw-mx-auto tw-container ${c} ${f && m ? "tw-border-none" : ""}`, children: [i.jsxs("button", { "aria-expanded": m, type: "button", "aria-label": n, onClick: g, className: `tw-flex tw-flex-row tw-w-full tw-justify-between ${w ?? w} ${ge[ie.FOCUS_VISIBLE]} tw-p-4 ${!m && !w ? "hover:tw-bg-light-hover focus:tw-bg-light-hover" : ""}`, children: [i.jsxs("div", { className: "tw-flex tw-flex-row", children: [i.jsx("h2", { className: `tw-text-xl ${u ?? u} tw-font-medium tw-text-left tw-mr-2`, children: n }), p && i.jsx(ne, { type: p, color: "success", alt: "Sucess" })] }), i.jsx("div", { className: `${h}`, children: i.jsx(ne, { type: "angle-icon", direction: `${m ? "up" : "down"}`, className: `${l ? "tw-opacity-20" : ""} tw-ease-in-out tw-duration-300 tw-transition-transform`, color: u == Rr.WHITE ? "white" : "dark", alt: "Toggle arrow" }) })] }), i.jsx("div", { className: `tw-overflow-hidden tw-transition-transform tw-origin-top tw-duration-200 tw-px-4 tw-pb-4 ${m ? `tw-scale-y-100 tw-h-max ${v}` : "tw-h-0 tw-scale-y-0 tw-delay-75 tw-hidden"}`, children: Array.isArray(r) ? r.map((C, y) => i.jsx(je, { ...C, textAlignment: a, className: "tw-pt-4" }, `richTextCollapse-${y}`)) : r })] });
}, zw = ({ id: e, collapseItems: t, className: n = "", labelCollapseLabelButton: r = "Collapse All", labelExpandLabelButton: a = "Expand All", customIdStorage: s = "", allowMultipleOpen: o = !0, hideCollapseAll: l = !1 }) => {
  const [d, c] = G(!0), [f, w] = Os(`containerActivesCollapse${s}`, Array.from({ length: t.length }, (h, m) => o ? d : m === 0)), u = () => {
    c(!d), w(Array.from({ length: t.length }, () => !d));
  }, p = (h, m) => {
    if (o) {
      const $ = f;
      $[h] = m, w($);
    } else {
      const $ = f.map((g, v) => v === h ? m : !1);
      w($);
    }
    f.every(($) => $ === !0) && c(!0), f.every(($) => $ === !1) && c(!1);
  };
  return i.jsxs("div", { ...!!e && { id: e }, className: `tw-w-full ${n}`, children: [t.length > 1 && !l && i.jsxs("button", { type: "button", "aria-expanded": d, "aria-label": d ? r : a, onClick: u, className: `tw-flex tw-w-full tw-justify-between tw-bg-white ${ge[ie.FOCUS_VISIBLE]} tw-p-4 tw-mx-auto tw-container`, children: [i.jsx("span", { className: "tw-font-medium tw-text-right tw-w-full tw-mr-4", children: d ? r : a }), i.jsx(ne, { type: "angle-icon", direction: `${d ? "up" : "down"}`, className: "tw-ease-in-out tw-duration-300 tw-transition-transform", color: "dark", alt: "Toggle arrow" })] }), t.map((h, m) => i.jsx(Nf, { ...h, id: m, isOpen: f[m], onClick: p }, `collapse-item-${m}-${h.title}`))] });
}, Yw = ({ mobileTitle: e, mobileIcon: t, menuItems: n, className: r = "", isOpen: a = !1, customIdStorage: s = "", handleCloseMenu: o }) => {
  const [l, d] = Os(`sidebarActivePanel${s}`, -1);
  return i.jsxs(i.Fragment, { children: [i.jsx("div", { className: `${a ? "tw-fixed tw-touch-none" : "tw-hidden"} lg:tw-hidden tw-left-0 tw-top-0 tw-bg-black tw-h-screen tw-w-screen tw-opacity-50 tw-z-50` }), i.jsxs("aside", { className: `${a ? "tw-fixed tw-touch-none" : "tw-hidden"} tw-z-50 lg:tw-z-0 tw-bg-white tw-h-full tw-overflow-hidden tw-min-w-max tw-px-5 tw-w-full md:tw-w-fit tw-left-0 tw-top-0 md:tw-max-w-xs lg:tw-inline-block lg:tw-relative lg:tw-w-full ${r}`, children: [i.jsxs("div", { className: " md:tw-w-64 tw-flex tw-justify-between tw-pb-8 tw-pt-4 lg:tw-hidden", children: [i.jsxs("span", { className: "tw-flex tw-font-medium tw-text-secondary tw-items-center tw-uppercase ", children: [i.jsx(ne, { type: t, size: 32, color: "secondary", className: "tw-pr-3" }), e] }), i.jsx("button", { "aria-label": "Close menu", className: "tw-opacity-100 lg:tw-opacity-0 tw-flex tw-justify-between tw-items-center tw-flex-row tw-gap-2 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-4 focus-visible:tw-outline-link", onClick: o, children: i.jsx(ne, { type: "close", size: 18, color: "secondary" }) })] }), i.jsx("hr", { className: "md:tw-w-64 tw-p-0 tw-relative tw-text-outlined-gray" }), i.jsx("div", { className: "md:tw-w-64 tw-w-full tw-h-5/6 tw-overflow-y-auto tw-bg-white", children: n.map(({ title: c, subItems: f }, w) => i.jsxs(Ve, { children: [i.jsx(Kr, { variant: It.SMALL, index: w, categories: f, title: c, activeCollapseIndex: l, onActiveCollapseIndex: d }), i.jsx("hr", { className: "tw-p-0 tw-relative tw-text-outlined-gray" })] }, `sidebar-menuItem-${c == null ? void 0 : c.label}-${w}`)) })] })] });
}, an = {
  primary: {
    base: "tw-w-full tw-p-4 tw-border-t-transparent tw-border-t",
    hover: "hover:tw-border-b-primary hover:tw-text-primary",
    enable: "tw-text-primary tw-border-b-primary tw-border-t-2 hover:tw-border-t-2 tw-border-b-2 hover:tw-border-b-2",
    disable: "tw-opacity-80 tw-pointer-events-none",
    rest: "tw-border-b tw-border-b-secondary"
  },
  secondary: {
    base: "tw-py-2 tw-px-4",
    hover: "hover:!tw-bg-secondary-hover hover:tw-text-white",
    enable: "!tw-bg-white tw-text-secondary",
    disable: "tw-pointer-events-none",
    rest: "!tw-bg-secondary !tw-text-white"
  }
};
var vt;
(function(e) {
  e.PRIMARY = "primary", e.SECONDARY = "secondary";
})(vt || (vt = {}));
const Zw = ({ tabs: e, variant: t = vt.PRIMARY, currentPath: n }) => {
  var l;
  const r = nt(() => n ? e.findIndex((d) => n === d.title.actionUrl) : e.findIndex((d) => d.active === !0), [n, e]), a = r(), [s, o] = G(a >= 0 ? a : t === vt.PRIMARY ? 0 : -1);
  return le(() => {
    const d = r();
    o(d >= 0 ? d : t === vt.PRIMARY ? 0 : -1);
  }, [n, e, t, r]), i.jsxs("div", { className: "tw-flex tw-flex-col", children: [i.jsx("div", { className: `tw-flex tw-w-full tw-overflow-x-auto ${t === vt.PRIMARY ? "tw-pb-2 tw-mb-2" : ""}`, role: "tablist", children: e.map((d, c) => i.jsx(J, { ...d.title, role: "tab", "aria-selected": s === c, variant: oe.NONE, className: `tw-justify-center tw-transition-colors ${an[t].base} ${an[t].hover} ${c === s ? an[t].enable : an[t].rest} ${d.disabled && an[t].disable}`, hasUnderline: !1, labelClassName: "tw-truncate", ...!d.title.onClick && { onClick: () => o(c) } }, `tab${c}`)) }), t === vt.PRIMARY && i.jsx(i.Fragment, { children: e[s].blocks && ((l = e[s].blocks) == null ? void 0 : l.map((d, c) => i.jsx("div", { children: d }, c))) })] });
}, Tf = ({ title: e, icon: t, productContent: n, description: r, rightButton: a, leftButton: s, isOpen: o = !1, handleCloseModal: l, children: d, productLabel: c }) => i.jsx(lt, { appear: !0, show: o, as: Ve, children: i.jsxs(yt, { as: "div", open: o, onClose: l, className: "tw-relative tw-z-50", children: [i.jsx(lt.Child, { as: Ve, enter: "tw-ease-out tw-duration-300", enterFrom: "tw-opacity-0", enterTo: "tw-opacity-100", leave: "tw-ease-in tw-duration-200", leaveFrom: "tw-opacity-100", leaveTo: "tw-opacity-0", children: i.jsx("div", { className: "tw-fixed tw-inset-0 tw-bg-black/50", "aria-hidden": "true" }) }), i.jsx("div", { className: "tw-fixed tw-inset-0 tw-overflow-y-auto", children: i.jsx("div", { className: "tw-flex tw-min-h-full tw-items-center tw-justify-center tw-p-4 tw-text-center", children: i.jsx(lt.Child, { as: Ve, enter: "tw-ease-out tw-duration-300", enterFrom: "tw-opacity-0 tw-scale-95", enterTo: "tw-opacity-100 tw-scale-100", leave: "tw-ease-in tw-duration-200", leaveFrom: "tw-opacity-100 tw-scale-100", leaveTo: "tw-opacity-0 tw-scale-95", children: i.jsxs(yt.Panel, { className: "tw-w-full tw-transform tw-overflow-hidden tw-bg-white tw-modal-size tw-text-left tw-align-middle tw-transition-all", children: [i.jsx("div", { className: "tw-flex tw-w-full tw-justify-end tw-p-4", children: i.jsx("button", { "aria-label": "Close menu", className: "tw-flex tw-justify-between tw-items-center tw-flex-row tw-gap-2 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-4 focus-visible:tw-outline-link", onClick: l, children: i.jsx(ne, { type: "close", size: 18, color: "secondary" }) }) }), i.jsxs("div", { className: "tw-w-full tw-p-4 tw-pt-2 tw-overflow-y-auto", children: [i.jsxs(yt.Title, { className: "tw-flex tw-text-xl tw-font-medium tw-text-secondary tw-items-center", children: [i.jsx(ne, { type: t, size: 36, color: "success", className: "tw-flex tw-pr-3 tw-items-center" }), e] }), (n || r) && i.jsxs("div", { className: "tw-flex tw-pt-4 tw-pb-6", children: [n && i.jsxs(i.Fragment, { children: [i.jsx("div", { className: "tw-w-24 md:tw-w-28 tw-h-24 md:tw-h-28 tw-flex", children: n.image ? i.jsx(de, { ...n.image, caption: void 0, className: "tw-object-cover tw-w-full tw-h-full tw-aspect-square" }) : n.customImageComponent ? n.customImageComponent : null }), i.jsxs("div", { className: "tw-flex tw-flex-col tw-pl-4 tw-gap-2", children: [i.jsx("span", { className: "tw-text-secondary tw-font-medium tw-text-sm", children: c ? i.jsxs(i.Fragment, { children: [c, i.jsx("span", { className: "tw-font-normal", children: n.name })] }) : n.name }), !!n.quantity && i.jsxs("span", { className: "tw-text-secondary tw-font-medium tw-text-sm", children: ["Quantity: ", i.jsx("span", { className: "tw-font-normal", children: n.quantity })] }), n.extraInfo && n.extraInfo.map((f, w) => i.jsxs("span", { className: "tw-text-secondary tw-font-medium tw-text-sm", children: [f.title, ": ", i.jsx("span", { className: "tw-font-normal", children: f.text })] }, `extraInfoItem-${n.name}-${w}`)), i.jsx("span", { className: "tw-text-secondary tw-font-medium tw-text-sm", children: n.price })] })] }), r && i.jsx(je, { ...r })] }), d, (s || a) && i.jsxs("div", { className: "tw-flex tw-justify-between tw-gap-2 tw-flex-col md:tw-grid md:tw-grid-cols-2", children: [s && i.jsx(Te, { ...s, variant: Me.TERTIARY, className: `tw-w-full ${a ? "" : "tw-col-start-2"}` }), a && i.jsx(Te, { ...a, variant: Me.SECONDARY, className: `tw-w-full ${s ? "" : "tw-col-start-2"}` })] })] })] }) }) }) })] }) });
var Mr = { exports: {} }, Cn = { exports: {} }, ue = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ci;
function Sf() {
  if (ci)
    return ue;
  ci = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, u = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function C(x) {
    if (typeof x == "object" && x !== null) {
      var E = x.$$typeof;
      switch (E) {
        case t:
          switch (x = x.type, x) {
            case d:
            case c:
            case r:
            case s:
            case a:
            case w:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case l:
                case f:
                case h:
                case p:
                case o:
                  return x;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function y(x) {
    return C(x) === c;
  }
  return ue.AsyncMode = d, ue.ConcurrentMode = c, ue.ContextConsumer = l, ue.ContextProvider = o, ue.Element = t, ue.ForwardRef = f, ue.Fragment = r, ue.Lazy = h, ue.Memo = p, ue.Portal = n, ue.Profiler = s, ue.StrictMode = a, ue.Suspense = w, ue.isAsyncMode = function(x) {
    return y(x) || C(x) === d;
  }, ue.isConcurrentMode = y, ue.isContextConsumer = function(x) {
    return C(x) === l;
  }, ue.isContextProvider = function(x) {
    return C(x) === o;
  }, ue.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, ue.isForwardRef = function(x) {
    return C(x) === f;
  }, ue.isFragment = function(x) {
    return C(x) === r;
  }, ue.isLazy = function(x) {
    return C(x) === h;
  }, ue.isMemo = function(x) {
    return C(x) === p;
  }, ue.isPortal = function(x) {
    return C(x) === n;
  }, ue.isProfiler = function(x) {
    return C(x) === s;
  }, ue.isStrictMode = function(x) {
    return C(x) === a;
  }, ue.isSuspense = function(x) {
    return C(x) === w;
  }, ue.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === c || x === s || x === a || x === w || x === u || typeof x == "object" && x !== null && (x.$$typeof === h || x.$$typeof === p || x.$$typeof === o || x.$$typeof === l || x.$$typeof === f || x.$$typeof === $ || x.$$typeof === g || x.$$typeof === v || x.$$typeof === m);
  }, ue.typeOf = C, ue;
}
var fe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ui;
function jf() {
  return ui || (ui = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, u = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function C(S) {
      return typeof S == "string" || typeof S == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      S === r || S === c || S === s || S === a || S === w || S === u || typeof S == "object" && S !== null && (S.$$typeof === h || S.$$typeof === p || S.$$typeof === o || S.$$typeof === l || S.$$typeof === f || S.$$typeof === $ || S.$$typeof === g || S.$$typeof === v || S.$$typeof === m);
    }
    function y(S) {
      if (typeof S == "object" && S !== null) {
        var be = S.$$typeof;
        switch (be) {
          case t:
            var Ae = S.type;
            switch (Ae) {
              case d:
              case c:
              case r:
              case s:
              case a:
              case w:
                return Ae;
              default:
                var Fe = Ae && Ae.$$typeof;
                switch (Fe) {
                  case l:
                  case f:
                  case h:
                  case p:
                  case o:
                    return Fe;
                  default:
                    return be;
                }
            }
          case n:
            return be;
        }
      }
    }
    var x = d, E = c, O = l, I = o, B = t, P = f, A = r, L = h, U = p, X = n, W = s, Z = a, j = w, M = !1;
    function R(S) {
      return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(S) || y(S) === d;
    }
    function N(S) {
      return y(S) === c;
    }
    function T(S) {
      return y(S) === l;
    }
    function k(S) {
      return y(S) === o;
    }
    function V(S) {
      return typeof S == "object" && S !== null && S.$$typeof === t;
    }
    function H(S) {
      return y(S) === f;
    }
    function Q(S) {
      return y(S) === r;
    }
    function z(S) {
      return y(S) === h;
    }
    function Y(S) {
      return y(S) === p;
    }
    function ee(S) {
      return y(S) === n;
    }
    function re(S) {
      return y(S) === s;
    }
    function te(S) {
      return y(S) === a;
    }
    function ve(S) {
      return y(S) === w;
    }
    fe.AsyncMode = x, fe.ConcurrentMode = E, fe.ContextConsumer = O, fe.ContextProvider = I, fe.Element = B, fe.ForwardRef = P, fe.Fragment = A, fe.Lazy = L, fe.Memo = U, fe.Portal = X, fe.Profiler = W, fe.StrictMode = Z, fe.Suspense = j, fe.isAsyncMode = R, fe.isConcurrentMode = N, fe.isContextConsumer = T, fe.isContextProvider = k, fe.isElement = V, fe.isForwardRef = H, fe.isFragment = Q, fe.isLazy = z, fe.isMemo = Y, fe.isPortal = ee, fe.isProfiler = re, fe.isStrictMode = te, fe.isSuspense = ve, fe.isValidElementType = C, fe.typeOf = y;
  }()), fe;
}
var fi;
function Ls() {
  return fi || (fi = 1, process.env.NODE_ENV === "production" ? Cn.exports = Sf() : Cn.exports = jf()), Cn.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var lr, wi;
function Pf() {
  if (wi)
    return lr;
  wi = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, l = 0; l < 10; l++)
        o["_" + String.fromCharCode(l)] = l;
      var d = Object.getOwnPropertyNames(o).map(function(f) {
        return o[f];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        c[f] = f;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return lr = a() ? Object.assign : function(s, o) {
    for (var l, d = r(s), c, f = 1; f < arguments.length; f++) {
      l = Object(arguments[f]);
      for (var w in l)
        t.call(l, w) && (d[w] = l[w]);
      if (e) {
        c = e(l);
        for (var u = 0; u < c.length; u++)
          n.call(l, c[u]) && (d[c[u]] = l[c[u]]);
      }
    }
    return d;
  }, lr;
}
var dr, hi;
function Yr() {
  if (hi)
    return dr;
  hi = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return dr = e, dr;
}
var cr, pi;
function Rs() {
  return pi || (pi = 1, cr = Function.call.bind(Object.prototype.hasOwnProperty)), cr;
}
var ur, mi;
function Af() {
  if (mi)
    return ur;
  mi = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Yr(), n = {}, r = Rs();
    e = function(s) {
      var o = "Warning: " + s;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(s, o, l, d, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in s)
        if (r(s, f)) {
          var w;
          try {
            if (typeof s[f] != "function") {
              var u = Error(
                (d || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw u.name = "Invariant Violation", u;
            }
            w = s[f](o, f, d, l, null, t);
          } catch (h) {
            w = h;
          }
          if (w && !(w instanceof Error) && e(
            (d || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof w + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), w instanceof Error && !(w.message in n)) {
            n[w.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + l + " type: " + w.message + (p ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, ur = a, ur;
}
var fr, gi;
function If() {
  if (gi)
    return fr;
  gi = 1;
  var e = Ls(), t = Pf(), n = Yr(), r = Rs(), a = Af(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(l) {
    var d = "Warning: " + l;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return fr = function(l, d) {
    var c = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function w(N) {
      var T = N && (c && N[c] || N[f]);
      if (typeof T == "function")
        return T;
    }
    var u = "<<anonymous>>", p = {
      array: g("array"),
      bigint: g("bigint"),
      bool: g("boolean"),
      func: g("function"),
      number: g("number"),
      object: g("object"),
      string: g("string"),
      symbol: g("symbol"),
      any: v(),
      arrayOf: C,
      element: y(),
      elementType: x(),
      instanceOf: E,
      node: P(),
      objectOf: I,
      oneOf: O,
      oneOfType: B,
      shape: L,
      exact: U
    };
    function h(N, T) {
      return N === T ? N !== 0 || 1 / N === 1 / T : N !== N && T !== T;
    }
    function m(N, T) {
      this.message = N, this.data = T && typeof T == "object" ? T : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function $(N) {
      if (process.env.NODE_ENV !== "production")
        var T = {}, k = 0;
      function V(Q, z, Y, ee, re, te, ve) {
        if (ee = ee || u, te = te || Y, ve !== n) {
          if (d) {
            var S = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw S.name = "Invariant Violation", S;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var be = ee + ":" + Y;
            !T[be] && // Avoid spamming the console because they are often not actionable except for lib authors
            k < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + ee + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), T[be] = !0, k++);
          }
        }
        return z[Y] == null ? Q ? z[Y] === null ? new m("The " + re + " `" + te + "` is marked as required " + ("in `" + ee + "`, but its value is `null`.")) : new m("The " + re + " `" + te + "` is marked as required in " + ("`" + ee + "`, but its value is `undefined`.")) : null : N(z, Y, ee, re, te);
      }
      var H = V.bind(null, !1);
      return H.isRequired = V.bind(null, !0), H;
    }
    function g(N) {
      function T(k, V, H, Q, z, Y) {
        var ee = k[V], re = Z(ee);
        if (re !== N) {
          var te = j(ee);
          return new m(
            "Invalid " + Q + " `" + z + "` of type " + ("`" + te + "` supplied to `" + H + "`, expected ") + ("`" + N + "`."),
            { expectedType: N }
          );
        }
        return null;
      }
      return $(T);
    }
    function v() {
      return $(o);
    }
    function C(N) {
      function T(k, V, H, Q, z) {
        if (typeof N != "function")
          return new m("Property `" + z + "` of component `" + H + "` has invalid PropType notation inside arrayOf.");
        var Y = k[V];
        if (!Array.isArray(Y)) {
          var ee = Z(Y);
          return new m("Invalid " + Q + " `" + z + "` of type " + ("`" + ee + "` supplied to `" + H + "`, expected an array."));
        }
        for (var re = 0; re < Y.length; re++) {
          var te = N(Y, re, H, Q, z + "[" + re + "]", n);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return $(T);
    }
    function y() {
      function N(T, k, V, H, Q) {
        var z = T[k];
        if (!l(z)) {
          var Y = Z(z);
          return new m("Invalid " + H + " `" + Q + "` of type " + ("`" + Y + "` supplied to `" + V + "`, expected a single ReactElement."));
        }
        return null;
      }
      return $(N);
    }
    function x() {
      function N(T, k, V, H, Q) {
        var z = T[k];
        if (!e.isValidElementType(z)) {
          var Y = Z(z);
          return new m("Invalid " + H + " `" + Q + "` of type " + ("`" + Y + "` supplied to `" + V + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return $(N);
    }
    function E(N) {
      function T(k, V, H, Q, z) {
        if (!(k[V] instanceof N)) {
          var Y = N.name || u, ee = R(k[V]);
          return new m("Invalid " + Q + " `" + z + "` of type " + ("`" + ee + "` supplied to `" + H + "`, expected ") + ("instance of `" + Y + "`."));
        }
        return null;
      }
      return $(T);
    }
    function O(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), o;
      function T(k, V, H, Q, z) {
        for (var Y = k[V], ee = 0; ee < N.length; ee++)
          if (h(Y, N[ee]))
            return null;
        var re = JSON.stringify(N, function(ve, S) {
          var be = j(S);
          return be === "symbol" ? String(S) : S;
        });
        return new m("Invalid " + Q + " `" + z + "` of value `" + String(Y) + "` " + ("supplied to `" + H + "`, expected one of " + re + "."));
      }
      return $(T);
    }
    function I(N) {
      function T(k, V, H, Q, z) {
        if (typeof N != "function")
          return new m("Property `" + z + "` of component `" + H + "` has invalid PropType notation inside objectOf.");
        var Y = k[V], ee = Z(Y);
        if (ee !== "object")
          return new m("Invalid " + Q + " `" + z + "` of type " + ("`" + ee + "` supplied to `" + H + "`, expected an object."));
        for (var re in Y)
          if (r(Y, re)) {
            var te = N(Y, re, H, Q, z + "." + re, n);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return $(T);
    }
    function B(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var T = 0; T < N.length; T++) {
        var k = N[T];
        if (typeof k != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + M(k) + " at index " + T + "."
          ), o;
      }
      function V(H, Q, z, Y, ee) {
        for (var re = [], te = 0; te < N.length; te++) {
          var ve = N[te], S = ve(H, Q, z, Y, ee, n);
          if (S == null)
            return null;
          S.data && r(S.data, "expectedType") && re.push(S.data.expectedType);
        }
        var be = re.length > 0 ? ", expected one of type [" + re.join(", ") + "]" : "";
        return new m("Invalid " + Y + " `" + ee + "` supplied to " + ("`" + z + "`" + be + "."));
      }
      return $(V);
    }
    function P() {
      function N(T, k, V, H, Q) {
        return X(T[k]) ? null : new m("Invalid " + H + " `" + Q + "` supplied to " + ("`" + V + "`, expected a ReactNode."));
      }
      return $(N);
    }
    function A(N, T, k, V, H) {
      return new m(
        (N || "React class") + ": " + T + " type `" + k + "." + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + H + "`."
      );
    }
    function L(N) {
      function T(k, V, H, Q, z) {
        var Y = k[V], ee = Z(Y);
        if (ee !== "object")
          return new m("Invalid " + Q + " `" + z + "` of type `" + ee + "` " + ("supplied to `" + H + "`, expected `object`."));
        for (var re in N) {
          var te = N[re];
          if (typeof te != "function")
            return A(H, Q, z, re, j(te));
          var ve = te(Y, re, H, Q, z + "." + re, n);
          if (ve)
            return ve;
        }
        return null;
      }
      return $(T);
    }
    function U(N) {
      function T(k, V, H, Q, z) {
        var Y = k[V], ee = Z(Y);
        if (ee !== "object")
          return new m("Invalid " + Q + " `" + z + "` of type `" + ee + "` " + ("supplied to `" + H + "`, expected `object`."));
        var re = t({}, k[V], N);
        for (var te in re) {
          var ve = N[te];
          if (r(N, te) && typeof ve != "function")
            return A(H, Q, z, te, j(ve));
          if (!ve)
            return new m(
              "Invalid " + Q + " `" + z + "` key `" + te + "` supplied to `" + H + "`.\nBad object: " + JSON.stringify(k[V], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(N), null, "  ")
            );
          var S = ve(Y, te, H, Q, z + "." + te, n);
          if (S)
            return S;
        }
        return null;
      }
      return $(T);
    }
    function X(N) {
      switch (typeof N) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !N;
        case "object":
          if (Array.isArray(N))
            return N.every(X);
          if (N === null || l(N))
            return !0;
          var T = w(N);
          if (T) {
            var k = T.call(N), V;
            if (T !== N.entries) {
              for (; !(V = k.next()).done; )
                if (!X(V.value))
                  return !1;
            } else
              for (; !(V = k.next()).done; ) {
                var H = V.value;
                if (H && !X(H[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function W(N, T) {
      return N === "symbol" ? !0 : T ? T["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && T instanceof Symbol : !1;
    }
    function Z(N) {
      var T = typeof N;
      return Array.isArray(N) ? "array" : N instanceof RegExp ? "object" : W(T, N) ? "symbol" : T;
    }
    function j(N) {
      if (typeof N > "u" || N === null)
        return "" + N;
      var T = Z(N);
      if (T === "object") {
        if (N instanceof Date)
          return "date";
        if (N instanceof RegExp)
          return "regexp";
      }
      return T;
    }
    function M(N) {
      var T = j(N);
      switch (T) {
        case "array":
        case "object":
          return "an " + T;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + T;
        default:
          return T;
      }
    }
    function R(N) {
      return !N.constructor || !N.constructor.name ? u : N.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, fr;
}
var wr, $i;
function Of() {
  if ($i)
    return wr;
  $i = 1;
  var e = Yr();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, wr = function() {
    function r(o, l, d, c, f, w) {
      if (w !== e) {
        var u = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw u.name = "Invariant Violation", u;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, wr;
}
if (process.env.NODE_ENV !== "production") {
  var _f = Ls(), Lf = !0;
  Mr.exports = If()(_f.isElement, Lf);
} else
  Mr.exports = Of()();
var Rf = Mr.exports;
const He = /* @__PURE__ */ Vi(Rf);
function Fr() {
  return Fr = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fr.apply(this, arguments);
}
function Mf(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, s;
  for (s = 0; s < r.length; s++)
    a = r[s], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function En(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ff(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var zn = /* @__PURE__ */ function(e) {
  Ff(t, e);
  function t() {
    var r;
    return r = e.call(this) || this, r.handleExpired = r.handleExpired.bind(En(r)), r.handleErrored = r.handleErrored.bind(En(r)), r.handleChange = r.handleChange.bind(En(r)), r.handleRecaptchaRef = r.handleRecaptchaRef.bind(En(r)), r;
  }
  var n = t.prototype;
  return n.getValue = function() {
    return this.props.grecaptcha && this._widgetId !== void 0 ? this.props.grecaptcha.getResponse(this._widgetId) : null;
  }, n.getWidgetId = function() {
    return this.props.grecaptcha && this._widgetId !== void 0 ? this._widgetId : null;
  }, n.execute = function() {
    var a = this.props.grecaptcha;
    if (a && this._widgetId !== void 0)
      return a.execute(this._widgetId);
    this._executeRequested = !0;
  }, n.executeAsync = function() {
    var a = this;
    return new Promise(function(s, o) {
      a.executionResolve = s, a.executionReject = o, a.execute();
    });
  }, n.reset = function() {
    this.props.grecaptcha && this._widgetId !== void 0 && this.props.grecaptcha.reset(this._widgetId);
  }, n.handleExpired = function() {
    this.props.onExpired ? this.props.onExpired() : this.handleChange(null);
  }, n.handleErrored = function() {
    this.props.onErrored && this.props.onErrored(), this.executionReject && (this.executionReject(), delete this.executionResolve, delete this.executionReject);
  }, n.handleChange = function(a) {
    this.props.onChange && this.props.onChange(a), this.executionResolve && (this.executionResolve(a), delete this.executionReject, delete this.executionResolve);
  }, n.explicitRender = function() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === void 0) {
      var a = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(a, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      }), this.captcha.appendChild(a);
    }
    this._executeRequested && this.props.grecaptcha && this._widgetId !== void 0 && (this._executeRequested = !1, this.execute());
  }, n.componentDidMount = function() {
    this.explicitRender();
  }, n.componentDidUpdate = function() {
    this.explicitRender();
  }, n.componentWillUnmount = function() {
    this._widgetId !== void 0 && (this.delayOfCaptchaIframeRemoving(), this.reset());
  }, n.delayOfCaptchaIframeRemoving = function() {
    var a = document.createElement("div");
    for (document.body.appendChild(a), a.style.display = "none"; this.captcha.firstChild; )
      a.appendChild(this.captcha.firstChild);
    setTimeout(function() {
      document.body.removeChild(a);
    }, 5e3);
  }, n.handleRecaptchaRef = function(a) {
    this.captcha = a;
  }, n.render = function() {
    var a = this.props;
    a.sitekey, a.onChange, a.theme, a.type, a.tabindex, a.onExpired, a.onErrored, a.size, a.stoken, a.grecaptcha, a.badge, a.hl;
    var s = Mf(a, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    return $e.createElement("div", Fr({}, s, {
      ref: this.handleRecaptchaRef
    }));
  }, t;
}($e.Component);
zn.displayName = "ReCAPTCHA";
zn.propTypes = {
  sitekey: He.string.isRequired,
  onChange: He.func,
  grecaptcha: He.object,
  theme: He.oneOf(["dark", "light"]),
  type: He.oneOf(["image", "audio"]),
  tabindex: He.number,
  onExpired: He.func,
  onErrored: He.func,
  size: He.oneOf(["compact", "normal", "invisible"]),
  stoken: He.string,
  hl: He.string,
  badge: He.oneOf(["bottomright", "bottomleft", "inline"])
};
zn.defaultProps = {
  onChange: function() {
  },
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
var Dr = { exports: {} }, we = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xi;
function Df() {
  if (xi)
    return we;
  xi = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, u = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function C(x) {
    if (typeof x == "object" && x !== null) {
      var E = x.$$typeof;
      switch (E) {
        case t:
          switch (x = x.type, x) {
            case d:
            case c:
            case r:
            case s:
            case a:
            case w:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case l:
                case f:
                case h:
                case p:
                case o:
                  return x;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function y(x) {
    return C(x) === c;
  }
  return we.AsyncMode = d, we.ConcurrentMode = c, we.ContextConsumer = l, we.ContextProvider = o, we.Element = t, we.ForwardRef = f, we.Fragment = r, we.Lazy = h, we.Memo = p, we.Portal = n, we.Profiler = s, we.StrictMode = a, we.Suspense = w, we.isAsyncMode = function(x) {
    return y(x) || C(x) === d;
  }, we.isConcurrentMode = y, we.isContextConsumer = function(x) {
    return C(x) === l;
  }, we.isContextProvider = function(x) {
    return C(x) === o;
  }, we.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, we.isForwardRef = function(x) {
    return C(x) === f;
  }, we.isFragment = function(x) {
    return C(x) === r;
  }, we.isLazy = function(x) {
    return C(x) === h;
  }, we.isMemo = function(x) {
    return C(x) === p;
  }, we.isPortal = function(x) {
    return C(x) === n;
  }, we.isProfiler = function(x) {
    return C(x) === s;
  }, we.isStrictMode = function(x) {
    return C(x) === a;
  }, we.isSuspense = function(x) {
    return C(x) === w;
  }, we.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === c || x === s || x === a || x === w || x === u || typeof x == "object" && x !== null && (x.$$typeof === h || x.$$typeof === p || x.$$typeof === o || x.$$typeof === l || x.$$typeof === f || x.$$typeof === $ || x.$$typeof === g || x.$$typeof === v || x.$$typeof === m);
  }, we.typeOf = C, we;
}
var he = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vi;
function kf() {
  return vi || (vi = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, w = e ? Symbol.for("react.suspense") : 60113, u = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function C(S) {
      return typeof S == "string" || typeof S == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      S === r || S === c || S === s || S === a || S === w || S === u || typeof S == "object" && S !== null && (S.$$typeof === h || S.$$typeof === p || S.$$typeof === o || S.$$typeof === l || S.$$typeof === f || S.$$typeof === $ || S.$$typeof === g || S.$$typeof === v || S.$$typeof === m);
    }
    function y(S) {
      if (typeof S == "object" && S !== null) {
        var be = S.$$typeof;
        switch (be) {
          case t:
            var Ae = S.type;
            switch (Ae) {
              case d:
              case c:
              case r:
              case s:
              case a:
              case w:
                return Ae;
              default:
                var Fe = Ae && Ae.$$typeof;
                switch (Fe) {
                  case l:
                  case f:
                  case h:
                  case p:
                  case o:
                    return Fe;
                  default:
                    return be;
                }
            }
          case n:
            return be;
        }
      }
    }
    var x = d, E = c, O = l, I = o, B = t, P = f, A = r, L = h, U = p, X = n, W = s, Z = a, j = w, M = !1;
    function R(S) {
      return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(S) || y(S) === d;
    }
    function N(S) {
      return y(S) === c;
    }
    function T(S) {
      return y(S) === l;
    }
    function k(S) {
      return y(S) === o;
    }
    function V(S) {
      return typeof S == "object" && S !== null && S.$$typeof === t;
    }
    function H(S) {
      return y(S) === f;
    }
    function Q(S) {
      return y(S) === r;
    }
    function z(S) {
      return y(S) === h;
    }
    function Y(S) {
      return y(S) === p;
    }
    function ee(S) {
      return y(S) === n;
    }
    function re(S) {
      return y(S) === s;
    }
    function te(S) {
      return y(S) === a;
    }
    function ve(S) {
      return y(S) === w;
    }
    he.AsyncMode = x, he.ConcurrentMode = E, he.ContextConsumer = O, he.ContextProvider = I, he.Element = B, he.ForwardRef = P, he.Fragment = A, he.Lazy = L, he.Memo = U, he.Portal = X, he.Profiler = W, he.StrictMode = Z, he.Suspense = j, he.isAsyncMode = R, he.isConcurrentMode = N, he.isContextConsumer = T, he.isContextProvider = k, he.isElement = V, he.isForwardRef = H, he.isFragment = Q, he.isLazy = z, he.isMemo = Y, he.isPortal = ee, he.isProfiler = re, he.isStrictMode = te, he.isSuspense = ve, he.isValidElementType = C, he.typeOf = y;
  }()), he;
}
process.env.NODE_ENV === "production" ? Dr.exports = Df() : Dr.exports = kf();
var Bf = Dr.exports, Zr = Bf, Hf = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Gf = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Vf = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Ms = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Xr = {};
Xr[Zr.ForwardRef] = Vf;
Xr[Zr.Memo] = Ms;
function bi(e) {
  return Zr.isMemo(e) ? Ms : Xr[e.$$typeof] || Hf;
}
var Uf = Object.defineProperty, Wf = Object.getOwnPropertyNames, yi = Object.getOwnPropertySymbols, zf = Object.getOwnPropertyDescriptor, Yf = Object.getPrototypeOf, Ci = Object.prototype;
function Fs(e, t, n) {
  if (typeof t != "string") {
    if (Ci) {
      var r = Yf(t);
      r && r !== Ci && Fs(e, r, n);
    }
    var a = Wf(t);
    yi && (a = a.concat(yi(t)));
    for (var s = bi(e), o = bi(t), l = 0; l < a.length; ++l) {
      var d = a[l];
      if (!Gf[d] && !(n && n[d]) && !(o && o[d]) && !(s && s[d])) {
        var c = zf(t, d);
        try {
          Uf(e, d, c);
        } catch {
        }
      }
    }
  }
  return e;
}
var Zf = Fs;
const Xf = /* @__PURE__ */ Vi(Zf);
function kr() {
  return kr = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kr.apply(this, arguments);
}
function Kf(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, s;
  for (s = 0; s < r.length; s++)
    a = r[s], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function qf(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var Xe = {}, Jf = 0;
function Qf(e, t) {
  return t = t || {}, function(r) {
    var a = r.displayName || r.name || "Component", s = /* @__PURE__ */ function(l) {
      qf(d, l);
      function d(f, w) {
        var u;
        return u = l.call(this, f, w) || this, u.state = {}, u.__scriptURL = "", u;
      }
      var c = d.prototype;
      return c.asyncScriptLoaderGetScriptLoaderID = function() {
        return this.__scriptLoaderID || (this.__scriptLoaderID = "async-script-loader-" + Jf++), this.__scriptLoaderID;
      }, c.setupScriptURL = function() {
        return this.__scriptURL = typeof e == "function" ? e() : e, this.__scriptURL;
      }, c.asyncScriptLoaderHandleLoad = function(w) {
        var u = this;
        this.setState(w, function() {
          return u.props.asyncScriptOnLoad && u.props.asyncScriptOnLoad(u.state);
        });
      }, c.asyncScriptLoaderTriggerOnScriptLoaded = function() {
        var w = Xe[this.__scriptURL];
        if (!w || !w.loaded)
          throw new Error("Script is not loaded.");
        for (var u in w.observers)
          w.observers[u](w);
        delete window[t.callbackName];
      }, c.componentDidMount = function() {
        var w = this, u = this.setupScriptURL(), p = this.asyncScriptLoaderGetScriptLoaderID(), h = t, m = h.globalName, $ = h.callbackName, g = h.scriptId;
        if (m && typeof window[m] < "u" && (Xe[u] = {
          loaded: !0,
          observers: {}
        }), Xe[u]) {
          var v = Xe[u];
          if (v && (v.loaded || v.errored)) {
            this.asyncScriptLoaderHandleLoad(v);
            return;
          }
          v.observers[p] = function(O) {
            return w.asyncScriptLoaderHandleLoad(O);
          };
          return;
        }
        var C = {};
        C[p] = function(O) {
          return w.asyncScriptLoaderHandleLoad(O);
        }, Xe[u] = {
          loaded: !1,
          observers: C
        };
        var y = document.createElement("script");
        y.src = u, y.async = !0;
        for (var x in t.attributes)
          y.setAttribute(x, t.attributes[x]);
        g && (y.id = g);
        var E = function(I) {
          if (Xe[u]) {
            var B = Xe[u], P = B.observers;
            for (var A in P)
              I(P[A]) && delete P[A];
          }
        };
        $ && typeof window < "u" && (window[$] = function() {
          return w.asyncScriptLoaderTriggerOnScriptLoaded();
        }), y.onload = function() {
          var O = Xe[u];
          O && (O.loaded = !0, E(function(I) {
            return $ ? !1 : (I(O), !0);
          }));
        }, y.onerror = function() {
          var O = Xe[u];
          O && (O.errored = !0, E(function(I) {
            return I(O), !0;
          }));
        }, document.body.appendChild(y);
      }, c.componentWillUnmount = function() {
        var w = this.__scriptURL;
        if (t.removeOnUnmount === !0)
          for (var u = document.getElementsByTagName("script"), p = 0; p < u.length; p += 1)
            u[p].src.indexOf(w) > -1 && u[p].parentNode && u[p].parentNode.removeChild(u[p]);
        var h = Xe[w];
        h && (delete h.observers[this.asyncScriptLoaderGetScriptLoaderID()], t.removeOnUnmount === !0 && delete Xe[w]);
      }, c.render = function() {
        var w = t.globalName, u = this.props;
        u.asyncScriptOnLoad;
        var p = u.forwardedRef, h = Kf(u, ["asyncScriptOnLoad", "forwardedRef"]);
        return w && typeof window < "u" && (h[w] = typeof window[w] < "u" ? window[w] : void 0), h.ref = p, da(r, h);
      }, d;
    }(go), o = Ot(function(l, d) {
      return da(s, kr({}, l, {
        forwardedRef: d
      }));
    });
    return o.displayName = "AsyncScriptLoader(" + a + ")", o.propTypes = {
      asyncScriptOnLoad: He.func
    }, Xf(o, r);
  };
}
var Ds = "onloadcallback", e2 = "grecaptcha";
function t2() {
  return typeof window < "u" && window.recaptchaOptions || {};
}
function n2() {
  var e = t2(), t = e.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + t + "/recaptcha/api.js?onload=" + Ds + "&render=explicit";
}
const r2 = Qf(n2, {
  callbackName: Ds,
  globalName: e2
})(zn), a2 = ({ children: e }) => i.jsx("div", { className: "tw-col-span-2", children: e }), i2 = ({ children: e }) => i.jsx(i.Fragment, { children: e }), Xw = ({ formId: e, heading: t, formFields: n, submitButton: r, numberOfColumns: a = "two", reCaptchaKey: s, className: o = "", onSubmit: l, showModalOnSuccess: d = !0 }) => {
  const { errors: c, submitFormState: f, handleSubmit: w, handleChangeRecaptcha: u, recaptchaRef: p, handleChange: h, handleSelectChange: m, handleBlur: $, isModalOpen: g, setIsModalOpen: v, modalInfo: C, values: y } = uf(n, l, d), x = a === "two" ? "md:tw-grid md:tw-grid-cols-2" : "";
  return i.jsxs(i.Fragment, { children: [i.jsxs("form", { id: e, name: e, className: `tw-flex tw-flex-col tw-items-center tw-w-full tw-px-5 tw-pt-4 tw-pb-10 tw-gap-6 tw-text-secondary ${o}`, onSubmit: w, children: [i.jsx("legend", { className: "tw-flex tw-flex-col tw-gap-4", children: i.jsx(Hs, { ...t }) }), i.jsx("div", { className: `tw-flex tw-flex-col tw-w-full md:tw-max-w-2xl lg:tw-max-w-4xl ${x} tw-gap-8`, children: n.map((E, O) => {
    var A;
    const I = ko(c, E), B = n.length % 2 && O === n.length - 1 ? a2 : i2, P = (A = E.options) == null ? void 0 : A.find((L) => E.name ? L.value === y[E.name] : null);
    return i.jsx(B, { children: E.type === "select" ? i.jsx(hs, { ...E, onSelectChange: m, onBlur: $, currentOption: P, error: I && I.error, errorMessage: I && I.errorMessage }) : i.jsx(Un, { ...E, required: E.hiddenField ? !1 : E.required, value: E.name && y[E.name] || "", onChange: h, onBlur: $, error: I && I.error, errorMessage: I && I.errorMessage }) }, O);
  }) }), !!s && i.jsx(r2, { ref: p, sitekey: s, onChange: u }), !!s && c.recaptcha && i.jsx("span", { className: "tw-text-error tw-text-sm tw-leading-4", children: c.recaptcha }), i.jsx(Te, { ...r, type: "submit", variant: Me.SECONDARY, className: "tw-w-fit", icon: f === "send" ? { type: "check" } : void 0, state: f === "disabled" || f === "send" ? De.DISABLED : f === "loading" ? De.LOADING : De.ENABLED, label: f === "loading" ? "Loading..." : f === "send" ? "Submitted" : r.label })] }), i.jsx(Tf, { isOpen: g, title: C.title, description: { text: C.message }, handleCloseModal: () => v(!1) })] });
}, Kw = ({ steps: e, className: t }) => i.jsx("ul", { className: `tw-flex tw-flex-col tw-w-full ${t}`, children: e.map((n, r) => i.jsx(Aw, { id: r + 1, description: n.description }, `or-step-item${r}`)) }), s2 = (e) => `
  ${e.length <= 2 ? "tw-hidden" : "tw-flex"}
  ${e.length <= 3 ? "sm:tw-hidden" : "sm:tw-flex"} 
  ${e.length <= 4 ? "md:tw-hidden" : "md:tw-flex"} 
  ${e.length <= 6 ? "lg:tw-hidden" : "lg:tw-flex"}
  ${e.length <= 7 ? "xl:tw-hidden" : "xl:tw-flex"}`, o2 = ({ group: e }) => {
  const { isAtTheBeginning: t, isAtTheEnd: n, onTransitionEnd: r } = Qt(), a = {
    spaceBetween: 16,
    threshold: 2,
    grabCursor: !0,
    modules: [Cs],
    resistanceRatio: 0,
    onTransitionEnd: r,
    breakpoints: {
      375: {
        slidesPerView: 2.2
      },
      640: {
        slidesPerView: 3.5
      },
      768: {
        slidesPerView: 4.8
      },
      1024: {
        slidesPerView: 6.3
      },
      1280: {
        slidesPerView: 7.5
      }
    }
  };
  return i.jsxs("section", { className: "tw-mt-6", children: [e.title && i.jsxs("span", { className: "tw-flex tw-gap-2 tw-items-center tw-py-2", children: [e.title, i.jsx("button", { onClick: e.onClickInformationIcon, children: i.jsx(ne, { alt: "Information", type: "info", size: 20, color: "link" }) })] }), i.jsxs(Ye, { ...a, children: [e.samples.map((s, o) => i.jsx(Ue, { className: "tw-flex tw-justify-center", children: i.jsx(Ws, { ...s }) }, `sample-card-${o}`)), i.jsxs("div", { className: `tw-flex ${s2(e.samples)} tw-gap-4`, children: [i.jsx(ke, { direction: "left", variant: "block", disabled: t }), i.jsx(ke, { direction: "right", variant: "block", disabled: n })] })] })] });
}, l2 = ({ group: e }) => i.jsxs("section", { children: [e.title && i.jsxs("span", { className: "tw-flex tw-gap-2 tw-items-center tw-p-2", children: [e.title, i.jsx("button", { onClick: e.onClickInformationIcon, children: i.jsx(ne, { alt: "Information", type: "info", size: 20, color: "link" }) })] }), i.jsx("div", { className: "tw-grid tw-grid-cols-2 tw-justify-center", children: e.samples.map((t, n) => i.jsx("div", { className: "tw-flex tw-justify-center", children: i.jsx(Ws, { ...t }) }, `sample-card-${n}`)) })] }), d2 = ({ titleContainer: e, samplesGroup: t, isActiveSwiper: n = !0 }) => i.jsxs("div", { className: `tw-w-full ${n ? "tw-py-6" : ""} `, children: [i.jsx("h2", { className: `tw-py-2 tw-px-6 tw-bg-subdued tw-text-lg tw-font-medium ${n ? "" : "tw-sticky tw-top-12 tw-z-50"}`, children: e }), t.map((r, a) => r.samples.length > 0 && (n ? i.jsx(o2, { group: r }, a) : i.jsx(l2, { group: r }, a)))] });
const qw = ({ breakpoints: e, swatchCardSelected: t, options: n = [], swatchCardHandler: r }) => {
  const { isAtTheBeginning: a, isAtTheEnd: s, onTransitionEnd: o } = Qt();
  return i.jsxs(Ye, { threshold: 10, watchSlidesProgress: !0, slidesPerView: 1, breakpoints: {
    320: {
      slidesPerView: 1
    },
    375: {
      slidesPerView: 2
    },
    640: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 3.5
    },
    1024: {
      slidesPerView: 4
    },
    1280: {
      slidesPerView: 5
    },
    ...e && Object.keys(e).length > 0 && e
  }, modules: [Pt], className: "tw-w-full !tw-px-6 !tw-py-3", onTransitionEnd: o, children: [i.jsx(ke, { className: `!tw-top-0 !tw-h-full ${n.length <= 5 ? "xl:tw-hidden" : "xl:tw-block"}`, direction: "left", disabled: a }), n.map((l, d) => i.jsx(Ue, { children: i.jsx("div", { className: "tw-mx-auto tw-w-fit", children: i.jsx(sw, { ...l, clickHandler: () => r(l), selected: t === l.id }) }) }, `swatch-card-slide-${d}`)), i.jsx(ke, { className: `!tw-top-0 !tw-h-full ${n.length <= Lo ? "xl:tw-hidden" : "xl:tw-block"}`, direction: "right", disabled: s })] });
}, Jw = ({ isOpen: e = !1, title: t, description: n, sampleGroups: r, actionButton: a, handleCloseDrawer: s }) => i.jsx(lt, { appear: !0, show: e, as: Ve, children: i.jsxs("div", { className: "samples-drawer tw-fixed tw-overflow-hidden tw-w-screen tw-z-20 tw-left-0 tw-botom-0 tw-right-0 tw-top-0 tw-h-screen", "aria-label": "drawer-container", children: [i.jsx(lt.Child, { as: Ve, enter: "tw-ease-out tw-duration-500", enterFrom: "tw-opacity-0", enterTo: "tw-opacity-100", leave: "tw-ease-in tw-duration-300", leaveFrom: "tw-opacity-100", leaveTo: "tw-opacity-0", children: i.jsx("div", { className: "tw-absolute tw-w-full tw-h-full tw-bg-black/50 tw-z-30", onClick: () => s(), "aria-hidden": "true" }) }), i.jsx(lt.Child, { as: Ve, enter: "tw-ease-out tw-duration-500", enterFrom: "tw-translate-x-full", enterTo: "tw-translate-0", leave: "tw-ease-in tw-duration-300", leaveFrom: "tw-translate-0", leaveTo: "tw-translate-x-full", children: i.jsx("div", { className: "tw-w-full tw-bg-white tw-max-w-[335px] sm:tw-max-w-[375px] tw-z-40 tw-transition-all tw-bg-whit tw-absolute tw-top-0 tw-right-0 tw-h-full", children: i.jsxs("div", { className: "tw-flex tw-flex-col tw-overflow-scroll tw-h-full tw-max-h-screen", children: [i.jsx("div", { className: "tw-flex tw-flex-row tw-justify-end tw-py-3 tw-px-5 tw-sticky tw-top-0 tw-right-0 w-full tw-bg-white tw-z-50", children: i.jsx("button", { className: "tw-justify-end", type: "button", "aria-label": "Close disclaimer banner", onClick: () => {
  s();
}, children: i.jsx(ne, { type: "close", size: 24, color: "secondary" }) }) }), i.jsx("div", { className: "tw-flex w-full tw-flex-col tw-bg-white ", children: i.jsxs("div", { className: "fw-flex tw-flex-col tw-gap-2 tw-pb-3 tw-px-5", children: [t && i.jsx("h2", { className: "tw-text-2xl tw-mb-2 tw-font-[325]", children: t }), n && i.jsx("h4", { className: "tw-text-sm", children: n })] }) }), i.jsx("div", { className: "tw-mb-36", children: r && r.length > 0 && r.map((o, l) => i.jsx(d2, { ...o, isActiveSwiper: !1 }, `sample-drawer-group-${l}`)) }), i.jsxs("div", { className: "tw-flex-shrink-0 tw-absolute tw-bottom-0 tw-right-0 tw-left-0 tw-flex-col tw-flex w-full tw-z-50 tw-w-full tw-p-4 tw-pr-8 tw-gap-4 tw-border-t tw-bg-white tw-border-outlined-gray", children: [i.jsx(Te, { className: "tw-h-[43px]", variant: Me.SECONDARY, label: "Close", onClick: () => s() }), a && i.jsx(Te, { className: "tw-h-[43px]", ...a, variant: Me.TERTIARY })] })] }) }) })] }) }), cn = {
  [_e.SMALL]: "tw-font-normal tw-text-secondary tw-m-0 tw-p-0 tw-text-xl",
  [_e.NORMAL]: "tw-font-normal tw-text-secondary tw-m-0 tw-p-0 tw-text-xl sm:tw-text-2xl tw-leading-7 md:tw-leading-8 lg:tw-leading-9",
  [_e.BIG]: "tw-text-secondary tw-text-xl sm:tw-text-2xl lg:tw-text-3xl"
}, ks = ({ isH1: e, children: t, className: n = "" }) => e ? i.jsx("h1", { className: n, children: t }) : i.jsx("h2", { className: n, children: t }), Ei = ({ isH1: e, textAlignment: t, headingSize: n, customClassName: r = "" }) => (a, s) => {
  const o = t ? zt[t] : "";
  return i.jsx(ks, { isH1: !!e, className: `${n ? `${cn[n]}` : "tw-text-2xl"} ${o} ${r}`, children: s });
}, Bs = ({ isH1: e, textAlignment: t, headingSize: n, customClassName: r = "" }) => ({
  renderNode: {
    [q.HEADING_1]: Ei({
      isH1: e,
      textAlignment: t,
      headingSize: n,
      customClassName: r
    }),
    [q.HEADING_2]: Ei({
      isH1: e,
      textAlignment: t,
      headingSize: n,
      customClassName: r
    }),
    // This is intentional to force render only heading blocks
    [q.PARAGRAPH]: () => null
  }
}), Hs = ({ id: e, className: t = "", description: n, hasUnderline: r = !1, title: a, textAlignment: s = Ze.LEFT, headingSize: o = _e.BIG, paddingX: l = !1, paddingY: d = !1 }) => {
  const c = l ? Xt : "", f = d ? xf : "", w = a ? !!a.content.find((u) => u.nodeType === q.HEADING_1) : !1;
  return i.jsxs("div", { className: `tw-flex tw-flex-col tw-gap-2 sm:tw-gap-3 tw-w-full ${c} ${f} ${t}`, ...!!e && { id: e }, children: [i.jsx(je, { text: a, customOptions: Bs({
    isH1: w,
    textAlignment: s,
    headingSize: o
  }), className: "tw-m-0 tw-p-0" }), !!n && i.jsx(je, { className: `tw-font-normal tw-text-secondary tw-text-sm md:tw-text-base tw-break-words ${zt[s]}`, text: n }), r && i.jsx("hr", { role: "separator", className: "tw-border-outlined-gray" })] });
}, Kt = (e) => ({
  //TODO: Change img to AtImage
  [q.EMBEDDED_ASSET]: (t) => i.jsx("img", { alt: t.data.target.fields.title, src: t.data.target.fields.file.url }),
  [_t.HYPERLINK]: (t, n) => i.jsx(J, { variant: oe.DEFAULT, href: t.data.uri, rel: "noopener noreferrer", label: n, className: e }),
  [q.PARAGRAPH]: (t, n) => i.jsx("p", { className: `tw-text-secondary tw-inline ${e}`, children: n }),
  [q.HEADING_1]: (t, n) => i.jsx("h1", { className: `${cn.normal} ${e}`, children: n }),
  [q.HEADING_2]: (t, n) => i.jsx("h2", { className: `${cn.normal} ${e}`, children: n }),
  [q.HEADING_3]: (t, n) => i.jsx("h3", { className: `${cn.small} ${e}`, children: n }),
  [q.HEADING_4]: (t, n) => i.jsx("h4", { className: `tw-font-bold tw-text-secondary tw-m-0 tw-p-0 tw-text-xl ${e}`, children: n }),
  [q.HEADING_5]: (t, n) => i.jsx("h5", { className: `tw-font-normal tw-text-secondary tw-m-0 tw-p-0 tw-text-xl ${e}`, children: n }),
  [q.HEADING_6]: (t, n) => i.jsx("h6", { className: `tw-font-bold tw-text-secondary tw-m-0 tw-p-0 tw-text-lg ${e}`, children: n }),
  [q.HR]: () => i.jsx("hr", { className: "tw-text-outlined-gray" }),
  [q.QUOTE]: (t, n) => i.jsx("blockquote", { className: "tw-italic tw-border-l-4 tw-p-4 tw-border-secondary tw-border-opacity-60", children: n }),
  [q.UL_LIST]: (t, n) => i.jsx("ul", { className: "tw-flex tw-flex-col tw-list-disc tw-list-inside tw-pl-3 marker:tw-text-secondary", children: n }),
  [q.OL_LIST]: (t, n) => i.jsx("ol", { className: "tw-flex tw-flex-col tw-list-decimal tw-list-inside tw-pl-3 marker:tw-text-secondary", children: n }),
  [q.LIST_ITEM]: (t, n) => i.jsx("li", { children: n }),
  [q.TABLE]: (t, n) => i.jsx("table", { className: "tw-w-full tw-border-collapse tw-border tw-border-secondary", children: n }),
  [q.TABLE_HEADER_CELL]: (t, n) => i.jsx("th", { className: "tw-py-1 tw-px-2 tw-text-center tw-border tw-border-secondary", children: i.jsx("div", { className: "tw-flex tw-flex-col", children: n }) }),
  [q.TABLE_CELL]: (t, n) => i.jsx("td", { className: "tw-py-1 tw-px-2 tw-border tw-border-secondary", children: i.jsx("div", { className: "tw-flex tw-flex-col", children: n }) })
}), Gs = (e) => ({
  ...Kt,
  [_t.HYPERLINK]: (t, n) => i.jsx(J, { variant: oe.WHITE, active: !0, href: t.data.uri, rel: "noopener noreferrer", label: n, className: e }),
  [q.PARAGRAPH]: (t, n) => i.jsx("p", { className: `tw-text-white tw-inline ${e}`, children: n }),
  [q.HEADING_2]: (t, n) => i.jsx("h2", { className: "tw-font-normal tw-text-white tw-m-0 tw-p-0 tw-text-lg md:tw-text-2xl lg:tw-text-3xl tw-leading-7 md:tw-leading-8 lg:tw-leading-9", children: n }),
  [q.HEADING_3]: (t, n) => i.jsx("h3", { className: `${cn.small} tw-text-white ${e}`, children: n }),
  [q.HEADING_4]: (t, n) => i.jsx("h4", { className: `tw-font-bold tw-text-white tw-m-0 tw-p-0 tw-text-xl ${e}`, children: n }),
  [q.HEADING_5]: (t, n) => i.jsx("h5", { className: `tw-font-normal tw-text-white tw-m-0 tw-p-0 tw-text-xl ${e}`, children: n }),
  [q.HEADING_6]: (t, n) => i.jsx("h6", { className: `tw-font-bold tw-text-white tw-m-0 tw-p-0 tw-text-lg ${e}`, children: n }),
  [q.HR]: () => i.jsx("hr", { className: "tw-text-white tw-opacity-40" }),
  [q.QUOTE]: (t, n) => i.jsx("blockquote", { className: "tw-italic tw-border-l-4 tw-p-4 tw-border-white tw-border-opacity-60", children: n }),
  [q.UL_LIST]: (t, n) => i.jsx("ul", { className: "tw-flex tw-flex-col tw-list-disc tw-list-inside tw-pl-3 marker:tw-text-white", children: n }),
  [q.OL_LIST]: (t, n) => i.jsx("ol", { className: "tw-flex tw-flex-col tw-list-decimal tw-list-inside tw-pl-3 marker:tw-text-white", children: n }),
  [q.LIST_ITEM]: (t, n) => i.jsx("li", { children: n }),
  [q.TABLE]: (t, n) => i.jsx("table", { className: "tw-w-full tw-border-collapse tw-border tw-border-white", children: n }),
  [q.TABLE_HEADER_CELL]: (t, n) => i.jsx("th", { className: "tw-py-1 tw-px-2 tw-text-center tw-border tw-border-white", children: i.jsx("div", { className: "tw-flex tw-flex-col", children: n }) }),
  [q.TABLE_CELL]: (t, n) => i.jsx("td", { className: "tw-py-1 tw-px-2 tw-border tw-border-white", children: i.jsx("div", { className: "tw-flex tw-flex-col", children: n }) })
});
var me;
(function(e) {
  e.WHITE = "white", e.BLACK = "black";
})(me || (me = {}));
const c2 = {
  [me.BLACK]: (e) => Kt(e),
  [me.WHITE]: (e) => Gs(e)
}, je = ({ text: e, textAlignment: t = Ze.LEFT, className: n = "", variant: r = me.BLACK, nodeClassName: a = "", customRenderNode: s, customOptions: o }) => {
  const l = rt(() => c2[r](a), [a, r]), d = e != null && e.json ? { ...e.json } : e;
  try {
    return i.jsx("div", { className: `tw-flex tw-flex-col tw-gap-4 ${zt[t]} ${n}`, children: Gr(d, o || {
      renderNode: s ? { ...l, ...s } : l,
      renderText: (c) => c.split(`
`).reduce((f, w, u) => [...f, u > 0 ? i.jsx("br", {}, u) : "", w], new Array())
    }) });
  } catch {
    return null;
  }
};
var pt;
(function(e) {
  e.LEFT = "left", e.RIGHT = "right", e.TOP = "top", e.BOTTOM = "bottom";
})(pt || (pt = {}));
var Gt;
(function(e) {
  e.LEFT = "left", e.RIGHT = "right", e.CENTER = "center";
})(Gt || (Gt = {}));
var Oe;
(function(e) {
  e.DEFAULT = "default", e.LARGE = "large", e.EXTRA_LARGE = "extra-large";
})(Oe || (Oe = {}));
const u2 = {
  [pt.LEFT]: (e) => "lg:tw-order-0",
  [pt.RIGHT]: (e) => "lg:tw-order-1",
  [pt.TOP]: (e, t) => `tw-order-0 ${e === Oe.LARGE || e === Oe.EXTRA_LARGE && t ? "-tw-mb-10" : ""}`,
  [pt.BOTTOM]: (e, t) => `tw-order-1 ${e === Oe.LARGE || e === Oe.EXTRA_LARGE && t ? "-tw-mt-10" : ""}`
}, f2 = {
  [Gt.LEFT]: "lg:tw-mx-0 lg:tw-justify-start",
  [Gt.RIGHT]: "lg:tw-mx-0 lg:tw-justify-end",
  [Gt.CENTER]: "lg:tw-mx-auto lg:tw-justify-center"
}, et = {
  [Oe.DEFAULT]: {
    container: "tw-bg-white tw-flex tw-flex-col lg:tw-gap-y-8 lg:tw-flex-row tw-mx-auto",
    image: "tw-overflow-hidden",
    imageContainer: "lg:tw-w-7/12",
    contentContainer: "lg:tw-w-5/12 tw-flex tw-flex-col-reverse lg:tw-flex-col",
    contentSpacing: "tw-px-4 tw-pb-5 lg:tw-py-6 tw-gap-5 lg:tw-gap-8",
    button: "tw-mt-auto tw-w-fit tw-self-center lg:tw-self-start",
    link: "tw-w-fit tw-self-center lg:tw-self-start tw-my-2 lg:tw-my-4",
    richText: "tw-items-center tw-text-center lg:tw-items-start lg:tw-text-left"
  },
  [Oe.LARGE]: {
    container: "tw-flex tw-flex-col tw-items-center",
    image: "",
    imageContainer: "tw-w-full",
    contentContainer: "tw-flex tw-flex-col tw-mx-5 tw-w-full tw-max-w-large-container tw-bg-white tw-z-10",
    contentSpacing: "tw-py-4 tw-px-2 sm:tw-px-4 tw-gap-4 lg:tw-gap-6",
    button: "tw-mt-auto tw-w-fit tw-self-center",
    link: "",
    richText: "tw-text-center !tw-gap-2 sm:!tw-gap-3"
  },
  [Oe.EXTRA_LARGE]: {
    container: "tw-flex tw-flex-col tw-items-center",
    image: "",
    imageContainer: "tw-w-full",
    contentContainer: "tw-flex tw-flex-col tw-mx-4 md:tw-mx-5 lg:tw-mx-6 sx:tw-mx-0 sx:tw-w-full tw-z-10",
    contentSpacing: "tw-py-4 tw-px-0 tw-gap-6",
    button: "tw-mt-auto tw-w-fit tw-self-center",
    link: "",
    richText: "tw-text-center !tw-gap-2 sm:!tw-gap-3"
  }
}, w2 = "https://vumbnail.com/", h2 = "https://img.youtube.com/vi/";
var mt;
(function(e) {
  e.VIMEO = "vimeo", e.YOUTUBE = "youtube";
})(mt || (mt = {}));
const p2 = (e) => {
  if (e != null && e.hostname.includes(mt.VIMEO)) {
    const t = e.pathname.replace("/", "");
    return `${w2}${t}.jpg`;
  }
  if (e != null && e.hostname.includes(mt.YOUTUBE)) {
    const t = e.searchParams.get("v") ?? "";
    return `${h2}${t}/0.jpg`;
  }
};
var gt;
(function(e) {
  e.VIDEO_FILE = "video-file", e.VIDEO_URL = "video-url", e.VIDEO_FILE_THUMBNAILS = "video-file-thumbnails";
})(gt || (gt = {}));
const m2 = Ot(({ videoUrl: e, className: t, caption: n, captionClassName: r, ...a }, s) => {
  var c;
  const o = e.split("/"), l = o[o.length - 1], d = () => {
    if (l.includes(".mp4"))
      return i.jsx("source", { src: e, type: "video/mp4" });
    if (l.includes(".webm"))
      return i.jsx("source", { src: e, type: "video/webm" });
  };
  return i.jsxs(i.Fragment, { children: [i.jsx("video", { className: t, src: e, controls: (c = a.videoAttributes) == null ? void 0 : c.controls, loop: !0, muted: !0, controlsList: "nodownload", autoPlay: !0, width: "100%", ref: s, playsInline: !0, tabIndex: -1, ...a, children: d() }), n && i.jsx("span", { className: `tw-my-2 tw-mx-1 tw-text-secondary tw-text-sm tw-text-left tw-block tw-w-full ${r ?? ""}`, children: n })] });
}), g2 = ({ image: e, videoUrl: t, className: n }) => {
  const r = rt(() => new URL(t), [t]), [a, s] = G(!1), [o, l] = G(!1), [d, c] = G(!1), f = r.searchParams.get("v") ?? "", w = Number(r.pathname.replace("/", "")), u = `youtube-player-${f}`, p = `vimeo-player-${w}`;
  return le(() => {
    const h = () => document.fullscreenElement || document.mozFullScreenElement || document.webkitCurrentFullScreenElement || document.msFullscreenElement, m = () => {
      var $, g;
      h() && (($ = document.querySelector("body")) == null || $.classList.add("tw-overflow-hidden")), !h() && ((g = document.querySelector("body")) == null || g.classList.remove("tw-overflow-hidden"));
    };
    if (["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"].forEach(($) => document.addEventListener($, m)), r != null && r.hostname.includes(mt.YOUTUBE) && a) {
      l(!0);
      const $ = Ao(u, {
        videoId: f
      });
      $.on("ready", () => l(!1)), $.playVideo(), $.on("stateChange", (g) => {
        g.data === 0 && s(!1);
      });
    }
    if (r != null && r.hostname.includes(mt.VIMEO) && a) {
      c(!0);
      const $ = new Io(p, {
        id: w
      });
      $.on("loaded", () => c(!1)), $.play(), $.on("ended", () => s(!1));
    }
    return () => ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"].forEach(($) => document.removeEventListener($, m));
  }, [r == null ? void 0 : r.hostname, a, u, f, p, w]), i.jsxs("div", { className: `tw-relative tw-aspect-video tw-overflow-hidden ${n}`, children: [i.jsxs("div", { className: `tw-transition-all tw-duration-700 ${!a || o || d ? "tw-opacity-100" : "tw-opacity-0 tw-hidden"}`, children: [i.jsx(de, { alt: e ? e.alt : String(f) || String(w), src: e ? e.src : p2(r), className: "tw-aspect-video tw-w-full tw-h-full tw-object-cover tw-ease-in-out tw-duration-700", "data-testid": "image" }), i.jsx("button", { className: `tw-absolute tw-inset-0 tw-flex tw-justify-center tw-items-center tw-w-full ${ge[ie.FOCUS_VISIBLE]}`, "data-testid": "play-btn", type: "button", disabled: o || d, "aria-label": "play button", onClick: () => s(!0), children: i.jsx(ne, { color: "white", size: 96, type: o || d ? "spinner" : "play-video", className: "tw-mx-auto tw-w-9 tw-h-9 sm:tw-w-12 sm:tw-h-12 lg:tw-w-24 lg:tw-h-24" }) })] }), a && (r == null ? void 0 : r.hostname.includes(mt.YOUTUBE)) && i.jsx("div", { className: `tw-video-size tw-transition-all tw-duration-200 ${o ? "tw-h-0 tw-scale-y-0" : "tw-scale-y-100 tw-h-max"}`, children: i.jsx("div", { id: u, "data-testid": "youtube-video" }) }), a && (r == null ? void 0 : r.hostname.includes(mt.VIMEO)) && i.jsx("div", { id: p, className: `tw-video-size tw-transition-all tw-duration-200 ${d ? "tw-h-0 tw-scale-y-0" : "tw-scale-y-100 tw-h-max"}`, "data-testid": "vimeo-video" })] });
}, $2 = ({ image: e, videoUrl: t, className: n, caption: r, captionClassName: a, videoAttributes: s }) => {
  const o = t.split("/"), l = o[o.length - 1], [d, c] = G(!1), f = () => {
    if (l.includes(".mp4"))
      return i.jsx("source", { src: t, type: "video/mp4" });
    if (l.includes(".webm"))
      return i.jsx("source", { src: t, type: "video/webm" });
  };
  return i.jsxs("div", { className: "tw-relative tw-aspect-video", children: [i.jsxs("div", { className: `tw-transition-all tw-duration-700 ${d ? "tw-opacity-0 tw-hidden" : "tw-opacity-100"}`, children: [e && i.jsx(de, { alt: e.alt, src: e.src, className: "tw-aspect-video tw-w-full tw-h-full tw-object-cover tw-ease-in-out tw-duration-700", "data-testid": "image" }), i.jsx("button", { className: `tw-absolute tw-inset-0 tw-flex tw-justify-center tw-items-center tw-w-full ${ge[ie.FOCUS_VISIBLE]}`, "data-testid": "play-btn", type: "button", "aria-label": "play button", onClick: () => c(!0), children: i.jsx(ne, { color: "white", size: 96, type: "play-video", className: "tw-mx-auto tw-w-9 tw-h-9 sm:tw-w-12 sm:tw-h-12 lg:tw-w-24 lg:tw-h-24" }) })] }), d && i.jsx("video", { className: n, src: t, controls: !0, loop: !0, muted: !0, controlsList: "nodownload", autoPlay: !0, width: "100%", playsInline: !0, tabIndex: -1, style: { height: "-webkit-fill-available" }, ...s, children: f() }), r && i.jsx("span", { className: `tw-my-2 tw-mx-1 tw-text-secondary tw-text-sm tw-text-left tw-block tw-w-full ${a ?? ""}`, children: r })] });
}, gn = Ot(({ variant: e = gt.VIDEO_URL, videoAttributes: t, ...n }, r) => e === gt.VIDEO_FILE ? i.jsx(m2, { ...t, ...n, ref: r }) : e === gt.VIDEO_FILE_THUMBNAILS ? i.jsx($2, { ...n }) : i.jsx(g2, { ...n })), x2 = {
  [_t.HYPERLINK]: (e, t) => i.jsx(J, { variant: oe.DEFAULT, hasUnderline: !0, active: !0, href: e.data.uri, actionUrl: "_blank", rel: "noopener noreferrer", label: t }),
  [q.PARAGRAPH]: (e, t) => i.jsx("p", { className: "tw-text-secondary tw-text-sm sm:tw-text-base", children: t })
}, Qw = ({ id: e, button: t, content: n, headingSize: r = _e.BIG, imageAspectRatio: a = Le.VIDEO, mobileAspectRatio: s = Le.VIDEO, imageLink: o, mobileImageLink: l, imagePosition: d = pt.LEFT, thumbnailsPosition: c = Gt.LEFT, link: f, preHeading: w, thumbnailLinks: u, variant: p = Oe.DEFAULT, video: h }) => {
  const m = p === Oe.DEFAULT, $ = p === Oe.EXTRA_LARGE, g = Array.isArray(u) && u.length > 0, v = (C, y) => {
    let x = !1;
    y && (x = !!y.content.find((O) => O.nodeType === q.HEADING_1));
    const E = Bs({
      isH1: x,
      textAlignment: C === Oe.DEFAULT ? Ze.LEFT : Ze.CENTER,
      headingSize: r,
      customClassName: Oe.DEFAULT === p ? "tw-text-center lg:tw-text-left" : ""
    });
    return {
      ...E,
      renderNode: {
        ...E.renderNode,
        ...x2
      }
    };
  };
  return i.jsxs("div", { ...!!e && { id: e }, className: et[p].container, children: [i.jsxs("div", { className: `${et[p].imageContainer} ${u2[d](p, !!t)}`, children: [h && p === Oe.EXTRA_LARGE && i.jsx(gn, { ...h }), !h && i.jsxs(i.Fragment, { children: [o && i.jsx(J, { ...o, image: { ...o.image, caption: void 0 }, className: l ? "tw-hidden md:tw-grid" : "", imageClassName: `${et[p].image} ${Sn[a]} ${ln[s]}` }), l && i.jsx(J, { ...l, image: { ...l.image, caption: void 0 }, className: "tw-grid md:tw-hidden", imageClassName: `${et[p].image} ${ln[s]}` })] })] }), i.jsxs("div", { className: `${et[p].contentContainer} ${m && !g ? "tw-justify-start" : "tw-justify-center"}`, children: [i.jsxs("div", { className: `${et[p].contentSpacing} tw-flex ${m && !g ? "lg:tw-pt-[2.625rem] tw-pt-6 tw-pb-8" : ""} ${$ && d === pt.TOP ? "tw-flex-col-reverse" : "tw-flex-col"} `, children: [(w == null ? void 0 : w.text) && m && i.jsx(je, { ...w, nodeClassName: `!tw-font-medium !tw-text-lg sm:!tw-text-xl ${et[p].richText}` }), i.jsx(je, { ...n, className: `${et[p].richText} ${m && !g ? "lg:tw-gap-5" : ""}`, customOptions: v(p, n.text) }), t && i.jsx(Te, { ...t, variant: t.variant || Me.SECONDARY, size: m ? St.COMPACT : St.DEFAULT, className: et[p].button }), f && m && i.jsx(J, { ...f, className: et[p].link })] }), g && m && i.jsx("div", { className: `tw-opacity-100 tw-flex tw-flex-row tw-gap-4 tw-z-10 tw-mx-auto tw-mt-4 tw-mb-5 sm:tw-mb-4 lg:tw-px-4 ${f2[c]}`, children: u == null ? void 0 : u.map((C, y) => {
    var x;
    return i.jsx(J, { ...C, image: { ...C.image, caption: void 0 }, "aria-label": `thumbnail-${y}`, imageClassName: "tw-thumbnail-size tw-shadow-lg", style: Do(y) }, `thumbnail-${(x = C.image) == null ? void 0 : x.alt}-${y}`);
  }) })] })] });
};
var un;
(function(e) {
  e.TWO = "2", e.THREE = "3", e.FOUR = "4";
})(un || (un = {}));
const v2 = {
  [un.TWO]: "tw-grid-cols-2",
  [un.THREE]: "tw-grid-cols-4",
  [un.FOUR]: "tw-grid-cols-4"
}, e3 = ({ id: e, imageLinks: t }) => {
  const n = (r) => {
    var s, o;
    if ("image" in r)
      return (s = r.image) != null && s.caption ? r.image.caption : (o = r == null ? void 0 : r.image) != null && o.alt ? r == null ? void 0 : r.image.alt : "";
    const a = r;
    return a != null && a.caption ? a.caption : a != null && a.alt ? a.alt : "";
  };
  return i.jsx("div", { ...!!e && { id: e }, className: `tw-flex md:tw-grid ${v2[t.length.toString()]} tw-gap-8 tw-mx-auto`, children: t.map((r, a) => {
    const s = n(r);
    return i.jsx(Tw, { className: `${a !== 0 ? "tw-hidden md:tw-block" : ""} ${t.length === 3 && a === 0 ? "tw-col-span-2" : ""} tw-object-cover tw-w-full tw-h-72 lg:tw-h-96`, text: s, children: "image" in r ? i.jsx(J, { ...r, image: { ...r.image, caption: void 0 }, className: "!tw-block", imageClassName: "tw-object-cover tw-w-full tw-h-72 lg:tw-h-96" }) : i.jsx(de, { ...r, caption: void 0, className: "tw-object-cover tw-w-full tw-h-72 lg:tw-h-96 group-hover:tw-opacity-100" }) }, `beauty-image-${a}${s ? `-${s}` : ""}`);
  }) });
}, fn = { actionUrl: "/", label: "Home" }, Ni = (e, t) => e >= 2 ? t[t.length - 2] ?? fn : e === 1 ? t[t.length - 1] ?? fn : fn, Ti = "tw-font-normal !tw-text-sm tw-text-gray tw-capitalize tw-whitespace-nowrap tw-p-0.5", t3 = ({ asPath: e, productDetailBreadcrumb: t }) => {
  const n = rt(() => {
    if (e && typeof e == "string" && !t) {
      const a = e.split("?")[0].split("/").filter((o) => o.length > 0), s = a.map((o, l) => {
        const d = typeof o == "string" ? o.replace(/-/g, " ") : o;
        return { actionUrl: "/" + a.slice(0, l + 1).join("/"), label: d, target: Qe.SELF };
      });
      return [fn, ...s];
    }
    if (t && !e) {
      let r = [];
      const { categorySlug: a, category2Slug: s, collectionName: o, collectionSlug: l, categoryName: d, category2Name: c, nameSlug: f, name: w } = t;
      return s && c && r.push({ actionUrl: `/catalog/${s}`, label: c }), a && d && r.push({ actionUrl: `/catalog/${a}`, label: d }), l && o && r.push({ actionUrl: `/catalog/${l}`, label: o }), f && w && r.push({ actionUrl: `/products/${f}`, label: w }), [fn, ...r];
    }
    return [];
  }, [e, t]);
  return i.jsxs(i.Fragment, { children: [i.jsxs("div", { className: "tw-flex tw-flex-row tw-items-center sm:tw-hidden", children: [i.jsx(ne, { type: "angle-icon", direction: "left", color: "dark", size: 16, className: "tw-mr-1" }), n && i.jsx(J, { actionUrl: Ni(n.length, n).actionUrl, target: Qe.SELF, label: Ni(n.length, n).label, className: Ti, dataTestId: "mobile-breadcrumb", active: !1 })] }), i.jsx("div", { className: "tw-hidden sm:tw-flex sm:tw-flex-row sm:tw-items-center sm:tw-gap-2 tw-bg-white", children: n.map((r, a) => i.jsxs(Ve, { children: [a > 0 && i.jsx("span", { className: "tw-font-normal tw-text-sm tw-text-gray", children: " / " }), a === n.length - 1 ? i.jsx("p", { className: "tw-font-medium tw-text-sm tw-text-dark tw-capitalize tw-truncate", children: r.label }) : i.jsx(J, { ...r, className: Ti, dataTestId: `desktop-breadcrumb-${a}`, active: !1 })] }, a)) })] });
}, xt = (e) => {
  const t = e != null && e.includes("http") ? Qe.BLANK : Qe.SELF;
  typeof e == "string" && t && Ui[t](e);
}, b2 = ({ button: e, secondaryButton: t }) => e && t ? i.jsxs(i.Fragment, { children: [i.jsx(Te, { className: "tw-w-full tw-mb-4", ...e }), i.jsx(Te, { className: "tw-w-full", ...t })] }) : e ? i.jsx(Te, { className: "tw-w-full", ...e }) : t ? i.jsx(Te, { className: "tw-w-full", ...t }) : null, y2 = ({ children: e, isLink: t = !1, actionUrl: n, className: r = "" }) => {
  const a = `tw-text-secondary tw-bg-white tw-min-h-full tw-flex tw-flex-col tw-w-full ${r}`;
  return t ? i.jsx("div", { onClick: () => xt(n), className: `tw-cursor-pointer ${ge[ie.FOCUS_VISIBLE_SHADOW]} ${a}`, role: "button", onKeyDown: (s) => {
    s.key === "Enter" && xt(n);
  }, tabIndex: 0, children: e }) : i.jsx("div", { className: a, children: e });
}, Si = "tw-object-cover tw-aspect-square", n3 = ({ title: e, description: t, image: n, hoverImage: r, link: a, button: s, secondaryButton: o, className: l = "" }) => {
  const [d, c] = G(!1);
  return i.jsx("div", { className: "tw-bg-white tw-w-full tw-p-1", children: i.jsxs(y2, { className: l, isLink: !!a || !!s || !!o, actionUrl: a ? a.actionUrl : s ? s.actionValue : o ? o.actionValue : null, children: [i.jsxs("div", { className: "tw-relative tw-w-full tw-h-full", children: [!!r && i.jsx("div", { className: "tw-absolute tw-w-full tw-h-full", children: i.jsx(de, { className: Si, ...r, caption: void 0 }) }), i.jsx("div", { className: `tw-transition-opacity tw-duration-500 tw-ease-out tw-w-full tw-h-full ${d && r ? "tw-opacity-0" : "tw-opacity-100"}`, onMouseEnter: () => c(!d), onMouseLeave: () => c(!d), children: i.jsx(de, { className: Si, ...n, caption: void 0 }) })] }), !!e && i.jsxs(i.Fragment, { children: [i.jsx("h3", { className: "tw-text-2xl tw-font-medium tw-font-condensed tw-pt-4 tw-uppercase tw-self-start", children: e }), i.jsx("hr", { className: "tw-w-1/5 tw-p-0 tw-bg-secondary tw-self-start" })] }), i.jsxs("div", { className: "tw-flex-1 tw-w-full tw-flex tw-flex-col tw-justify-between tw-bg-white", children: [t && i.jsx("div", { className: "tw-my-2 tw-leading-6", children: i.jsx(je, { ...t }) }), s || o ? i.jsx("div", { className: `tw-flex tw-flex-col ${t ? "" : "tw-mt-4"}`, children: b2({ button: s, secondaryButton: o }) }) : a && a.label ? i.jsx(J, { ...a, hasUnderline: !1, variant: oe.DEFAULT, className: `tw-w-fit tw-mb-7 tw-p-0.5 ${t ? "" : "tw-mt-4"}` }) : null] })] }) });
}, C2 = ({ children: e, actionUrl: t, className: n = "" }) => {
  const r = `tw-flex tw-w-full tw-gap-0 tw-h-flex ${n}`;
  return t ? i.jsx("div", { onClick: () => xt(t), className: `tw-cursor-pointer ${ge[ie.FOCUS_VISIBLE_SHADOW]} ${r}`, role: "button", onKeyDown: (a) => {
    a.key === "Enter" && xt(t);
  }, tabIndex: 0, children: e }) : i.jsx("div", { className: r, children: e });
}, E2 = "tw-object-cover tw-w-full tw-h-full tw-rounded-full", r3 = ({ text: e, image: t, className: n = "", actionUrl: r = null }) => {
  const a = { ...t, caption: void 0 };
  return i.jsx("div", { className: "tw-bg-white tw-py-20", children: i.jsx("div", { className: "tw-max-w-6xl tw-mx-auto tw-px-4 tw-flex tw-flex-row tw-items-center tw-gap-4 lg:tw-gap-0", children: i.jsxs(C2, { className: `tw-w-auto ${n}`, actionUrl: r, children: [i.jsxs("div", { className: "tw-w-3/5 tw-flex tw-flex-col tw-justify-center tw-items-start tw-overflow-hidden tw-relative tw-m-0", children: [i.jsx("div", { className: "tw-absolute tw-top-0 tw-left-0 tw-text-gray-300 tw-opacity-20", style: {
    fontSize: "clamp(3rem, 6vw, 6rem)",
    fontWeight: "bold",
    fontFamily: "serif, Arial, sans-serif",
    transform: "translate(-5%, -20%)"
  }, children: "“" }), i.jsx("div", { className: "tw-text-left tw-flex tw-flex-col tw-justify-center tw-items-start", children: i.jsx("div", { className: "tw-font-normal tw-z-10 tw-text-left tw-pl-10 lg:tw-pl-16 tw-pr-4", style: {
    fontSize: "clamp(0.875rem, 2vw, 1.5rem)",
    wordWrap: "break-word",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal"
  }, children: i.jsx(je, { text: e, variant: me.BLACK, className: "tw-overflow-hidden tw-text-center" }) }) })] }), i.jsxs("div", { className: "tw-w-2/5 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-relative tw-m-0", children: [i.jsx("div", { className: "tw-w-full tw-max-w-[300px] tw-aspect-square tw-rounded-full tw-overflow-hidden", children: i.jsx(de, { ...a, className: E2 }) }), i.jsx("div", { className: "tw-absolute tw-text-gray-300 tw-opacity-20", style: {
    fontSize: "clamp(3rem, 6vw, 6rem)",
    fontWeight: "bold",
    fontFamily: "serif, Arial, sans-serif",
    transform: "translate(60px, 60px)",
    bottom: "-20px",
    right: "50px"
  }, children: "”" })] })] }) }) });
};
var ot;
(function(e) {
  e.EMAIL = "email", e.CHAT = "chat", e.PHONE = "phone";
})(ot || (ot = {}));
var wn;
(function(e) {
  e.ONLINE = "online", e.PENDING = "pending", e.OFFLINE = "offline";
})(wn || (wn = {}));
const N2 = {
  [wn.OFFLINE]: "tw-bg-error",
  [wn.PENDING]: "tw-bg-gray",
  [wn.ONLINE]: "tw-bg-success"
}, T2 = {
  [ot.EMAIL]: "mail",
  [ot.CHAT]: "chat",
  [ot.PHONE]: "phone"
}, a3 = ({ variant: e, title: t, usPhoneNumber: n, internationalNumber: r, chat: a, chatStatus: s, email: o }) => i.jsxs("div", { className: `tw-list-none tw-flex tw-flex-row md:tw-flex-col ${e === ot.PHONE ? "tw-items-start xs:tw-items-center" : "tw-items-center"} tw-gap-4 tw-bg-subdued tw-py-4 tw-px-3 tw-w-full tw-min-w-max sx:tw-mx-5`, children: [i.jsx("div", { className: "tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-secondary tw-w-10 tw-h-10 sm:tw-w-14 sm:tw-h-14", children: i.jsx(ne, { type: T2[e], color: "white", size: 24 }) }), i.jsxs("div", { children: [i.jsx("h3", { className: "tw-text-xl tw-uppercase tw-font-medium tw-text-secondary md:tw-text-center tw-break-all", children: t }), i.jsxs("div", { className: "tw-text-secondary tw-text-sm tw-flex tw-justify-center tw-flex-col sm:tw-flex-row md:tw-text-center tw-gap-5 sm:tw-gap-8 md:tw-gap-4", children: [e === ot.PHONE && i.jsxs("div", { className: "tw-flex tw-flex-col tw-space-y-4 xs:tw-space-y-0 xs:tw-flex-row xs:tw-space-x-5 md:tw-flex-col md:tw-space-x-0 md:tw-space-y-4 md:tw-mt-4", children: [n && i.jsxs("div", { className: "tw-bg-subdued", children: [i.jsx("p", { children: "US Orders" }), i.jsx(J, { ...n, active: !1 })] }), r && i.jsxs("div", { className: "tw-bg-subdued", children: [i.jsx("p", { children: "International Orders" }), i.jsx(J, { ...r, active: !1 })] })] }), e === ot.CHAT && a && s && i.jsxs("div", { className: "tw-flex tw-items-center tw-border tw-border-outlined-gray tw-rounded-full tw-py-2 tw-px-4 tw-mt-2 md:tw-mt-8 tw-bg-subdued", children: [i.jsx(J, { ...a, active: !1 }), i.jsx("div", { className: `tw-h-2 tw-px-1 ${N2[s]} tw-rounded-xl tw-ml-3` })] }), e === ot.EMAIL && o && i.jsx("p", { className: "md:tw-mt-6 tw-bg-subdued", children: i.jsx(J, { ...o, active: !1 }) })] })] })] });
function S2({ imagePosition: e, backgroundColor: t, centeredOnMobile: n, imagePositionMobile: r }) {
  const a = e === Mn.LEFT, s = r === Fn.TOP;
  return {
    [Pe.DEFAULT]: {
      container: `tw-flex tw-w-full tw-gap-10 sm:tw-gap-12 md:tw-gap-0 ${Pi[r].imageClass} ${j2[e].imageClass} ${ji[t].backgroundClass}`,
      content: `tw-w-auto tw-flex tw-flex-col ${n ? "tw-items-center md:tw-items-start" : "tw-items-start"} tw-w-full tw-h-full tw-px-0 md:tw-px-6 xl:tw-px-8 tw-m-auto tw-gap-8 sm:tw-text-left md:tw-w-1/2 md:tw-pb-0 tw-px-5 sm:tw-mx-0 md:tw-mx-0 ${s ? "tw-mb-10" : "tw-mt-10"} md:tw-my-0`,
      text: `tw-flex tw-flex-col tw-gap-4 sm:tw-gap-6 tw-h-full tw-justify-center  ${n ? "tw-items-center md:tw-items-start" : "tw-items-start"}`,
      richText: `tw-text-sm sm:tw-text-base ${n ? "tw-text-center md:tw-text-left" : "tw-text-left"}`,
      button: "tw-max-w-max",
      title: `tw-text-xl sm:tw-text-2xl lg:tw-text-3xl ${n ? "tw-text-center md:tw-text-left" : "tw-text-left"}`,
      imageContainer: "tw-w-full md:tw-w-6/12",
      image: "tw-object-cover tw-h-full"
    },
    [Pe.PRODUCT_BANNER]: {
      container: `tw-flex  ${Pi[r].imageClass} ${a ? "lg:tw-flex-row" : "lg:tw-flex-row-reverse"} tw-w-full tw-max-h-max tw-text-secondary tw-bg-white tw-py-4 tw-gap-5 sm:tw-gap-8 lg:tw-gap-0`,
      content: "tw-flex tw-flex-col tw-w-full tw-pb-2 tw-gap-8 tw-px-4 sm:tw-px-5 md:tw-px-6 lg:tw-w-1/3",
      text: "tw-flex tw-flex-col",
      richText: "tw-flex tw-flex-col tw-gap-6 tw-text-sm sm:tw-text-base",
      button: "tw-max-w-max tw-mx-auto sm:tw-mx-0",
      title: "tw-py-4 tw-text-xl sm:tw-text-2xl lg:tw-text-3xl",
      imageContainer: "tw-w-full lg:tw-w-2/3",
      image: "tw-object-cover tw-w-full"
    },
    [Pe.NOT_FOUND]: {
      container: "tw-flex tw-flex-col-reverse lg:tw-flex-row-reverse tw-w-full tw-text-secondary tw-max-h-max tw-bg-white tw-py-4 tw-gap-y-5 md:tw-gap-y-0",
      content: "tw-flex tw-flex-col tw-w-full lg:tw-px-8 tw-gap-8 lg:tw-w-3/5",
      text: "tw-flex tw-flex-col",
      richText: "tw-flex tw-flex-col tw-gap-6 tw-text-sm xl:tw-text-base",
      button: "tw-max-w-max tw-mx-0 !tw-text-sm",
      title: "tw-text-xl sm:tw-text-2xl lg:tw-text-3x tw-py-4",
      imageContainer: "tw-w-full",
      image: "tw-object-cover tw-w-full"
    },
    [Pe.LARGE]: {
      container: "tw-flex tw-w-full tw-flex-col tw-py-4 md:tw-py-8 lg:tw-py-6 xl:tw-py-4",
      content: `tw-flex tw-flex-col tw-w-full sm:tw-text-left md:tw-flex-row md:tw-text-right md:tw-h-auto md:tw-pb-0 md:tw-justify-center ${ji[t].backgroundClass}`,
      text: "tw-flex tw-flex-col tw-gap-6 tw-pt-10 tw-pb-6 md:tw-pt-0 md:tw-pb-0 sm:tw-justify-center tw-w-full md:tw-shrink-0 md:tw-grow-0 md:tw-basis-1/4 lg:tw-pb-10",
      richText: "tw-px-4 sm:tw-px-5 md:tw-px-0 md:tw-grow md:tw-shrink md:tw-basis-0 tw-text-sm sm:tw-text-base",
      button: "tw-hidden",
      title: "tw-text-xl sm:tw-text-2xl lg:tw-text-3x tw-px-4 sm:tw-px-5 md:tw-px-6",
      imageContainer: "tw-w-full md:tw-self-right md:tw-grow md:tw-shrink md:tw-basis-0",
      image: "tw-object-cover tw-w-full"
    }
  };
}
var Nt;
(function(e) {
  e.WHITE = "white", e.BLACK = "black", e.GRAY = "gray";
})(Nt || (Nt = {}));
const ji = {
  white: {
    backgroundClass: "tw-bg-white tw-text-secondary"
  },
  black: {
    backgroundClass: "tw-bg-secondary tw-text-white"
  },
  gray: {
    backgroundClass: "tw-bg-subdued tw-text-secondary"
  }
};
var Mn;
(function(e) {
  e.LEFT = "left", e.RIGHT = "right";
})(Mn || (Mn = {}));
var Fn;
(function(e) {
  e.TOP = "top", e.BOTTOM = "bottom";
})(Fn || (Fn = {}));
const j2 = {
  left: {
    imageClass: "md:tw-flex-row-reverse"
  },
  right: {
    imageClass: "md:tw-flex-row"
  }
}, Pi = {
  top: {
    imageClass: "tw-flex-col-reverse"
  },
  bottom: {
    imageClass: "tw-flex-col"
  }
}, i3 = {
  left: {
    imageClass: "tw-flex-col-reverse lg:tw-flex-row-reverse"
  },
  right: {
    imageClass: "tw-flex-col lg:tw-flex-row"
  }
}, Ai = ({ backgroundColor: e, variant: t }) => ({
  renderNode: {
    ...e === Nt.BLACK && t !== Pe.LARGE ? Gs : Kt,
    [_t.HYPERLINK]: (n, r) => i.jsx(J, { variant: e === Nt.BLACK && t === Pe.DEFAULT ? oe.WHITE : oe.DEFAULT, hasUnderline: !0, active: !0, href: n.data.uri, actionUrl: "_blank", rel: "noopener noreferrer", label: r })
  }
});
var Pe;
(function(e) {
  e.DEFAULT = "default", e.PRODUCT_BANNER = "product-banner", e.NOT_FOUND = "not-found", e.LARGE = "large";
})(Pe || (Pe = {}));
const s3 = ({ id: e, backgroundColor: t = Nt.WHITE, buttons: n, containerClassName: r = "", contentClassName: a = "", image: s, imagePosition: o = Mn.LEFT, imagePositionMobile: l = Fn.TOP, text: d, title: c, isH1: f = !1, subtitle: w, variant: u = Pe.DEFAULT, video: p, imageAspectRatio: h = Le.VIDEO, mobileAspectRatio: m = Le.VIDEO, centeredOnMobile: $ = !1, mobileImage: g }) => {
  const v = S2({ imagePosition: o, backgroundColor: t, centeredOnMobile: $, imagePositionMobile: l }), C = u === Pe.DEFAULT && t === Nt.BLACK ? me.WHITE : me.BLACK;
  return i.jsxs("div", { ...!!e && { id: e }, className: `${v[u].container} ${r}`, children: [i.jsxs("div", { className: `${v[u].content} ${a}`, children: [i.jsxs("div", { className: `${v[u].text} ${p ? "" : Ro[h]}`, children: [i.jsx(ks, { isH1: f, className: `${v[u].title}`, children: c }), u === Pe.DEFAULT && i.jsx("hr", { className: "tw-w-22 tw-h-px tw-bg-secondary" }), u !== Pe.LARGE ? d && i.jsx(je, { text: d, customOptions: u === Pe.PRODUCT_BANNER ? void 0 : Ai({ backgroundColor: t, variant: u }), className: v[u].richText, variant: C }) : i.jsx("span", { className: "tw-text-sm sm:tw-text-base tw-px-4 sm:tw-px-6", children: w })] }), u === Pe.LARGE && s && i.jsx("div", { className: `${v[u].imageContainer}`, children: i.jsx(de, { ...s, className: `${v[u].image} ${Sn[h]} ${ln[m]}`, caption: void 0 }) }), Array.isArray(n) && n.length > 0 && i.jsx("div", { className: "tw-flex tw-flex-row tw-justify-start tw-gap-5 lg:tw-gap-8 md:tw-pt-2 md:tw-pb-10", children: n.map((y) => i.jsx(Te, { ...y, variant: t === Nt.BLACK ? Me.TERTIARY : y.variant || Me.SECONDARY, className: v[u].button }, `Call to Action - ${y.label}`)) })] }), u !== Pe.LARGE ? i.jsx("div", { className: `${v[u].imageContainer}`, children: !p || u === Pe.NOT_FOUND ? i.jsxs(i.Fragment, { children: [g && i.jsx(de, { ...g, id: "optional-mobile-image", className: `${v[u].image} ${Sn[h]} ${ln[m]} md:tw-hidden`, caption: void 0 }), s && i.jsx(de, { ...s, id: "main-image", className: `${v[u].image} ${Sn[h]} ${ln[m]} ${g ? "tw-hidden md:tw-grid" : ""}`, caption: void 0 })] }) : i.jsx(gn, { ...p }) }) : d && i.jsxs("div", { className: "tw-flex tw-pt-4", children: [i.jsx("div", { className: "tw-hidden md:tw-flex md:tw-shrink-0 md:tw-grow-0 md:tw-basis-1/4", children: i.jsx("span", { className: "md:tw-opacity-0 md:tw-text-2xl lg:tw-text-3x md:tw-px-6", children: c }) }), i.jsx(je, { text: d, className: v[u].richText, customOptions: Ai({ backgroundColor: t, variant: u }) })] })] });
}, P2 = ({ button: e, description: t, title: n }) => i.jsx("div", { className: "tw-text-left tw-bg-subdued hover:tw-bg-light-hover tw-px-6  tw-text-secondary tw-h-full tw-flex tw-justify-center focus-within:tw-border-secondary focus-within:tw-outline-offset-0 focus-within:tw-outline-link", children: i.jsxs("div", { className: "tw-flex tw-flex-col tw-py-20 tw-justify-center tw-gap-4 tw-w-fit tw-aspect-square sm:tw-aspect-auto", children: [i.jsx("h4", { className: "tw-text-3xl tw-leading-8 tw-font-normal tw-font-condensed tw-uppercase", children: n }), i.jsx(je, { ...t }), i.jsx("div", { className: "tw-mt-3", children: e && i.jsx(Te, { className: "tw-w-full", focus: ie.FOCUS_VISIBLE, ...e }) })] }) }), A2 = ({ children: e, coords: t, updateTooltipCoords: n }) => (le(() => (typeof window !== void 0 && window.addEventListener("resize", n), () => {
  typeof window !== void 0 && window.removeEventListener("resize", n);
}), []), i.jsx("div", { style: { transform: "translate(-100px, 0px)", ...t }, className: "tw-absolute tw-z-10", children: i.jsx("div", { className: "tw-break-words tw-opacity-90 tw-bg-dark tw-p-2 tw-w-full tw-max-w-[200px] tw-text-bold tw-text-center tw-text-white tw-text-md", children: e }) })), I2 = ({ children: e }) => typeof window !== void 0 ? Hi(i.jsx("div", { className: "tooltip-portal", children: e }), document.body) : null, O2 = ({ item: e, children: t, showCaption: n }) => {
  const r = xe(null), [a, s] = G(!1), [o, l] = G({ left: 0, top: 0 }), d = (c) => {
    const f = c == null ? void 0 : c.getBoundingClientRect();
    f && typeof window !== void 0 && l({
      left: f.x + 60 + f.width / 2,
      top: f.y + f.height * 1.25 + window.scrollY
    });
  };
  return i.jsxs("div", { children: [i.jsx("div", { ref: r, onMouseEnter: () => {
    d(r == null ? void 0 : r.current), s(!0);
  }, onMouseLeave: () => {
    s(!1);
  }, children: t }), a && i.jsx(I2, { children: i.jsxs(A2, { coords: o, updateTooltipCoords: () => d(r == null ? void 0 : r.current), children: [e.alt, n && e.caption && i.jsx("p", { className: "tw-text-sm !tw-font-light", children: e.caption })] }) })] });
}, Vs = ({ children: e, item: t, hideTooltip: n, showCaption: r }) => n ? i.jsx(i.Fragment, { children: e }) : i.jsx(O2, { item: t, showCaption: r, children: e }), _2 = ({ showing: e }) => {
  const t = Wn();
  return le(() => {
    e !== void 0 && e > -1 && t && t.slideTo(e);
  }, [e, t]), i.jsx(i.Fragment, {});
}, L2 = {
  0: {
    slidesPerView: 3,
    spaceBetween: 16
  },
  375: {
    slidesPerView: 3.25
  },
  640: {
    slidesPerView: 6,
    spaceBetween: 16
  },
  758: {
    slidesPerView: 5
  },
  1024: {
    slidesPerView: 6.5
  },
  1280: {
    slidesPerView: 9
  }
}, o3 = ({ colorImages: e, selectedColor: t, onImageClick: n }) => {
  const { isAtTheBeginning: r, isAtTheEnd: a, onTransitionEnd: s } = Qt(), [o, l] = G(!0);
  return i.jsxs(Ye, { threshold: 10, watchSlidesProgress: !0, modules: [Pt], breakpoints: L2, onBreakpoint: (d, { slidesPerView: c }) => {
    typeof c == "number" && l(e.length > c);
  }, resistanceRatio: 0, spaceBetween: 0, className: `tw-w-full ${o && "!tw-px-6"} `, onTransitionEnd: s, children: [o && i.jsx(ke, { disabled: r, direction: "left", className: "!tw-top-0 !tw-h-full" }), i.jsx(_2, { showing: t }), e.map((d, c) => i.jsx(Ue, { children: i.jsx("button", { className: `tw-w-fit tw-rounded-full tw-relative focus-visible:tw-outline-2 focus-visible:tw-outline-link tw-p-px tw-border-2 ${t === c ? "tw-border-secondary" : "tw-border-transparent tw-outline-2 hover:tw-border-light-disabled"}`, onClick: (f) => {
    f.preventDefault(), f.stopPropagation(), n(c);
  }, children: i.jsx(Vs, { item: d, hideTooltip: !1, children: i.jsx(de, { ...d, caption: void 0, className: "tw-contain tw-rounded-full tw-w-16 tw-h-16   md:tw-h-9 md:tw-w-9  tw-object-cover tw-rounded-swatch-item", "aria-label": d.alt ?? `swatch-${c}` }) }) }) }, `swatch-${c}`)), o && i.jsx(ke, { direction: "right", disabled: a, className: "!tw-top-0 !tw-h-full" })] });
};
var qt;
(function(e) {
  e.LIGHT = "light", e.DARK = "dark";
})(qt || (qt = {}));
const Ii = {
  [qt.DARK]: {
    text: me == null ? void 0 : me.BLACK,
    icon: "gray"
  },
  [qt.LIGHT]: { text: me == null ? void 0 : me.WHITE, icon: "white" }
}, R2 = ({ content: e, color: t, link: n, image: r, storedAnnouncement: a = !0, textFont: s = Yt.GOTHAM, variant: o = qt.LIGHT, onStoredAnnouncement: l }) => {
  const [d, c] = G(a), [f, w] = G("tw-opacity-0");
  return le(() => {
    const u = setTimeout(() => {
      c(a), w("");
    }, 100);
    return () => clearTimeout(u);
  }, [a]), d ? i.jsxs("div", { "aria-hidden": !d, style: { backgroundColor: t }, className: `tw-w-full tw-max-w-[1980px] tw-relative tw-flex md:tw-gap-x-10 tw-flex-col md:tw-flex-row tw-items-center md:tw-p-3 tw-pr-6 tw-py-3 tw-pl-3 ${f}`, children: [r && i.jsx("div", { children: i.jsx(de, { ...r, className: "md:tw-pb-0 tw-pb-1 tw-max-w-xs tw-items-center tw-max-h-20 md:tw-max-h-24", caption: void 0 }) }), i.jsx("div", { className: `tw-flex ${n ? "tw-flex-col md:tw-flex-row" : ""} tw-w-full tw-gap-6 tw-flex-row tw-items-center tw-justify-center
         `, children: i.jsxs("div", { className: "tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-items-center", children: [i.jsx(je, { ...e, nodeClassName: `${_o[s]} ${Yt.D_DIN_CONDENSED === s ? "tw-text-base tw-tracking-wide" : "tw-text-md"} xl:tw-text-lg tw-text-center`, variant: Ii[o].text, className: `tw-grow ${e.className ?? ""}`, textAlignment: Ze.CENTER }), n && i.jsx(J, { ...n, variant: o === qt.LIGHT ? oe.WHITE : oe.DEFAULT, active: !0, className: "tw-text-sm tw-min-w-max tw-mt-2 lg:tw-mt-0 lg:tw-pl-5" })] }) }), i.jsx("button", { className: "tw-absolute tw-top-1 tw-right-1 tw-z-30 md:tw-static tw-justify-end", type: "button", "aria-label": "Close disclaimer banner", onClick: () => {
    l && l(!d), c(!d), w("tw-opacity-0");
  }, children: i.jsx(ne, { type: "close", size: 20, color: Ii[o].icon }) })] }) : null;
}, Oi = (e, t) => e.actionUrl ? e.actionUrl === t : !1, M2 = ({ className: e = "", title: t, categories: n, currenPath: r = "" }) => {
  const { visibility: a, setVisibility: s, setForcedVisibility: o } = cf(!1, !1), [l, d] = G(!1);
  le(() => {
    d(Oi(t, r));
  }, [t, r]);
  const c = (f) => {
    (f.key === "Enter" || f.key === " ") && s(!0), f.key === "Escape" && s(!1);
  };
  return i.jsxs("div", { className: `tw-h-full tw-w-max tw-relative tw-flex tw-items-center tw-z-20 ${e}`, children: [i.jsx("div", { className: "tw-relative tw-w-max tw-bg-white", children: i.jsx(J, { variant: oe.NAV, actionUrl: (n == null ? void 0 : n.length) === 0 ? t.actionUrl : void 0, className: `${l ? "tw-font-medium !tw-underline !tw-underline-offset-8" : ""}`, hasUnderline: !1, onMouseEnter: () => {
    s(!0);
  }, onKeyUp: c, onMouseLeave: () => {
    s(!1);
  }, ...t }) }), n && (n == null ? void 0 : n.length) > 0 && i.jsx("div", { className: `tw-absolute tw-top-full tw-border-outlined-gray tw-border tw-transition-opacity tw-bg-white tw-shadow-sm tw-z-30 -tw-ml-8 ${a ? "tw-block tw-opacity-100" : "tw-hidden tw-opacity-0"}`, onMouseEnter: () => {
    d(!0), o(!0);
  }, onMouseLeave: () => {
    d(!1), o(!1);
  }, children: i.jsx("div", { className: "tw-p-6 tw-flex tw-flex-row tw-gap-x-6", children: n == null ? void 0 : n.map(({ subItems: f, title: w }, u) => i.jsxs(Ve, { children: [i.jsxs("div", { className: "tw-w-44", children: [w.label && i.jsx("h4", { className: "tw-text-dark tw-font-medium tw-text-xs tw-mb-4", children: w.label }), i.jsx("ul", { className: "tw-flex tw-flex-col", "aria-label": `column ${u + 1}`, children: f == null ? void 0 : f.map((p, h) => i.jsx("li", { className: "tw-bg-white", children: i.jsx(J, { ...p, variant: oe.NAV, className: `tw-p-1.5 ${Oi(p, r) ? "tw-font-medium !tw-underline !tw-underline-offset-8" : ""}`, hasUnderline: !1, labelClassName: "tw-text-sm", onKeyUp: c }) }, `${h}-${p.label}`)) })] }), i.jsx("div", { className: "tw-border-l tw-border-outlined-gray last:tw-hidden" })] }, `${u}-${w}`)) }) })] });
}, F2 = ({ children: e, actionUrl: t }) => t ? i.jsx("div", { onClick: () => xt(t), role: "button", onKeyDown: (n) => {
  n.key === "Enter" && xt(t);
}, className: `tw-w-full tw-cursor-pointer ${ge[ie.FOCUS_VISIBLE_SHADOW]}`, tabIndex: 0, children: e }) : i.jsx(i.Fragment, { children: e }), l3 = ({ actionUrl: e, preTitle: t, title: n, description: r, image: a }) => i.jsx(F2, { actionUrl: e, children: i.jsxs("div", { className: `${e ? "tw-cursor-pointer hover:tw-bg-light-hover" : ""} tw-flex tw-gap-4 md:tw-gap-6 md:tw-px-4 tw-w-full tw-py-8 tw-border-b tw-border-b-outlined-gray`, children: [a && i.jsx(de, { ...a, caption: void 0, className: "!tw-w-[100px] !tw-h-[100px] tw-object-cover tw-flex-shrink-0" }), i.jsxs("div", { className: "tw-flex-1 tw-min-w-0 tw-flex tw-flex-col tw-justify-center", children: [i.jsx("div", { className: "tw-text-sm tw-text-gray tw-font-medium", children: t }), i.jsx("div", { className: "tw-text-xl tw-text-primary tw-font-medium", children: n }), i.jsx("div", { className: "tw-text-secondary tw-line-clamp-2 tw-font-light", children: r })] })] }) }), _i = {
  default: {
    base: "tw-text-secondary hover:tw-text-link active:tw-text-link active:tw-underline focus-visible:tw-underline focus-visible:tw-text-link tw-p-0.5",
    disabled: "tw-select-none tw-text-light-disabled tw-pointer-events-none"
  },
  nav: {
    base: "tw-text-secondary tw-no-underline hover:tw-font-medium active:tw-underline active:tw-underline-offset-8 tw-p-0.5 tw-pb-2.5 focus-visible:tw-underline focus-visible:tw-underline-offset-8 focus-visible:tw-font-medium",
    disabled: "tw-p-0.5 tw-pb-2.5 tw-select-none tw-text-light-disabled tw-pointer-events-none"
  },
  white: {
    base: "tw-text-white hover:tw-text-light-hover active:tw-text-link active:tw-underline focus-visible:tw-text-link focus-visible:tw-underline tw-p-0.5",
    disabled: "tw-select-none tw-text-light-disabled tw-pointer-events-none"
  },
  none: {
    base: "",
    disabled: "tw-pointer-events-none"
  }
};
var oe;
(function(e) {
  e.DEFAULT = "default", e.NAV = "nav", e.WHITE = "white", e.NONE = "none";
})(oe || (oe = {}));
var Br;
(function(e) {
  e.LEFT = "left", e.RIGHT = "right";
})(Br || (Br = {}));
const D2 = {
  left: {
    linkClass: "tw-inline-flex tw-flex-row"
  },
  right: {
    linkClass: "tw-inline-flex tw-flex-row-reverse tw-justify-end"
  }
}, k2 = "tw-font-normal tw-inline-flex tw-items-center tw-rounded-none tw-cursor-pointer tw-leading-4 tw-transition-colors tw-duration-75", J = ({ ariaLabel: e, children: t, className: n = "", labelClassName: r, imageClassName: a = "", actionUrl: s, target: o = Qe.SELF, dataTestId: l, variant: d = oe.DEFAULT, label: c, icon: f, iconElement: w, iconPosition: u, hasUnderline: p = !0, active: h = !0, image: m, focus: $ = ie.FOCUS_VISIBLE, linkWrapper: g, disabled: v = !1, ...C }) => {
  const y = nt(() => w || (f ? i.jsx(ne, { ...f, className: `tw-w-4 tw-h-4 ${f.className}`, size: f.size ? f.size : 16 }) : null), [f, w]), x = i.jsx("a", { tabIndex: v ? -1 : 0, "aria-label": e, target: o, href: s, rel: Qe.BLANK === o ? "noopener noreferrer" : "", "data-testid": l, className: `
      tw-gap-1 tw-bg-inherit ${ge[$]} ${v ? _i[d].disabled : _i[d].base} ${p ? "hover:tw-underline" : ""} ${h ? "tw-underline" : ""} ${m ? "tw-grid" : u ? D2[u].linkClass : k2} ${n ?? ""}
      `, ...C, children: m ? i.jsx(de, { ...m, className: a, caption: void 0 }) : t ?? i.jsxs(i.Fragment, { children: [y(), c ? i.jsx("span", { className: r, children: c }) : null] }) });
  return g ? g(x, s) : x;
};
var $t;
(function(e) {
  e.DEFAULT = "default", e.BIG = "big", e.SHIPPING = "shipping";
})($t || ($t = {}));
const Nn = {
  [$t.DEFAULT]: {
    iconSize: 30,
    iconClassName: "tw-basis-9",
    containerClasses: "tw-h-full tw-flex tw-flex-row tw-gap-4 tw-items-start tw-text-sm tw-leading-6",
    title: "tw-font-medium"
  },
  [$t.BIG]: {
    iconSize: 100,
    iconClassName: "tw-basis-24",
    containerClasses: "tw-flex tw-flex-row tw-gap-6 tw-items-start md:tw-items-center tw-text-sm tw-leading-6 tw-my-3",
    title: "tw-font-medium"
  },
  [$t.SHIPPING]: {
    iconSize: 42,
    iconClassName: "tw-basis-11",
    containerClasses: "tw-flex tw-flex-row tw-gap-4 tw-items-center tw-text-base tw-leading-4 tw-border-outlined-gray tw-border tw-p-4",
    title: "tw-font-medium tw-text-lg"
  }
}, Li = (e) => e.split(`
`).reduce((t, n, r) => [...t, r > 0 ? i.jsx("br", {}, r) : "", n], new Array()), B2 = ({ children: e, className: t = "", isListItem: n = !1 }) => n ? i.jsx("li", { className: t, children: e }) : i.jsx("div", { className: t, children: e }), H2 = ({ title: e, description: t, icon: n, variant: r = $t.DEFAULT }) => {
  const a = r !== $t.SHIPPING ? {
    renderNode: Kt(),
    renderText: Li
  } : {
    renderNode: {
      ...Kt(),
      [_t.HYPERLINK]: (s, o) => i.jsx(J, { variant: oe.DEFAULT, hasUnderline: !0, active: !0, href: s.data.uri, actionUrl: "_blank", rel: "noopener noreferrer", label: o })
    },
    renderText: Li
  };
  return i.jsxs(B2, { isListItem: r === $t.DEFAULT, className: Nn[r].containerClasses, children: [n && i.jsx(ne, { ...n, size: Nn[r].iconSize, className: `tw-flex-shrink-0 tw-grow-0 tw-h-fit ${Nn[r].iconClassName} ${n.className ?? ""}` }), i.jsxs("div", { className: "tw-text-secondary", children: [i.jsx("h3", { className: Nn[r].title, children: e }), Gr(t, a)] })] });
}, d3 = ({ description: e, infoItems: t }) => {
  let n = rt(() => {
    {
      const r = t.length + 1;
      let a = "";
      switch (r) {
        case 3:
          a = "lg:tw-grid-cols-3";
          break;
        case 4:
          a = "lg:tw-grid-cols-4";
          break;
        case 5:
          a = "lg:tw-grid-cols-5";
          break;
        default:
          a = "lg:tw-grid-cols-1";
      }
      return a;
    }
  }, [t]);
  return i.jsxs("div", { children: [i.jsx("hr", { role: "separator", className: "tw-border-outlined-gray" }), i.jsxs("ul", { className: `tw-grid tw-grid-cols-1 md:tw-grid-cols-2 ${n} tw-items-center tw-gap-4 tw-my-6`, children: [i.jsx("li", { className: "md:tw-col-span-2 lg:tw-col-span-1 tw-text-secondary tw-leading-6", children: Gr(e, { renderNode: Kt() }) }), t.map((r, a) => i.jsx(H2, { ...r }, a))] }), i.jsx("hr", { role: "separator", className: "tw-mt-4 lg:tw-mt-8 tw-border-outlined-gray" })] });
}, G2 = ({ links: e, title: t, position: n, hasActiveCollapse: r, handleCloseMenu: a }) => {
  const [s, o] = G(r), [l, d] = G(!0);
  return i.jsxs("div", { className: "odd:tw-border-y odd:tw-border-y-outlined-gray even:tw-border-b even:tw-border-b-outlined-gray tw-border-x-transparent tw-bg-inherit", children: [t.label ? i.jsxs("button", { onClick: () => o(!s), type: "button", className: `tw-bg-inherit hover:tw-bg-light-hover focus:tw-bg-light-hover tw-w-full tw-py-3.5 tw-text-dark tw-text-left tw-text-sm tw-font-medium tw-flex tw-flex-row tw-justify-between ${s ? "tw-underline tw-underline-offset-8" : ""} ${ge[ie.FOCUS_VISIBLE]} focus-visible:tw-underline focus-visible:tw-underline-offset-8`, children: [i.jsx("span", { children: t.label }), i.jsx(ne, { type: s ? "minus" : "plus", color: "secondary" })] }) : i.jsx("hr", { className: `${n === 0 ? "tw-hidden" : "tw-border-outlined-gray"}` }), s && i.jsx("ul", { className: "tw-flex tw-flex-col tw-gap-1 tw-mb-2 tw-bg-inherit", "aria-label": `nested-link-${n + 1}`, children: l && e && (e == null ? void 0 : e.length) > 8 ? i.jsxs(i.Fragment, { children: [e.slice(0, 8).map((c, f) => i.jsx("li", { className: "tw-bg-inherit", children: i.jsx(J, { ...c, onClick: a, variant: oe.NAV, hasUnderline: !1, active: !1, className: `tw-py-2 tw-px-1 tw-leading-6 tw-w-fit ${c.active ? "tw-font-medium !tw-underline !tw-underline-offset-8" : ""} ${c.className ?? ""}` }) }, `${f}-${c.label}`)), i.jsx(Te, { size: St.COMPACT, onClick: () => d(!l), variant: Me.TERTIARY, label: "See more categories", className: "tw-w-fit tw-mx-auto tw-my-4 !tw-text-sm" })] }) : e == null ? void 0 : e.map((c, f) => i.jsx("li", { className: "tw-bg-inherit", children: i.jsx(J, { ...c, onClick: a, variant: oe.NAV, hasUnderline: !1, active: !1, className: `tw-py-2 tw-px-1 tw-leading-6 tw-w-fit ${c.active ? "tw-font-medium !tw-underline !tw-underline-offset-8" : ""} ${c.className ?? ""}` }) }, `${f}-${c.label}`)) })] });
};
var It;
(function(e) {
  e.DEFAULT = "default", e.SMALL = "small";
})(It || (It = {}));
const Ri = {
  [It.DEFAULT]: {
    title: "tw-text-xl tw-font-medium tw-leading-7",
    blockItems: "tw-py-2"
  },
  [It.SMALL]: {
    title: "tw-text-base tw-font-medium",
    blockItems: ""
  }
}, Kr = ({ activeCollapseIndex: e, categories: t, index: n = -1, hasNestedLinks: r = !1, title: a, onActiveCollapseIndex: s, variant: o = It.DEFAULT, showTitleLink: l = !1, handleCloseMenu: d }) => {
  const c = (f) => {
    s && s(f === e ? -1 : f);
  };
  return i.jsxs("div", { className: "tw-bg-inherit tw-h-fit", children: [i.jsxs(J, { className: `tw-flex tw-justify-between tw-w-full tw-p-3 tw-no-underline hover:tw-no-underline tw-underline-offset-8 tw-transition-colors hover:tw-bg-light-hover focus:tw-bg-light-hover tw-bg-inherit ${ge[ie.FOCUS_VISIBLE]} ${n === e && o === It.DEFAULT ? "tw-underline tw-underline-offset-8 tw-decoration-dark" : ""} focus-visible:tw-underline focus-visible:tw-underline-offset-8 tw-decoration-dark`, role: t ? "button" : "link", actionUrl: t ? "#" : a == null ? void 0 : a.actionUrl, onClick: (f) => {
    t && f.preventDefault(), !t && d && d(), c(n);
  }, linkWrapper: a.linkWrapper, ariaLabel: a.ariaLabel, target: a.target, rel: a.rel, children: [i.jsx("span", { className: `tw-text-secondary ${Ri[o].title} tw-text-left`, children: a == null ? void 0 : a.label }), i.jsx(ne, { type: "angle-icon", direction: t ? "down" : "right", color: "secondary", className: `tw-ease-in-out tw-duration-300 tw-transition-transform ${n === e && t ? " tw-rotate-0" : ""}` })] }), i.jsxs("div", { className: `tw-mt-1 tw-flex tw-flex-col tw-gap-0 tw-overflow-hidden tw-transition-transform tw-origin-top tw-duration-150 tw-px-3 tw-bg-inherit ${Ri[o].blockItems}  ${n === e ? "tw-scale-y-100 tw-h-max" : "tw-h-0 tw-scale-y-0"}`, children: [l && i.jsx("div", { className: "tw-bg-inherit tw-border tw-py-1 tw-border-y-outlined-gray tw-border-x-transparent", children: i.jsx(J, { ...a, className: "tw-py-2 tw-w-fit", label: "Shop All", labelClassName: "tw-text-sm", variant: oe.NAV, hasUnderline: !1, onClick: d }) }), r ? t == null ? void 0 : t.map(({ subItems: f, title: w }, u) => i.jsx(G2, { links: f, title: w, position: u, hasActiveCollapse: u === e, handleCloseMenu: d }, `${u}-${w}`)) : t == null ? void 0 : t.map((f, w) => i.jsx("div", { className: `tw-bg-inherit ${w === t.length - 1 ? "tw-pb-1" : ""}`, children: i.jsx(J, { ...f, onClick: d, variant: oe.NAV, hasUnderline: !1, active: !1, className: `tw-py-2 tw-px-1 tw-leading-6 tw-w-fit ${f.active ? "tw-font-medium !tw-underline !tw-underline-offset-8" : ""} ${f.className}` }) }, w))] })] });
}, V2 = ({ subItems: e, title: t }) => i.jsxs("div", { className: "tw-hidden tw-opacity-0 md:tw-opacity-100 md:tw-block", children: [i.jsx("h3", { className: "tw-text-secondary tw-text-xl tw-font-medium tw-leading-7 tw-mb-6", children: t.label }), i.jsx("ul", { children: e == null ? void 0 : e.map((n, r) => i.jsx("li", { "aria-label": "menu-item", className: "tw-text-base tw-mb-4 tw-leading-4 tw-bg-subdued", children: i.jsx(J, { ...n, variant: oe.NAV, hasUnderline: !1, className: `${n.active ? "tw-font-medium !tw-underline !tw-underline-offset-8" : ""} tw-p-1` }) }, r)) })] });
var Hr = /* @__PURE__ */ new Map(), Tn = /* @__PURE__ */ new WeakMap(), Mi = 0, U2 = void 0;
function W2(e) {
  return e ? (Tn.has(e) || (Mi += 1, Tn.set(e, Mi.toString())), Tn.get(e)) : "0";
}
function z2(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? W2(e.root) : e[t]}`).toString();
}
function Y2(e) {
  let t = z2(e), n = Hr.get(t);
  if (!n) {
    const r = /* @__PURE__ */ new Map();
    let a;
    const s = new IntersectionObserver((o) => {
      o.forEach((l) => {
        var d;
        const c = l.isIntersecting && a.some((f) => l.intersectionRatio >= f);
        e.trackVisibility && typeof l.isVisible > "u" && (l.isVisible = c), (d = r.get(l.target)) == null || d.forEach((f) => {
          f(c, l);
        });
      });
    }, e);
    a = s.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), n = {
      id: t,
      observer: s,
      elements: r
    }, Hr.set(t, n);
  }
  return n;
}
function Z2(e, t, n = {}, r = U2) {
  if (typeof window.IntersectionObserver > "u" && r !== void 0) {
    const d = e.getBoundingClientRect();
    return t(r, {
      isIntersecting: r,
      target: e,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: d,
      intersectionRect: d,
      rootBounds: d
    }), () => {
    };
  }
  const { id: a, observer: s, elements: o } = Y2(n);
  let l = o.get(e) || [];
  return o.has(e) || o.set(e, l), l.push(t), s.observe(e), function() {
    l.splice(l.indexOf(t), 1), l.length === 0 && (o.delete(e), s.unobserve(e)), o.size === 0 && (s.disconnect(), Hr.delete(a));
  };
}
function Us({
  threshold: e,
  delay: t,
  trackVisibility: n,
  rootMargin: r,
  root: a,
  triggerOnce: s,
  skip: o,
  initialInView: l,
  fallbackInView: d,
  onChange: c
} = {}) {
  var f;
  const [w, u] = tn.useState(null), p = tn.useRef(), [h, m] = tn.useState({
    inView: !!l,
    entry: void 0
  });
  p.current = c, tn.useEffect(
    () => {
      if (o || !w)
        return;
      let C;
      return C = Z2(
        w,
        (y, x) => {
          m({
            inView: y,
            entry: x
          }), p.current && p.current(y, x), x.isIntersecting && s && C && (C(), C = void 0);
        },
        {
          root: a,
          rootMargin: r,
          threshold: e,
          // @ts-ignore
          trackVisibility: n,
          // @ts-ignore
          delay: t
        },
        d
      ), () => {
        C && C();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(e) ? e.toString() : e,
      w,
      a,
      r,
      s,
      o,
      n,
      d,
      t
    ]
  );
  const $ = (f = h.entry) == null ? void 0 : f.target, g = tn.useRef();
  !w && $ && !s && !o && g.current !== $ && (g.current = $, m({
    inView: !!l,
    entry: void 0
  }));
  const v = [u, h.inView, h.entry];
  return v.ref = v[0], v.inView = v[1], v.entry = v[2], v;
}
const X2 = ({ children: e, coords: t, updateTooltipCoords: n }) => (le(() => (typeof window !== void 0 && window.addEventListener("resize", n), () => {
  typeof window !== void 0 && window.removeEventListener("resize", n);
}), []), i.jsx("div", { style: { transform: "translate(-100px, 0px)", ...t }, className: "tw-absolute tw-z-10", children: i.jsx("div", { className: "tw-opacity-90 tw-bg-dark tw-px-2 tw-w-full tw-max-w-[100px] tw-text-white tw-text-sm", children: e }) })), K2 = ({ children: e }) => typeof window !== void 0 ? Hi(i.jsx("div", { className: "tooltip-portal", children: e }), document.body) : null, q2 = ({ item: e, children: t }) => {
  const n = xe(null), [r, a] = G(!1), [s, o] = G({ left: 0, top: 0 }), l = (d) => {
    const c = d == null ? void 0 : d.getBoundingClientRect();
    c && typeof window !== void 0 && o({
      left: c.x + 60 + c.width / 2,
      top: c.y + c.height * 1.25 + window.scrollY
    });
  };
  return i.jsxs("div", { children: [i.jsx("div", { ref: n, onMouseEnter: () => {
    l(n == null ? void 0 : n.current), a(!0);
  }, onMouseLeave: () => {
    a(!1);
  }, children: t }), r && i.jsx(K2, { children: i.jsx(X2, { coords: s, updateTooltipCoords: () => l(n == null ? void 0 : n.current), children: e.alt }) })] });
}, J2 = ({ children: e, item: t, hideTooltip: n }) => n ? i.jsx(i.Fragment, { children: e }) : i.jsx(q2, { item: t, children: e }), Q2 = ({ thumbnailImages: e, swiperActiveThumb: t, hideTooltip: n, setSwiper: r }) => {
  const { isAtTheBeginning: a, isAtTheEnd: s, onTransitionEnd: o } = Qt(), [l, d] = G(!0), c = rt(() => e, [e]), [f, w] = G(c), u = nt(() => {
    w((h) => [...h.slice(0, -1), ...e.slice(ew)]);
  }, [e]), p = f.length <= hr;
  return le(() => {
    w(c);
  }, [e[0].src]), i.jsxs(Ye, { threshold: 10, watchSlidesProgress: !0, slidesPerView: hr, modules: [Pt], resistanceRatio: 0, slidesPerGroup: hr, className: `!tw-h-16 ${l ? "!tw-mx-1 !tw-px-5" : "!tw-m-0 !tw-px-4"} !tw-pt-4 tw-swiper-horizontal-thumbnail`, onTransitionEnd: o, onSwiper: r, children: [l && i.jsx(ke, { direction: "left", disabled: a || p, className: "!tw-h-12" }), f.map((h, m) => {
    const $ = m === f.length - 2, g = m === 0;
    return h.title ? i.jsx(Ue, { className: "tw-py-3 !tw-h-fit", onDrag: (v) => v.preventDefault(), children: i.jsxs("button", { className: `tw-flex tw-flex-row tw-justify-center tw-items-center ${ge[ie.FOCUS_VISIBLE]}`, onClick: (v) => {
      v.preventDefault(), v.stopPropagation(), u(), d(!0);
    }, children: [i.jsx("span", { className: "tw-pl-[7px] tw-block xs:tw-hidden", children: h.title }), i.jsx("span", { className: "tw-pl-[7px] tw-hidden xs:tw-block tw-whitespace-nowrap tw-text-sm", children: `${h.title} More` })] }) }, `swatch-link-${m}`) : i.jsx(Ue, { className: `tw-flex !tw-h-fit ${g ? "tw-ml-[0.25rem]" : ""} ${l ? "" : "!tw-w-fit"} ${!$ && !l ? "tw-pr-2" : ""}`, onDrag: (v) => v.preventDefault(), children: i.jsx("button", { className: `tw-w-fit tw-rounded-full tw-relative focus-visible:tw-outline-2 focus-visible:tw-outline-link tw-p-px tw-border-2 ${t === m ? "tw-border-secondary" : "tw-border-transparent tw-outline-2 hover:tw-border-light-disabled"}`, onClick: (v) => {
      v.preventDefault(), v.stopPropagation();
    }, children: i.jsx(J2, { item: h, hideTooltip: n, children: i.jsx(de, { ...h, caption: void 0, className: "tw-contain tw-rounded-full !tw-h-[34px] !tw-w-[34px] tw-object-cover tw-rounded-swatch-item", "aria-label": h.alt ?? `swatch-${m}` }) }) }) }, `swatch-${m}`);
  }), l && i.jsx(ke, { direction: "right", disabled: s || p, className: "!tw-h-12" })] });
}, ew = 4, hr = 5;
var Dn;
(function(e) {
  e.RIGHT = "right", e.CENTER = "center", e.LEFT = "left";
})(Dn || (Dn = {}));
var bt;
(function(e) {
  e.BLACK = "tw-bg-black", e.BLUE = "tw-bg-primary", e.GOLD = "tw-bg-amber-700", e.WHITE = "tw-bg-white", e.GREEN = "tw-bg-green-800";
})(bt || (bt = {}));
const tw = Ot(({ title: e, price: t, showStartingAtLabel: n = !0, showRequestQuote: r = !1, showPricesLabel: a = !0, isImageFit: s = !1, hideTooltip: o = !1, mainImages: l = [], thumbnailImages: d = [], beautyImages: c, colorImages: f, hoverImage: w, wallToWall: u, objectID: p, index: h, clickHandler: m, intersectionHandler: $, actionClickHandler: g, bannerLocation: v = Dn.LEFT, bannerColor: C = bt.GOLD, bannerText: y, bannerTTL: x, action: E }, O) => {
  const [I, B] = G(0), [P, A] = G(), L = Rn("(min-width: 1024px)"), { ref: U } = Us({
    threshold: 0,
    triggerOnce: !0,
    onChange: (W) => {
      W && $ && $(p, h);
    },
    trackVisibility: !0,
    delay: 100
  }), X = rt(() => !!E, [E]);
  return i.jsxs("div", { className: `tw-flex tw-flex-col tw-h-full tw-justify-between ${L ? "hover:tw-shadow-md" : "tw-shadow-md"}`, children: [i.jsx(J, { ...e, active: !1, hasUnderline: !1, variant: oe.NONE, className: `${e.className} !tw-items-start tw-h-full tw-relative`, children: i.jsxs("div", { ref: O, className: "tw-flex tw-flex-col tw-w-full tw-bg-white", onClick: () => {
    typeof m == "function" && m(p, h);
  }, children: [i.jsxs("div", { className: "tw-group tw-relative tw-z-[2]", "data-testid": "ml-product-card-image-container", children: [c ? i.jsx("div", { className: "tw-absolute group-hover:tw-block tw-hidden tw-top-0 tw-right-0 tw-z-20 tw-w-full tw-h-full", children: i.jsxs(i.Fragment, { children: [i.jsx(Ye, { navigation: !0, modules: [Ju], loop: !0, className: "tw-h-full tw-w-full beauty-swiper tw-bg-red-50", children: c.map((W, Z) => i.jsx(Ue, { onDrag: (j) => j.preventDefault(), children: i.jsx(de, { ...W, disableFadding: !0, caption: void 0, className: `tw-aspect-square !tw-opacity-1 tw-w-full ${s ? "tw-object-cover" : "tw-object-contain"}` }) }, `swatch-${Z}`)) }), i.jsx("style", { children: `
    .beauty-swiper .swiper-button-next,
    .beauty-swiper .swiper-button-prev {
      background-color: rgba(0, 0, 0, 0.5);
      color: white;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .beauty-swiper .swiper-button-next:hover,
    .beauty-swiper .swiper-button-prev:hover {
      background-color: rgba(255, 255, 255, 0.8);
      color: black;
      transition: background-color 0.2s ease, color 0.2s ease;
    }

    .beauty-swiper .swiper-button-next::after,
    .beauty-swiper .swiper-button-prev::after {
      font-size: 16px;
    }
  ` })] }) }) : w && i.jsx("div", { className: "tw-absolute group-hover:tw-block tw-hidden tw-top-0 tw-right-0 tw-z-20 tw-w-full ", children: i.jsx(de, { ...w, disableFadding: !0, caption: void 0, className: `tw-aspect-square  ${s ? "tw-object-cover" : "tw-object-contain "}` }) }), v == Dn.LEFT && y && x && x >= Date.now() && i.jsx("div", { className: `tw-shadow-lg tw-w-fit ${C} tw-z-[3] tw-absolute tw-top-0 tw-left-0 tw-text-start tw-m-1`, children: i.jsx("p", { className: `tw-text-sm tw-font-bold ${C == bt.GOLD || C == bt.BLACK || C == bt.BLUE || C == bt.GREEN ? "tw-text-white" : "tw-text-black"}  tw-text-center tw-px-1`, children: y }) }), f ? i.jsx(Ye, { threshold: 10, modules: [Pt], thumbs: { swiper: P && !P.destroyed ? P : null }, spaceBetween: 10, className: "tw-h-full tw-w-full", resistanceRatio: 0, onActiveIndexChange: (W) => {
    B(W.activeIndex);
  }, children: f.map((W, Z) => i.jsx(Ue, { onDrag: (j) => j.preventDefault(), children: i.jsx(de, { ...W, disableFadding: !0, caption: void 0, className: `tw-aspect-square !tw-opacity-1 tw-w-full  ${s ? "tw-object-cover" : "tw-object-contain"}` }) }, `swatch-${Z} `)) }) : i.jsx(Ye, { threshold: 10, modules: [Pt], thumbs: { swiper: P && !P.destroyed ? P : null }, spaceBetween: 10, className: "tw-h-full tw-w-full", resistanceRatio: 0, onActiveIndexChange: (W) => {
    B(W.activeIndex);
  }, children: l.map((W, Z) => i.jsx(Ue, { onDrag: (j) => j.preventDefault(), children: i.jsx(de, { ...W, disableFadding: !0, caption: void 0, className: `tw-aspect-square !tw-opacity-1 tw-w-full  ${s ? "tw-object-cover" : "tw-object-contain"}` }) }, `swatch-${Z} `)) })] }), i.jsx(Q2, { thumbnailImages: f || d, swiperActiveThumb: I, hideTooltip: o, setSwiper: A }), i.jsx("div", { ref: U, className: `tw-px-4 tw-py-4 ${X ? "tw-pt-4 tw-pb-6" : ""} tw-flex tw-flex-col tw-select-none`, children: i.jsxs("div", { children: [i.jsx("h4", { className: `tw-text-secondary tw-font-medium tw-text-xl ${X ? "" : "tw-mb-1"} `, children: e.label }), a && i.jsxs(i.Fragment, { children: [i.jsxs("p", { className: "tw-flex tw-items-center tw-flex-row tw-gap-1 tw-text-xs tw-text-dark", children: [n && "Starting at:", i.jsx("span", { className: "tw-text-lg tw-font-normal ", children: t })] }), u && i.jsxs("p", { className: "tw-flex tw-items-center tw-flex-row tw-gap-1 tw-text-xs tw-text-dark", children: ["Wall-to-wall: ", i.jsx("span", { className: "tw-text-lg tw-font-normal", children: u })] })] }), r && i.jsx(i.Fragment, { children: i.jsx("p", { className: "tw-flex tw-items-center tw-flex-row tw-gap-1 tw-text-xs tw-text-dark", children: i.jsx("span", { className: "tw-text-lg tw-font-normal ", children: "Request Quote" }) }) })] }) })] }) }), X && i.jsx(J, { ...E, href: "#", className: `tw-leading-6 tw-flex tw-items-center !tw-py-3 tw-px-4 tw-w-full tw-h-12 ${L ? "hover:tw-bg-light-hover" : ""} hover:tw-font-normal`, labelClassName: "tw-leading-6", onClick: (W) => {
    W.preventDefault(), W.stopPropagation(), typeof g == "function" && g(p, h);
  }, hasUnderline: !1, variant: oe.NAV, focus: ie.NO_FOCUS })] });
});
var Jt;
(function(e) {
  e.NORMAL = "normal", e.ROUNDED = "rounded";
})(Jt || (Jt = {}));
const nw = {
  [Jt.NORMAL]: "tw-rounded-none",
  [Jt.ROUNDED]: "tw-rounded-full"
}, c3 = ({ image: e, link: t, variant: n = Jt.NORMAL, objectID: r, index: a, intersectionHandler: s, clickHandler: o, uppercaseLink: l = !0 }) => {
  const { ref: d } = Us({
    threshold: 0,
    triggerOnce: !0,
    onChange: (c) => {
      c && s && s(a, r);
    },
    trackVisibility: !0,
    delay: 100
  });
  return i.jsxs("div", { ref: d, className: "tw-py-4 tw-flex tw-flex-col tw-items-center tw-gap-y-6 tw-bg-white", onClick: () => {
    typeof o == "function" && o(a, r);
  }, children: [i.jsx(J, { ...t, "aria-label": `${t.label}-image-link`, className: `tw-size-vertical-image ${Jt.NORMAL === n ? "" : "focus-visible:tw-rounded-full"}`, children: i.jsx(de, { ...e, className: `tw-size-vertical-image tw-aspect-square ${nw[n]}`, caption: void 0 }) }), i.jsx(J, { ...t, active: !0, className: `${l ? "tw-uppercase " : ""}tw-text-center`, labelClassName: "tw-leading-6", "aria-label": `${t.label}-link` })] });
};
const rw = ({ showing: e }) => {
  const t = Wn();
  return le(() => {
    e !== void 0 && e > -1 && t && !t.destroyed && t.slideTo(e);
  }, [e, t]), i.jsx(i.Fragment, {});
}, aw = ({ images: e, isZoomImageOpen: t, onZoomImageModalOpen: n, showing: r }) => {
  const a = rt(() => ({
    containerClass: "swiper-zoom-container",
    minRatio: 1
  }), []), s = "!tw-w-10 tw-h-10 tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-absolute tw-bg-subdued tw-m-auto tw-top-0 tw-bottom-0";
  return i.jsx(lt, { appear: !0, show: t, as: Ve, children: i.jsxs(yt, { as: "div", open: t, onClose: n, className: "tw-relative tw-z-55", children: [i.jsx(lt.Child, { as: Ve, enter: "tw-ease-out tw-duration-300", enterFrom: "tw-opacity-0", enterTo: "tw-opacity-100", leave: "tw-ease-in tw-duration-200", leaveFrom: "tw-opacity-100", leaveTo: "tw-opacity-0", children: i.jsx("div", { className: "tw-fixed tw-inset-0 tw-bg-black/50", "aria-hidden": "true" }) }), i.jsx("div", { className: "tw-fixed tw-inset-0 tw-overflow-y-auto tw-p-2 sm:tw-p-4", children: i.jsx("div", { className: "tw-flex tw-min-h-full tw-items-center tw-justify-center tw-text-center", children: i.jsx(lt.Child, { as: Ve, enter: "tw-ease-out tw-duration-300", enterFrom: "tw-opacity-0 tw-scale-95", enterTo: "tw-opacity-100 tw-scale-100", leave: "tw-ease-in tw-duration-200", leaveFrom: "tw-opacity-100 tw-scale-100", leaveTo: "tw-opacity-0 tw-scale-95", children: i.jsx(yt.Panel, { className: "tw-w-fit tw-transform tw-overflow-hidden tw-bg-white tw-text-left tw-align-middle tw-transition-all", children: i.jsxs("div", { className: "tw-flex tw-flex-col tw-m-auto tw-p-2 sm:tw-p-4", children: [i.jsx("div", { className: "tw-flex tw-flex-row tw-justify-end tw-pb-8 xl:tw-px-3", children: i.jsx("button", { className: `${ge[ie.FOCUS_VISIBLE]}`, "aria-label": "Close zoom view", type: "button", onClick: n, children: i.jsx(ne, { type: "close", color: "secondary" }) }) }), i.jsx("div", { className: "tw-w-fit tw-mx-auto tw-modal-zoom-size !w-aspect-square", children: i.jsxs(Ye, { zoom: a, modules: [Qu], className: "tw-w-full", children: [i.jsx(rw, { showing: r || 0 }), i.jsx(ke, { direction: "left", className: s }), e == null ? void 0 : e.map((o, l) => i.jsx(Ue, { children: i.jsxs("div", { className: "swiper-zoom-container !tw-w-auto tw-flex tw-flex-col tw-px-5", children: [o && !o.isVideo && i.jsx(de, { ...o, className: "!tw-h-auto tw-flex-grow !tw-object-cover !tw-aspect-square !tw-flex", captionClassName: "!tw-line-clamp-5" }), o && o.isVideo && o.src && i.jsx(gn, { className: "tw-aspect-square", videoAttributes: { controls: !0 }, videoUrl: o.src, variant: gt.VIDEO_FILE, caption: o.caption || "", captionClassName: "!tw-line-clamp-5" })] }) }, `swatch-zoom-${l}`)), i.jsx(ke, { direction: "right", className: s })] }) })] }) }) }) }) })] }) });
}, iw = ({ showing: e }) => {
  const t = Wn();
  return le(() => {
    e !== void 0 && e > -1 && t && t.slideTo(e);
  }, [e, t]), i.jsx(i.Fragment, {});
}, u3 = ({ images: e = [], thumbnailImages: t, showing: n, onActiveImageChange: r }) => {
  const [a, s] = G(), [o, l] = G(0), { isAtTheBeginning: d, isAtTheEnd: c, onTransitionEnd: f } = Qt(), w = Rn("(min-width: 1280px)"), [u, p] = G(!1), [h, m] = G(0), $ = nt(() => {
    document.body.style.overflow = "auto", document.body.style.touchAction = "auto", p(!1);
  }, []), g = rt(() => t || e, [t, e]), v = `xl:tw-vertical-arrow  ${!w && "!tw-top-8"} ${g.length < 3 ? "tw-hidden sx:tw-hidden md:tw-hidden" : "tw-block sx:tw-block md:tw-block"} ${g.length <= 5 ? "sm:tw-hidden lg:tw-hidden" : "sm:tw-block xl:tw-flex"}`;
  return le(() => {
    r && r(e[o]);
  }, [o, r, e]), i.jsxs("div", { className: "tw-flex tw-flex-col xl:tw-flex-row-reverse xl:tw-gap-8", children: [i.jsxs(Ye, { modules: [Pt], thumbs: { swiper: a && !a.destroyed ? a : null }, spaceBetween: 10, className: "tw-h-full tw-gallery-size tw-flex-shrink-0 tw-mx-0", resistanceRatio: 0, onActiveIndexChange: (C) => l(C.activeIndex), children: [i.jsx(iw, { showing: n }), e.map((C, y) => {
    const { isVideo: x, thumbnailImage: E, ...O } = C;
    return i.jsx(Ue, { children: i.jsx("button", { className: `tw-m-1 xl:tw-m-0 hover:tw-cursor-zoom-in ${ge[ie.FOCUS_VISIBLE]} `, type: "button", onClick: () => {
      m(y), p(!0);
    }, children: i.jsx(de, { ...O, src: x ? E : C.src, className: "tw-gallery-size tw-aspect-square tw-grid tw-relative", captionClassName: "!tw-line-clamp-5", playButtonOverlay: x }) }) }, `swatch-${y}`);
  })] }), i.jsx("div", { children: i.jsxs(Ye, { threshold: 10, watchSlidesProgress: !0, breakpoints: {
    320: { slidesPerView: 2, slidesPerGroup: 2 },
    375: { slidesPerView: 3, slidesPerGroup: 3 },
    640: { slidesPerView: 5, slidesPerGroup: 5 },
    768: { slidesPerView: 3, slidesPerGroup: 3 },
    1024: { slidesPerView: 5, slidesPerGroup: 5 },
    1280: { slidesPerView: 5, spaceBetween: 0, slidesPerGroup: 5 }
  }, direction: w ? "vertical" : "horizontal", modules: [Pt], resistanceRatio: 0, className: "tw-h-full tw-w-full tw-gallery-thumbnail tw-relative", onTransitionEnd: f, onSwiper: s, children: [i.jsx(ke, { disabled: d, variant: w ? "vertical" : "default", direction: w ? "up" : "left", className: v }), g.map((C, y) => {
    const {
      isVideo: x,
      // eslint-disable-next-line unused-imports/no-unused-vars
      thumbnailImage: E,
      ...O
    } = C;
    return i.jsx(Ue, { className: "tw-p-2 xl:tw-p-0", children: i.jsx("div", { "aria-label": C.alt ?? `swatch-${y}`, className: `tw-w-fit focus-visible:tw-outline-2 tw-border-2 tw-mx-auto tw-relative ${o === y ? "tw-border-secondary" : "tw-border-transparent hover:tw-border-light-disabled"}`, children: i.jsx(de, { ...O, caption: "", className: "tw-w-20 md:tw-w-24 tw-h-20 md:tw-h-24 tw-cursor-pointer tw-grid", playButtonOverlay: x, playButtonOverlaySize: 36 }) }) }, `swatch-${y}`);
  }), i.jsx(ke, { disabled: c, variant: w ? "vertical" : "default", direction: w ? "down" : "right", className: v })] }) }), u && i.jsx(aw, { images: e, showing: h, isZoomImageOpen: u, onZoomImageModalOpen: $ })] });
}, Ws = ({ id: e, title: t, subtitle: n, description: r, image: a, outOfStockLabel: s = "Out Of Stock", loadingLabel: o = "Loading", removeLabel: l = "Remove", addLabel: d = "Add", isAddedToCart: c = !1, className: f = "", onClick: w, isOutOfStock: u, imageClassName: p = "", titleClassName: h = "", subtitleClassName: m = "", descriptionClassName: $ = "" }) => {
  const [g, v] = G(c), [C, y] = G(!1), x = async () => {
    w ? (y(!0), w(e, !g).then(() => v(!g)).finally(() => y(!1))) : v(!g);
  };
  return le(() => {
    v(c);
  }, [t]), i.jsxs("div", { className: `tw-flex tw-flex-col tw-p-2 tw-mx-2 tw-my-4 tw-gap-2 tw-w-36 tw-text-secondary tw-min-h-max tw-justify-between tw-bg-white tw-z-10
      ${ge[ie.FOCUS_VISIBLE_SHADOW]}
      focus-within:tw-border-secondary focus-within:tw-outline-offset-0 focus-within:tw-outline-link
      tw-border ${C || u ? "tw-pointer-events-none" : "tw-cursor-pointer"} ${g ? "tw-border-secondary" : "tw-border-outlined-gray"} hover:tw-border-secondary
      ${f}`, onClick: x, "data-testid": "ml-sample-card", children: [i.jsx(de, { ...a, className: `tw-w-full tw-aspect-square tw-max-h-32 tw-h-32 ${ge[ie.NO_FOCUS]} ${p}`, caption: void 0 }), i.jsx("h4", { className: `tw-text-sm tw-font-normal tw-mb-auto tw-capitalize ${h}`, children: t }), n && i.jsx("h5", { className: `tw-text-xs tw-leading-4 ${m}`, children: n }), r && i.jsx("span", { className: `tw-text-xs tw-leading-4 ${$}`, children: r }), i.jsx(Te, { className: `tw-w-full ${u ? "tw-px-2" : ""}`, label: u ? s : C ? o : g ? l : d, size: St.COMPACT, variant: g ? Me.SECONDARY : Me.TERTIARY, icon: g && !C ? { type: "close" } : void 0, focus: ie.NO_FOCUS, disabled: C || u, state: u ? De.DISABLED : C ? De.LOADING : De.ENABLED })] });
}, sw = ({ id: e, title: t, subtitle: n, selected: r, isOutOfStock: a, disabled: s, description: o, image: l, clickHandler: d, quantity: c }) => i.jsxs("button", { "data-testid": e, disabled: s || a, type: "button", onClick: d, className: `tw-relative tw-w-swatch-card disabled:tw-opacity-75 disabled:tw-pointer-events-none tw-border
      ${r ? "tw-border-secondary" : "tw-border-outlined-gray"} 
      ${ge[ie.FOCUS_VISIBLE]}
     `, children: [r ? i.jsx("div", { className: "tw-pointer-events-none tw-absolute tw-right-5 tw-top-4 tw-z-10 tw-bg-white tw-p-0.75", children: i.jsx(ne, { size: 18, type: ps[jt.FILLED], color: s || a ? "gray" : "secondary" }) }) : i.jsx("div", { className: "tw-bg-white tw-p-0.75 tw-absolute tw-z-10 tw-right-5 tw-top-4", children: i.jsx("div", { className: `tw-ring-2 tw-grow-0 tw-shrink-0 ${s || a ? "tw-ring-gray tw-bg-light-disabled" : "tw-ring-secondary"} tw-ring-inset tw-checkbox-size` }) }), i.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-2 tw-w-full tw-p-2 tw-bg-white tw-min-h-swatch-card tw-h-full tw-text-left", children: [l && i.jsx(de, { ...l, className: `tw-aspect-square tw-w-full tw-border tw-border-outlined-gray tw-grid ${o ? "!tw-h-[112px]" : "!tw-h-[122px] tw-long"} ${s || a ? "tw-disabled-diagonal" : ""}`, caption: void 0 }), t && i.jsx("span", { className: `${s || a ? "tw-text-gray" : "tw-text-secondary"} tw-text-sm tw-font-normal tw-select-none tw-leading-5`, children: t }), n && i.jsx("span", { className: `${s || a ? "tw-text-gray" : "tw-text-secondary"} tw-text-xs tw-font-normal tw-select-none tw-leading-4`, children: n }), o && i.jsx("span", { className: "tw-text-secondary tw-text-xs tw-leading-4", children: o }), r && c && c.showQuantity && i.jsxs("div", { className: "tw-flex tw-flex-row tw-gap-0.5 tw-items-center tw-bg-subdued tw-w-full", children: [i.jsx("button", { "aria-label": `${e}-decrease-button`, className: `tw-basis-9 tw-h-9 tw-shrink-0 tw-grow-0 tw-flex tw-justify-center tw-items-center tw-bg-subdued disabled:tw-cursor-not-allowed disabled:tw-opacity-50 ${ge[ie.FOCUS_VISIBLE]}`, type: "button", onClick: (f) => {
  f.stopPropagation(), typeof c.decrease == "function" && c.decrease();
}, disabled: Number(c.value) <= Number(c.min), children: i.jsx(ne, { type: "minus", size: 16, color: "secondary" }) }), i.jsx(jr, { dataTestId: c.dataTestId, fieldId: c.fieldId, type: "number", inputClassName: " tw-h-9 tw-text-center tw-w-full tw-basis-9 tw-shrink-0 tw-grow-0 tw-px-0", onChange: (f) => {
  f.stopPropagation(), typeof c.onChange == "function" && c.onChange(f);
}, value: Number(c.value) === 0 ? 1 : Number(c.value), max: c.max, readOnly: c.readOnly }), i.jsx("button", { "aria-label": `${e}-increase-button`, className: `tw-basis-9 tw-h-9 tw-shrink-0 tw-grow-0 tw-flex tw-justify-center tw-items-center tw-bg-subdued disabled:tw-cursor-not-allowed disabled:tw-opacity-50 ${ge[ie.FOCUS_VISIBLE]}`, type: "button", onClick: (f) => {
  f.stopPropagation(), typeof c.increase == "function" && c.increase();
}, disabled: Number(c.value) >= Number(c.max) || Number(c.value) < 0, children: i.jsx(ne, { type: "plus", size: 16, color: "secondary" }) })] })] })] });
var Tt;
(function(e) {
  e.Light = "light", e.Dark = "dark";
})(Tt || (Tt = {}));
const ow = {
  [Tt.Light]: "tw-bg-white tw-text-secondary tw-shadow-md",
  [Tt.Dark]: "tw-bg-secondary tw-text-white tw-shadow-md"
}, lw = "focus-visible:tw-outline-link focus-visible:tw-outline-offset-0 focus-visible:tw-outline-1 focus-visible:tw-outline", zs = ({ title: e = "", description: t, price: n = "", image: r, children: a, referenceClassName: s = "tw-max-w-max tw-max-h-max", floatingContentClassName: o = "", floatingWrapperClassName: l = "", placement: d, theme: c = Tt.Dark, startsOpen: f = !1, ariaLabelledby: w }) => {
  const [u, p] = G(f), h = xe(null), { refs: m, floatingStyles: $, context: g } = $o({
    placement: d,
    open: u,
    strategy: "absolute",
    transform: !0,
    onOpenChange: p,
    middleware: [xo(), vo(), bo({ element: h })],
    whileElementsMounted: yo
  }), v = Co(g, { move: !1, handleClose: Eo() }), C = No(g), y = To(g), x = So(g, { role: "tooltip" }), { getReferenceProps: E, getFloatingProps: O } = jo([v, C, y, x]);
  return i.jsxs(i.Fragment, { children: [i.jsx("div", { ref: m.setReference, role: "tooltip", "aria-label": "Show more information", "aria-labelledby": w, "aria-haspopup": "true", "aria-expanded": u, className: `tw-group tw-flex ${s} ${lw}`, tabIndex: 0, ...E(), "data-testid": "ml-floating-reference", children: a }), u && i.jsxs("div", { ref: m.setFloating, style: $, ...O(), "data-testid": "ml-floating-element", className: `tw-z-40 ${l}`, children: [i.jsxs("div", { className: `tw-z-40 ${ow[c]} tw-h-auto tw-w-max tw-max-w-xs tw-text-sm tw-rounded-[3px] ${r ? "tw-p-7" : "tw-p-3"} ${o}`, onClick: (I) => {
    I.preventDefault(), I.stopPropagation();
  }, children: [r && i.jsx(de, { src: r.src, alt: r.alt, width: 256, height: 240, ...r }), e && i.jsx("h4", { className: `tw-font-medium ${r ? "tw-mt-4" : ""}`, children: e }), t ? typeof t == "string" ? i.jsx("p", { className: `${r ? "tw-mt-2" : ""} `, children: t }) : i.jsx(je, { className: `${r ? "tw-mt-2" : ""} `, variant: Tt.Dark === c ? me.WHITE : me.BLACK, ...t }) : null, n && i.jsx("p", { className: "tw-font-medium tw-mt-6", children: n })] }), i.jsx(Po, { ref: h, className: "tw-absolute", context: g, fill: Tt.Dark === c ? "#495057" : "#FFFFFF" })] })] });
}, dw = {
  [_e.SMALL]: "lg:tw-text-3xl",
  [_e.NORMAL]: "lg:tw-text-4xl",
  [_e.BIG]: "lg:tw-text-5xl"
}, cw = {
  [_e.SMALL]: "tw-text-xl",
  [_e.NORMAL]: "tw-text-2xl",
  [_e.BIG]: "tw-text-3xl"
}, uw = ({ isH1: e, children: t, className: n = "" }) => e ? i.jsx("h1", { className: n, children: t }) : i.jsx("h2", { className: n, children: t }), Fi = ({ isH1: e, textAlignment: t, headingSize: n, headingSizeMobile: r, customClassName: a = "", fontWeigth: s }) => (o, l) => {
  const d = t ? zt[t] : "";
  return i.jsx(uw, { isH1: !!e, className: `${n ? `${dw[n]}` : "lg:tw-text-3xl"} ${r ? cw[r] : "tw-text-xl"} ${d} ${Gi[s]} ${a} }`, children: l });
}, fw = ({ isH1: e, textAlignment: t, headingSize: n, headingSizeMobile: r, customClassName: a = "", fontWeigth: s }) => ({
  renderNode: {
    [q.HEADING_1]: Fi({
      isH1: e,
      textAlignment: t,
      headingSize: n,
      headingSizeMobile: r,
      customClassName: a,
      fontWeigth: s
    }),
    [q.HEADING_2]: Fi({
      isH1: e,
      textAlignment: t,
      headingSize: n,
      headingSizeMobile: r,
      customClassName: a,
      fontWeigth: s
    }),
    // This is intentional to force render only heading blocks
    [q.PARAGRAPH]: () => null
  }
}), ww = ({ fontWeight: e, textAlignment: t }) => ({
  renderNode: {
    [_t.HYPERLINK]: (n, r) => i.jsx(J, { variant: oe.NONE, hasUnderline: !0, active: !0, href: n.data.uri, actionUrl: "_blank", rel: "noopener noreferrer", label: r, className: `tw-text-sm md:tw-text-base lg:tw-text-xl ${zt[t]}` }),
    [q.PARAGRAPH]: (n, r) => i.jsx("p", { className: `tw-text-sm md:tw-text-base lg:tw-text-xl ${zt[t]} ${Gi[e]}`, children: r })
  }
});
var Vt;
(function(e) {
  e.TOP = "top", e.CENTER = "center", e.BOTTOM = "bottom";
})(Vt || (Vt = {}));
var ze;
(function(e) {
  e.OPACITY_10 = "10%", e.OPACITY_20 = "20%", e.OPACITY_30 = "30%", e.OPACITY_40 = "40%", e.OPACITY_50 = "50%", e.OPACITY_60 = "60%", e.OPACITY_70 = "70%", e.OPACITY_80 = "80%", e.OPACITY_90 = "90%";
})(ze || (ze = {}));
var kn;
(function(e) {
  e.WHITE = "white", e.BLACK = "black";
})(kn || (kn = {}));
var tt;
(function(e) {
  e.TOP_RIGHT = "top-right", e.TOP_LEFT = "top-left", e.MIDDLE_RIGHT = "middle-right", e.MIDDLE_LEFT = "middle-left", e.BOTTOM_RIGHT = "bottom-right", e.BOTTOM_LEFT = "bottom-left";
})(tt || (tt = {}));
var st;
(function(e) {
  e.VIDEO = "video", e.IMAGE = "image";
})(st || (st = {}));
const hw = {
  [Vt.TOP]: "tw-justify-start",
  [Vt.CENTER]: "tw-justify-center",
  [Vt.BOTTOM]: "tw-justify-end"
}, pw = {
  [tt.TOP_RIGHT]: "tw-top-0 tw-right-0",
  [tt.TOP_LEFT]: "tw-top-0 tw-left-0",
  [tt.MIDDLE_RIGHT]: "tw-top-1/2 tw-right-0 tw--mt-4",
  [tt.MIDDLE_LEFT]: "tw-top-1/2 tw-left-0 tw--mt-4",
  [tt.BOTTOM_RIGHT]: "tw-bottom-0 tw-right-0",
  [tt.BOTTOM_LEFT]: "tw-bottom-0 tw-left-0"
}, mw = {
  [ze.OPACITY_10]: "10%",
  [ze.OPACITY_20]: "20%",
  [ze.OPACITY_30]: "30%",
  [ze.OPACITY_40]: "40%",
  [ze.OPACITY_50]: "50%",
  [ze.OPACITY_60]: "60%",
  [ze.OPACITY_70]: "70%",
  [ze.OPACITY_80]: "80%",
  [ze.OPACITY_90]: "90%"
}, gw = ({ children: e, isLink: t = !1, actionUrl: n }) => t ? i.jsx("div", { onClick: () => xt(n), className: `tw-cursor-pointer ${ge[ie.FOCUS_VISIBLE_SHADOW]}`, role: "button", onKeyDown: (r) => {
  r.key === "Enter" && xt(n);
}, tabIndex: 0, children: e }) : i.jsx(i.Fragment, { children: e }), f3 = ({ background: e, backgroundMobile: t, ctaButton: n, contentColorMobile: r = me.BLACK, contentColorDesktop: a = me.BLACK, contentMobile: s, contentDesktop: o, caption: l, captionPosition: d = tt.TOP_LEFT, captionPositionMobile: c = tt.TOP_LEFT, captionColor: f = kn.WHITE, contentPosition: w = Vt.CENTER, hasDropShadow: u = !1, hasOverlay: p = !1, headingTextSize: h = _e.NORMAL, headingTextSizeMobile: m = _e.SMALL, displayCaptionOnMobile: $ = !0, headingFontWeight: g = Wt.BOOK, subheadingFontWeight: v = Wt.BOOK, overlayColor: C, overlayOpacity: y = ze.OPACITY_50, variant: x = st.IMAGE, sectionClassName: E = "", contentClassName: O = "" }) => {
  const [I, B] = G(!0), P = xe(null), A = Rn("(min-width: 1024px)"), L = Rn("(max-width: 1023px)"), U = !!(e.actionUrl || t.actionUrl), X = () => {
    var Z, j;
    if (I) {
      B(!1), (Z = P == null ? void 0 : P.current) == null || Z.pause();
      return;
    } else {
      B(!0), (j = P == null ? void 0 : P.current) == null || j.play();
      return;
    }
  }, W = ({ headingTextSize: Z, headingTextSizeMobile: j, content: M, headingFontWeight: R, subheadingFontWeight: N }) => {
    let T = !1;
    M && (T = !!M.content.find((H) => H.nodeType === q.HEADING_1));
    const k = fw({
      isH1: T,
      headingSize: Z,
      headingSizeMobile: j,
      textAlignment: Ze.CENTER,
      fontWeigth: R
    }), V = ww({
      fontWeight: N,
      textAlignment: Ze.CENTER
    });
    return {
      ...k,
      ...V,
      renderNode: {
        ...k.renderNode,
        ...V.renderNode
      }
    };
  };
  return i.jsx(gw, { isLink: U, actionUrl: A ? e.actionUrl : t.actionUrl, children: i.jsxs("section", { role: x === st.IMAGE ? "link" : "", className: `tw-w-full tw-relative lg:tw-aspect-video tw-aspect-square bg-subdued ${E}`, tabIndex: 0, children: [e && x === st.IMAGE && i.jsx(de, { className: `tw-aspect-video tw-bg-cover ${L ? "tw-hidden" : ""}`, caption: null, tabIndex: U ? 0 : -1, ...e.image }), t && x === st.IMAGE && i.jsx(de, { className: `tw-aspect-square tw-bg-cover ${A ? "tw-hidden" : ""}`, caption: null, tabIndex: U ? 0 : -1, ...t.image }), A && e && x === st.VIDEO && i.jsx(gn, { videoUrl: e.videoUrl, variant: gt.VIDEO_FILE, ref: P, className: `tw-aspect-video tw-w-full ${e.className ?? ""}`, videoAttributes: e.videoAttributes }), L && t && x === st.VIDEO && i.jsx(gn, { videoUrl: t.videoUrl, variant: gt.VIDEO_FILE, ref: P, className: `tw-aspect-square tw-w-full ${t.className ?? ""}`, videoAttributes: t.videoAttributes }), p && i.jsx("div", { className: "tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full", style: { backgroundColor: C, opacity: mw[y] } }), i.jsxs("div", { className: `tw-flex tw-flex-col tw-py-20 tw-px-6 tw-absolute tw-top-0 tw-items-center tw-w-full tw-h-full tw-z-[1] ${hw[w]} ${u ? "tw-text-shadow" : ""} ${O}`, children: [l && i.jsx("div", { className: `tw-border-l tw-max-w-xs tw-m-6 ${f === kn.WHITE ? "tw-text-white" : "tw-text-dark"} ${pw[A ? d : c]} ${$ ? "tw-absolute" : `${L ? "tw-hidden" : "tw-absolute"}`}`, children: i.jsx("p", { className: "tw-text-sm lg:tw-text-base tw-pl-4", children: l }) }), i.jsxs("div", { className: "tw-w-full tw-min-h-12", children: [s && L && i.jsx(je, { ...s, variant: r === me.WHITE ? me.WHITE : me.BLACK, customOptions: W({
    headingTextSize: h,
    headingTextSizeMobile: m,
    content: s.text,
    headingFontWeight: g,
    subheadingFontWeight: v
  }), className: `${r === me.WHITE ? "!tw-text-white" : "!tw-text-dark"}` }), o && A && i.jsx(je, { ...o, variant: r === me.WHITE ? me.WHITE : me.BLACK, customOptions: W({
    headingTextSize: h,
    headingTextSizeMobile: m,
    content: o.text,
    headingFontWeight: g,
    subheadingFontWeight: v
  }), className: `${a === me.WHITE ? "!tw-text-white" : "!tw-text-dark"}` })] }), n && i.jsx(Te, { ...n, className: "tw-mt-4" }), x === st.VIDEO && i.jsx(Te, { label: "", name: `${I ? "pause background video" : "play background video"}`, ariaLabel: `${I ? "pause background video" : "play background video"}`, className: `tw-absolute tw-bg-transparent hover:tw-bg-transparent !tw-p-0 !tw-border-0 !tw-shadow-none tw-bottom-0 tw-right-0 tw-my-4 tw-mx-2 tw-z-[1] ${a === me.WHITE ? "!tw-text-white" : "!tw-text-dark"}`, icon: { type: `${I ? "pause-video" : "play-video"}` }, onClick: X })] })] }) });
}, w3 = ({ colorImages: e, selectedColor: t, onImageClick: n }) => i.jsx("div", { className: "tw-flex tw-flex-wrap tw-gap-4", children: e.map((r, a) => i.jsx("button", { className: `tw-w-fit tw-rounded-full tw-relative focus-visible:tw-outline-2 focus-visible:tw-outline-link tw-p-px tw-border-2 ${t === r.alt ? "tw-border-secondary" : "tw-border-transparent tw-outline-2 hover:tw-border-light-disabled"}`, onClick: (s) => {
  s.preventDefault(), s.stopPropagation(), n(r.alt ?? "");
}, children: i.jsx(Vs, { item: r, hideTooltip: !1, showCaption: !0, children: i.jsx(de, { ...r, caption: void 0, className: "!tw-w-10 !tw-h-10 md:!tw-w-16 md:!tw-h-16 tw-contain tw-rounded-full tw-object-cover tw-rounded-swatch-item ", "aria-label": r.alt ?? `swatch-${a}` }) }) }, `swatch-${a}`)) }), Ys = ({ name: e, hasPopover: t, children: n, popover: r }) => t ? i.jsx(zs, { title: (r == null ? void 0 : r.title) ?? e, ...r, children: n }) : i.jsx(i.Fragment, { children: n }), $w = ({ hiddenField: e, checkboxVariant: t = jt.FILLED, dataTestId: n, disabled: r, fieldId: a = "", label: s = "", error: o, helperMessage: l = "", errorMessage: d = "", inputClassName: c, labelClassName: f, name: w = "", type: u, value: p, hasInfoButton: h, InfoButtonIcon: m, image: $, required: g, onClickInfoHandler: v, onChange: C, showCondition: y, hasPopover: x, popover: E, ...O }) => {
  const { showElement: I } = Lt(y);
  return I ? i.jsxs("label", { htmlFor: a || w, className: `tw-flex tw-gap-2 tw-cursor-pointer tw-justify-start tw-items-center tw-w-fit ${O.className}${e ? " tw-hidden" : ""}`, children: [i.jsxs("div", { className: `tw-relative tw-ring-2 tw-grow-0 tw-shrink-0 ${r ? "tw-ring-gray tw-bg-light-disabled" : "tw-ring-secondary"} tw-ring-inset tw-checkbox-size tw-flex tw-items-center focus-within:tw-ring-link`, children: [i.jsx("input", { ...O, className: `tw-sr-only tw-peer ${c}`, "data-testid": n, disabled: r, id: a || w, name: w, onChange: C, type: u, value: p }), i.jsx(ne, { size: 18, type: ps[t], className: "tw-pointer-events-none tw-hidden peer-checked:tw-block", color: r ? "gray" : "secondary" })] }), $ && i.jsx("div", { className: "tw-w-[60px] tw-h-[60px] tw-flex-shrink-0 tw-flex-grow-0 tw-basis-[60px]", children: i.jsx(de, { ...$, caption: void 0, className: "tw-w-[60px] tw-h-[60px]" }) }), i.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-1", children: [i.jsxs("div", { className: "tw-flex tw-flex-row tw-gap-1 tw-items-center", children: [s && i.jsxs("span", { className: `${r ? "tw-text-gray" : "tw-text-secondary"} tw-text-base tw-font-normal ${f}`, children: [s, g && i.jsx("span", { className: "tw-text-error tw-text-base tw-ml-1", children: "*" })] }), h && i.jsx(Ys, { hasPopover: x, popover: E, name: w, children: i.jsx("button", { className: `${ge[ie.FOCUS_VISIBLE]} focus-visible:tw-rounded-full`, type: "button", onClick: () => {
    typeof v == "function" && v();
  }, children: i.jsx(ne, { type: m || "info", color: "link" }) }) })] }), !o && l && i.jsx("span", { className: "tw-text-secondary tw-text-sm tw-leading-4", children: l }), o && d && i.jsx("span", { className: "tw-text-error tw-text-sm tw-leading-4", children: d })] })] }) : null;
};
var Ut;
(function(e) {
  e.DARK = "dark", e.OUTLINED = "outlined", e.LIGHT = "light";
})(Ut || (Ut = {}));
const xw = {
  [Ut.DARK]: "tw-bg-secondary tw-text-white tw-border-secondary",
  [Ut.LIGHT]: "tw-text-secondary tw-bg-white tw-border-white",
  [Ut.OUTLINED]: "tw-text-secondary tw-bg-transparent tw-border-secondary"
}, h3 = ({ label: e = "", variant: t = Ut.LIGHT, ...n }) => i.jsxs("li", { role: "listitem", className: `tw-flex tw-w-fit tw-border ${xw[t]}`, children: [i.jsx("span", { className: "tw-flex tw-items-center tw-text-sm tw-font-normal tw-px-2 tw-py-1", children: e }), i.jsx("button", { role: "button", type: "button", "aria-label": `Remove ${e} chip`, className: `tw-px-2 ${n.className} ${ge[ie.FOCUS_VISIBLE]}`, ...n, children: i.jsx(ne, { type: "close", size: 16, color: "currentColor" }) })] }), vw = ({ hiddenField: e, label: t = "", type: n, fieldId: r = "", error: a, errorMessage: s = "", helperMessage: o = "", name: l = "", labelClassName: d, inputClassName: c, showCondition: f, ...w }) => {
  const { showElement: u } = Lt(f);
  return u ? i.jsxs("div", { className: `tw-flex tw-flew-row tw-justify-between tw-items-center${e ? " tw-hidden" : ""}`, children: [i.jsxs("label", { htmlFor: r || l, className: `tw-text-secondary tw-select-none tw-cursor-pointer tw-whitespace-nowrap tw-flex tw-flex-col ${d ?? ""}`, children: [t, !a && o && i.jsx("span", { className: "tw-text-secondary tw-text-sm tw-leading-4 tw-font-normal tw-normal-case", children: o }), a && s && i.jsx("span", { className: "tw-text-error tw-text-sm tw-leading-4 tw-font-normal tw-normal-case", children: s })] }), i.jsxs("div", { className: "tw-relative tw-inline-flex tw-items-center", children: [i.jsx("input", { ...w, type: n === "control" ? "checkbox" : "", role: "switch", id: r || l, className: `tw-sr-only tw-peer ${c ?? ""}` }), i.jsx("label", { htmlFor: r || l, className: "tw-cursor-pointer tw-w-11 tw-h-6 tw-bg-light-disabled tw-rounded-full peer-focus:tw-ring-2 peer-focus:tw-ring-link peer-checked:after:tw-translate-x-full peer-checked:after:tw-border-white after:tw-content-[''] after:tw-absolute after:tw-top-0.5 after:tw-left-0.5 after:tw-bg-white after:tw-rounded-full after:tw-h-5 after:tw-w-5 after:tw-transition-all peer-checked:tw-bg-secondary" })] })] }) : null;
}, p3 = ({ className: e, mobileSrc: t, src: n, ...r }) => {
  const [a, s] = G(n), o = _s();
  return le(() => {
    o && t && (o < 768 ? s(t) : s(n));
  }, [o, t, n]), i.jsx("div", { children: i.jsx("iframe", { allowFullScreen: !0, className: `tw-object-cover tw-w-full ${e}`, allow: "clipboard-write", loading: "lazy", src: a, ...r }) });
}, bw = ({ hiddenField: e, labelClassName: t, inputClassName: n, checked: r, dataTestId: a, disabled: s, fieldId: o = "", label: l, name: d = "", value: c, image: f, error: w, helperMessage: u = "", helperMessageRichText: p, errorMessage: h = "", hasInfoButton: m, InfoButtonIcon: $, onChange: g, onClickInfoHandler: v, showCondition: C, hasPopover: y, popover: x, ...E }) => {
  const { showElement: O } = Lt(C), I = ({ hasPopover: B, children: P, popover: A }) => B ? i.jsx(zs, { title: (A == null ? void 0 : A.title) ?? d, ...A, children: P }) : i.jsx(i.Fragment, { children: P });
  return O ? i.jsxs("div", { className: `tw-flex tw-flex-row tw-items-center tw-gap-2${e ? " tw-hidden" : ""}`, children: [i.jsx("input", { ...E, id: o || d, name: d, disabled: s, "data-testid": a, value: c, checked: r, className: `${s ? "tw-accent-gray tw-pointer-events-none tw-text-secondary" : ""} tw-accent-secondary tw-w-5 tw-h-5 tw-flex-shrink-0 tw-flex-grow-0 tw-basis-5 tw-cursor-pointer ${ge[ie.FOCUS_VISIBLE]} ${n}`, onChange: g }), i.jsxs("label", { htmlFor: o || d, className: `tw-flex tw-flex-row tw-gap-2 tw-items-center tw-cursor-pointer ${s ? "tw-text-gray tw-pointer-events-none" : ""} ${t}`, children: [f && i.jsx("div", { className: "tw-w-[60px] tw-h-[60px] tw-flex-shrink-0 tw-flex-grow-0 tw-basis-[60px]", children: i.jsx(de, { ...f, caption: void 0, className: "tw-w-[60px] tw-h-[60px]" }) }), i.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-1", children: [i.jsxs("div", { className: "tw-flex tw-flex-row tw-gap-1 tw-items-center", children: [i.jsx("span", { children: l }), m && i.jsx(I, { hasPopover: y, popover: x, children: i.jsx("button", { className: `${ge[ie.FOCUS_VISIBLE]} focus-visible:tw-rounded-full`, type: "button", onClick: () => {
    typeof v == "function" && v();
  }, children: i.jsx(ne, { type: $ || "info", color: "link" }) }) })] }), !w && u && i.jsx("span", { className: "tw-text-secondary tw-text-sm tw-leading-4", children: u }), p && i.jsx(je, { ...p, className: "tw-font-normal" }), w && h && i.jsx("span", { className: "tw-text-error tw-text-sm tw-leading-4", children: h })] })] })] }) : null;
};
var dt;
(function(e) {
  e.BEAUTY_BANNER = "beauty-banner", e.PRODUCT_CARD_THUMB = "product-card-thumb";
})(dt || (dt = {}));
const pr = 0, yw = 42, Di = {
  [dt.BEAUTY_BANNER]: {
    X: pr,
    Y: pr
  },
  [dt.PRODUCT_CARD_THUMB]: { X: pr, Y: yw }
}, Cw = {
  [dt.BEAUTY_BANNER]: "tw-fixed tw-bg-secondary tw-font-medium",
  [dt.PRODUCT_CARD_THUMB]: "tw-absolute tw-whitespace-nowrap tw-bg-dark tw-text-ellipsis "
}, Ew = 10, Nw = 25, Tw = ({ text: e, className: t = "tw-max-w-max tw-max-h-max", children: n, variant: r = dt.BEAUTY_BANNER, initialXPosition: a = Di[r].X, initialYPosition: s = Di[r].Y }) => {
  const o = xe(null), [l, d] = G(a), [c, f] = G(s), w = (u) => {
    var g;
    const { clientX: p, clientY: h } = u, $ = (((g = o == null ? void 0 : o.current) == null ? void 0 : g.clientWidth) ?? 0) / 2;
    dt.BEAUTY_BANNER === r && (d(p - $ + Ew), f(h + Nw));
  };
  return i.jsxs("div", { onMouseMove: w, className: `tw-group ${t}`, children: [i.jsx("span", { ref: o, role: "tooltip", style: {
    top: `${c}px`,
    left: dt.BEAUTY_BANNER === r ? `${l}px` : l
  }, className: `tw-z-40 tw-hidden group-hover:tw-inline-block tw-h-fit tw-max-w-xs tw-text-sm tw-text-white tw-px-2 group-hover:hover:tw-opacity-100 tw-transition tw-duration-200 tw-delay-700 tw-opacity-90 ${Cw[r]}`, children: e }), n] });
}, Sw = ({ hiddenField: e, label: t = "", fieldId: n = "", name: r = "", cols: a = 30, rows: s = 4, required: o = !1, labelClassName: l, inputClassName: d = "", value: c, maxLength: f, minLength: w, error: u, errorMessage: p = "", helperMessage: h = "", showCondition: m, containerClassName: $ = "", ...g }) => {
  const { showElement: v } = Lt(m), C = u ? "tw-border-error focus:tw-border-error" : "";
  return v ? i.jsxs("div", { className: `tw-flex tw-flex-col tw-gap-1${e ? " tw-hidden" : ""} ${$}`, children: [t && i.jsxs("label", { htmlFor: n || r, className: `tw-text-secondary tw-text-sm tw-leading-4 tw-flex ${l}`, children: [t, o && i.jsx(ne, { type: "asterisk", size: 8, color: "error", className: "tw-ml-1" })] }), i.jsx("textarea", { id: n || r, name: r, cols: a, rows: s, required: o && v, maxLength: f, minLength: w, className: `tw-w-full tw-h-auto ${fs} ${C} ${d}`, value: c, ...g }), !u && h && i.jsx("span", { className: "tw-text-secondary tw-text-sm tw-leading-4", children: h }), u && p && i.jsx("span", { className: "tw-text-error tw-text-sm tw-leading-4", children: p })] }) : null;
}, jw = {
  left: "tw-left-0",
  right: "tw-right-0",
  down: "tw-bottom-0",
  up: "-tw-top-1"
}, Pw = {
  vertical: "tw-absolute tw-z-10 tw-h-6 tw-w-10 tw-border tw-border-transparent tw-flex tw-justify-center  tw-items-center",
  default: "tw-absolute tw-z-10 tw-h-10 tw-w-6 tw-border tw-border-transparent",
  block: "tw-flex tw-justify-center tw-items-center tw-w-10 tw-h-10 tw-bg-subdued hover:tw-bg-light-hover active:tw-bg-light-active"
}, ke = Bi(({ disabled: e = !1, direction: t = "left", className: n = "", variant: r = "default" }) => {
  const a = Wn(), s = rt(() => t === "up" || t === "down", [t]);
  return i.jsx("button", { "aria-label": t === "right" ? "Next button" : "Prev button", type: "button", onClick: (o) => (o.preventDefault(), o.stopPropagation(), t === "right" || t == "down" ? a.slideNext() : a.slidePrev()), className: `${Pw[r]} ${s ? "" : "tw-top-4"} tw-bg-white ${ge[ie.FOCUS_VISIBLE]} ${jw[t]}  ${e ? "tw-select-none tw-pointer-events-none" : ""} ${n}`, children: i.jsx(ne, { type: "angle-icon", direction: t, color: e ? "light-disabled" : "secondary" }) });
}), Aw = ({ id: e, description: t }) => i.jsxs("li", { className: "tw-flex tw-flex-col tw-items-start md:tw-flex-row md:tw-items-center tw-p-4 -tw-mt-px tw-border tw-border-1 tw-border-outlined-gray", children: [i.jsxs("span", { className: "tw-flex tw-flex-row-reverse tw-gap-2 md:tw-flex-col tw-h-max tw-px-0 tw-py-2 md:tw-p-2 md:tw-pr-4 tw-items-center tw-uppercase tw-text-xs tw-font-medium tw-border-b-2 md:tw-border-b-0 md:tw-border-r-2 tw-border-outlined-gray", children: [i.jsx("span", { className: "tw-text-xl", children: e }), "Step"] }), i.jsx(je, { text: t.text, className: "tw-pt-4 md:tw-pt-0 md:tw-pl-4" })] });
export {
  Bt as ActionType,
  jr as AtBaseInput,
  Te as AtButton,
  St as AtButtonSize,
  De as AtButtonState,
  Me as AtButtonVariant,
  $w as AtCheckbox,
  h3 as AtChip,
  Ut as AtChipVariant,
  vw as AtControl,
  ne as AtIcon,
  p3 as AtIframe,
  de as AtImage,
  H2 as AtInfoItem,
  $t as AtInfoItemVariant,
  J as AtLink,
  Br as AtLinkIconPosition,
  oe as AtLinkVariant,
  bw as AtRadio,
  Aw as AtStep,
  ke as AtSwiperArrow,
  Sw as AtTextArea,
  Tw as AtTooltip,
  dt as AtTooltipVariant,
  di as BgColor,
  kn as CaptionColor,
  tt as CaptionPosition,
  jt as CheckboxVariant,
  bt as ColorProp,
  Ee as ContainerColumnDesktop,
  Lr as ContainerColumnMobile,
  _r as ContainerColumnTablet,
  Vt as ContentPosition,
  mt as DOMAIN,
  ie as FocusElement,
  Wt as FontWeight,
  Gi as FontWeightClasses,
  iw as GalleryWatcher,
  ks as Heading,
  Le as ImageAspectRatio,
  Ys as InfoButtonWrapper,
  ew as LIMIT_INITIAL_THUMBS,
  Ct as LayoutType,
  Qe as LinkTarget,
  Dn as LocationProp,
  Lo as MAX_DESKTOP_SWATCH_SLIDES,
  ot as MLContactVariant,
  R2 as MlAnnouncement,
  qt as MlAnnouncementVariant,
  Qw as MlBanner,
  pt as MlBannerImagePosition,
  f3 as MlBannerOverlay,
  st as MlBannerOverlayVariant,
  Gt as MlBannerThumbnailsPosition,
  Oe as MlBannerVariant,
  e3 as MlBeautyBanner,
  un as MlBeautyBannerColumns,
  t3 as MlBreadcrumb,
  P2 as MlCTACard,
  n3 as MlCard,
  o3 as MlColorSlider,
  w3 as MlColorSwatch,
  a3 as MlContact,
  wn as MlContactChatStatus,
  s3 as MlContentStrip,
  Nt as MlContentStripBackgroundColor,
  Fn as MlContentStripImageMobilePosition,
  Mn as MlContentStripImagePosition,
  Pe as MlContentStripVariant,
  M2 as MlFlyoutMenu,
  Un as MlFormField,
  u3 as MlGallery,
  Hs as MlHeading,
  _e as MlHeadingSize,
  l3 as MlHorizontal,
  d3 as MlInfo,
  Kr as MlLinksCollapse,
  It as MlLinksCollapseVariant,
  V2 as MlMenuItem,
  zs as MlPopover,
  tw as MlProductCard,
  r3 as MlPullQuote,
  je as MlRichText,
  me as MlRichTextVariant,
  Ws as MlSampleCard,
  sw as MlSwatchCard,
  c3 as MlVertical,
  Jt as MlVerticalVariant,
  gn as MlVideo,
  gt as MlVideoVariant,
  hr as NUMBER_OF_SLIDES,
  Nf as OrCollapse,
  zw as OrCollapseContainer,
  Hw as OrContainer,
  Et as OrContainerVariant,
  Jw as OrDrawer,
  Gw as OrFooter,
  Xw as OrForm,
  Vw as OrHeader,
  Tf as OrModal,
  K0 as OrNewsLetter,
  Ww as OrProductListing,
  d2 as OrSampleContainer,
  Uw as OrSearch,
  Yw as OrSidebarMenu,
  Kw as OrStepper,
  qw as OrSwatchCardsSlider,
  Zw as OrTabs,
  vt as OrTabsVariant,
  ze as OverlayOpacity,
  Tt as PopoverTheme,
  L2 as SLIDES_PER_BREAKPOINT,
  Ze as TextAlignment,
  Rr as TextColor,
  Yt as TextFont,
  Vs as ThumbnailWrapper,
  O2 as TooltipCard,
  Oi as activeLink,
  x2 as atLinkBanner,
  fs as baseInputClasses,
  ps as checkboxVariantIcon,
  B0 as classesDirection,
  Oo as colors,
  vf as containerSectionBottomPaddingClasses,
  Xt as containerSectionHorizontalPaddingClasses,
  bf as containerSectionTopPaddingClasses,
  xf as containerSectionVerticalPaddingClasses,
  sn as countryCodes,
  Ht as defaultCountry,
  ni as fixedCodes,
  ge as focusElementClasses,
  Sr as formatPhoneNumber,
  S2 as getClasses,
  _c as getCountry,
  ff as getErrorMessage,
  Bs as getHeadingRichTextOptions,
  Oc as getPhoneNumberData,
  An as getRichTextNode,
  Do as getTransitionDuration,
  fa as getValidateFunction,
  Bo as getValidateFunctionSubmit,
  D2 as iconPositionClass,
  H0 as icons,
  Di as initialTooltipPosition,
  ko as isFieldValid,
  Ro as lgAspectRatioClasses,
  Sn as mdAspectRatioClasses,
  Ri as mlLinksCollapseClasses,
  ln as mobileAspectRatioClasses,
  kw as objectValuesToControls,
  c2 as renderNodeVariant,
  Kt as richTextNodes,
  Gs as richTextNodesWhite,
  cn as sizeClassesHeading,
  Ui as targetFunctions,
  zt as textAlignmentClasses,
  _o as textFontClasses,
  wa as toKebabCase,
  uf as useForm,
  Rn as useMediaQuery,
  Bw as useScrollListener,
  Os as useSessionStorage,
  Qt as useSwiperArrow,
  cf as useVisibility,
  _s as useWindowWidth,
  Nn as variantAtInfoClasses,
  ji as variantBackground,
  j2 as variantDefaultImagePosition,
  i3 as variantProductBannerImagePosition
};
